export default [
  {
    "paths": [
      "M953.4 844.4l-413.2-699c-5.8-10-16.6-17.4-28.2-17.4-11.8 0-22.6 7.4-28.2 17.4l-413.2 699c-5.6 10-9.6 26-3.8 35.8s16.4 15.8 28 15.8h834.2c11.6 0 22.2-6 28-15.8 6-9.8 2-26-3.6-35.8zM576 800h-128v-96h128v96zM576 640h-128v-288h128v288z"
    ],
    "grid": 0,
    "tags": [
      "ion-alert-circled"
    ]
  },
  {
    "paths": [
      "M640 960h-256v-192h256v192zM608 640h-192l-32-576h256l-32 576z"
    ],
    "grid": 0,
    "tags": [
      "ion-alert"
    ]
  },
  {
    "paths": [
      "M512 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zM726 554h-172v172h-84v-172h-172v-84h172v-172h84v172h172v84z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-add-circle"
    ]
  },
  {
    "paths": [
      "M832 554.666h-277.334v277.334h-85.332v-277.334h-277.334v-85.332h277.334v-277.334h85.332v277.334h277.334v85.332z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-add"
    ]
  },
  {
    "paths": [
      "M940 249.674l-196.886-163.56-55.628 65.862 196.884 163.538 55.63-65.84zM334.384 149.838l-55.652-65.838-194.732 165.674 55.628 65.838 194.756-165.674zM533.402 345.256h-64.202v254.892l203.298 121.078 32.102-53.106-171.2-99.834v-223.030zM512 175.33c-214 0-385.202 172.042-385.202 382.332 0 210.298 171.202 382.338 385.202 382.338 211.872 0 385.202-172.040 385.202-382.338 0-210.288-173.33-382.332-385.202-382.332zM512 855.040c-164.786 0-299.6-133.812-299.6-297.376 0-163.554 134.814-297.368 299.6-297.368 164.788 0 299.6 133.812 299.6 297.368 0 165.678-134.812 297.376-299.6 297.376z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-alarm-clock"
    ]
  },
  {
    "paths": [
      "M512 96c-228.8 0-416 187.202-416 416s187.2 416 416 416c228.8 0 416-187.202 416-416s-187.2-416-416-416zM560 720h-96v-80h96v80zM560 544h-96v-256h96v256z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-alert"
    ]
  },
  {
    "paths": [
      "M192 352h160v-160h-160v160zM432 832h160v-160h-160v160zM192 832h160v-160h-160v160zM192 592h160v-160h-160v160zM432 592h160v-160h-160v160zM672 192v160h160v-160h-160zM432 352h160v-160h-160v160zM672 592h160v-160h-160v160zM672 832h160v-160h-160v160z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-apps"
    ]
  },
  {
    "paths": [
      "M907.188 200.002l-64.706-78.598c-11.544-16.15-32.316-25.404-53.154-25.404h-554.658c-20.832 0-41.602 9.254-53.152 25.404l-64.702 78.598c-13.88 13.844-20.816 34.668-20.816 57.77v577.78c0 50.848 41.6 92.448 92.45 92.448h647.106c50.848 0 92.444-41.6 92.444-92.45v-577.78c0-23.1-6.926-43.924-20.812-57.768zM512 766.218l-254.22-254.218h161.78v-92.448h184.886v92.448h161.78l-254.226 254.218zM193.068 188.442l36.972-46.222h554.662l43.93 46.222h-635.564z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-archive"
    ]
  },
  {
    "paths": [
      "M854 469.25h-519.408l239.404-239.404-61.996-59.846-342 342 342 342 59.844-59.848-237.252-239.402h519.408v-85.5z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-back"
    ]
  },
  {
    "paths": [
      "M554.75 170v519.408l239.404-239.404 59.846 61.996-342 342-342-342 59.848-59.844 239.402 237.252v-519.408h85.5z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-down"
    ]
  },
  {
    "paths": [
      "M512 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zM512 640l-192-192h384l-192 192z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-dropdown-circle"
    ]
  },
  {
    "paths": [
      "M256 384l256 256 256-256z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-dropdown"
    ]
  },
  {
    "paths": [
      "M928 512c0-229.75-186.25-416-416-416s-416 186.25-416 416 186.25 416 416 416 416-186.25 416-416zM384 512l192-192v384l-192-192z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-dropleft-circle"
    ]
  },
  {
    "paths": [
      "M640 256l-256 256 256 256z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-dropleft"
    ]
  },
  {
    "paths": [
      "M512 928c229.75 0 416-186.25 416-416s-186.25-416-416-416-416 186.25-416 416 186.25 416 416 416zM448 704v-384l192 192-192 192z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-dropright-circle"
    ]
  },
  {
    "paths": [
      "M384 256l256 256-256 256z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-dropright"
    ]
  },
  {
    "paths": [
      "M928 512c0-229.75-186.25-416-416-416s-416 186.25-416 416 186.25 416 416 416 416-186.25 416-416zM704 576h-384l192-192 192 192z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-dropup-circle"
    ]
  },
  {
    "paths": [
      "M256 640l256-256 256 256z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-dropup"
    ]
  },
  {
    "paths": [
      "M170 554.75h519.408l-239.404 239.404 61.996 59.846 342-342-342-342-59.844 59.848 237.252 239.402h-519.408v85.5z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-forward"
    ]
  },
  {
    "paths": [
      "M554.75 854v-519.408l239.404 239.404 59.846-61.996-342-342-342 342 59.848 59.844 239.402-237.252v519.408h85.5z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-arrow-up"
    ]
  },
  {
    "paths": [
      "M682.668 256v469.332c0 93.876-76.792 170.668-170.668 170.668-93.874 0-170.666-76.792-170.666-170.668v-490.664c0-59.73 46.936-106.668 106.666-106.668 59.728 0 106.666 46.938 106.666 106.668v490.666c0 23.458-19.21 42.666-42.668 42.666s-42.666-19.208-42.666-42.666v-405.334h-64v405.334c0.002 59.728 46.938 106.666 106.668 106.666s106.668-46.938 106.668-106.666v-490.666c0-93.866-76.792-170.668-170.668-170.668s-170.668 76.802-170.668 170.668v490.664c0.002 130.126 104.544 234.668 234.668 234.668s234.668-104.542 234.668-234.668v-469.332h-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-attach"
    ]
  },
  {
    "paths": [
      "M469.334 554.666v261.334h-213.334v80h512v-80h-213.334v-261.334l341.334-341.332v-85.334h-768v85.334l341.334 341.332zM320 298.666l-85.334-85.332h554.668l-85.334 85.332h-384z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-bar"
    ]
  },
  {
    "paths": [
      "M661.332 262.404c37.336 0 67.196-29.87 67.196-67.202s-29.86-67.202-67.196-67.202c-37.332 0-67.192 29.87-67.192 67.202s29.86 67.202 67.192 67.202zM773.332 522.668c-102.664 0-186.664 84-186.664 186.666s84 186.666 186.664 186.666c102.668 0 186.668-84 186.668-186.666s-84-186.666-186.668-186.666zM773.332 840c-72.804 0-130.664-57.86-130.664-130.666s57.86-130.666 130.664-130.666c72.808 0 130.668 57.86 130.668 130.666s-57.86 130.666-130.668 130.666zM611.194 448h156.806v-64h-117.69l-69.24-120.268c-11.21-18.666-31.738-31.728-54.14-31.728-16.798 0-33.596 7.464-44.798 18.666l-143.464 138.13c-11.202 11.202-18.666 28-18.666 44.798 0 24.262 18.404 42.93 37.070 54.13l122.928 76.54v171.732h64v-224l-78.666-64 85.858-89.066 60.002 89.066zM250.666 522.668c-102.666 0-186.666 84-186.666 186.666s84 186.666 186.666 186.666c102.666 0 186.666-84 186.666-186.666s-83.998-186.666-186.666-186.666zM250.666 840c-72.798 0-130.666-57.86-130.666-130.666s57.868-130.666 130.666-130.666c72.798 0 130.666 57.86 130.666 130.666s-57.868 130.666-130.666 130.666z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-bicycle"
    ]
  },
  {
    "paths": [
      "M168.51 826h2.126c68.246 0 127.954-38.042 170.61-84.988 42.65 46.946 102.36 85.524 170.608 85.524s127.958-38.668 170.61-85.612c42.654 46.944 102.36 85.076 170.606 85.076h2.124l102.506-277.56c4.252-10.658 2.126-23.282-2.14-33.952-4.272-10.666-14.474-16.974-25.134-21.246l-76.426-24.976v-196.3c0-46.946-39.312-85.966-86.232-85.966h-127.958l-31.986-106h-191.938l-31.99 106h-127.958c-46.916 0-85.938 39.020-85.938 85.964v196.3l-76.148 25.066c-10.66 4.272-21.164 10.668-25.436 21.334-4.27 10.67-6.316 20.98-2.062 33.774l102.156 277.562zM256 272h512v168.522l-256-83.21-256 83.21v-168.522z",
      "M682.462 816.014c-104.506 72.534-236.712 72.516-341.216-0.018 0 0-115.276 128.004-213.264 128.004h42.654c59.708 0 117.292-23.452 170.61-51.188 106.63 55.468 234.586 55.456 341.216-0.014 53.318 27.738 110.9 51.202 170.608 51.202h42.656c-95.302 0-213.264-127.986-213.264-127.986z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-boat"
    ]
  },
  {
    "paths": [
      "M720 128h-416c-44.004 0-80 35.996-80 80v688l288-128 288 128v-688c0-44.004-35.996-80-80-80z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-bookmark"
    ]
  },
  {
    "paths": [
      "M512 340.272c50.998 0 99.134 20.050 135.542 56.458 36.408 36.406 56.458 84.544 56.458 135.542 0 35.242-8.844 68.062-26.288 97.546-16.678 28.196-40.874 52.072-69.97 69.052l-31.742 18.524v178.606h-128v-178.606l-31.742-18.524c-59.374-34.648-96.258-98.486-96.258-166.598 0-50.998 20.050-99.134 56.458-135.542s84.544-56.458 135.542-56.458zM554.666 64c-12.792 0-85.332 0-85.332 0v128h85.332v-128zM812.792 171.728l-76.792 76.814 59.728 59.73 76.812-76.792-59.748-59.752zM211.208 171.728l-59.75 59.75 76.812 76.792 59.73-59.728-76.792-76.814zM512 276.272c-140.792 0-256 115.208-256 256 0 93.876 51.208 177.062 128 221.876v205.852h256v-205.854c76.792-44.812 128-125.876 128-221.876 0-140.792-115.208-255.998-256-255.998v0zM960 489.604h-128v85.334h128v-85.334zM192 489.604h-128v85.334h128v-85.334z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-bulb"
    ]
  },
  {
    "paths": [
      "M160 704c0 38.396 27.728 49.062 53.334 72.542v76.792c0 23.458 19.198 42.668 42.666 42.668h42.666c23.468 0 42.668-19.208 42.668-42.668v-42.666h341.332v42.666c0 23.458 19.208 42.668 42.668 42.668h42.666c23.458 0 42.666-19.208 42.666-42.668v-76.792c25.606-23.48 53.334-36.27 53.334-72.542v-407.332c0-149.334-164.272-168.668-352-168.668s-352 19.334-352 168.668v407.332zM320 735.978c-36.272 0-64-27.728-64-64 0-36.27 27.728-64 64-64s64 27.73 64 64c0 36.272-27.728 64-64 64zM704 735.978c-36.272 0-64-27.728-64-64 0-36.27 27.728-64 64-64s64 27.73 64 64c0 36.272-27.728 64-64 64zM768 490.666h-512v-213.332h512v213.332z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-bus"
    ]
  },
  {
    "paths": [
      "M736.010 544h-192v192h192v-192zM672.010 128v64h-320v-64h-96v64h-48.020c-44.004 0-80 35.996-80 80v544c0 44.004 35.996 80 80 80h608.020c44.004 0 80-35.996 80-80v-544c0-44.004-35.996-80-80-80h-48v-64h-96zM816.010 816h-608.020v-424h608.020v424z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-calendar"
    ]
  },
  {
    "paths": [
      "M853.332 661.334c-53.332 0-104.542-8.542-151.458-23.458-14.938-4.272-32-2.146-42.664 10.666l-93.878 93.856c-121.604-61.856-219.728-160-281.604-281.606l93.878-93.854c10.664-10.666 14.924-27.728 10.664-42.666-17.074-49.062-25.604-100.272-25.604-153.606 0-23.458-19.198-42.666-42.666-42.666h-149.334c-23.468 0-42.666 19.208-42.666 42.666 0 401.062 324.272 725.334 725.332 725.334 23.46 0 42.668-19.208 42.668-42.666v-149.334c0-23.458-19.208-42.666-42.668-42.666z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-call"
    ]
  },
  {
    "paths": [
      "M638 560c0 69.588-56.412 126-126 126s-126-56.412-126-126c0-69.588 56.412-126 126-126s126 56.412 126 126z",
      "M880 192h-176l-64-64h-256l-64 64h-176c-44.184 0-80 35.816-80 80v544c0 44.184 35.816 80 80 80h736c44.184 0 80-35.816 80-80v-544c0-44.184-35.816-80-80-80zM512 784c-123.71 0-224-100.29-224-224s100.29-224 224-224 224 100.29 224 224-100.29 224-224 224z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-camera"
    ]
  },
  {
    "paths": [
      "M512 96c-230.882 0-416 185.118-416 416 0 230.872 185.118 416 416 416 230.87 0 416-185.128 416-416 0-230.882-185.128-416-416-416zM720.004 661.762l-58.24 58.234-149.764-149.762-149.762 149.762-58.242-58.234 149.766-149.762-149.766-149.762 58.242-58.232 149.762 149.756 149.762-149.756 58.24 58.232-149.764 149.762 149.766 149.762z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-cancel"
    ]
  },
  {
    "paths": [
      "M806.416 234.666c-8.542-25.604-32-42.666-59.75-42.666h-469.332c-27.75 0-51.208 17.062-59.75 42.666l-89.584 234.668v320c0 23.458 19.208 42.666 42.666 42.666h42.668c23.458 0 42.666-19.208 42.666-42.666v-21.334h512v21.334c0 23.458 19.208 42.666 42.666 42.666h42.668c23.458 0 42.666-19.208 42.666-42.666v-320l-89.584-234.668zM277.334 640c-36.25 0-64-27.73-64-64s27.75-64 64-64 64 27.732 64 64-27.75 64-64 64zM746.666 640c-36.25 0-64-27.73-64-64s27.75-64 64-64 64 27.732 64 64-27.75 64-64 64zM213.334 426.666l64-170.666h469.332l64 170.666h-597.332z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-car"
    ]
  },
  {
    "paths": [
      "M339.2 755.2c-45.764 0-83.2 37.436-83.2 83.202 0 45.764 37.436 83.2 83.2 83.2s83.202-37.436 83.202-83.2c-0.002-45.768-37.44-83.202-83.202-83.202zM96 102.4v83.2h83.2l149.766 303.364-62.616 101.908c-6.236 10.4-10.4 24.964-10.4 39.53 0 55.7 38.050 83.2 89.65 83.2h486.4v-80h-476.214c-6.236 0-10.4-4.164-10.4-10.4 0-2.072 4.414-10.4 4.414-10.4l41.564-65.6h309.908c31.202 0 58.256-16.634 72.8-43.672l149.764-257.6c2.474-4.922 4.164-12.492 4.164-20.798 0-22.892-18.728-39.53-41.6-39.53h-615.672l-39.528-83.202h-135.2zM748.798 755.2c-45.764 0-83.2 37.436-83.2 83.202 0 45.764 37.436 83.2 83.2 83.2s83.202-37.438 83.202-83.202c0-45.766-37.438-83.2-83.202-83.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-cart"
    ]
  },
  {
    "paths": [
      "M783.106 128h-667.892c-8.952 0-19.214 7.49-19.214 16.318v428.434c0 8.826 10.262 17.248 19.214 17.248h114.786v177.788l180.256-177.788h372.85c8.954 0 14.894-8.422 14.894-17.248v-428.434c0-8.828-5.942-16.318-14.894-16.318z",
      "M912.792 254h-64.792v333.14c0 31.974-13.83 52.86-50.304 52.86h-361.504l-77.81 78h259.376l180.242 178v-178h114.792c8.956 0 15.208-8.524 15.208-17.364v-428.43c0-8.828-6.252-18.206-15.208-18.206z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-chat"
    ]
  },
  {
    "paths": [
      "M810.666 128h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-597.332c0-46.938-38.396-85.334-85.334-85.334z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-checkbox-blank"
    ]
  },
  {
    "paths": [
      "M810.666 213.334v597.332h-597.332v-597.332h597.332zM810.666 128h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-597.332c0-46.938-38.396-85.334-85.334-85.334v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-checkbox-outline-blank"
    ]
  },
  {
    "paths": [
      "M337.062 430.938l-59.728 59.728 192 192 426.666-426.666-59.728-59.728-366.938 364.79-132.272-130.124zM810.666 810.666h-597.332v-597.332h426.666v-85.334h-426.666c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-341.332h-85.334v341.332z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-checkbox-outline"
    ]
  },
  {
    "paths": [
      "M810.666 128h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-597.332c0-46.938-38.396-85.334-85.334-85.334zM426.666 725.334l-213.332-213.334 59.728-59.728 153.604 153.604 324.272-324.272 59.728 59.73-384 384z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-checkbox"
    ]
  },
  {
    "paths": [
      "M341.436 432.964l-58.236 58.236 187.2 187.2 416-416-58.236-58.236-357.764 355.672-128.964-126.872zM844.8 512c0 183.036-149.766 332.8-332.8 332.8s-332.8-149.764-332.8-332.8 149.764-332.8 332.8-332.8c31.2 0 62.4 4.164 91.528 12.482l64.472-64.482c-47.836-20.8-99.836-31.2-156-31.2-228.8 0-416 187.2-416 416s187.2 416 416 416 416-187.2 416-416h-83.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-checkmark-circle"
    ]
  },
  {
    "paths": [
      "M810.666 160h-174.7c-14.208-55.208-64.324-96-123.966-96s-109.758 40.792-123.966 96h-174.7c-46.938 0-85.334 38.396-85.334 85.334v629.33c0 46.938 38.396 85.336 85.334 85.336h597.332c46.938 0 85.334-38.398 85.334-85.336v-629.33c0-46.938-38.396-85.334-85.334-85.334zM512 160c23.458 0 42.666 19.198 42.666 42.666s-19.208 42.668-42.666 42.668-42.666-19.2-42.666-42.668 19.208-42.666 42.666-42.666zM816 880h-608v-640h80v144h448v-144h80v640z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-clipboard"
    ]
  },
  {
    "paths": [
      "M810 273.596l-59.596-59.596-238.404 238.404-238.404-238.404-59.596 59.596 238.404 238.404-238.404 238.404 59.596 59.596 238.404-238.404 238.404 238.404 59.596-59.596-238.404-238.404z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-close"
    ]
  },
  {
    "paths": [
      "M512 96c-228.8 0-416 187.2-416 416s187.2 416 416 416c228.8 0 416-187.2 416-416s-187.2-416-416-416zM699.2 678.4c0 0-351.518 0-353.598 0-68.636 0-124.8-56.164-124.8-124.798 0-68.638 56.164-124.8 124.8-124.8 2.082 0 4.164 0 6.234 0 18.728-72.8 83.202-124.798 160.166-124.798 91.528 0 166.398 74.87 166.398 166.396h20.8c58.236 0 104 45.764 104 104.002 0 58.234-45.764 103.998-104 103.998z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-cloud-circle"
    ]
  },
  {
    "paths": [
      "M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998zM426.666 725.334l-149.332-149.334 59.728-59.728 89.604 89.604 221.876-221.876 59.73 59.728-281.606 281.606z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-cloud-done"
    ]
  },
  {
    "paths": [
      "M806.002 434.002c-28.008-137.998-148.006-242.002-294.002-242.002-115.996 0-215.998 65.996-265.994 162-120.002 12.004-214.006 113.996-214.006 238 0 131.992 108.008 240 240 240h520c110 0 200-90 200-200.002 0-105.994-81.994-191.998-185.998-197.996zM792 752h-520c-88.008 0-160-71.992-160-160 0-88 71.992-160 160-160h28.008c25.996-92 110-160 211.992-160 121.992 0 220 98 220 220v20h60c65.996 0 120 54.006 120 120 0 65.996-54.004 120-120 120z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-cloud-outline"
    ]
  },
  {
    "paths": [
      "M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-cloud"
    ]
  },
  {
    "paths": [
      "M512 128c-211.198 0-384 172.802-384 384 0 211.208 172.802 384 384 384 36.272 0 64-27.728 64-64 0-17.062-6.396-32-17.062-42.666-10.666-10.668-17.062-25.606-17.062-42.668 0-36.27 27.728-64 64-64h76.792c117.334 0 213.334-96 213.334-213.332-0.002-187.73-172.794-341.334-384.002-341.334zM277.334 512c-36.272 0-64-27.728-64-64s27.728-64 64-64c36.27 0 64 27.728 64 64s-27.73 64-64 64zM405.334 341.334c-36.272 0-64-27.73-64-64 0-36.272 27.728-64 64-64 36.27 0 64 27.728 64 64 0 36.27-27.73 64-64 64zM618.666 341.334c-36.27 0-64-27.73-64-64 0-36.272 27.73-64 64-64 36.272 0 64 27.728 64 64 0 36.27-27.728 64-64 64zM746.666 512c-36.27 0-64-27.728-64-64s27.73-64 64-64c36.272 0 64 27.728 64 64s-27.728 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-color-palette"
    ]
  },
  {
    "paths": [
      "M512 462.716c-26.884 0-49.286 22.4-49.286 49.284s22.4 49.286 49.286 49.286 49.286-22.4 49.286-49.286-22.402-49.284-49.286-49.284zM512 64c-246.4 0-448 201.6-448 448s201.6 448 448 448 448-201.6 448-448-201.6-448-448-448zM610.568 610.568l-367.368 170.232 170.232-367.358 367.368-170.242-170.232 367.368z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-compass"
    ]
  },
  {
    "paths": [
      "M662.16 676.41c-44.312 25.188-95.554 39.566-150.168 39.566-54.604 0-105.838-14.364-150.146-39.542-117.54 35.87-207.322 115.566-233.846 219.566h768c-26.51-104-116.292-183.738-233.84-219.59z",
      "M511.992 128c-145.742 0-263.89 118.254-263.89 264.026 0 145.774 118.148 263.944 263.89 263.944s263.89-118.17 263.89-263.944c-0-145.772-118.148-264.026-263.89-264.026zM511.992 589.972c-83.916 0-155.626-51.972-184.418-125.972h368.836c-28.792 74-100.504 125.972-184.418 125.972z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-contact"
    ]
  },
  {
    "paths": [
      "M478.416 687.874c-35.56 20.206-76.684 31.752-120.51 31.752-43.818 0-84.934-11.542-120.492-31.74-94.326 28.776-152.128 124.114-173.414 208.114h587.824c-21.278-84-79.074-179.366-173.408-208.126z",
      "M357.906 240.070c-116.958 0-211.772 94.788-211.772 211.716s94.814 211.714 211.772 211.714c116.958 0 211.772-94.788 211.772-211.714 0-116.928-94.816-211.716-211.772-211.716zM357.906 613.046c-67.342 0-124.89-45.026-147.994-101.046h295.988c-23.108 56.022-80.652 101.046-147.994 101.046z",
      "M645.204 768h314.796c-21.276-84-79.074-163.382-173.406-192.144-35.562 20.208-76.686 31.746-120.512 31.746-29.646 0-58.048-5.308-84.336-14.98-14.89 24.94-33.854 51.184-55.948 69.812 52.692 20.274 92.494 65.566 119.406 105.566z",
      "M613.090 400h200.986c-23.108 56-80.654 100.586-147.994 100.586-17.75 0-34.808-3.384-50.75-9.020-2.676 17.418-7.086 34.14-13.040 50.236 20.132 6.348 41.558 9.724 63.79 9.724 116.958 0 211.772-94.82 211.772-211.744 0-116.93-94.814-211.732-211.772-211.732-74.98 0-140.854 39.406-178.486 98.18 63.618 36.536 110.326 99.77 125.494 173.77z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-contacts"
    ]
  },
  {
    "paths": [
      "M128 742.4h153.59v153.6h102.41v-256h-256v102.4zM281.59 281.6h-153.59v102.4h256v-256h-102.41v153.6zM640 896h102.4v-153.6h153.6v-102.4h-256v256zM742.4 281.6v-153.6h-102.4v256h256v-102.4h-153.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-contract"
    ]
  },
  {
    "paths": [
      "M128 736v160h160l471.454-471.458-159.998-159.996-471.456 471.454zM883.204 300.796c17.062-17.062 17.062-42.668 0-59.73l-100.27-100.27c-17.062-17.062-42.668-17.062-59.73 0l-78.936 78.938 159.998 159.996 78.938-78.934z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-create"
    ]
  },
  {
    "paths": [
      "M256 810.858c0 46.834 38.396 85.142 85.334 85.142h341.334c46.936 0 85.332-38.308 85.332-85.142v-490.858h-512v490.858zM832 192h-160l-53.57-64h-212.858l-53.572 64h-160v64h640v-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-delete"
    ]
  },
  {
    "paths": [
      "M874.666 64h-725.332c-46.938 0-85.334 38.394-85.334 85.332v565.334c0 46.938 38.396 85.334 85.334 85.334h277.332l-85.332 96v64h341.332v-64l-85.332-96h277.332c46.938 0 85.334-38.396 85.334-85.334v-565.334c0-46.938-38.396-85.332-85.334-85.332zM874.666 640h-725.332v-490.668h725.332v490.668z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-desktop"
    ]
  },
  {
    "paths": [
      "M576 96h-304c-44.184 0-80 35.816-80 80v672c0 44.184 35.816 80 80 80h480c44.184 0 80-35.816 80-80v-496l-256-256zM544 384v-224l224 224h-224z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-document"
    ]
  },
  {
    "paths": [
      "M775.162 279.424l-61.652-61.424-279.684 278.638 61.662 61.438 279.674-278.652zM962.344 218l-466.856 462.938-182.78-182.102-61.654 61.43 244.434 245.734 528.512-526.576-61.656-61.424zM0 560.266l246.642 245.734 61.658-61.426-244.432-245.738-63.868 61.43z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-done-all"
    ]
  },
  {
    "paths": [
      "M372.602 679.786l-180.602-180.864-64 61.014 244.602 244.064 523.398-522.988-64-61.012z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-done"
    ]
  },
  {
    "paths": [
      "M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998zM448 536v-152h128v152h136l-200 200-200-200h136z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-download"
    ]
  },
  {
    "paths": [
      "M960 403.334c0-29.866-14.938-57.606-40.542-72.532l-407.458-202.802-407.458 202.802c-23.48 14.926-40.542 42.666-40.542 72.532v407.332c0 46.938 38.394 85.334 85.332 85.334h725.336c46.938 0 85.332-38.396 85.332-85.334v-407.332zM512 608l-342.738-224 342.738-170.666 342.738 170.666-342.738 224z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-drafts"
    ]
  },
  {
    "paths": [
      "M430.938 665.604l59.726 59.728 213.336-213.332-213.336-213.334-59.726 59.73 110.938 110.938h-413.876v85.332h411.728l-108.79 110.938zM810.668 128h-597.336c-46.936 0-85.332 38.396-85.332 85.332v170.668h85.332v-170.666h597.336v597.336h-597.336v-170.67h-85.332v170.668c0 46.936 38.396 85.332 85.332 85.332h597.336c46.936 0 85.332-38.396 85.332-85.332v-597.336c0-46.936-38.396-85.332-85.332-85.332z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-exit"
    ]
  },
  {
    "paths": [
      "M793.59 793.6h-153.59v102.4h256v-256h-102.41z",
      "M793.6 230.41v153.59h102.4v-256h-256v102.41z",
      "M230.41 230.4h153.59v-102.4h-256v256h102.41z",
      "M230.4 793.59v-153.59h-102.4v256h256v-102.41z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-expand"
    ]
  },
  {
    "paths": [
      "M699.2 128c-72.8 0-141.436 33.484-187.2 87.894-45.766-54.41-114.4-87.894-187.2-87.894-128.964 0-228.8 100.442-228.8 230.19 0 159.032 141.436 286.696 355.672 483.388l60.328 54.422 60.328-54.422c214.234-196.694 355.672-324.358 355.672-483.388 0-129.748-99.836-230.19-228.8-230.19zM537.672 786.514l-8.438 7.746-17.234 15.546-17.232-15.544-8.428-7.738c-100.836-92.564-187.922-172.508-245.492-243.988-55.914-69.426-80.848-126.28-80.848-184.346 0-45.73 16.844-87.862 47.43-118.632 30.484-30.668 72.166-47.558 117.37-47.558 52.268 0 103.94 24.334 138.22 65.090l48.98 58.232 48.978-58.232c34.282-40.756 85.952-65.090 138.222-65.090 45.206 0 86.886 16.89 117.372 47.556 30.584 30.772 47.428 72.902 47.428 118.634 0 58.066-24.934 114.918-80.844 184.342-57.568 71.48-144.65 151.418-245.484 243.982z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-favorite-outline"
    ]
  },
  {
    "paths": [
      "M512 896l-60.328-54.422c-214.236-196.694-355.672-324.358-355.672-483.388 0-129.748 99.836-230.19 228.8-230.19 72.798 0 141.434 33.484 187.2 87.894 45.764-54.41 114.398-87.894 187.2-87.894 128.964 0 228.8 100.442 228.8 230.19 0 159.032-141.438 286.696-355.672 483.388l-60.328 54.422z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-favorite"
    ]
  },
  {
    "paths": [
      "M752 128v85.334h-80v-85.334h-320v85.334h-80v-85.334h-80v768h80v-85.332h80v85.332h320v-85.332h80v85.332h80v-768h-80zM352 725.334h-80v-85.334h80v85.334zM352 554.668h-80v-85.334h80v85.334zM352 384h-80v-85.332h80v85.332zM752 725.334h-80v-85.334h80v85.334zM752 554.668h-80v-85.334h80v85.334zM752 384h-80v-85.332h80v85.332z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-film"
    ]
  },
  {
    "paths": [
      "M874.668 288h-362.656l-85.336-96h-277.344c-46.938 0-85.332 38.396-85.332 85.334v469.332c0 46.938 38.394 85.334 85.332 85.334h725.336c46.938 0 85.332-38.396 85.332-85.334v-373.332c0-46.938-38.394-85.334-85.332-85.334zM896 746.666c0 11.564-9.77 21.334-21.332 21.334h-725.336c-11.564 0-21.332-9.77-21.332-21.334v-394.666h746.668c11.562 0 21.332 9.77 21.332 21.334v373.332z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-folder-open"
    ]
  },
  {
    "paths": [
      "M426.676 192h-277.344c-46.938 0-85.332 38.396-85.332 85.334v469.332c0 46.938 38.394 85.334 85.332 85.334h725.336c46.938 0 85.332-38.396 85.332-85.334v-373.332c0-46.938-38.394-85.334-85.332-85.334h-362.656l-85.336-96z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-folder"
    ]
  },
  {
    "paths": [
      "M416 800h192v-95.988h-192v95.988zM64 224v95.988h896v-95.988h-896zM224 561.566h576v-99.11h-576v99.11z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-funnel"
    ]
  },
  {
    "paths": [
      "M512 96c-229.752 0-416 186.25-416 416s186.248 416 416 416c229.75 0 416-186.25 416-416s-186.25-416-416-416zM468.902 865.998c-78.928-9.452-151.956-44.784-209.038-101.864-67.348-67.348-104.436-156.89-104.436-252.134 0-85.74 30.072-166.848 85.202-231.318 1.42 17.034 4.926 35.296 4.028 48.35-3.28 47.59-7.976 77.374 19.88 117.524 10.852 15.638 13.518 38.056 18.8 56.156 5.166 17.708 25.804 26.996 40.038 37.906 28.718 22.018 56.192 47.61 86.644 66.988 20.098 12.79 32.652 19.152 26.766 43.678-4.734 19.724-6.056 31.874-16.26 49.446-3.114 5.362 11.754 39.836 16.702 44.784 14.996 14.994 29.876 28.75 46.222 42.25 25.342 20.938-2.462 48.144-14.548 78.234zM764.134 764.134c-51.266 51.266-115.398 84.972-185.112 98.162 9.88-24.432 27.472-46.14 43.79-58.724 14.194-10.952 31.972-32.018 39.386-48.704 7.408-16.664 17.222-31.11 27.154-46.434 14.13-21.798-34.838-54.672-50.706-61.562-35.708-15.502-62.588-36.42-94.322-58.75-22.61-15.908-68.514 8.308-94.040-2.834-34.962-15.266-63.766-41.792-94.156-64.678-31.36-23.618-29.844-51.152-29.844-85.994 24.564 0.906 59.508-6.798 75.816 12.956 5.146 6.234 22.84 34.084 34.684 24.188 9.676-8.086-7.17-40.498-10.424-48.118-10.010-23.43 22.808-32.568 39.606-48.456 21.92-20.728 68.94-53.236 65.224-68.094s-47.048-56.954-72.498-50.386c-3.814 0.984-37.394 36.194-43.882 41.718 0.172-11.492 0.344-22.982 0.52-34.474 0.11-7.256-13.536-14.704-12.902-19.384 1.6-11.828 34.524-33.294 42.714-42.714-5.738-3.586-25.318-20.404-31.244-17.936-14.348 5.98-30.552 10.1-44.9 16.078 0-4.976-0.604-9.65-1.324-14.266 28.752-12.73 59.174-21.582 90.62-26.304l28.168 11.32 19.888 23.602 19.848 20.466 17.35 5.59 27.558-25.99-7.106-18.554v-16.678c54.5 7.916 105.968 28.248 151.044 59.6-8.064 0.722-16.926 1.908-26.924 3.18-4.13-2.44-9.428-3.548-13.93-5.246 13.062 28.084 26.686 55.78 40.528 83.492 14.786 29.602 47.586 61.354 53.346 92.602 6.788 36.832 2.078 70.288 5.792 113.622 3.576 41.73 47.048 89.144 47.048 89.144s20.074 6.838 36.768 4.456c-15.562 61.566-47.466 118.028-93.538 164.104z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-globe"
    ]
  },
  {
    "paths": [
      "M901.358 547c-29.17-29.154-72.108-31.78-101.278-2.624l-83.374 83.328c-21.704 21.672-47.86 21.718-63.128 3.704-10.114-11.936-6.122-48.748-3.288-72.098l41.814-343.698c3.734-30.706-18.14-60.37-48.86-64.102-30.716-3.734-58.644 19.878-62.382 50.578l-46.122 269.954c-2.41 6.716-7.58 7.876-8.162-1.164l-15.698-350.878c0-30.93-25.084-56-56.028-56-30.946 0-56.030 25.070-56.030 56l-1.104 353.504c0.292 4.080-3.208 5.248-3.84 0.588l-49.846-275.938c-5.5-30.438-34.646-52.406-65.096-46.906-30.454 5.496-50.678 36.374-45.182 66.806l44.386 322.91c0.046 5.744-1.882 9.026-4.616 1.662l-66.218-177.034c-10.36-29.144-42.392-46.13-71.552-35.778-29.158 10.354-44.402 44.122-34.046 73.262l116.084 379.25c0.606 2.092 1.248 4.17 1.906 6.236l0.242 0.78c0.022 0.062 0.050 0.116 0.070 0.176 32.148 98.948 125.13 170.482 234.844 170.482 70.232 0 143.182-24.756 198.714-67.344 0.002 0 0.006-0.004 0.006-0.004 59.98-36.102 252.142-242.694 252.142-242.694 29.174-29.154 24.816-73.798-4.358-102.958z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-hand"
    ]
  },
  {
    "paths": [
      "M512 96c-194.642 0-352 154.228-352 344.974 0 190.76 157.358 344.974 352 344.974v142.052c200.85-95.378 352-304.39 352-487.026 0-190.746-157.358-344.974-352-344.974zM492 461.266l-42.114 80.734h-62.126l41.424-80h-61.184v-122h124v121.266zM656 461.266l-40.464 80.734h-62.126l41.408-80h-62.818v-122h124v121.266z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-hangout"
    ]
  },
  {
    "paths": [
      "M512 96c-230.874 0-416 187.2-416 416s185.126 416 416 416 416-187.2 416-416c0-228.8-187.198-416-416-416zM512 844.8c-183.036 0-332.808-149.766-332.808-332.8 0-183.036 149.774-332.8 332.808-332.8s332.808 149.764 332.808 332.8c0 183.036-149.772 332.8-332.808 332.8zM657.6 470.4c35.366 0 62.402-27.036 62.402-62.4s-27.038-62.4-62.402-62.4c-35.364 0-62.4 27.036-62.4 62.4s27.036 62.4 62.4 62.4zM366.4 470.4c35.364 0 62.4-27.036 62.4-62.4s-27.038-62.4-62.4-62.4c-35.366 0-62.402 27.036-62.402 62.4s27.038 62.4 62.402 62.4zM512 740.8c97.766 0 178.872-60.328 212.162-145.602h-424.324c33.29 85.274 114.396 145.602 212.162 145.602z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-happy"
    ]
  },
  {
    "paths": [
      "M416 896v-256h192v256h195.2v-384h124.8l-416-384-416 384h124.8v384z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-home"
    ]
  },
  {
    "paths": [
      "M896 810.666v-597.332c0-46.938-38.396-85.334-85.334-85.334h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334zM362.666 576l106.668 128 149.332-192 192 256h-597.332l149.332-192z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-image"
    ]
  },
  {
    "paths": [
      "M874.668 832c46.938 0 85.332-38.394 85.332-85.332v-533.332c0-46.938-38.394-85.336-85.332-85.336h-725.336c-46.938 0-85.332 38.398-85.332 85.336v533.332c0 46.938 38.394 85.332 85.332 85.332h-149.332c0 46.938 128 64 192 64h640c64 0 192-17.062 192-64h-149.332zM149.332 213.336h725.336v543.996h-725.336v-543.996zM512 869.332c-23.458 0-42.666-19.208-42.666-42.668 0-23.458 19.208-42.664 42.666-42.664s42.666 19.208 42.666 42.664c0 23.46-19.208 42.668-42.666 42.668z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-laptop"
    ]
  },
  {
    "paths": [
      "M816 128h-608c-44.182 0-80 35.816-80 80v608c0 44.184 35.818 80 80 80h608c44.184 0 80-35.816 80-80v-608c0-44.184-35.816-80-80-80zM608 736h-320v-96h320v96zM736 560h-448v-96h448v96zM736 384h-448v-96h448v96z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-list"
    ]
  },
  {
    "paths": [
      "M512 352c-88.008 0-160.002 72-160.002 160 0 88.008 71.994 160 160.002 160 88.010 0 159.998-71.992 159.998-160 0-88-71.988-160-159.998-160zM893.876 469.334c-19.21-177.062-162.148-320-339.21-339.198v-66.136h-85.332v66.134c-177.062 19.198-320 162.136-339.208 339.198h-66.126v85.334h66.124c19.208 177.062 162.144 320 339.208 339.208v66.126h85.332v-66.124c177.062-19.208 320-162.146 339.21-339.208h66.126v-85.334h-66.124zM512 810.666c-164.274 0-298.668-134.396-298.668-298.666 0-164.272 134.394-298.666 298.668-298.666 164.27 0 298.664 134.396 298.664 298.666s-134.394 298.666-298.664 298.666z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-locate"
    ]
  },
  {
    "paths": [
      "M752 372h-40v-80c0-110-90-200-200-200s-200 90-200 200v80h-40c-44.004 0-80 35.996-80 80v400c0 44.004 35.996 80 80 80h480c44.004 0 80-35.996 80-80v-400c0-44.004-35.996-80-80-80zM512 736c-44.004 0-80-35.996-80-80s35.996-80 80-80 80 35.996 80 80-35.996 80-80 80zM636.004 372h-248.008v-80c0-68.008 56.006-124.004 124.004-124.004 68.008 0 124.004 55.996 124.004 124.004v80z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-lock"
    ]
  },
  {
    "paths": [
      "M874.664 160h-725.328c-46.938 0-85.336 38.396-85.336 85.334v533.332c0 46.938 38.398 85.334 85.336 85.334h725.328c46.938 0 85.336-38.396 85.336-85.334v-533.332c0-46.938-38.398-85.334-85.336-85.334zM864 341.334l-352 234.666-352-234.666v-85.334l352 234.666 352-234.666v85.334z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-mail"
    ]
  },
  {
    "paths": [
      "M874.666 128c-4.352 0-8.792 2.738-18.352 6.414s-216.314 83.19-216.314 83.19l-256-89.604-241.062 81.062c-8.544 2.146-14.938 10.666-14.938 21.332v644.272c0 12.792 8.542 21.334 21.332 21.334 3.656 0 13.010-4.66 18.174-6.638s216.494-82.968 216.494-82.968l256 89.606 241.062-81.062c8.542-2.146 14.938-10.668 14.938-21.334v-644.272c0-12.79-8.542-21.332-21.334-21.332zM640 810.666l-256-89.604v-507.73l256 89.606v507.728z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-map"
    ]
  },
  {
    "paths": [
      "M128 768h768v-85.332h-768v85.332zM128 554.668h768v-85.334h-768v85.334zM128 256v85.33h768v-85.33h-768z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-menu"
    ]
  },
  {
    "paths": [
      "M735.902 709.308l-361.902-361.226v0.692l-221.776-221.712-48.382 48.082 270.158 269.796v57.632c0 75.58 62.242 137.428 137.82 137.428 17.22 0 33.904-3.24 49.13-9.090l64.778 64.548c-34.666 17.586-73.624 27.72-113.564 27.72-125.972 0-242.73-97.18-242.73-233.18h-77.888c0 154.002 124.454 285.404 274.454 306.028v163.974h92v-163.974c44-6.704 86.132-22.444 123.254-45.244l190.556 190.156 48.066-48-67.694-67.57-116.432-115.918 116.448 115.918-116.296-116.060z",
      "M650 502.572v-301.144c0-75.58-62.418-137.428-138-137.428s-138 61.848-138 137.428v50.488l274.218 273.936c1.34-7.582 1.782-15.358 1.782-23.28z",
      "M832.878 490h-77.882c0 40.992-10.996 79.352-29.862 112.394l55.144 55.032c33.046-48.22 52.6-105.574 52.6-167.426z",
      "M919.998 892.854l-67.794-67.486 67.71 67.57z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-microphone-off"
    ]
  },
  {
    "paths": [
      "M512 640c75.424 0 137.142-61.848 137.142-137.428v-301.144c0-75.58-61.718-137.428-137.142-137.428s-137.142 61.848-137.142 137.428v301.144c0 75.58 61.718 137.428 137.142 137.428zM754.278 489.096c0 137.428-116.564 233.63-242.278 233.63s-242.278-96.204-242.278-233.63h-77.722c0 155.746 123.438 286.306 274.288 306.93v163.974h91.426v-163.974c150.848-22.904 274.286-151.184 274.286-306.93h-77.722z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-microphone"
    ]
  },
  {
    "paths": [
      "M272 432c-44.004 0-80 35.996-80 80s35.996 80 80 80 80-35.996 80-80-35.996-80-80-80zM752 432c-44.004 0-80 35.996-80 80s35.996 80 80 80 80-35.996 80-80-35.996-80-80-80zM512 432c-44.004 0-80 35.996-80 80s35.996 80 80 80 80-35.996 80-80-35.996-80-80-80z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-more-horizontal"
    ]
  },
  {
    "paths": [
      "M592 272c0-44.004-35.996-80-80-80s-80 35.996-80 80 35.996 80 80 80 80-35.996 80-80zM592 752c0-44.004-35.996-80-80-80s-80 35.996-80 80 35.996 80 80 80 80-35.996 80-80zM592 512c0-44.004-35.996-80-80-80s-80 35.996-80 80 35.996 80 80 80 80-35.996 80-80z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-more-vertical"
    ]
  },
  {
    "paths": [
      "M512 128l-320 738.124 29.876 29.876 290.124-128 290.124 128 29.876-29.876z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-navigate"
    ]
  },
  {
    "paths": [
      "M514 240.942c14.166 0 47.822 8.958 47.822 8.958 91.178 20.894 155.356 104.878 155.356 199.7v255.224l34.218 34.374h-478.792l34.218-34.374v-255.224c0-94.82 64.178-178.806 155.356-199.7 0 0 36.086-8.958 47.822-8.958zM512 96c-35.204 0-62.118 27.036-62.118 62.4v29.118c-118.030 27.046-207.060 135.202-207.060 262.082v228.8l-82.822 83.2v41.6h704v-41.6l-82.822-83.2v-228.8c0-126.88-89.032-235.036-207.060-262.082v-29.118c0-35.364-26.914-62.4-62.118-62.4v0zM594.822 844.8h-165.646c0 45.762 37.266 83.2 82.824 83.2s82.822-37.438 82.822-83.2v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-notifications-none"
    ]
  },
  {
    "paths": [
      "M512 927.312c45.628 0 82.95-37.312 82.95-83.312h-165.9c-0 46 37.322 83.312 82.95 83.312z",
      "M262.166 214.344l0.106 0.148-66.092-65.938-48.172 48.212 126.084 126.306c-20.316 37.97-32.092 81.32-32.092 127.068v229.11l-82 83.312v41.438h595.486l72.364 72.66 48.158-48.602-24.208-24.058h0.632l-590.266-589.656z",
      "M782 450.14c0-127.052-90-235.354-208-262.436v-29.156c0-35.412-26.742-62.486-62-62.486-35.256 0-62 27.074-62 62.486v29.156c-30 6.876-58.096 19.002-83.5 35.326l415.5 415.68v-188.57z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-notifications-off"
    ]
  },
  {
    "paths": [
      "M512 928c45.558 0 82.822-37.438 82.822-83.2h-165.646c-0 45.762 37.266 83.2 82.824 83.2zM781.178 678.4v-228.8c0-126.88-89.032-235.036-207.060-262.082v-29.118c0-35.364-26.914-62.4-62.118-62.4s-62.118 27.036-62.118 62.4v29.118c-118.030 27.046-207.060 135.202-207.060 262.082v228.8l-82.822 83.2v41.6h704v-41.6l-82.822-83.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-notifications"
    ]
  },
  {
    "paths": [
      "M810.68 810.664h-597.36v-597.328h266.68v-85.336h-266.68c-46.938 0-85.32 38.394-85.32 85.336v597.328c0 46.942 38.382 85.336 85.32 85.336h597.36c46.938 0 85.32-38.394 85.32-85.336v-266.664h-85.32v266.664zM576 128v85.336h174.948l-430.95 430.93 59.732 59.732 430.952-430.94v174.942h85.318v-320h-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-open"
    ]
  },
  {
    "paths": [
      "M64 768h544v64h-544v-64z",
      "M800 768h160v64h-160v-64z",
      "M768 895c0 35.898-28.654 65-64 65v0c-35.346 0-64-29.102-64-65v-190c0-35.898 28.654-65 64-65v0c35.346 0 64 29.102 64 65v190z",
      "M64 480h160v64h-160v-64z",
      "M416 480h544v64h-544v-64z",
      "M384 607c0 35.898-28.654 65-64 65v0c-35.346 0-64-29.102-64-65v-190c0-35.898 28.654-65 64-65v0c35.346 0 64 29.102 64 65v190z",
      "M64 192h544v64h-544v-64z",
      "M800 192h160v64h-160v-64z",
      "M768 319c0 35.898-28.654 65-64 65v0c-35.346 0-64-29.102-64-65v-190c0-35.898 28.654-65 64-65v0c35.346 0 64 29.102 64 65v190z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-options"
    ]
  },
  {
    "paths": [
      "M674.908 464c67.198 0 122.184-54.004 122.184-120 0-65.994-54.986-120-122.184-120s-122.18 54.006-122.18 120c-0 65.996 54.982 120 122.18 120zM349.092 464c67.198 0 122.18-54.004 122.18-120 0-65.994-54.982-120-122.18-120s-122.184 54.006-122.184 120c0 65.996 54.986 120 122.184 120zM349.092 552c-95.716 0-285.092 45.996-285.092 140v108h576v-108c0-94.004-195.198-140-290.908-140zM674.908 574.006c-12.21 0-20.65 0-34.908 1.994 46.852 34.004 64 56 64 116v108h256v-108c0-94.004-189.376-117.994-285.092-117.994z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-people"
    ]
  },
  {
    "paths": [
      "M608 512c105.61 0 192-86.402 192-192s-86.39-192-192-192-192 86.402-192 192 86.39 192 192 192zM608 608c-127.196 0-384 64.804-384 192v96h768v-96c0-127.196-256.804-192-384-192z",
      "M224 448v-128h-64v128h-128v64h128v128h64v-128h128v-64h-128z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-person-add"
    ]
  },
  {
    "paths": [
      "M512 512c105.61 0 192-86.402 192-192s-86.39-192-192-192-192 86.402-192 192 86.39 192 192 192zM512 608c-127.196 0-384 64.804-384 192v96h768v-96c0-127.196-256.804-192-384-192z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-person"
    ]
  },
  {
    "paths": [
      "M960 717.712v-411.426c0-45.262-36.652-82.286-81.456-82.286h-733.088c-44.804 0-81.456 37.024-81.456 82.286v411.426c0 45.264 36.652 82.288 81.456 82.288h733.090c44.802 0 81.454-37.024 81.454-82.288zM224 728v-432h576v432h-576z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-phone-landscape"
    ]
  },
  {
    "paths": [
      "M717.712 64h-411.426c-45.262 0-82.286 36.652-82.286 81.456v733.090c0 44.802 37.024 81.454 82.286 81.454h411.426c45.264 0 82.288-36.652 82.288-81.456v-733.088c0-44.804-37.024-81.456-82.288-81.456zM728 800h-432v-576h432v576z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-phone-portrait"
    ]
  },
  {
    "paths": [
      "M512 64c-176.008 0-320 141.114-320 313.602 0 235.198 320 582.398 320 582.398s320-347.2 320-582.398c0-172.488-143.992-313.602-320-313.602zM512 489.602c-63.992 0-114.288-49.29-114.288-112 0-62.714 50.294-112 114.288-112s114.288 49.286 114.288 112c0 62.71-50.296 112-114.288 112z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-pin"
    ]
  },
  {
    "paths": [
      "M896 672v-80l-320-208v-225.6c0-35.366-29.64-62.4-64-62.4-34.358 0-64 27.036-64 62.4v225.6l-320 208v80l320-96v227.204l-96 62.398v62.398l160-32 160 32v-62.398l-96-62.398v-227.204l320 96z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-plane"
    ]
  },
  {
    "paths": [
      "M928 304h-208c0-114-93.124-207.718-208-207.718s-208 93.718-208 207.718h-208c37.376 432 26 624 26 624h779.998c-0.002 0-11.376-196 26.002-624zM512 148.21c86.016 0 155.998 69.79 155.998 155.79h-311.998c0-86 69.982-155.79 156-155.79zM408 795.28v-337.546l285.998 168.774-285.998 168.772z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-playstore"
    ]
  },
  {
    "paths": [
      "M799.9 320h-575.8c-70.452 0-128.1 57.606-128.1 128v277.334h159.798v170.666h512.402v-170.666h159.8v-277.334c0-70.394-57.65-128-128.1-128zM704 832h-384v-256h384v256zM768.202 128h-512.404v160h512.402v-160z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-print"
    ]
  },
  {
    "paths": [
      "M512 96c-228.798 0-416 187.202-416 416s187.202 416 416 416 416-187.202 416-416-187.202-416-416-416zM512 844.798c-183.036 0-332.798-149.764-332.798-332.798s149.762-332.8 332.798-332.8 332.8 149.764 332.8 332.8-149.764 332.798-332.8 332.798z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-radio-button-off"
    ]
  },
  {
    "paths": [
      "M512 304c-114.4 0-208 93.6-208 208s93.6 208 208 208 208-93.6 208-208-93.6-208-208-208zM512 96c-228.798 0-416 187.202-416 416s187.202 416 416 416 416-187.202 416-416-187.202-416-416-416zM512 844.8c-183.036 0-332.8-149.766-332.8-332.8s149.764-332.8 332.8-332.8 332.8 149.764 332.8 332.8-149.764 332.8-332.8 332.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-radio-button-on"
    ]
  },
  {
    "paths": [
      "M512 776c-145.194 0-264-118.81-264-264 0-145.202 118.806-264 264-264 72.6 0 138.598 30.8 184.812 79.202l-140.812 140.798h308v-308l-103.396 103.404c-63.792-63.808-151.792-103.404-248.604-103.404-193.594 0-352 158.406-352 352s156.188 352 352 352c162.090 0 296.574-108.268 338.802-256h-93.102c-37.49 99.122-134.276 168-245.7 168z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-refresh"
    ]
  },
  {
    "paths": [
      "M512 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zM726 554h-428v-84h428v84z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-remove-circle"
    ]
  },
  {
    "paths": [
      "M192 470h640v84h-640v-84z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-remove"
    ]
  },
  {
    "paths": [
      "M329.704 559.878l123.668-120.502-305.932-295.964c-67.252 65.528-67.252 173.354 0 238.88l182.264 177.586z",
      "M624.778 483.76c67.272 29.604 160.566 8.464 227.82-59.186 82.444-80.33 99.818-196.606 34.726-257.92-62.93-63.42-182.262-46.49-264.708 33.842-69.436 67.65-91.132 158.552-60.748 221.972-95.478 95.136-423.104 414.346-423.104 414.346l60.754 59.186 299.42-291.732 299.416 291.732 60.748-59.186-299.418-291.738 65.094-61.316z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-restaurant"
    ]
  },
  {
    "paths": [
      "M512 576c-90.886 0-167.35 52.152-204.41 128h408.82c-37.060-75.848-113.524-128-204.41-128z",
      "M512 96c-230.874 0-416 187.2-416 416s185.126 416 416 416 416-187.2 416-416c0-228.8-187.198-416-416-416zM512 844.8c-183.036 0-332.808-149.766-332.808-332.8 0-183.036 149.774-332.8 332.808-332.8s332.808 149.764 332.808 332.8c0 183.036-149.772 332.8-332.808 332.8z",
      "M657.6 470.4c35.366 0 62.402-27.036 62.402-62.4s-27.038-62.4-62.402-62.4c-35.364 0-62.4 27.036-62.4 62.4s27.036 62.4 62.4 62.4z",
      "M366.4 470.4c35.364 0 62.4-27.036 62.4-62.4s-27.038-62.4-62.4-62.4c-35.366 0-62.402 27.036-62.402 62.4s27.038 62.4 62.402 62.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-sad"
    ]
  },
  {
    "paths": [
      "M675.018 610.744h-35.002l-13.142-10.972c41.582-50.464 67.844-114.108 67.844-186.514-0.002-157.994-126.926-285.258-284.448-285.258-155.366 0-282.27 127.264-282.27 285.258s126.904 285.256 284.45 285.256c70.022 0 135.662-26.334 185.982-68.016l13.122 10.974v35.102l218.806 219.426 65.64-65.828-220.982-219.428zM412.45 610.744c-109.404 0-196.926-87.774-196.926-197.486 0-109.716 87.522-197.484 196.926-197.484 109.4 0 196.924 87.768 196.924 197.484 0 109.712-87.524 197.486-196.924 197.486z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-search"
    ]
  },
  {
    "paths": [
      "M96 896l832-384-832-384v298.666l596 85.334-596 85.334z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-send"
    ]
  },
  {
    "paths": [
      "M827.934 553.6c2.12-12.47 2.12-27.036 2.12-41.6s-2.12-27.036-2.12-41.6l89.334-68.636c8.52-6.236 10.638-16.634 4.26-27.036l-85.098-143.528c-4.258-8.328-17.014-12.47-25.534-8.328l-106.372 41.602c-21.276-16.636-46.788-31.202-72.32-41.602l-14.896-110.234c-2.12-8.308-10.638-16.636-21.276-16.636h-170.196c-10.636 0-19.154 8.328-21.274 16.636l-17.016 110.234c-25.534 10.4-48.928 24.964-72.342 41.602l-106.372-41.602c-10.638-4.142-21.276 0-25.534 8.328l-85.098 143.53c-4.238 8.306-2.122 20.798 4.258 27.036l91.482 68.634c0 14.564-2.12 27.036-2.12 41.6s2.12 27.036 2.12 41.6l-89.336 68.636c-8.52 6.236-10.636 16.634-4.26 27.036l85.098 143.528c4.26 8.328 17.016 12.47 25.534 8.328l106.374-41.602c21.274 16.636 46.788 31.202 72.32 41.602l17.016 110.234c2.138 10.4 10.636 16.636 21.274 16.636h170.196c10.638 0 19.156-8.328 21.276-16.636l17.036-110.234c25.514-10.4 48.928-24.964 72.32-41.602l106.374 41.602c10.636 4.142 21.274 0 25.534-8.328l85.098-143.53c4.258-8.306 2.12-20.798-4.26-27.036l-93.6-68.634zM510.936 657.6c-82.978 0-148.92-64.47-148.92-145.6s65.942-145.6 148.92-145.6 148.922 64.47 148.922 145.6-65.944 145.6-148.922 145.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-settings"
    ]
  },
  {
    "paths": [
      "M767.644 688.854c-32.090 0-62.048 10.652-83.442 31.958l-305.914-176.84c2.142-10.656 4.284-19.186 4.284-29.838 0-10.656-2.142-19.186-4.284-29.838l301.652-174.7c23.524 21.306 53.482 34.082 87.704 34.082 70.59 0 128.356-57.532 128.356-127.84 0-70.304-57.766-127.838-128.356-127.838-70.594 0-128.358 57.534-128.358 127.84 0 10.654 2.13 19.186 4.284 29.838l-301.642 174.7c-23.534-21.308-53.482-34.082-87.712-34.082-70.592 0-126.216 57.532-126.216 127.84 0 70.306 57.754 127.84 128.356 127.84 34.23 0 64.178-12.778 87.712-34.084l303.782 176.842c-2.152 8.51-4.282 17.042-4.282 27.694 0 68.188 55.612 123.574 124.074 123.574 68.458 0 124.072-55.386 124.072-123.574 0.002-68.188-55.61-123.574-124.070-123.574z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-share-alt"
    ]
  },
  {
    "paths": [
      "M896 496l-320-304v170.668c-298.668 42.666-405.334 256-448 469.332 106.666-149.332 234.666-217.604 448-217.604v174.938l320-293.334z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-share"
    ]
  },
  {
    "paths": [
      "M916 420.818l-290.534-24.952-113.466-267.866-113.486 267.868-290.514 24.95 220.384 191.048-66.062 284.134 249.678-150.628 249.66 150.628-66.042-284.132 220.382-191.050zM545.062 690.574l-33.062-19.948-0.004-378.554 69.58 164.26 178.108 15.296-135.138 117.15 40.484 174.174-119.968-72.378z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-star-half"
    ]
  },
  {
    "paths": [
      "M916 420.818l-290.534-24.952-113.466-267.866-113.486 267.868-290.514 24.95 220.384 191.048-66.062 284.134 249.678-150.628 249.66 150.628-66.042-284.132 220.382-191.050zM545.062 690.572l-33.062-19.948-153.036 92.328 40.496-174.172-135.142-117.152 178.084-15.296 69.594-164.262 69.58 164.26 178.108 15.296-135.138 117.15 40.484 174.174-119.968-72.378z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-star-outline"
    ]
  },
  {
    "paths": [
      "M512 745.372l249.66 150.628-66.042-284.132 220.382-191.050-290.534-24.95-113.466-267.868-113.486 267.868-290.514 24.95 220.384 191.050-66.062 284.132z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-star"
    ]
  },
  {
    "paths": [
      "M464 613.334h96v-261.334h-96v261.334z",
      "M815.34 340.542l61.572-61.572-67.884-67.882-61.57 61.572c-65.024-50.546-146.72-80.66-235.458-80.66-212.078 0-384 171.922-384 384s171.922 384 384 384 384-171.922 384-384c0-88.738-30.114-170.434-80.66-235.458zM724.132 788.132c-56.664 56.664-132 87.868-212.132 87.868s-155.47-31.204-212.132-87.868c-56.664-56.662-87.868-132-87.868-212.132s31.204-155.47 87.868-212.132c56.662-56.664 132-87.868 212.132-87.868s155.468 31.204 212.132 87.868c56.664 56.662 87.868 132 87.868 212.132s-31.204 155.47-87.868 212.132z",
      "M384 64h256v96h-256v-96z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-stopwatch"
    ]
  },
  {
    "paths": [
      "M512 96c-187.728 0-352 21.336-352 170.668v426.664c0 83.208 66.124 149.332 149.334 149.332l-53.334 53.336v32h512v-32l-53.334-53.336c83.208 0 149.334-66.124 149.334-149.332v-426.664c0-149.332-164.272-170.668-352-170.668zM320 768c-36.272 0-64-27.73-64-64 0-36.274 27.728-64 64-64s64 27.726 64 64c0 36.27-27.728 64-64 64zM480 480h-224v-192h224v192zM704 768c-36.272 0-64-27.73-64-64 0-36.274 27.728-64 64-64s64 27.726 64 64c0 36.27-27.728 64-64 64zM768 480h-224v-192h224v192z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-subway"
    ]
  },
  {
    "paths": [
      "M512 320c50.998 0 99.134 20.050 135.542 56.458s56.458 84.544 56.458 135.542-20.050 99.134-56.458 135.542c-36.408 36.408-84.544 56.458-135.542 56.458s-99.134-20.050-135.542-56.458c-36.408-36.408-56.458-84.544-56.458-135.542s20.050-99.134 56.458-135.542c36.408-36.408 84.544-56.458 135.542-56.458zM554.666 64h-85.332v128h85.332v-128zM812.792 151.458l-76.792 76.812 59.728 59.73 76.812-76.792-59.748-59.75zM211.208 151.458l-59.75 59.75 76.814 76.792 59.728-59.73-76.792-76.812zM512 256c-140.792 0-256 115.208-256 256s115.208 256 256 256 256-115.208 256-256-115.208-256-256-256v0zM960 469.332h-128v85.336h128v-85.336zM192 469.332h-128v85.336h128v-85.336zM795.728 736l-59.728 59.73 76.792 76.812 59.75-59.75-76.814-76.792zM228.272 736l-76.812 76.792 59.75 59.75 76.79-76.812-59.728-59.73zM554.666 832h-85.332v128c12.792 0 85.332 0 85.332 0v-128z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-sunny"
    ]
  },
  {
    "paths": [
      "M512 186.18v-122.18l-160 162.908 160 162.912v-122.186c131.992 0 240 109.964 240 244.366 0 40.726-10 79.428-28.008 114.032l58.008 59.062c31.992-50.914 50-109.976 50-173.094 0-179.198-144.004-325.82-320-325.82zM512 756.368c-132.002 0-240-109.976-240-244.368 0-40.726 10-79.418 27.998-114.040l-57.998-59.052c-32.002 48.872-50 109.964-50 173.092 0 179.198 144.004 325.82 320 325.82v122.18l160-162.906-160-162.914v122.188z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-sync"
    ]
  },
  {
    "paths": [
      "M816 128h-624c-44.004 0-64 35.996-64 80v688l128-128h560c44.004 0 80-35.996 80-80v-480c0-44.004-35.996-80-80-80zM396.8 484h-76.8v-80h76.8v80zM550.4 484h-76.8v-80h76.8v80zM704 484h-76.8v-80h76.8v80z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-textsms"
    ]
  },
  {
    "paths": [
      "M512 86c-236.422 0-426 191.702-426 426s189.578 426 426 426 426-191.702 426-426-191.702-426-426-426zM512 852.8c-187.436 0-340.8-153.366-340.8-340.8s153.364-340.8 340.8-340.8 340.8 153.364 340.8 340.8-153.364 340.8-340.8 340.8z",
      "M533.3 299h-63.9v255.6l223.65 134.186 31.95-53.25-191.7-112.888z"
    ],
    "attrs": [
      {
        "opacity": 0.9
      },
      {
        "opacity": 0.9
      }
    ],
    "grid": 0,
    "tags": [
      "ion-android-time"
    ]
  },
  {
    "paths": [
      "M160 693.332c0 83.208 66.124 149.332 149.334 149.332l-53.334 53.336v32h512v-32l-53.334-53.336c83.208 0 149.334-66.124 149.334-149.332v-426.664c0-149.332-164.272-170.668-352-170.668s-352 21.336-352 170.668v426.664zM512 752c-44.004 0-80-35.994-80-79.998s35.996-80.002 80-80.002 80 35.998 80 80.002-35.996 79.998-80 79.998zM768 448h-512v-192h512v192z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-train"
    ]
  },
  {
    "paths": [
      "M752 372h-40v-80c0-110-90-200-200-200s-200 90-200 200h75.996c0-68.008 56.006-124.004 124.004-124.004 68.008 0 124.004 55.996 124.004 124.004h-0.004v80h-364c-44.004 0-80 35.996-80 80v400c0 44.004 35.996 80 80 80h480c44.004 0 80-35.996 80-80v-400c0-44.004-35.996-80-80-80zM512 736c-44.004 0-80-35.996-80-80s35.996-80 80-80 80 35.996 80 80-35.996 80-80 80z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-unlock"
    ]
  },
  {
    "paths": [
      "M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998zM576 552v152h-128v-152h-136l200-200 200 200h-136z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-upload"
    ]
  },
  {
    "paths": [
      "M128 384v256h170.668l213.332 223.086v-702.17l-213.332 223.084h-170.668zM704 512c0-76.798-42.666-144.814-106.666-177.726v353.272c64-30.73 106.666-98.746 106.666-175.546z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-volume-down"
    ]
  },
  {
    "paths": [
      "M128 384v256h170.668l213.332 223.086v-702.17l-213.332 223.084h-170.668z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-volume-mute"
    ]
  },
  {
    "paths": [
      "M811 512c0 45.434-9.766 88.724-27.206 127.71l63.76 63.76c31.012-56.81 48.446-122.164 48.446-191.47 0-186.512-128-344.508-298-384v89.956c124 37.308 213 155.808 213 294.044z",
      "M512 160.916l-102.042 104.96 102.042 102.038z",
      "M841.684 793.77l-659.452-659.456-48 48 180.998 180.826-16.56 20.86h-170.67v256h170.668l213.332 223.086v-303.086l189.83 189.372c-30.24 25.514-65.83 45.054-103.83 56.672v89.956c62-14.344 117.992-44.326 164.63-85.618l79.22 79.386 48-48.086-48.004-48.078-0.162 0.166z",
      "M704.376 512c0-76.798-42.376-144.814-106.376-177.726v119.64l101.602 101.602c3.108-14.038 4.774-28.608 4.774-43.516z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-volume-off"
    ]
  },
  {
    "paths": [
      "M128 384v256h170.668l213.332 223.086v-702.17l-213.332 223.084h-170.668zM704 512c0-76.798-42.666-144.814-106.666-177.726v353.272c64-30.73 106.666-98.746 106.666-175.546zM597.334 128v89.956c123.728 37.308 213.334 155.808 213.334 294.044 0 138.238-89.606 256.738-213.334 294.044v89.956c170.666-39.492 298.666-197.486 298.666-384 0-186.512-128-344.508-298.666-384z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-volume-up"
    ]
  },
  {
    "paths": [
      "M576 224c44.446 0 79.994-35.552 79.994-80 0-44.45-35.548-80-79.994-80s-80.006 35.55-80.006 80c0 44.448 35.56 80 80.006 80z",
      "M576 464h208v-80h-144l-89.604-138.666c-15.396-23.334-36.272-36.272-61.866-36.272-6.396 0-17.656 1.062-25.598 3.494l-222.932 75.444v224h80v-160l81.062-32-161.062 640h80l113.396-328.542 100.604 136.542v192h76v-256l-114.062-192 39.49-123.728 40.572 75.728z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-walk"
    ]
  },
  {
    "paths": [
      "M64 928h896l-448-832-448 832zM560 800h-96v-96h96v96zM560 640h-96v-192h96v192z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-warning"
    ]
  },
  {
    "paths": [
      "M832 512c0-102.002-48.008-192.002-121.992-250l-38.008-230h-320l-38.008 230c-73.984 57.998-121.992 147.998-121.992 250 0 101.992 48.008 191.992 121.992 250l38.008 230h320l38.008-230c73.984-58.008 121.992-148.008 121.992-250zM272 512c0-132.002 108.008-240 240-240s240 107.998 240 240c0 131.992-108.008 240-240 240s-240-108.008-240-240z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-watch"
    ]
  },
  {
    "paths": [
      "M512 457.438c-45.758 0-83.194 37.058-83.194 82.36 0 45.304 37.436 82.364 83.194 82.364 45.756 0 83.194-37.058 83.194-82.364 0-45.302-37.438-82.36-83.194-82.36zM761.6 539.796c0-135.892-112.326-247.078-249.6-247.078s-249.6 111.186-249.6 247.078c0 90.606 49.922 170.894 124.792 214.144l41.614-72.064c-49.944-28.834-83.208-80.306-83.208-142.080 0-90.59 74.866-164.716 166.402-164.716 91.542 0 166.402 74.126 166.402 164.716 0 61.774-33.266 113.246-83.208 142.080l41.614 72.064c74.866-43.248 124.792-123.538 124.792-214.144zM512 128c-228.806 0-416 185.308-416 411.796 0 152.374 83.184 284.14 208 356.204l41.598-72.064c-99.838-57.648-166.414-162.648-166.414-284.138 0-181.186 149.782-329.436 332.816-329.436s332.812 148.25 332.812 329.436c0 121.49-66.568 228.542-166.41 284.138l41.598 72.064c124.812-72.064 208-203.83 208-356.204 0-226.488-187.194-411.796-416-411.796z"
    ],
    "grid": 0,
    "tags": [
      "ion-android-wifi"
    ]
  },
  {
    "paths": [
      "M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM783.53 783.53c-72.53 72.526-168.96 112.47-271.53 112.47s-199-39.944-271.53-112.47c-72.526-72.53-112.47-168.96-112.47-271.53s39.944-199 112.47-271.53c72.53-72.526 168.96-112.47 271.53-112.47s199 39.944 271.53 112.47c72.526 72.53 112.47 168.96 112.47 271.53s-39.944 199-112.47 271.53z",
      "M400.086 212.134c-81.262 30.342-146.868 92.764-181.434 171.866h293.348l-111.914-171.866z",
      "M825.594 576c4.198-20.68 6.406-42.082 6.406-64 0-73.248-24.628-140.734-66.032-194.668l-143.968 258.668h203.594z",
      "M719.946 268.79c-55.932-47.868-128.558-76.79-207.946-76.79-15.932 0-31.588 1.182-46.896 3.43l156.6 252.57 98.242-179.21z",
      "M198.408 448c-4.2 20.68-6.408 42.082-6.408 64 0 73.278 24.648 140.788 66.082 194.732l143.918-258.732h-203.592z",
      "M623.918 811.864c81.262-30.342 146.866-92.764 181.43-171.864h-293.348l111.918 171.864z",
      "M304.092 755.242c55.926 47.848 128.536 76.758 207.908 76.758 15.938 0 31.598-1.184 46.912-3.432l-156.584-252.568-98.236 179.242z"
    ],
    "grid": 0,
    "tags": [
      "ion-aperture"
    ]
  },
  {
    "paths": [
      "M512 615.4l256-231.4h-160v-192h-192.8v192h-159.2z",
      "M930.8 594.4l-142.8-110h-84l124 123.6h-101.2c-4.6 0-8.6 2.4-10.8 5.8l-36.8 91h-335l-36.8-91c-2-3.6-6.2-5.8-10.8-5.8h-101l124.4-123.6h-84.4l-142.8 110c-21.2 12.4-31.6 38-28.2 63.2l17.4 133.8c4.6 26.2 19.4 40.6 56.2 40.6h747.6c38.2 0 51.6-15.2 56.2-40.6l17.4-133.8c3.4-25.8-7.4-50.8-28.6-63.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-archive"
    ]
  },
  {
    "paths": [
      "M513 897l384-384h-224v-384h-320v384h-224z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-down-a"
    ]
  },
  {
    "paths": [
      "M197.8 369.4l3.6 4.2 272 313c9.2 10.6 23 17.2 38.4 17.2s29.2-6.8 38.4-17.2l276.4-317.6c3.4-5 5.4-11 5.4-17.4 0-17.4-14.8-31.6-33.2-31.6v0h-573.6c-18.4 0-33.2 14.2-33.2 31.6 0 6.6 2.2 12.8 5.8 17.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-down-b"
    ]
  },
  {
    "paths": [
      "M767.2 645.4l-210 200.6c-11.6 12-27.4 18-44.8 18s-33-6-44.8-18l-210.8-200.6c-25-23.8-25-62.6 0-86.4s65.4-23.8 90.4 0l100.8 96.4v-434c0-33.8 28.6-61.2 64-61.2s64 27.4 64 61.2v434l100.8-96.4c25-23.8 65.4-23.8 90.4 0s25 62.4 0 86.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-down-c"
    ]
  },
  {
    "paths": [
      "M548 419.4l127.8-127.6-99.8-99.8h256v256l-99.8-99.8-127.6 127.8z",
      "M548 604.6l127.8 127.6-99.8 99.8h256v-256l-99.8 99.8-127.6-127.8z",
      "M476 604.6l-127.8 127.6 99.8 99.8h-256v-256l99.8 99.8 127.6-127.8z",
      "M476 419.4l-127.8-127.6 99.8-99.8h-256v256l99.8-99.8 127.6 127.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-expand"
    ]
  },
  {
    "paths": [
      "M64 768v-320l121.6 121.6 261.8-281.6 214 224 298.6-256-298.6 405.4-214-213.4-187 196.4 123.6 123.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-graph-down-left"
    ]
  },
  {
    "paths": [
      "M640 768l123.6-123.6-187-196.4-214 213.4-298.6-405.4 298.6 256 214-224 261.8 281.6 121.6-121.6v320z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-graph-down-right"
    ]
  },
  {
    "paths": [
      "M384 256l-123.6 123.6 187 196.4 214-213.4 298.6 405.4-298.6-256-214 224-261.8-281.6-121.6 121.6v-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-graph-up-left"
    ]
  },
  {
    "paths": [
      "M640 256l123.6 123.6-187 196.4-214-213.4-298.6 405.4 298.6-256 214 224 261.8-281.6 121.6 121.6v-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-graph-up-right"
    ]
  },
  {
    "paths": [
      "M129 513l384 384v-224h384v-320h-384v-224z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-left-a"
    ]
  },
  {
    "paths": [
      "M654.6 197.8l-4.2 3.6-313 272c-10.6 9.2-17.2 23-17.2 38.4s6.8 29.2 17.2 38.4l317.6 276.4c5 3.4 11 5.4 17.4 5.4 17.4 0 31.6-14.8 31.6-33.2v0-573.6c0-18.4-14.2-33.2-31.6-33.2-6.6 0-12.8 2.2-17.8 5.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-left-b"
    ]
  },
  {
    "paths": [
      "M378.6 256.8l-200.6 210c-12 11.6-18 27.4-18 44.8s6 33 18 44.8l200.6 210.8c23.8 25 62.6 25 86.4 0s23.8-65.4 0-90.4l-96.2-100.8h434c33.8 0 61.2-28.6 61.2-64s-27.4-64-61.2-64h-434l96.4-100.8c23.8-25 23.8-65.4 0-90.4-24-25-62.6-25-86.6 0z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-left-c"
    ]
  },
  {
    "paths": [
      "M960 512l-192-192v152h-216v-216h152l-192-192-192 192h152v216h-216v-152l-192 192 192 192v-152h216v216h-152l192 192 192-192h-152.4l-0.8-217 217.2 0.6v152.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-move"
    ]
  },
  {
    "paths": [
      "M576 192l99.8 99.8-127.8 127.6-256.2 256.4-99.8-99.8v256h256l-99.8-99.8 384-384 99.8 99.8v-256z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-resize"
    ]
  },
  {
    "paths": [
      "M384 192v128h496c8.8 0 16 7.2 16 16v480c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h496v-256h-384v128l-256-192 256-192z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-return-left"
    ]
  },
  {
    "paths": [
      "M896 384l-256 192v-128h-384v256h496c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-480c0-8.8 7.2-16 16-16h496v-128l256 192z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-return-right"
    ]
  },
  {
    "paths": [
      "M897 513l-384-384v224h-384v320h384v224z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-right-a"
    ]
  },
  {
    "paths": [
      "M369.4 826.2l4.2-3.6 313-272c10.6-9.2 17.2-23 17.2-38.4s-6.8-29.2-17.2-38.4l-317.6-276.4c-5-3.4-11-5.4-17.4-5.4-17.4 0-31.6 14.8-31.6 33.2v0 573.6c0 18.4 14.2 33.2 31.6 33.2 6.6 0 12.8-2.2 17.8-5.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-right-b"
    ]
  },
  {
    "paths": [
      "M645.4 256.8l200.6 210c12 11.6 18 27.4 18 44.8s-6 33-18 44.8l-200.6 210.8c-23.8 25-62.6 25-86.4 0s-23.8-65.4 0-90.4l96.4-100.8h-434c-34-0-61.4-28.6-61.4-64s27.4-64 61.2-64h434l-96.4-100.8c-23.8-25-23.8-65.4 0-90.4 24-25 62.6-25 86.6 0z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-right-c"
    ]
  },
  {
    "paths": [
      "M896 184.6l-163.8 163.6 99.8 99.8h-256v-256l99.8 99.8 163.6-163.8z",
      "M896 839.4l-163.8-163.6 99.8-99.8h-256v256l99.8-99.8 163.6 163.8z",
      "M128 839.4l163.8-163.6-99.8-99.8h256v256l-99.8-99.8-163.6 163.8z",
      "M128 184.6l163.8 163.6-99.8 99.8h256v-256l-99.8 99.8-163.6-163.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-shrink"
    ]
  },
  {
    "paths": [
      "M128 656v96c0 8.8 7.2 16 16 16h496v128l256-192-256-192v128h-496c-8.8 0-16 7.2-16 16z",
      "M896 368v-96c0-8.8-7.2-16-16-16h-496v-128l-256 192 256 192v-128h496c8.8 0 16-7.2 16-16z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-swap"
    ]
  },
  {
    "paths": [
      "M513 129l-384 384h224v384h320v-384h224z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-up-a"
    ]
  },
  {
    "paths": [
      "M826.2 654.6l-3.6-4.2-272-313c-9.2-10.6-23-17.2-38.4-17.2s-29.2 6.8-38.4 17.2l-276.4 317.6c-3.4 5-5.4 11-5.4 17.4 0 17.4 14.8 31.6 33.2 31.6v0h573.6c18.4 0 33.2-14.2 33.2-31.6 0-6.6-2.2-12.8-5.8-17.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-up-b"
    ]
  },
  {
    "paths": [
      "M256.8 378.6l210-200.6c11.6-12 27.4-18 44.8-18s33 6 44.8 18l210.8 200.6c25 23.8 25 62.6 0 86.4s-65.4 23.8-90.4 0l-100.8-96.2v434c0 33.8-28.6 61.2-64 61.2s-64-27.4-64-61.2v-434l-100.8 96.4c-25 23.8-65.4 23.8-90.4 0-25-24-25-62.6 0-86.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-arrow-up-c"
    ]
  },
  {
    "paths": [
      "M960 448l-373.656 14.974 217.032-334.974-118.494-64-172.882 352-172.352-352-118.992 64 217 334.974-373.656-14.974v128l371.074-20.132-207.774 340.132 111.938 64 172.762-352 172.762 352 111.898-64-207.734-340.132 371.074 20.132z"
    ],
    "grid": 0,
    "tags": [
      "ion-asterisk"
    ]
  },
  {
    "paths": [
      "M907.6 814.2c-47.8 50.6-104.6 87.6-170.4 110.8-65.8 23.4-135.2 35-208.2 35-69.8 0-133.4-11-190.6-33.2-57.2-22-106.2-52.8-146.6-92.2-40.6-39.4-72-86.6-94.4-141.6s-33.4-115-33.4-180c0-64.2 12.2-123.6 36.6-178.2s57.6-102 99.8-142.2c42.2-40.2 91.4-71.6 148-94.6 56.2-22.6 116.6-34 180.6-34 55.2 0 108.8 8 160.6 24 52 16 98 40.2 138.2 72.2 40.2 32.2 72.2 72.2 96.2 120.4s36 104.8 36 169.8c0 48.2-6.6 90.8-20 127.6-13.4 37-31.2 67.8-53.6 92.8s-47.8 43.6-76.6 56c-28.8 12.4-59 18.6-90.6 18.6-32.4 0-58.4-7.6-78-22.8-19.4-15.2-29.2-34.6-29.2-57.8h-6c-12.2 19.2-30.8 37.6-56 54.8s-56 26-92.6 26c-55.2 0-97.8-18-127.8-54.2s-45-83-45-141c0-33.8 5.6-67 17-100s27.6-62.2 48.6-88c21-25.6 46.2-46.4 75.4-62s61.6-23.4 97.4-23.4c30.8 0 56.8 6.4 78 19.2 21 12.8 34.8 28.6 41.4 47h1.2l9.8-48.2h108.4l-47.8 227.8c-1.6 11.2-3.8 23.6-6.6 37.4-2.8 13.6-4.2 26.4-4.2 38.6 0 13.6 2.6 25 8 34.4 5.2 9.2 15.6 13.8 31 13.8 31.6 0 57.8-16.8 78.6-50.6 20.6-33.8 31-79 31-136 0-48.2-8.2-91-24.4-128.2-16.2-37.4-38.8-68.6-67.6-94-28.8-25.2-63.2-44.4-102.8-57.2-39.8-12.8-83.2-19.2-130.2-19.2-51.2 0-98 9-140.6 27s-79 43-109 74.6c-30 31.8-53.4 69-70 112-16.8 42.8-25.2 89.2-25.2 139 0 53 8.8 100.8 26.2 143.4s42 78.8 73.6 109c31.6 30.2 69.4 53.2 113.2 69.2s92.2 24 144.8 24c65.8 0 122.4-10.4 169.8-31.4 47.4-20.8 91-49.8 130.8-86.8l67.2 72.4zM526.6 376c-19.4 0-36.6 5.6-51.2 16.8s-27 25.4-37.2 42.8c-10.2 17.2-17.8 36.4-23.2 57.2-5.2 20.8-8 41-8 60.2 0 9.6 1 19.8 3 30.8 2 10.8 6 20.8 12.2 30.2 6 9.2 14 16.8 23.8 22.8s22.8 9 39 9c22 0 40.6-5.4 56-16.2s28-24.4 37.8-41c9.8-16.4 16.8-34.4 21.4-53.6 4.4-19.2 6.6-37 6.6-53 0-12.8-1.2-25.4-3.6-38-2.4-12.4-6.6-23.6-12.8-33.8-6-10-14.4-18.2-25-24.6-10.4-6.4-23.4-9.6-38.8-9.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-at"
    ]
  },
  {
    "paths": [
      "M826.884 664.614c3.056 3.020 4.744 7.124 4.744 11.42 0 4.302-1.688 8.406-4.744 11.414l-43.646 43.81c-3.15 3.172-7.25 4.742-11.382 4.742-4.142 0-8.276-1.57-11.39-4.742l-152.46-152.922-152.46 152.922c-3.116 3.172-7.25 4.742-11.39 4.742-4.132 0-8.234-1.57-11.384-4.742l-43.648-43.81c-3.054-3.008-4.746-7.112-4.746-11.414 0-4.296 1.692-8.4 4.746-11.42l153.072-152.614-153.476-152.594c-6.292-6.306-6.292-16.546 0-22.854l43.614-43.838c3.032-3.022 7.104-4.714 11.392-4.714 4.304 0 8.378 1.694 11.382 4.714l152.896 151.066 152.894-151.066c3.008-3.022 7.082-4.714 11.386-4.714 4.286 0 8.358 1.694 11.39 4.714l43.614 43.838c6.292 6.306 6.292 16.546 0 22.854l-153.48 152.594 153.076 152.614z",
      "M997.882 187.118c-17.808-17.81-40.49-27.118-66.132-27.118h-595.75c-48.606 0-87.434 18.804-115.412 56.882l-220.588 294.994 221.528 293.982c13.808 17.71 28.848 31.402 45.98 40.834 20.258 11.156 43.302 17.308 68.492 17.308h596c52.382 0 92-44.514 92-98v-512c0-25.642-8.308-49.074-26.118-66.882zM960 766c0 17.674-10.326 34-28 34h-596c-30.334 0-48.666-13.332-64-33l-192-255 192-256.876c19-26 42.334-31.124 64-31.124h595c17.674 0 29 12.326 29 30v512z"
    ],
    "grid": 0,
    "tags": [
      "ion-backspace-outline"
    ]
  },
  {
    "paths": [
      "M997.882 187.118c-17.808-17.81-40.49-27.118-66.132-27.118h-595.75c-48.606 0-87.434 18.804-115.412 56.882l-220.588 294.994 221.528 293.982c13.808 17.71 28.848 31.402 45.98 40.834 20.258 11.156 43.302 17.308 68.492 17.308h596c52.382 0 92-44.514 92-98v-512c0-25.642-8.308-49.074-26.118-66.882zM826.884 664.614c3.056 3.020 4.744 7.124 4.744 11.42 0 4.302-1.688 8.406-4.744 11.414l-43.646 43.81c-3.15 3.172-7.25 4.742-11.382 4.742-4.142 0-8.276-1.57-11.39-4.742l-152.46-152.922-152.46 152.922c-3.116 3.172-7.25 4.742-11.39 4.742-4.132 0-8.234-1.57-11.384-4.742l-43.648-43.81c-3.054-3.008-4.746-7.112-4.746-11.414 0-4.296 1.692-8.4 4.746-11.42l153.072-152.614-153.476-152.594c-6.292-6.306-6.292-16.546 0-22.854l43.614-43.838c3.032-3.022 7.104-4.714 11.392-4.714 4.304 0 8.378 1.694 11.382 4.714l152.896 151.066 152.894-151.066c3.008-3.022 7.082-4.714 11.386-4.714 4.286 0 8.358 1.694 11.39 4.714l43.614 43.838c6.292 6.306 6.292 16.546 0 22.854l-153.48 152.594 153.076 152.614z"
    ],
    "grid": 0,
    "tags": [
      "ion-backspace"
    ]
  },
  {
    "paths": [
      "M896 320h-128v-9c0-137-110-247-247-247h-16c-137 0-249 110-249 247v9h-128l-64 640h896l-64-640zM320 311c0-101.4 83.6-183 185-183h16c101.4 0 183 81.6 183 183v9h-384v-9zM135.6 896l49.8-512h70.6v72.6c-19.2 11-32 31.8-32 55.4 0 35.4 28.6 64 64 64s64-28.6 64-64c0-23.6-12.8-44.4-32-55.4v-72.6h384v72.6c-19.2 11-32 31.8-32 55.4 0 35.4 28.6 64 64 64s64-28.6 64-64c0-23.6-12.8-44.4-32-55.4v-72.6h70.8l49.8 512h-753z"
    ],
    "grid": 0,
    "tags": [
      "ion-bag"
    ]
  },
  {
    "paths": [
      "M84.2 768h762.2c11 0 19.8-9 19.8-20v-108h73.8c11.2 0 20.2-9 20.2-20v-216c0-11-9-20-20.2-20h-74v-108c0-11-8.6-20-19.8-20h-762c-11.2 0-20.2 9-20.2 20v472c0 11 9 20 20.2 20zM514.8 320l-55.8 162h123l-200.8 222 55.8-162h-123l200.8-222z"
    ],
    "grid": 0,
    "tags": [
      "ion-battery-charging"
    ]
  },
  {
    "paths": [
      "M939.8 384h-73.8v-108c0-11-8.6-20-19.8-20h-762c-11.2 0-20.2 9-20.2 20v472c0 11 9 20 20.2 20h762.2c11 0 19.8-9 19.8-20v-108h73.8c11.2 0 20.2-9 20.2-20v-216c-0.2-11-9.2-20-20.4-20zM896 576h-94v128h-674v-384h674v128h94v128z"
    ],
    "grid": 0,
    "tags": [
      "ion-battery-empty"
    ]
  },
  {
    "paths": [
      "M939.8 384h-73.8v-108c0-11-8.6-20-19.8-20h-762c-11.2 0-20.2 9-20.2 20v472c0 11 9 20 20.2 20h762.2c11 0 19.8-9 19.8-20v-108h73.8c11.2 0 20.2-9 20.2-20v-216c-0.2-11-9.2-20-20.4-20z"
    ],
    "grid": 0,
    "tags": [
      "ion-battery-full"
    ]
  },
  {
    "paths": [
      "M939.8 384h-73.8v-108c0-11-8.6-20-19.8-20h-762c-11.2 0-20.2 9-20.2 20v472c0 11 9 20 20.2 20h762.2c11 0 19.8-9 19.8-20v-108h73.8c11.2 0 20.2-9 20.2-20v-216c-0.2-11-9.2-20-20.4-20zM896 576h-94v128h-98l-64-384h162v128h94v128z"
    ],
    "grid": 0,
    "tags": [
      "ion-battery-half"
    ]
  },
  {
    "paths": [
      "M84.2 768h762.2c11 0 19.8-9 19.8-20v-108h73.8c11.2 0 20.2-9 20.2-20v-216c0-11-9-20-20.2-20h-74v-108c0-11-8.6-20-19.8-20h-762c-11.2 0-20.2 9-20.2 20v472c0 11 9 20 20.2 20zM802 320v128h94v128h-94v128h-354l-64-384h418z"
    ],
    "grid": 0,
    "tags": [
      "ion-battery-low"
    ]
  },
  {
    "paths": [
      "M287 385v447c0 17.672 15.702 33 33.376 33h416c17.672 0 30.624-15.328 30.624-33v-447h-480zM719 688c0 8.836-7.164 16-16 16s-16-7.164-16-16v-96c0-8.836 7.164-16 16-16s16 7.164 16 16v96zM704.376 544c-8.836 0-16-7.162-16-16s7.164-16 16-16 16 7.162 16 16-7.166 16-16 16z",
      "M890.156 65h-633.28c-108.69 0-129.188 54.852-129.188 79.5 60.5 8.5 63.312 9.5 63.312 73.5 0 32 0 614 0 614 0 70.692 58.682 129 129.376 129h415.5c70.692 0 127.124-58.308 127.124-129 0 0 0-633.5 0-671 0-40.698 24.596-76.552 27.032-80.366 2.438-3.812 6-7.596 6-9.916 0-2.342-0.832-5.718-5.876-5.718zM799 161v671c0 35.84-24.886 65-59.624 65h-419c-35.234 0-65.376-29.766-65.376-65v-614c0-23.624 2.188-74.5-7.656-87.914 1.842-1.586 6.228-1.086 9.032-1.086h545.32c-1.472 0-2.696 21.598-2.696 32z"
    ],
    "grid": 0,
    "tags": [
      "ion-beaker"
    ]
  },
  {
    "paths": [
      "M832 320h-64v-32c29-7 64-48.6 64-96 0-70.6-57.4-128-128-128-32.6 0-62.2 12.2-84.8 32.2-24.8-20.2-56.4-32.2-90.8-32.2-31.6 0-60.8 10.2-84.6 27.4-19.8-17-45.8-27.4-74-27.4-34.2 0-64.8 15.2-85.6 39-23.4-24-56-39-92.2-39-70.6 0-128 57.4-128 128 0 32.4 12.2 62 32 84.6 0 0.4 0 0.8 0 1.4v108c0 53 43 96 96 96v446c0 17.6 14.4 32 32 32h512c17.6 0 32-14.4 32-32v-160h64c70.6 0 128-57.4 128-128v-192c0-70.6-57.4-128-128-128zM655.6 608c-3.2 0-6-1.2-8.6-2.8-4.4-2.8-7-8-7-13.6v-95.6c0-8.8 7.2-16 16-16s16 7.2 16 16v96.2c0 10-7.6 15.8-16.4 15.8zM670 456.8c-2.4 3.6-6 6-10.2 7-4.2 0.8-8.6 0-12-2.2-3.6-2.4-6-6-7-10.2-0.8-4.2 0-8.6 2.2-12 2.4-3.6 6-6 10.2-7 4.2-0.8 8.6 0 12 2.2 3.6 2.4 6 6 7 10.2 1 4 0.2 8.4-2.2 12zM704 320v64h-255.6c-0.2-8.6-7.2-15.6-16-15.6s-15.8 7-16 15.6h-160.4v-81.2c13-7.6 24.6-17.2 34-28.6 2.4-3 4.8-6 7-9.2 3 2.4 6 4.8 9.2 6.8 18.2 12.2 40 19.4 63.4 19.4 12.8 0 25.2-2.2 36.6-6 25.6 40.4 70.6 67.4 122 67.4 44 0 83.4-19.8 109.8-50.8 11.4-13.4 20.4-28.8 26.2-45.8h39.8v64zM765.2 210.4c-5-11-16.2-18.4-29.2-18.4h-110c0 0-17.4-1.4-17.4 16.4s-5.8 34.2-15.6 47.4c-14.6 19.8-38.2 32.8-64.8 32.8-29.8 0-55.8-16.2-69.6-40.4-3.2-5.4-5.6-11.2-7.4-17.2-0.2-1.2-0.6-2.2-0.8-3.2-4-11.8-15-20.4-28.2-20.4-7.8 0-15 3-20.4 8 0 0 0 0-0.2 0.2-4.8 4.2-10.6 7.4-16.8 9.4-4.8 1.6-10 2.4-15.4 2.4-15 0-29.4-8-37.6-17.2-20-22.8-47.4-13.6-59.4-11s-24.4 23.4-24.4 23.4c-2.2 4.2-5 8-8 11.6-11.8 13.4-29 22-48.2 22v162c-17.6 0-32-14.4-32-32v-138.6c-15.4-9-26.8-24.2-30.6-42-1-4.2-1.4-8.8-1.4-13.4 0-35.2 28.8-64 64-64 23.6 0 46.6 15.4 60.2 30.8s53.4 15.4 67.8 0c13.6-14.6 28.6-30.8 49.6-30.8 12 0 23.2 4.4 31.8 11.6 3.8 3.2 7.2 7 9.8 11.2 2.2 3.6 4 8.4 6.2 11.6 5.4 6.8 13 11 22.4 11 8.8 0 16.6-3.8 22-10 1.2-1.4 2.4-3 3.4-4.6 4-5 8.4-9.6 13.4-13.6 13.6-10.8 31-17.2 49.6-17.2 21.2 0 40.4 8.2 54.8 21.8 3.4 3.2 13.4 9 26.4 10.2 9 0.8 12.2 0.6 16.4 0 20.6-2.6 28.8-9.4 32.8-13.2 11.6-11.6 27.6-18.8 45.2-18.8 35.2 0 64 28.8 64 64 0.4 6.2-0.6 12.4-2.4 18.2zM896 640c0 35.4-28.6 64-64 64h-64v-320h64c35.4 0 64 28.6 64 64v192z",
      "M352.4 336.4c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M672.4 336.4c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
    ],
    "grid": 0,
    "tags": [
      "ion-beer"
    ]
  },
  {
    "paths": [
      "M280 287.2c-31.8 31.8-23.4 34.6-21.2 36.8s179.6 171.2 179.6 171.2 7.8 6.8 7.8 16.8v0c0 10-7.8 16.8-7.8 16.8s-177.4 169-179.6 171.2c-2.2 2.2-10.6 5 21.2 36.8s36.8 24.4 38.4 22.8l134.8-128.6c0.2-0.2 0.4-0.4 0.6-0.6s0.6-0.4 0.8-0.6c4.6-3.8 19.6-21.2 19.6-6.4 0 14.6 0 303.6 0 312.8v3.6c0 11 10.4 20.2 23.2 20.2 7 0 13.4-2.6 17.8-7v0c0 0 236.4-225.6 245.6-234.4s10-21.4 2-29.4l-167.8-160.6c0 0-8.8-8.6-8.8-16.6s8.8-16.6 8.8-16.6l167.8-160.6c8-8 7.2-20.8-2-29.4-9.2-8.8-245.6-234.4-245.6-234.4v0c-4.2-4.2-10.6-7-17.6-7-12.8 0-23.2 9.2-23.2 20.2v3.8c0 9.2 0 298.2 0 312.8 0 14.8-15-2.6-19.6-6.4-0.2-0.2-0.6-0.4-0.8-0.6s-0.4-0.4-0.6-0.6l-134.8-128.6c-2-1.8-6.8-9.2-38.6 22.6zM560 239.8c0-13.2 15 4.6 19.6 8.8l61 58.4c4.2 4 5.8 9.4 5.8 14.4s-2 11.2-5.6 14.6c-3.6 3.4-61.6 59-61.6 59-4.6 3.6-19.2 19.6-19.2 3.4 0 0 0-145.4 0-158.6zM560 625.6c0-16.4 14.4-0.4 19.2 3.4 0 0 58.2 55.6 61.8 59s5.6 9.8 5.6 14.6-1.6 10.4-5.8 14.4l-61 58.4c-4.6 4.2-19.6 22-19.6 8.8-0.2-13.2-0.2-158.6-0.2-158.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-bluetooth"
    ]
  },
  {
    "paths": [
      "M541.86 701.202c-1.422-16.362-15.132-29.202-31.86-29.202-15.27 0-28.020 10.704-31.21 25.012l-0.014-0.004-31.224 185.004c-1.006 4.504-1.552 9.182-1.552 13.988 0 35.346 28.654 64 64 64s64-28.654 64-64c0-5.798-0.786-11.41-2.23-16.754l-29.91-178.044z",
      "M611.808 710.092l-0.002-0.004-0.006 0.004z",
      "M785.75 780.522c-3.436-2.814-6.6-5.762-10.276-7.88l-127.258-95.014c-11.55-7.592-23.994-7.378-33.054 1.7-8.262 8.286-9.372 20.738-3.356 30.762l97.918 131.526c1.892 2.988 4.332 5.598 6.732 8.39 15.604 18.142 50.16 19.176 69.292-0.014 19.142-19.174 18.862-54.020 0.002-69.47z",
      "M745.022 670.036h-0.004v0.004z",
      "M870.856 644.95l-119.042-4.568c-7.782-1.116-14.8 4.106-16.13 12.022-1.208 7.222 2.694 14.276 9.336 17.632l0.026-0.078c0.082 0.038 0.124 0.012 0.21 0.050l115.434 35.512c16.578 3.86 35.312-4.686 35.312-23.296-0.002-23.568-6.168-34.89-25.146-37.274z",
      "M278.444 670.040v-0.004h-0.004z",
      "M278.418 669.958l0.026 0.078c6.642-3.358 10.544-10.41 9.336-17.632-1.33-7.916-8.35-13.136-16.13-12.022l-119.042 4.568c-18.982 2.384-24.608 13.706-24.608 37.272 0 18.612 18.196 27.156 34.774 23.296l115.434-35.512c0.084-0.038 0.128-0.012 0.21-0.048z",
      "M375.806 677.614l-127.194 94.862c-3.676 2.114-7.138 4.724-10.274 7.862-19.126 19.134-19.132 50.176-0.008 69.3 19.122 19.142 50.11 19.156 69.236 0.014 2.6-2.598 4.81-5.388 6.704-8.37l97.924-131.282c6.014-10 4.904-22.426-3.354-30.692-9.054-9.056-23.416-9.784-33.034-1.694z",
      "M704 256c0-122-144.7-192-192-192 24.034 171.106-203.334 239.334-224 384s96 192 96 192c32.666-119.792 144.772-159.994 219.334-211.334 81.332-56 100.666-108.544 100.666-172.666z",
      "M704 512c10.060-31.226 9.82-98 0-128-17.998 37-52.574 68.6-94.372 97.378-17.168 11.822-39.718 22.886-57.66 33.594-37.428 22.33-69.968 43.696-94.658 72.8 22.692 34.728 56.636 52.228 86.69 52.228 71.998 0 128-28.676 160-128z",
      "M304.074 320c23.444-31.904 49.712-50.418 76.38-76.724 26.872-26.508 44.154-44.942 54.928-66.346-21.332-42.662-55.698-53.216-83.382-48.93 4.666 60.668-59.94 93.134-64 137.314-2.454 26.686 5 46.686 16.074 54.686z"
    ],
    "grid": 0,
    "tags": [
      "ion-bonfire"
    ]
  },
  {
    "paths": [
      "M688 128h-352c-8.8 0-16 7.2-16 16v112h384v-112c0-8.8-7.2-16-16-16z",
      "M320 896l192-192 192 192v-608h-384z"
    ],
    "grid": 0,
    "tags": [
      "ion-bookmark"
    ]
  },
  {
    "paths": [
      "M447.91 424.022c0 0 16.108-9.358 39.97-14.022 42.636-8.332 78.944-11 94.932 17 19.554 34.248 36.804 106.834 32.976 171-2 33.5-9.244 44.25-9.244 44.25s-30.666 19.050-94.682 13.75c-69.45-5.75-79.942-30.008-79.942-30.008s8.994-22.61 15.99-84.998c6.994-62.388 0-116.972 0-116.972z",
      "M367.968 570c25.092-6.646 46.060-14.378 55.318-17.97 1.386-9.414 2.56-19.436 3.388-30.030 0.542-6.922 0.93-13.508 1.204-19.792-13.708-4.666-27.068-9.702-57.538-20.208-77.32-26.666-114.292-34-114.292-34s28.48-5 84.438 6c39.972 7.858 68.784 19 87.894 28.666 1.542-31.998-4.954-65.166-4.954-65.166-43.968-80.5-184.366-193.5-254.69-193.5-52.96 0-104.736 137-104.736 288s46.060 288 103.020 288c66.712 0 232.926-160 232.926-160s11.476-25.156 19.758-67.144c-37.576 10.396-127.68 17.144-127.68 17.144s41.968-11 75.944-20z",
      "M855.264 224c-72.74 0-204.726 113-248.696 193.5l-1.522 2.75c0 0 2.778 5.054 3.746 6.75 6.848 11.992 13.408 28.696 18.884 48.082 16.23-5.61 47.198-16.328 75.046-26.082 39.97-14 69.95-19 69.95-19s-105.964 47.482-139.21 68.528c4.338 20.318 7.386 42.398 8.436 64.484 10.846 4.432 33.102 12.95 59.828 19.988 37.972 10 80.796 23 80.796 23s-108.404-10.54-140.228-25.044c-0.026 5.724-0.19 11.418-0.526 17.044-1.994 33.438-9.216 44.208-9.244 44.248 15.242 21.086 150 157.752 224.456 157.752 56.96 0 103.020-137 103.020-288s-51.776-288-104.736-288z"
    ],
    "grid": 0,
    "tags": [
      "ion-bowtie"
    ]
  },
  {
    "paths": [
      "M544 544h-64v-16h-416v352c0 8.8 6.6 16 15.6 16h865c8.8 0 15.4-7.2 15.4-16v-352h-416v16z",
      "M944.4 288h-240.4v-61.4c-2-56.4-43.4-98.6-102.4-98.6h-179.2c-58.8 0-100.4 42.2-102.4 98.6v61.4h-240.4c-8.8 0-15.6 7.2-15.6 16v192h416v-16h64v16h416v-192c0-8.8-6.6-16-15.6-16zM640 232.4c0 0.6 0 1.2 0 2v53.6h-256v-53.6c0-0.8 0-1.4 0-2s0-1.2 0-2c0-19.4 17.2-38.4 37.6-38.4h180.8c20.2 0 37.6 18.8 37.6 38.4-0 0.8-0 1.4-0 2z"
    ],
    "grid": 0,
    "tags": [
      "ion-briefcase"
    ]
  },
  {
    "paths": [
      "M749.28 254.654c-58.55-77.63-143.156-126.654-237.28-126.654s-178.73 49.024-237.28 126.654c12.708 31.28 31.666 60 56.26 84.594 48.352 48.352 112.638 74.98 181.020 74.98s132.668-26.628 181.020-74.98c24.594-24.594 43.552-53.316 56.26-84.594z",
      "M253.672 285.648c-3.45 5.654-6.792 11.406-9.984 17.288-5.852-3.68-10.638-7.48-15.49-11.546-2.342-1.962-5.908-7.898-9.092-14.7 10.82-22.628 2.362-50.074-19.828-62.522-23.122-12.968-52.376-4.744-65.348 18.378-12.97 23.12-4.742 52.376 18.374 65.346 2.502 1.404 5.078 2.544 7.694 3.458 5.632 12.538 14.64 28.662 27.096 39.094 8.368 7.014 17.584 14.234 30.408 21.348-14.39 40.518-23.152 84.606-25.090 130.854-22.052 0.414-37.238 4.2-50.948 8.244-8.32 2.454-16.384 6.79-23.646 11.704-1.908-0.23-3.846-0.364-5.816-0.364-26.51 0-48 21.49-48 48s21.49 48 48 48c25.86 0 46.934-20.454 47.952-46.064 10.092-2.964 19.776-5.318 34.19-5.548 6.334 66.030 26.608 126.966 57.226 178.448-28.332 22.012-45.764 46.032-53.21 72.634 0 0-1.5 0.876-3.746 2.732-1.964 1.588-3.864 3.3-5.608 5.238-17.73 19.71-16.124 50.062 3.586 67.79 19.708 17.73 50.056 16.124 67.786-3.586 16.174-17.976 16.19-44.762 1.116-62.79 6.148-11.124 12.472-18.028 27.34-29.922 54.102 63.308 126.812 104.076 207.366 108.838v-450.256c-106.472-5.836-197.542-69.468-242.328-160.096z",
      "M912 512.228c-1.97 0-3.908 0.132-5.816 0.364-7.262-4.914-15.326-9.25-23.646-11.704-13.708-4.042-28.894-7.83-50.948-8.244-1.938-46.25-10.7-90.336-25.090-130.854 12.824-7.114 22.042-14.334 30.408-21.348 12.456-10.432 21.462-26.556 27.096-39.094 2.616-0.916 5.192-2.056 7.694-3.458 23.116-12.97 31.344-42.228 18.374-65.346-12.97-23.122-42.226-31.346-65.348-18.378-22.19 12.45-30.648 39.894-19.828 62.522-3.184 6.802-6.75 12.738-9.092 14.7-4.852 4.066-9.638 7.866-15.49 11.546-3.192-5.882-6.536-11.634-9.984-17.288-44.786 90.628-135.856 154.26-242.328 160.096v450.258c80.554-4.762 153.264-45.53 207.372-108.84 14.868 11.894 21.192 18.798 27.34 29.922-15.074 18.028-15.058 44.812 1.116 62.79 17.728 19.71 48.076 21.316 67.786 3.586 19.708-17.726 21.316-48.078 3.586-67.79-1.744-1.938-3.642-3.65-5.608-5.238-2.246-1.858-3.746-2.732-3.746-2.732-7.448-26.604-24.878-50.624-53.21-72.634 30.62-51.48 50.892-112.418 57.226-178.448 14.414 0.23 24.098 2.584 34.19 5.548 1.018 25.612 22.092 46.064 47.952 46.064 26.51 0 48-21.49 48-48s-21.496-48-48.006-48z"
    ],
    "grid": 0,
    "tags": [
      "ion-bug"
    ]
  },
  {
    "paths": [
      "M800 64h-576c-17.6 0-32 14.4-32 32v832c0 17.6 14.4 32 32 32h576c17.6 0 32-14.4 32-32v-832c0-17.6-14.4-32-32-32zM288 416h64v64h-64v-64zM288 544h64v64h-64v-64zM288 672h64v64h-64v-64zM480 864h-192v-64h192v64zM480 736h-64v-64h64v64zM480 608h-64v-64h64v64zM480 480h-64v-64h64v64zM608 864h-64v-64h64v64zM608 736h-64v-64h64v64zM608 608h-64v-64h64v64zM608 480h-64v-64h64v64zM736 864h-64v-192h64v192zM736 608h-64v-64h64v64zM736 480h-64v-64h64v64zM736 320h-448v-160h448v160z"
    ],
    "grid": 0,
    "tags": [
      "ion-calculator"
    ]
  },
  {
    "paths": [
      "M288 256c35.4 0 64-28.6 64-64v-64c0-35.4-28.6-64-64-64s-64 28.6-64 64v64c0 35.4 28.6 64 64 64z",
      "M736 256c35.4 0 64-28.6 64-64v-64c0-35.4-28.6-64-64-64s-64 28.6-64 64v64c0 35.4 28.6 64 64 64z",
      "M944 128h-112v81.4c0 45-46.4 78.6-94.4 78.6s-97.6-33.6-97.6-78.6v-81.4h-256v81.4c0 45-48 78.6-96 78.6s-96-33.6-96-78.6v-81.4h-112c-8.8 0-16 7.2-16 16v800c0 8.8 7.2 16 16 16h864c8.8 0 16-7.2 16-16v-800c0-8.8-7.2-16-16-16zM864 864h-704v-512h704v512z"
    ],
    "grid": 0,
    "tags": [
      "ion-calendar"
    ]
  },
  {
    "paths": [
      "M860.8 294h-135l-80.8-81.6c0 0-0.4-0.4-0.6-0.4l-0.4-0.4c-12-12-28.2-19.6-46.6-19.6h-168c-19.6 0-37 8.4-49.2 21.8v0.2l-79 80h-138c-37.2 0-67.2 29.2-67.2 66.4v404.2c0 37.2 30 67.4 67.2 67.4h697.6c37 0 67.2-30.2 67.2-67.4v-404.2c0-37.2-30.2-66.4-67.2-66.4zM512 731c-101.8 0-184.8-83.2-184.8-185.2 0-102.2 83-185.2 184.8-185.2 102 0 184.8 83 184.8 185.2 0 102-82.8 185.2-184.8 185.2zM848.2 401c-15.4 0-28-12.6-28-28.2s12.6-28.2 28-28.2c15.4 0 28 12.6 28 28.2s-12.6 28.2-28 28.2z",
      "M512 405.8c-77.2 0-139.6 62.6-139.6 140 0 77.2 62.4 140 139.6 140 77 0 139.6-62.6 139.6-140s-62.6-140-139.6-140z"
    ],
    "grid": 0,
    "tags": [
      "ion-camera"
    ]
  },
  {
    "paths": [
      "M904 192h-784c-31 0-55.8 25-56 56v0 528c0.4 31 25 56 56 56h784c31.2 0 56-25.4 56-56.6v0-526.8c0-31.2-24.8-56.6-56-56.6zM154.2 256h715.4c13.8 0 24.2 10.2 26.2 24v40h-767.8v-40.6c2-13.6 12.6-23.4 26.2-23.4zM869.8 768h-715.6c-13.8 0-24.2-9.8-26.2-23.4v-232.6h768v232c-2 13.8-12.6 24-26.2 24z",
      "M192 608h384v32h-384v-32z",
      "M192 672h192v32h-192v-32z",
      "M704 608h128v96h-128v-96z"
    ],
    "grid": 0,
    "tags": [
      "ion-card"
    ]
  },
  {
    "paths": [
      "M0 192v512h1024v-512h-1024zM385.016 640h-224.758c0-53.164-43.098-96.258-96.258-96.258v-159.742c70.692 0 128-57.306 128-128h193.018c-39.866 46.91-65.018 115.534-65.018 192s25.152 145.090 65.016 192zM596.178 522.496c-5.164 8.364-11.956 15.204-20.378 20.514-8.428 5.31-18.008 9.214-28.75 11.67-5.624 1.288-11.308 2.238-17.048 2.864v18.456h-36v-18.86c-5.536-0.714-10.922-1.726-16.144-3.082-11.376-2.95-21.282-7.318-29.702-13.418-8.428-6.094-15.168-13.606-20.22-23.146-4.84-9.122-7.456-21.494-7.856-31.494h39.47c0.192 6 1.656 13.064 4.402 18.368 2.946 5.706 7.052 9.766 12.32 13.4 5.144 3.56 11.064 6.164 17.726 7.838v-68.716c-4.872-1.202-10.032-2.49-15.516-3.876-9.692-2.36-17.746-5.458-24.17-9.292-6.428-3.836-11.532-8.114-15.322-12.834-3.792-4.718-6.476-9.734-8.056-15.044-1.582-5.312-2.372-10.716-2.372-16.226 0-10.62 2.372-19.81 7.112-27.582 4.736-7.766 11.004-14.208 18.796-19.324 7.79-5.112 16.638-8.896 26.54-11.358 4.308-1.068 8.638-1.89 12.988-2.496v-18.858h36v18.998c4.92 0.706 9.712 1.676 14.36 2.946 10.43 2.854 19.592 7.126 27.488 12.828 7.9 5.708 14.166 12.728 18.8 21.084 4.218 7.622 6.516 16.144 6.89 26.144h-39.732c-1.506-12-6.35-20.652-14.548-25.846-3.932-2.492-8.372-4.392-13.258-5.774v60.736c5.178 1.278 10.3 2.536 15.308 3.756 6.842 1.672 11.74 2.906 14.692 3.688 7.372 2.166 13.794 5.116 19.274 8.85 5.474 3.738 10.056 8.016 13.746 12.834 3.682 4.822 6.42 9.984 8.214 15.488 1.786 5.506 2.686 11.020 2.686 16.524 0.002 11.798-2.582 21.884-7.74 30.24zM960 543.742c-52 0-96 43.094-96 96.258h-225.018c39.866-46.91 65.018-115.534 65.018-192s-25.152-145.090-65.020-192h193.020c0 70.694 57.306 128 128 128v159.742z",
      "M256 448c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
      "M896 448c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
      "M545.786 470.42c-4.79-1.646-10.058-3.236-15.786-4.778v61.712c3.184-0.46 6.138-1.094 8.832-1.918 6.106-1.868 11.058-4.278 14.85-7.226s6.528-6.342 8.214-10.178c1.684-3.834 2.526-7.716 2.526-11.654 0-8.062-1.95-14.012-5.842-17.848-3.9-3.832-8.168-6.532-12.794-8.11z",
      "M472.008 381.918c-2.636 3.542-3.95 7.964-3.95 13.276 0 7.476 2.472 13.326 7.424 17.552 4.754 4.068 10.936 7.166 18.518 9.322v-52.712c-4.36 0.9-8.384 2.27-12.040 4.156-4.002 2.064-7.32 4.866-9.952 8.406z",
      "M0 768h1024v64h-1024v-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-cash"
    ]
  },
  {
    "paths": [
      "M248.6 800h305.4c28.8 0 28.8 0.2 42.6 10.4s171.4 117.6 171.4 117.6v-128h7.4c84.4 0 152.6-63.6 152.6-142.8v-417.8c0-79.2-68.4-143.4-152.6-143.4h-526.8c-84.2 0-152.6 64.2-152.6 143.4v417.8c0 79.2 68.4 142.8 152.6 142.8zM704.2 384c35.4 0 64 28.6 64 64s-28.6 64-64 64c-35.4 0-64-28.6-64-64s28.6-64 64-64zM512.2 384c35.4 0 64 28.6 64 64s-28.6 64-64 64c-35.4 0-64-28.6-64-64s28.6-64 64-64zM320.2 384c35.4 0 64 28.6 64 64s-28.6 64-64 64c-35.4 0-64-28.6-64-64s28.6-64 64-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-chatbox-working"
    ]
  },
  {
    "paths": [
      "M248.6 800h305.4c28.8 0 28.8 0.2 42.6 10.4s171.4 117.6 171.4 117.6v-128h7.4c84.4 0 152.6-63.6 152.6-142.8v-417.8c0-79.2-68.4-143.4-152.6-143.4h-526.8c-84.2 0-152.6 64.2-152.6 143.4v417.8c0 79.2 68.4 142.8 152.6 142.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-chatbox"
    ]
  },
  {
    "paths": [
      "M588.2 731c-5.2-3.6-14.4-9-35-9h-232.2c-69.4 0-129-52.2-129-118.4v-201.6h-3.6c-52.6 0-92.4 41-92.4 91v257.8c0 50 42.8 81.2 95.4 81.2h32.6v96l106.2-90c3.8-2.8 10.6-6 26.4-6h179.6c46 0 94.8-22.8 103.8-64l-51.8-37z",
      "M802 96h-434.6c-69.4 0-111.4 53.6-111.4 119.6v336.4c0 66.2 56 120 125.4 120h202.2c20.8 0 30 4.6 35 8.4l149.4 119.6v-128h34c69.6 0 126-53.8 126-119.8v-336.6c0-66-56.4-119.6-126-119.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-chatboxes"
    ]
  },
  {
    "paths": [
      "M512 898.8c57.8 0 112.8-11.4 162.6-31.8 1.2-0.6 2.2-1 3.4-1.4 0.2 0 0.4 0 0.4-0.2 7-2.6 14.6-4 22.4-4 8.6 0 16.8 1.6 24.2 4.8l168 61.8-44.2-176.8c0-10.6 3-20.6 7.8-29.2 0 0 0 0 0 0 1.6-2.6 3.2-5.2 5-7.4 41.8-62.6 66-137 66-216.8 0.4-222-185.8-401.8-415.6-401.8s-416 179.8-416 401.4c0 221.8 186.2 401.4 416 401.4zM704 448c35.4 0 64 28.6 64 64s-28.6 64-64 64c-35.4 0-64-28.6-64-64s28.6-64 64-64zM512 448c35.4 0 64 28.6 64 64s-28.6 64-64 64c-35.4 0-64-28.6-64-64s28.6-64 64-64zM320 448c35.4 0 64 28.6 64 64s-28.6 64-64 64c-35.4 0-64-28.6-64-64s28.6-64 64-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-chatbubble-working"
    ]
  },
  {
    "paths": [
      "M512 898.8c57.8 0 112.8-11.4 162.6-31.8 1.2-0.6 2.2-1 3.4-1.4 0.2 0 0.4 0 0.4-0.2 7-2.6 14.6-4 22.4-4 8.6 0 16.8 1.6 24.2 4.8l168 61.8-44.2-176.8c0-10.6 3-20.6 7.8-29.2 0 0 0 0 0 0 1.6-2.6 3.2-5.2 5-7.4 41.8-62.6 66-137 66-216.8 0.4-222-185.8-401.8-415.6-401.8s-416 179.8-416 401.4c0 221.8 186.2 401.4 416 401.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-chatbubble"
    ]
  },
  {
    "paths": [
      "M146.6 782c0 0 0 0 0 0 3.6 6 5.6 12.8 5.6 20.4l-24.2 125.6 112.4-44.2c5.4-2.2 11.2-3.4 17.4-3.4 5.6 0 11 1 16 2.8 0 0 0.2 0 0.4 0 0.8 0.4 1.6 0.6 2.4 1 35.6 14.6 74.8 22.8 115.8 22.8 92.6 0 175.2-41 229.6-105.2-28.2 7.2-57.8 11.4-88.2 11.4-191.8 0-347.4-150-347.4-335 0-23.6 2.6-46.4 7.4-68.6-60 52.2-97.8 127.6-97.8 211.6 0 56.8 17.2 110.4 47 155 1.2 1.6 2.4 3.8 3.6 5.8z",
      "M580.6 96c-167.4 0-307.2 114.4-340 266.4-4.8 22.2-7.4 45-7.4 68.6 0 185 155.4 335 347.4 335 30.6 0 60-4.2 88.2-11.4 16.2-4.2 32.2-9 47.6-15.2 1-0.4 1.8-0.8 2.8-1.2 0.2 0 0.4 0 0.4-0.2 5.8-2.2 12.2-3.4 18.6-3.4 7.2 0 14 1.4 20.2 4l137.2 51.6-34-147.6c0-8.8 2.4-17.2 6.6-24.4 0 0 0 0 0 0 1.2-2.2 2.8-4.2 4.2-6.2 34.8-52.2 55-114.4 55-181 0.6-185-154.8-335-346.8-335z"
    ],
    "grid": 0,
    "tags": [
      "ion-chatbubbles"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448c247.4 0 448-200.6 448-448s-200.6-448-448-448zM741.8 362.2l-278.2 357c-2.2 2.2-5.8 7-10.2 7-4.6 0-7.6-3.2-10.2-5.8s-157.8-151.8-157.8-151.8l-3-3c-1.2-1.8-2.2-4-2.2-6.4s1-4.6 2.2-6.4c0.8-0.8 1.4-1.4 2.2-2.4 15.4-16.2 46.6-49 48.6-51 2.6-2.6 4.8-6 9.6-6 5 0 8.2 4.2 10.6 6.6s90 86.6 90 86.6l222.6-286c2-1.6 4.4-2.8 7-2.8s5 1 7 2.6l61.2 48.2c1.6 2 2.6 4.4 2.6 7 0.2 2.6-0.8 4.8-2 6.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-checkmark-circled"
    ]
  },
  {
    "paths": [
      "M896 143.8c-34.6-26.8-83-18.6-108.2 18.2l-359.8 526.4-198.2-214.6c-29.2-33.2-78.2-34.8-109.4-3.6-31.2 31-32.8 83.2-3.4 116.2 0 0 240.8 267.2 275.4 294s83 18.6 108.2-18.2l412.6-603.4c25.2-37 17.4-88.4-17.2-115z"
    ],
    "grid": 0,
    "tags": [
      "ion-checkmark-round"
    ]
  },
  {
    "paths": [
      "M923.2 219.2l-109.8-86.6c-3.4-2.8-7.6-4.8-12.4-4.8s-9.2 2-12.6 5l-399.4 513.2c0 0-157-151-161.4-155.4s-10.2-11.8-19-11.8c-8.8 0-12.8 6.2-17.4 10.8-3.4 3.6-59.4 62.4-87 91.6-1.6 1.8-2.6 2.8-4 4.2-2.4 3.4-4 7.2-4 11.4 0 4.4 1.6 8 4 11.4l5.6 5.2c0 0 278.6 267.6 283.2 272.2s10.2 10.4 18.4 10.4c8 0 14.6-8.6 18.4-12.4l498.2-640c2.4-3.4 4-7.2 4-11.6 0-5-2-9.2-4.8-12.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-checkmark"
    ]
  },
  {
    "paths": [
      "M512 596.6v0 0l348.4-334.4c8.6-8.4 22.8-8.2 31.6 0.4l61.2 59.8c8.8 8.6 9 22.6 0.4 31l-425.4 408.4c-4.4 4.4-10.4 6.4-16.2 6-6 0.2-11.8-1.8-16.2-6l-425.4-408.4c-8.6-8.4-8.4-22.4 0.4-31l61.2-59.8c8.8-8.6 23-8.8 31.6-0.4l348.4 334.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-chevron-down"
    ]
  },
  {
    "paths": [
      "M427.4 512v0 0l334.4-348.2c8.4-8.6 8.2-22.8-0.4-31.6l-59.8-61.2c-8.6-8.8-22.6-9-31-0.4l-408.4 425.2c-4.4 4.4-6.4 10.4-6 16.2-0.2 6 1.8 11.8 6 16.2l408.4 425.4c8.4 8.6 22.4 8.4 31-0.4l59.8-61.2c8.6-8.8 8.8-23 0.4-31.6l-334.4-348.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-chevron-left"
    ]
  },
  {
    "paths": [
      "M596.6 512v0 0l-334.4-348.2c-8.4-8.6-8.2-22.8 0.4-31.6l59.8-61.2c8.6-8.8 22.6-9 31-0.4l408.4 425.4c4.4 4.4 6.4 10.4 6 16.2 0.2 6-1.8 11.8-6 16.2l-408.4 425.2c-8.4 8.6-22.4 8.4-31-0.4l-59.8-61.2c-8.6-8.8-8.8-23-0.4-31.6l334.4-348.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-chevron-right"
    ]
  },
  {
    "paths": [
      "M512 427.4v0 0l348.4 334.4c8.6 8.4 22.8 8.2 31.6-0.4l61.2-59.8c8.8-8.6 9-22.6 0.4-31l-425.4-408.4c-4.4-4.4-10.4-6.4-16.2-6-6-0.2-11.8 1.8-16.2 6l-425.4 408.4c-8.6 8.4-8.4 22.4 0.4 31l61.2 59.8c8.8 8.6 23 8.8 31.6 0.4l348.4-334.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-chevron-up"
    ]
  },
  {
    "paths": [
      "M322 321h384c-3.376-40-19.458-70.9-55.842-80.712-0.892-0.238-2.24-0.848-3.134-1.082-24.008-6.848-42.024-15.306-42.024-41.562v-41.19c0-51.072-41.048-92.454-92.020-92.454-50.932 0-91.98 41.382-91.98 92.454v41.19c0 26.256-17.184 34.338-41.194 41.186-0.894 0.234-1.6 1.22-2.532 1.458-36.382 9.812-51.42 40.712-55.274 80.712zM513.98 128.79c15.23 0 27.582 12.39 27.582 27.664 0 15.308-12.352 27.7-27.582 27.7-15.228 0-27.544-12.39-27.544-27.7-0-15.274 12.316-27.664 27.544-27.664z",
      "M811.222 127h-148.222v27.976c0 21.166 18.386 38.024 39.014 38.024h74.424c13.334 0 24.198 10.87 24.88 24.39l0.17 654.2c-0.644 12.864-10.606 23.092-23.028 24.034l-528.836 0.062c-12.422-0.942-22.298-11.39-22.944-24.252l-0.17-654.028c0.644-13.522 11.716-24.406 25.012-24.406h74.462c20.626 0 37.014-16.858 37.014-38.024v-27.976h-146.262c-30.236 0-55.736 25.116-55.736 56.15v720.76c0 31.004 25.5 57.090 55.738 57.090h594.484c30.276 0 53.778-26.086 53.778-57.090v-720.76c0-31.034-23.502-56.15-53.778-56.15z",
      "M289 385h224v64h-224v-64z",
      "M289 769h320v64h-320v-64z",
      "M289 641h258v64h-258v-64z",
      "M289 513h416v64h-416v-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-clipboard"
    ]
  },
  {
    "paths": [
      "M511.976 64c-247.406 0-447.976 200.596-447.976 448 0 247.43 200.57 448 447.976 448 247.43 0 448.024-200.57 448.024-448 0-247.404-200.594-448-448.024-448zM783.522 783.53c-20.198 20.196-42.252 37.856-65.772 52.84l-31.892-55.24-27.712 16 31.91 55.272c-49.676 26.060-104.744 40.91-162.054 43.248v-63.65h-32v63.65c-57.312-2.332-112.382-17.18-162.060-43.24l31.916-55.282-27.712-16-31.898 55.25c-23.522-14.984-45.58-32.648-65.778-52.848-20.198-20.198-37.86-42.254-52.844-65.778l55.248-31.898-16-27.71-55.282 31.916c-26.060-49.678-40.908-104.748-43.242-162.060h63.65v-32h-63.65c2.334-57.31 17.184-112.38 43.246-162.058l55.276 31.916 16-27.712-55.246-31.896c14.984-23.52 32.644-45.574 52.838-65.77 20.2-20.202 42.258-37.866 65.78-52.852l31.898 55.248 27.712-16-31.916-55.28c49.682-26.066 104.752-40.916 162.062-43.246v63.65h32v-63.648c57.308 2.338 112.376 17.19 162.052 43.252l-31.908 55.268 27.712 16 31.89-55.236c23.52 14.984 45.574 32.646 65.772 52.842 20.2 20.198 37.862 42.252 52.848 65.774l-55.238 31.892 16 27.712 55.272-31.912c26.062 49.678 40.914 104.746 43.248 162.054h-63.648v32h63.648c-2.334 57.31-17.184 112.378-43.244 162.056l-55.274-31.914-16 27.712 55.242 31.894c-14.986 23.528-32.65 45.584-52.85 65.784z",
      "M800 482h-231.464c-5.636-10.598-14.166-19.416-24.536-25.416v-136.584h-64v136.584c-19.124 11.068-32 31.732-32 55.416 0 35.346 28.654 64 64 64 22.85 0 42.888-11.984 54.212-30h233.788v-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-clock"
    ]
  },
  {
    "paths": [
      "M512 66c-247.4 0-448 200.6-448 448s200.6 448 448 448c247.4 0 448-200.6 448-448s-200.6-448-448-448zM728.6 665c3 3 4.6 7 4.6 11.2s-1.6 8.4-4.6 11.2l-43.2 43.4c-3.2 3.2-7.2 4.6-11.2 4.6s-8.2-1.6-11.2-4.6l-151-151.2-150.8 151.4c-3 3.2-7.2 4.6-11.2 4.6s-8.2-1.6-11.2-4.6l-43.2-43.4c-3-3-4.6-7-4.6-11.2s1.6-8.4 4.6-11.2l151.4-152-151.8-150c-6.2-6.2-6.2-16.4 0-22.6l43.2-43.4c3-3 7-4.6 11.2-4.6s8.2 1.6 11.2 4.6l151.4 149.4 151.4-149.4c3-3 7-4.6 11.2-4.6s8.2 1.6 11.2 4.6l43.2 43.4c6.2 6.2 6.2 16.4 0 22.6l-151.8 150 151.2 151.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-close-circled"
    ]
  },
  {
    "paths": [
      "M875 773.2l-261.2-261.2 261.2-261.2c28.2-28.2 28.2-73.6 0-101.8s-73.6-28.2-101.8 0l-261.2 261.2-261.2-261.2c-28.2-28.2-73.6-28.2-101.8 0s-28.2 73.6 0 101.8l261.2 261.2-261.2 261.2c-28.2 28.2-28.2 73.6 0 101.8s73.6 28.2 101.8 0l261.2-261.2 261.2 261.2c28.2 28.2 73.6 28.2 101.8 0 28-28.2 28-73.8 0-101.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-close-round"
    ]
  },
  {
    "paths": [
      "M887.2 774.2l-262.4-263.4 263-260c10.8-10.8 10.8-28.4 0-39.2l-74.8-75.2c-5.2-5.2-12.2-8-19.6-8s-14.4 3-19.6 8l-261.8 259.2-262.2-259c-5.2-5.2-12.2-8-19.6-8s-14.4 3-19.6 8l-74.6 75.2c-10.8 10.8-10.8 28.4 0 39.2l263 260-262.2 263.2c-5.2 5.2-8.2 12.2-8.2 19.6s2.8 14.4 8.2 19.6l74.8 75.2c5.4 5.4 12.4 8.2 19.6 8.2 7 0 14.2-2.6 19.6-8.2l261.2-262.4 261.4 262.2c5.4 5.4 12.4 8.2 19.6 8.2 7 0 14.2-2.6 19.6-8.2l74.8-75.2c5.2-5.2 8.2-12.2 8.2-19.6-0.2-7.2-3.2-14.2-8.4-19.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-close"
    ]
  },
  {
    "paths": [
      "M0 128v768h1024v-768h-1024zM928 511.65c0.090 53.448-3.094 94.286-7.594 160.446s-38.406 112.904-118.212 120.24c-79.792 7.334-191.456 7.904-290.194 7.664-98 0.24-210.396-0.33-290.188-7.664-79.806-7.336-113.71-54.080-118.21-120.24s-7.682-106.998-7.592-160.446c-0.090-53.45 0.19-88.248 7.596-160.448s46.020-112.534 118.212-119.868 181.866-7.334 275.59-7.334c4.862 0 10.592 0 14.592 0 4.874 0 9.742 0 14.604 0 93.724 0 203.396 0 275.59 7.334s110.806 47.666 118.212 119.868 7.684 106.998 7.594 160.448z",
      "M744 567.692v1.532c0 37.278-23.162 59.132-54.006 59.132-30.836 0-51.616-24.618-54.568-59.132 0 0-2.67-18.156-2.67-54.596s3.092-59.518 3.092-59.518c5.422-38.946 24.376-59.132 55.214-59.132 30.734 0 55.168 26.524 55.168 66.776 0.046 0.172 0.020 1.248 0.020 1.248h103.082c0-50-12.618-95.112-37.84-123.492-25.234-28.366-62.806-42.546-112.738-42.546-24.966 0-47.86 3.308-68.66 9.884-20.808 6.59-38.752 18.124-53.832 34.582-15.090 16.468-26.794 38.508-35.11 66.118-8.324 27.618-12.484 62.448-12.484 104.494 0 41.040 3.376 75.368 10.144 102.976 6.754 27.622 16.776 49.66 30.036 66.118 13.264 16.468 29.906 27.87 49.934 34.2 20.020 6.326 43.558 9.496 70.608 9.496 57.208 0 98.178-14.516 122.886-42.636 24.696-28.122 37.056-69.196 37.056-123.196h-105.332c0 0 0 5.752 0 7.692z",
      "M390 567.692v1.532c0 37.278-23.162 59.132-54.006 59.132-30.836 0-51.616-24.618-54.568-59.132 0 0-2.67-18.156-2.67-54.596s3.092-59.518 3.092-59.518c5.422-38.946 24.376-59.132 55.214-59.132 30.734 0 55.168 26.524 55.168 66.776 0.046 0.172 0.020 1.248 0.020 1.248h103.082c0-50-12.618-95.112-37.84-123.492-25.234-28.366-62.806-42.546-112.738-42.546-24.966 0-47.86 3.308-68.66 9.884-20.808 6.59-38.752 18.124-53.832 34.582-15.090 16.468-26.794 38.508-35.11 66.118-8.324 27.618-12.484 62.448-12.484 104.494 0 41.040 3.376 75.368 10.144 102.976 6.754 27.622 16.776 49.66 30.036 66.118 13.264 16.468 29.906 27.87 49.934 34.2 20.020 6.326 43.558 9.496 70.608 9.496 57.208 0 98.178-14.516 122.886-42.636 24.696-28.122 37.056-69.196 37.056-123.196h-105.332c0 0 0 5.752 0 7.692z"
    ],
    "grid": 0,
    "tags": [
      "ion-closed-captioning"
    ]
  },
  {
    "paths": [
      "M796.2 466.4c0-2.4 0.4-4.8 0.4-7.2 0-130-103.6-235.2-231.4-235.2-92.2 0-171.4 54.8-208.6 134-16.2-8.2-34.4-13-53.6-13-59 0-108.2 43.8-117.6 101-70.8 24.4-121.4 92.2-121.4 172 0 100.4 80.2 181.8 179 182h553.4c90.4-0.4 163.4-75 163.4-166.8 0.2-92-73.2-166.6-163.6-166.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-cloud"
    ]
  },
  {
    "paths": [
      "M661.934 568.208c12.96-12.934 12.96-33.902 0-46.844-12.96-12.934-34.684-12.934-47.646 0l-70.288 69.5v-237.704c0-18.302-13.678-33.12-31.998-33.12-18.324 0-32.002 14.816-32.002 33.12v237.704l-70.010-69.5c-12.962-12.934-34.19-12.934-47.146 0-12.964 12.942-13.078 33.91-0.114 46.844l126.14 126.046c0.040 0.040 0.056 0.074 0.1 0.114 1.45 1.432 3.026 2.734 4.736 3.89 0.204 0.134 0.4 0.268 0.604 0.4 0.644 0.412 1.302 0.806 1.98 1.174 0.234 0.128 0.462 0.266 0.7 0.386 0.842 0.436 1.698 0.846 2.584 1.21 0.004 0.002 0.008 0.002 0.012 0.004 0.81 0.334 1.634 0.616 2.466 0.884 0.224 0.074 0.444 0.17 0.67 0.236 0.302 0.094 0.614 0.148 0.922 0.23 2.848 0.77 5.744 1.176 8.63 1.176 2.884 0 5.78-0.406 8.624-1.176 0.306-0.082 0.624-0.136 0.928-0.23 0.226-0.066 0.448-0.162 0.67-0.236 0.832-0.27 1.658-0.55 2.466-0.884 0.004-0.002 0.008-0.002 0.014-0.004 0.882-0.366 1.74-0.774 2.578-1.208 0.244-0.128 0.48-0.266 0.72-0.396 0.664-0.37 1.316-0.752 1.95-1.158 0.218-0.138 0.434-0.28 0.646-0.424 0.816-0.548 1.612-1.124 2.368-1.744 0.008-0.004 0.014-0.008 0.022-0.012 0.812-0.664 1.582-1.368 2.324-2.102 0.048-0.044 0.102-0.086 0.148-0.132l126.202-126.044z",
      "M336 784c-12.286 0-24.57-4.688-33.942-14.058l-224-224c-18.746-18.746-18.746-49.138 0-67.882l224-224c18.746-18.744 49.136-18.744 67.882 0 18.742 18.744 18.742 49.136 0 67.882l-190.058 190.058 190.058 190.058c18.742 18.744 18.742 49.136 0 67.882-9.374 9.372-21.654 14.060-33.94 14.060z",
      "M688 784c12.286 0 24.57-4.688 33.942-14.058l224-224c18.746-18.746 18.746-49.138 0-67.882l-224-224c-18.746-18.744-49.136-18.744-67.882 0-18.742 18.744-18.742 49.136 0 67.882l190.058 190.058-190.058 190.058c-18.742 18.744-18.742 49.136 0 67.882 9.374 9.372 21.654 14.060 33.94 14.060z"
    ],
    "grid": 0,
    "tags": [
      "ion-code-download"
    ]
  },
  {
    "paths": [
      "M416.332 512.332c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M560.332 512.332c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M704.332 512.332c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M336 784c-12.286 0-24.57-4.688-33.942-14.058l-224-224c-18.746-18.746-18.746-49.138 0-67.882l224-224c18.746-18.744 49.136-18.744 67.882 0 18.742 18.744 18.742 49.136 0 67.882l-190.058 190.058 190.058 190.058c18.742 18.744 18.742 49.136 0 67.882-9.374 9.372-21.654 14.060-33.94 14.060z",
      "M688 784c12.286 0 24.57-4.688 33.942-14.058l224-224c18.746-18.746 18.746-49.138 0-67.882l-224-224c-18.746-18.744-49.136-18.744-67.882 0-18.742 18.744-18.742 49.136 0 67.882l190.058 190.058-190.058 190.058c-18.742 18.744-18.742 49.136 0 67.882 9.374 9.372 21.654 14.060 33.94 14.060z"
    ],
    "grid": 0,
    "tags": [
      "ion-code-working"
    ]
  },
  {
    "paths": [
      "M336 784c-12.286 0-24.57-4.688-33.942-14.058l-224-224c-18.746-18.746-18.746-49.138 0-67.882l224-224c18.746-18.744 49.136-18.744 67.882 0 18.742 18.744 18.742 49.136 0 67.882l-190.058 190.058 190.058 190.058c18.742 18.746 18.742 49.136 0 67.882-9.374 9.372-21.654 14.060-33.94 14.060z",
      "M688 784c12.286 0 24.57-4.688 33.942-14.058l224-224c18.746-18.746 18.746-49.138 0-67.882l-224-224c-18.746-18.744-49.136-18.744-67.882 0-18.742 18.744-18.742 49.136 0 67.882l190.058 190.058-190.058 190.058c-18.742 18.746-18.742 49.136 0 67.882 9.374 9.372 21.654 14.060 33.94 14.060z"
    ],
    "grid": 0,
    "tags": [
      "ion-code"
    ]
  },
  {
    "paths": [
      "M766.2 514.8c1.2-10.8 1.8-20 1.8-27.6 0-39.2-6.6-39.4-32-39.4h-151c14.6-24 23-48.8 23-74 0-75.8-114.6-112.8-114.6-176 0-23.4 10.2-42.6 18.6-69.8-53 14-94.8 67-94.8 123.2 0 96.6 112.6 97.4 112.6 169.6 0 9-2.8 17-4.2 27h-111.8c1.6-6 2.6-12.4 2.6-18.6 0-45.6-78.2-67.8-78.2-105.6 0-14 2-25.6 6.4-42-25.8 10.2-56.6 40-56.6 73.6 0 53.4 63.8 58.6 73.6 92.6h-201.6c-25.4 0-32 0.2-32 39.4s15.4 122.6 56.6 222c41.2 99.4 88.8 143.2 122.4 172.4l0.2-0.4c10.2 9.2 23.6 14.6 38.4 14.6h204.8c14.8 0 28.2-5.4 38.4-14.6l0.2 0.4c18-15.6 40-35.6 62.8-65.8 9.4 4 19.6 7.4 30.8 10 16.8 4 33.6 6 49.6 6 48 0 91.2-18.4 121.6-51.6 26.8-29.2 42.2-68.8 42.2-108.4 0-77.8-56-142.8-129.8-157zM732.2 768.4c-17.2 0-31.2-2.4-44.2-8.4 8-16 15.8-31.8 23.4-50.2 20.2-48.8 34.2-94 43.2-131.6 44 8.6 77.4 47.6 77.4 94.2 0 45.4-34.4 96-99.8 96z"
    ],
    "grid": 0,
    "tags": [
      "ion-coffee"
    ]
  },
  {
    "paths": [
      "M512 64c-78 0-151.2 20-215 54.8-23.2-33-61.6-54.8-105-54.8-70.6 0-128 57.4-128 128 0 43.4 21.8 81.8 54.8 105-34.8 63.8-54.8 137-54.8 215 0 247.4 200.6 448 448 448s448-200.6 448-448c0-247.4-200.6-448-448-448zM128 192c0-35.4 28.6-64 64-64 21 0 39.6 10 51.2 25.6-34 25.4-64.2 55.6-89.6 89.6-15.6-11.6-25.6-30.2-25.6-51.2zM783.6 783.6c-72.6 72.4-169 112.4-271.6 112.4s-199-40-271.6-112.4c-72.4-72.6-112.4-169-112.4-271.6s40-199 112.4-271.6c72.6-72.4 169-112.4 271.6-112.4s199 40 271.6 112.4c72.4 72.6 112.4 169 112.4 271.6s-40 199-112.4 271.6z",
      "M704 256c0 0-203.2 167.4-240 208s-144 304-144 304 204.8-164.6 240-208 144-304 144-304z"
    ],
    "grid": 0,
    "tags": [
      "ion-compass"
    ]
  },
  {
    "paths": [
      "M885.6 199.2l-60.8-60.8c-14-13.8-36.4-13.8-50.2 0l-63.6 63.6 111 111 63.6-63.4c13.8-14.2 13.8-36.6 0-50.4z",
      "M692.2 221l-344 355-28.2 128 128-28.2 353.2-346z",
      "M768 512v300c0 10.2-7.8 20.2-18.4 20.2s-538-0.2-538-0.2c-11.2 0-19.6-10.8-19.6-20s0-536 0-536c0-10 9.4-20 21.2-20h298.8l64-64h-401.2c-26 0-46.8 20.6-46.8 46.6v610.6c0 25.8 21 46.8 46.8 46.8h610.6c25.8 0 46.6-21 46.6-46.8v-401.2l-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-compose"
    ]
  },
  {
    "paths": [
      "M160 704h128v128h-128v-128z",
      "M352 576h128v256h-128v-256z",
      "M544 384h128v448h-128v-448z",
      "M736 192h128v640h-128v-640z"
    ],
    "grid": 0,
    "tags": [
      "ion-connection-bars"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448c247.4 0 448-200.6 448-448s-200.6-448-448-448zM783.6 783.6c-72.6 72.4-169.6 112.4-271.6 112.4v-768c102 0 199 40 271.6 112.4 72.4 72.6 112.4 169 112.4 271.6s-40 199-112.4 271.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-contrast"
    ]
  },
  {
    "paths": [
      "M704 864h128v96h-128v-96z",
      "M832 704v-512h-480v128h352v384h-384v-640h-128v128h-128v128h128v512h768v-128z"
    ],
    "grid": 0,
    "tags": [
      "ion-crop"
    ]
  },
  {
    "paths": [
      "M934.602 336.168c-3.61 0-7.032 0.658-10.14 1.924l-4.562 2.3-350.726 181.868c0 0-0.104 0.046-0.104 0.094-15.12 9.336-25.070 25.012-25.070 42.85v371.708c0 12.764 11.298 23.088 25.38 23.088 4.356 0 8.502-1.026 12.13-2.808 0.31-0.19 0.726-0.376 1.038-0.564l349.98-185.67c16.482-9.008 27.47-25.484 27.47-44.21v-367.584c0.002-12.718-11.4-22.996-25.396-22.996z",
      "M908.546 237.042l-363.4-163.462c0 0-21.318-9.58-33.154-9.58s-33.052 9.58-33.052 9.58l-363.712 163.462c0 0-15.978 6.584-15.978 18.958 0 13.124 16.6 23 16.6 23l370.968 195.7c7.568 3.374 16.154 5.298 25.174 5.298 9.122 0 17.83-1.926 25.484-5.392l5.078-2.63 365.786-193.072c0 0 15.016-8.072 15.016-22.906 0-12.998-14.81-18.956-14.81-18.956z",
      "M454.932 522.356l-7.984-4.086-347.424-180.176c-2.99-1.268-6.516-1.924-10.142-1.924-13.994 0-25.38 10.276-25.38 22.994v367.584c0 18.776 10.97 35.204 27.454 44.21l0.416 0.282 349.478 185.388c3.836 2.16 8.398 3.374 13.272 3.374 13.978 0 25.38-10.324 25.38-23.088v-371.708c-0.002-17.838-9.954-33.514-25.070-42.85z"
    ],
    "grid": 0,
    "tags": [
      "ion-cube"
    ]
  },
  {
    "paths": [
      "M512 317.8c-107.4 0-194.4 87-194.4 194.4s87 194.2 194.4 194.2c107.4 0 194.4-87 194.4-194.2 0-107.4-87-194.4-194.4-194.4zM512 599c-48 0-87-39-87-87s39-87 87-87c48 0 87 39 87 87s-39 87-87 87z",
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448 448-200.6 448-448c0-247.4-200.6-448-448-448zM512 757.6c-135.6 0-245.6-110-245.6-245.6s110-245.6 245.6-245.6c135.6 0 245.6 110 245.6 245.6s-110 245.6-245.6 245.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-disc"
    ]
  },
  {
    "paths": [
      "M797.2 338.4c-1.8-4.4-4-8.6-7-12.2l-167.6-183.4c-3.8-4.2-8.4-7.2-13.4-9.8-5.8-3-12.2-4.2-19-4.2h-319.8c-24.8 0-45.4 21.2-45.4 47.8v670.4c0 26.8 20.6 49.8 45.4 49.8h486.2c24.8 0 44.4-23 44.4-49.8v-488.2c0-7.2-1-14.2-3.8-20.4zM321 357.2c0-3 3.6-4.2 6.8-4.2h141.6c3.2 0 5.6 1.2 5.6 4.2v21.6c0 2.8-2.2 6.2-5.6 6.2h-141.6c-3.2 0-6.8-3.4-6.8-6.2v-21.6zM321 613.2c0-3 3.6-4.2 6.8-4.2h244.4c3.2 0 4.8 1.2 4.8 4.2v21.6c0 2.8-1.4 6.2-4.8 6.2h-244.4c-3.2 0-6.8-3.4-6.8-6.2v-21.6zM641 762.8c0 2.8-1.4 6.2-4.8 6.2h-308.4c-3.2 0-6.8-3.4-6.8-6.2v-21.6c0-3 3.6-4.2 6.8-4.2h308.4c3.2 0 4.8 1.2 4.8 4.2v21.6zM705 506.8c0 2.8-1.4 6.2-4.8 6.2h-372.4c-3.2 0-6.8-3.4-6.8-6.2v-21.6c0-3 3.6-4.2 6.8-4.2h372.4c3.2 0 4.8 1.2 4.8 4.2v21.6zM611.2 355c-11.2 0-22.2-10.4-22.2-22.6v-132l142.4 154.6h-120.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-document-text"
    ]
  },
  {
    "paths": [
      "M798.6 337.8c-1.4-5.8-4-10-7-13.6l-167.4-183.4c-3.8-4.2-8.2-6.2-13.2-8.8-5.8-3-12.2-3.2-18.8-3.2h-319.8c-24.8 0-47.4 19.2-47.4 45.8v670.4c0 26.8 22.6 51.8 47.4 51.8h486.2c24.8 0 42.4-25 42.4-51.8v-488.2c0-7.2-0.8-12.4-2.4-19zM611 222l116 127h-116v-127zM289 833v-640h258v163.4c0 29.6 26.8 56.6 56.2 56.6h133.8v420h-448z"
    ],
    "grid": 0,
    "tags": [
      "ion-document"
    ]
  },
  {
    "paths": [
      "M0 288h1024v64h-1024v-64z",
      "M0 480h1024v64h-1024v-64z",
      "M0 672h1024v64h-1024v-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-drag"
    ]
  },
  {
    "paths": [
      "M714.55 251.050c-4.418-7.972-18.996-23.674-27.954-26.65-11.958-1.842-4.796 8.826-4.796 13.4-3.086 2.314-7.882 4.908-10.204 8-1.398 1.2 3.408 12.206 12.674 8.67s3.928 3.598 10.328 17.73 19.214 14.414 24.98 10.134c7.31-5.424-1.006-24.024-5.028-31.284z",
      "M751.6 341.2c-0.002 0.012-0.008 0.022-0.010 0.034 0 0.024 0.004 0.024 0.010-0.034z",
      "M869.2 394.2c0.8 0-3.6-0.8 0 0v0z",
      "M512 64c-247.4 0-448 200.6-448 448 0 247.402 200.6 448 448 448 247.402 0 448-200.598 448-448 0-247.4-200.598-448-448-448zM346.798 858.848c-11.030-6.266-18.748-15.12-21.922-31.858-7.894-41.616-0.606-64.134 35.924-88.49 17.208-11.472 20.044-25.344 33.8-39.1 3.37-4.28 12.422-20.748 18.4-21.6 7.274-1.558 27.418-5.054 31.4-13 7.58-10.292 24.254-54.796 31.6-59.204 11.994-7.85 28.838-31.92 16.6-46.2-14.042-17.286-33.598-17.532-51.8-26.602-16.030-8.016-23.148-44.562-35.4-57.202-23.824-24.272-59.998-38.398-90-53.4-16.232-6.5-14.688-8.512-27.4 4.2-16.324 16.324-40.186-4.134-42.6-21-0.18-5.604-6.592-36.432-2.8-38.8 35.912-22.45-16.656-17.28-21-27.6-10.71-29.986 26.016-53.72 50.8-56.2 27.77-3.476 33.568 43.79 44.2 39.8 5.112-2.552 5.132-24.788 5.8-29.6 2.534-16.058 7.176-18.546 22.8-24.35 18.196-6.758 32.126-15.234 51.4-18.45 22.012-6.39 40.634-3.066 57.6-17.2 7.776-5.83 13.408 3.16 20.8 4.8 15.998 3.198 19.4-22.2 19.4-31.8-0.068-9.33 2.53-17.26-9.4-27.2-15.612-12.138-38.058-1.738-50.6 10.8-15.148 14.070-32.714 13.1-27.6-11.2 1.268-8.866 20.418-19.174 28-24 7.4-4.444 11.808 5.044 20.8 2.8 13.158-2.926 18.068 9.47 33.6 9.6 6.466-1.462 29.592-13.762 17.228-38.732 1.858-0.018 3.712-0.060 5.572-0.060 3.71 0 7.414 0.068 11.11 0.172 5.61 17.762-11.93 32.886-3.11 55.228 17.58 42.95 31.984 6.028 49.4-14 5.698-5.698 9.266-4.422 18.6-6.2 5.792-0.966 14.11-18.54 16.786-23.964 40.116 9.912 78.242 26.254 113.134 48.51-14.894 1.584-18.696-2.792-18.468 14.754 0.084 6.634 0.594 26.638 10.548 28.3 16.554 1.95 13.562 13.664 29.102 15.7 14.886 1.952 5.632 15.106 11.702 28.1 6.786 20.454-39.612 26.604-48.604 29.6-27.28 9.108 12.68 48.82 30.4 44.6 5.634-1.408 24.43-3.804 25.734-10.134-0.022-0.646-3.672-22.024-1.734-24.466 3.066-3.868 10.246-5.892 21.552 0.51 26.748 15.146 40.292 51.4 71.794 58.59 4.292 0.978 11.72-0.3 16.988 4.066 4.462 6.030 15.84 16.832 2.262 16.832-18.034-4.006-27.56 1.718-42.396-9.748-15.466-11.954-25.086-21.782-45.5-22.152-17.58-0.318-33.36-7.638-51.476-4.7-10.1 1.638-20.076 5.622-29.824 8.6-9.234 3.076-11.020 19.53-20.4 21.4-38.934 9.162-30.522 46.338-37.546 75.826-2.702 11.324-12.050 42.006-1.852 52.174 18.24 17.708 39.566 42.070 66.352 45.926 14.412 2.074 45.908-9.152 55.646 5.474 4.124 8.208 14.894-6.060 17.8 1.202 7.326 21.976-8.526 36.372-8.674 57.102-0.22 30.406 18.356 41.14-6.526 68.296-27.284 27.214-8.666 61.576-23.8 94-8.084 16.674-9.616 39.788-21.744 47.554-26.642 17.064-55.4 30.798-85.428 40.768-53.254 17.676-110.31 23.344-166.034 16.912-29.238-3.376-58.082-10.114-85.76-20.13-7.538-2.726-14.56-5.010-20.944-7.408-4.804-2.056-9.572-4.194-14.292-6.446zM263.398 804.658c-0.936-0.794-1.87-1.592-2.798-2.396-6.888-5.984-13.604-12.226-20.12-18.742-6.776-6.776-13.268-13.762-19.468-20.942-0.070-0.082-0.14-0.164-0.21-0.246-1.274-1.476-2.514-2.972-3.764-4.468-103.37-124.922-118.52-307.856-31.838-447.664 12.156 12.156-8.202 36.048 15 52 10.248 7.212 20.042 4.318 18 17.6-1.986 12.898 10.71 12.67 12.6 24 5.684 24.858 38.414 37.284 19.8 65.2-18.236 25.25-33.984 53.458-20.2 85.6 4.508 11.72 15.838 23.716 24.444 32.488 15.626 15.932 14.754 6.376 14.754 26.512-0.312 8.746 10.522 17.794 9.4 23.4-2.002 16.022-5.808 31.86-7.8 47.8-3.584 57.276-0.258 113.324 42.6 156.2-15.938-9.612-31.272-20.498-45.936-32.58-1.496-1.238-2.982-2.498-4.464-3.762z"
    ],
    "grid": 0,
    "tags": [
      "ion-earth"
    ]
  },
  {
    "paths": [
      "M160 288h704v384h-704v-384z",
      "M928 192h-832c-17.674 0-32 14.326-32 32v512c0 17.674 13.864 32 31.536 32h832.464c17.674 0 32-14.326 32-32v-512c0-17.674-14.326-32-32-32zM896 704h-768v-448h768v448z",
      "M160 960h64l56.294-160h-62.624z",
      "M541.66 64h-58.716l-34.602 96h127.856z",
      "M743.706 800l56.294 160h64l-57.56-160z",
      "M480 800h64v96h-64v-96z"
    ],
    "grid": 0,
    "tags": [
      "ion-easel"
    ]
  },
  {
    "paths": [
      "M326.001 879.146l-181.138-181.138 500.696-500.696 181.138 181.138-500.696 500.696z",
      "M943.446 176.786l-96.23-96.228c-23.446-23.448-63.116-21.792-88.608 3.7l-90.404 90.406 181.138 181.136 90.404-90.404c25.486-25.492 27.144-65.164 3.7-88.61z",
      "M128.042 726.504l-64.042 233.496 233.474-64.042z"
    ],
    "grid": 0,
    "tags": [
      "ion-edit"
    ]
  },
  {
    "paths": [
      "M512 64c-128 0-320 266.4-320 513.8s128 382.2 320 382.2 320-134.8 320-382.2c0-247.4-192-513.8-320-513.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-egg"
    ]
  },
  {
    "paths": [
      "M798 640v0c20 0 33.6-14.2 33.6-31.8 0-6.6-2.2-12.2-5.6-18l-275.4-380.8c-9.2-10.6-23-17.4-38.6-17.4-15.4 0-29.2 6.8-38.4 17.4l-276 381.6c-3.4 5.2-5.2 11-5.2 17.4 0 17.4 13.6 31.6 33.6 31.6v0h572z",
      "M807.4 704h-590.6c-13.6 0-24.8 10.8-24.8 24.4v79.2c0 13.4 11 24.4 24.8 24.4h590.6c13.6 0 24.6-11 24.6-24.4v-79.2c-0-13.6-11-24.4-24.6-24.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-eject"
    ]
  },
  {
    "paths": [
      "M992 320c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128s128 57.308 128 128z",
      "M450 320h-382.402c-22.2 0-27.796 6-22.598 21 3 8.8 16.8 16.2 25 20.4 22 11.6 327.598 178.2 339 184.2 11.398 6 23 8.8 41 8.8s29.598-2.8 41-8.8c7.58-3.99 145.25-78.994 243.118-132.214-18.93-26.284-30.118-58.52-30.118-93.386h-254z",
      "M586.398 546.6l164.402 185c4 4 5.796 8.8 3.598 11.202-2.398 2.2-7.598 1-11.8-2.8l-197.2-166.4c-29.8 19.202-50.8 32.4-54.398 34.4-15.402 7.8-26.2 8.8-41 8.8s-25.602-1-41-8.8c-3.8-2-24.602-15.2-54.402-34.4l-197.2 166.4c-4 4-9.398 5.2-11.8 2.8-2.398-2.202-0.598-7.202 3.402-11.202l164.2-185c-97.4-63-246.2-167.8-262.602-176.2-17.598-9-18.598 1.6-18.598 9.8 0 8.202 0 410 0 410 0 18.6 27.398 41.8 47 41.8h742c19.598 0 43-23.4 43-41.8 0 0 0-188.796 0-310.2-43.452 0-82.832-17.346-111.664-45.458-52.002 35.804-115.616 79.508-165.938 112.058z"
    ],
    "grid": 0,
    "tags": [
      "ion-email-unread"
    ]
  },
  {
    "paths": [
      "M134 297.4c22 11.6 327.6 178.2 339 184.2s23 8.8 41 8.8c18 0 29.6-2.8 41-8.8s317-172.6 339-184.2c8.2-4.2 22-11.8 25-20.4 5.2-15.2-0.4-21-22.6-21h-764.8c-22.2 0-27.8 6-22.6 21 3 8.8 16.8 16.2 25 20.4z",
      "M911.4 306.4c-16.4 8.4-163.6 113.2-261 176.2l164.4 185c4 4 5.8 8.8 3.6 11.2-2.4 2.2-7.6 1-11.8-2.8l-197.2-166.4c-29.8 19.2-50.8 32.4-54.4 34.4-15.4 7.8-26.2 8.8-41 8.8s-25.6-1-41-8.8c-3.8-2-24.6-15.2-54.4-34.4l-197.2 166.4c-4 4-9.4 5.2-11.8 2.8-2.4-2.2-0.6-7.2 3.4-11.2l164.2-185c-97.4-63-246.2-167.8-262.6-176.2-17.6-9-18.6 1.6-18.6 9.8s0 410 0 410c0 18.6 27.4 41.8 47 41.8h742c19.6 0 43-23.4 43-41.8 0 0 0-402 0-410 0-8.4 1.2-18.8-16.6-9.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-email"
    ]
  },
  {
    "paths": [
      "M891.8 854.2l-235.8-398.4v-299.8c0-15.4-13-28-29-28s-29 12.4-29 28v307.2c0 3.6 1.2 7.2 2.6 10.6-15.2-22.2-41.2-36.8-70.8-36.8-47 0-85 36.6-85 82 0 33.6 21 63 50.8 75h-144l70-117c2.4-4.2 4.2-9 4.2-13.8v-60.8c8 6.4 20 10.2 32.2 10.2 30.6 0 55-23.8 55-53.2s-24.4-53.2-55-53.2c-12.2 0-24.2 3.8-32.2 10.2v-160.4c0-15.4-13-28-29-28s-29 12.4-29 28v299.8l-235.6 398.4c-5 8.6-5.2 19.2 0 27.8s14.4 14 24.8 14h710c10.2 0 19.6-5.2 24.8-14 5.2-8.4 5-19.2 0-27.8zM564.4 594c29.8-12 50.8-41.6 50.8-75 0-11.4-2.4-22.4-6.8-32.2l62 107.2h-106z",
      "M530.2 257.2c24 0 43.4-18.8 43.4-41.8 0-23.2-19.4-41.8-43.4-41.8s-43.4 18.8-43.4 41.8c-0.2 23 19.4 41.8 43.4 41.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-erlenmeyer-flask-bubbles"
    ]
  },
  {
    "paths": [
      "M877.63 791.4l-200.612-299c-25.6-40.6-38.018-88.8-38.018-140.4 0 0 0-147 0-186s25.184-66.5 30.018-84.166c4.592-16.784 1.024-16.834-30.376-16.834h-253.59c-31.998 0-37.096 0.018-32.622 16.832 4.836 18.168 30.57 46.768 30.57 85.168s0 185 0 185c0 51.6-14.57 99.6-40.17 140.4l-98.558 153-98.202 145.8c-11.6 18-18.102 41.4-18.102 64.4 0 56 32.694 105.4 126.492 105.4h515.178c93.996 0 126.394-49.4 126.394-105.4-0.2-23-6.802-46.2-18.402-64.2zM818.436 882c-8.8 8.4-23.204 15-48.998 15h-515.18c-25.6 0-41.6-7-50.398-15.4-5.4-5.2-12-14.1-12-26.7 0-10 2.8-20.25 7.8-28.25l198.078-300.784c31.398-50.398 49.264-110.462 49.264-173.864v-223.002h128v222.8c0 62.398 15.522 122.6 47.718 174l201.046 300c4.998 8 7.936 18.5 7.936 28.5-0.002 12.8-7.866 22.5-13.266 27.7z",
      "M778.434 822.602c0.102 0.15 0.2 0.794 0 0.498l-163.744-246.1h-207.294l-162.138 246.302c-3 4.2-4.6 10.35-4.6 15.948 0 15 12.576 27.75 27.374 27.75h488c15 0 27.198-13.45 27.198-28.25-0.002-5-2.198-12.148-4.796-16.148zM604.042 683.4c-3-3-4.6-7.202-4.6-11.4s1.798-8.4 4.6-11.4c3-3 7.2-4.6 11.2-4.6 4.204 0 8.4 1.6 11.204 4.6 3 3 4.598 7.202 4.598 11.4s-1.798 8.4-4.598 11.4c-3 3-7 4.6-11.204 4.6-4 0-8.2-1.8-11.2-4.6zM697.84 801.4c-2.8 1.796-5.8 2.6-8.604 2.6-4.998 0-10.198-2.6-13.196-7.2l-46.998-71.8c-4.8-7.4-2.8-17.4 4.598-22.2 2.8-1.8 5.8-2.602 8.8-2.602 5.2 0 10.2 2.602 13 7.202l47 71.8c4.796 7.398 2.796 17.398-4.6 22.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-erlenmeyer-flask"
    ]
  },
  {
    "paths": [
      "M752.8 316.6l143.2-143.4-45.2-45.2-155.2 155.2c-55.6-27.8-116.6-45.2-183.6-45.2-163.8 0-291.4 104.4-448 274 69.6 74.8 133.6 145.4 206.6 196.2l-142.6 142.6 45.2 45.2 153.8-153.8c54 27.4 114 43.8 185 43.8 199.8 0 346.8-163.6 448-271-56-68.2-124.8-143.6-207.2-198.4zM332.8 512c0-100.8 80.4-182.6 179.2-182.6 38.6 0 74.4 12.4 103.6 33.8l-101.4 101.4c-1.4-5.2-2.2-10.8-2.2-16.6 0-15.8 5.8-30.2 15.2-41.4-5-0.8-10-1.2-15.2-1.2-57.6 0-104.6 47.8-104.6 106.6 0 17.2 4 33.6 11.2 48l-54.6 54.8c-19.6-29.4-31.2-64.8-31.2-102.8zM512 694.6c-38.6 0-74.4-12.4-103.6-33.8l54.8-54.8c14.6 8 31.2 12.4 48.8 12.4 57.6 0 104.6-47.8 104.6-106.6 0-4.6-0.4-9.2-0.8-13.8-11 8.6-24.6 13.8-39.6 13.8-5.8 0-11.2-0.8-16.6-2.2l100.6-100.6c19.6 29.2 31.2 64.6 31.2 102.8-0.2 101-80.6 182.8-179.4 182.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-eye-disabled"
    ]
  },
  {
    "paths": [
      "M512 256c-163.8 0-291.4 97.6-448 256 134.8 135.4 248 256 448 256 199.8 0 346.8-152.8 448-253.2-103.6-117.6-250.4-258.8-448-258.8zM512 694.6c-98.8 0-179.2-82-179.2-182.6 0-100.8 80.4-182.6 179.2-182.6s179.2 82 179.2 182.6c0 100.8-80.4 182.6-179.2 182.6z",
      "M512 448c0-15.8 5.8-30.2 15.2-41.4-5-0.8-10-1.2-15.2-1.2-57.6 0-104.6 47.8-104.6 106.6s47 106.6 104.6 106.6 104.6-47.8 104.6-106.6c0-4.6-0.4-9.2-0.8-13.8-11 8.6-24.6 13.8-39.6 13.8-35.6 0-64.2-28.6-64.2-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-eye"
    ]
  },
  {
    "paths": [
      "M576 568c110.4-28.4 192-128.6 192-248 0-141.4-114.6-256-256-256s-256 114.6-256 256c0 119.2 81.6 219.4 192 248v136h-128v128h128v128h128v-128h128v-128h-128v-136zM512 480c-88.2 0-160-71.8-160-160s71.8-160 160-160 160 71.8 160 160-71.8 160-160 160z"
    ],
    "grid": 0,
    "tags": [
      "ion-female"
    ]
  },
  {
    "paths": [
      "M762 257.2h-497.8c-24.2 0-39 0-39 40.8v56.2h576v-56.2c0-40.8-14.8-40.8-39.2-40.8z",
      "M666 193h-306c-26.2 0-39 0.6-39 37.4h384c-0.2-36.8-12.8-37.4-39-37.4z",
      "M864.8 339.2l-31.8-18.8v64.6h-642v-64.6l-30.4 18.8c-28.6 17.8-35.6 30.6-30 81.8l35 369.6c7.4 41.4 31.8 42.4 48 42.4h599.8c16.2 0 40.4-1 47.8-42.4l34.4-368.8c4.6-48.8-4-65.6-30.8-82.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-filing"
    ]
  },
  {
    "paths": [
      "M896.8 416h-688l682.4-136c17-3.2 28-19.4 24.8-36.2l-17.8-90.8c-3.2-16.8-19.6-27.6-36.6-24.4l-740.2 147.2c-17 3.2-28 19.4-24.8 36l17.8 90.8c1.2 5.6 4.2 10.4 7.8 14.4-14.8 2.4-26.2 14.4-26.2 29.8v418.4c0 17 14 30.8 31.2 30.8h769.6c17.2 0 31.2-13.8 31.2-30.8v-418.4c-0-17-14-30.8-31.2-30.8zM610 804.8l-101.4-72.6-101.4 72.6 39-116.8-101.6-72h125.4l38.4-116.8 38.6 116.8h125.4l-101.6 72 39.2 116.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-film-marker"
    ]
  },
  {
    "paths": [
      "M786.534 476.176l-0.462 20.808c-1.628 23.3-7.594 63.824-28.204 109.472 6.502-30.416 9.956-61.964 9.956-94.328 0-24.192-1.916-47.936-5.598-71.088-30.182-189.802-179.252-339.846-368.276-371.036-22.538-5.434-35.854-6.004-35.854-6.004 0.476 0.562 0.93 1.124 1.4 1.688 78.916 94.362 88.2 193.312 75.488 263.7-4.562 25.258-11.956 46.842-19.982 63.21 0 0 6.718-27.822 6.070-59.44-0.586-28.468-7.144-60.012-29.972-77.104 6.994 36.756-1.504 67.002-18.242 95.458-49.478 84.104-170.858 147.26-180.858 303.304v7.672c0 107.384 51.248 197.958 137.438 250.024-13.7-24.688-29.928-70.414-17.466-120.302 7.996 47.338 19.902 72.090 41.758 103.512 16.306 23.442 38.208 38.538 66.19 49.868s58.070 14.41 91.858 14.41c111.618 0 210.456-57.134 267.69-143.904l0.534 0.122v-0.014c32-50.508 52.2-111 52.2-176.038-0.002-59.942-17.010-116.024-45.668-163.99z"
    ],
    "grid": 0,
    "tags": [
      "ion-fireball"
    ]
  },
  {
    "paths": [
      "M852.8 365c-71.6 11.8-188.4 15-266-132.2-83.2-158.2-217.6-163-296.2-148.6-38.2 7-66.8 39-66.8 70v393.2c22.6 8.6 46.8-0.4 53-1.6 1.6-0.4 3-0.6 4.8-1 50-11 102.8-16.2 233.6 46.6 164 78.6 307.6-66.2 363.2-167 4-7 17.4-40.4 17.4-72.4-19.4 8-43 13-43 13z",
      "M176 64h-32c-8.8 0-16 7.2-16 16v864c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-864c0-8.8-7.2-16-16-16z"
    ],
    "grid": 0,
    "tags": [
      "ion-flag"
    ]
  },
  {
    "paths": [
      "M257.844 640c26.1 268 207.528 320 253.864 320s254.914-80.98 256.284-320c1.672-292-243.172-286-191.79-576-173.348 128-339.624 357.632-318.358 576zM431.334 736c0-88.366 80.374-160 80.374-160s81.402 71.634 81.402 160c0 88.368-81.402 160-81.402 160s-80.374-71.632-80.374-160z"
    ],
    "grid": 0,
    "tags": [
      "ion-flame"
    ]
  },
  {
    "paths": [
      "M294.8 903.8c0.8 0.4 1.4 1 2.2 1.4 21.8 12 45 21.4 68.8 29.6 3.6 1.2 7.2 2.4 10.8 3.6 42.8 13.6 88 21.8 135.4 21.8 247.4 0 448-200.6 448-448 0-168.6-93.2-315.4-231-391.8-0.8-0.4-1.4-0.8-2-1.2-21.8-12-45-21.4-68.8-29.6-3.6-1.2-7.2-2.4-10.8-3.6-42.8-13.8-88.2-22-135.4-22-247.4 0-448 200.6-448 448 0 168.6 93.2 315.2 230.8 391.8zM236.4 313.2l108.8 108.8 72.6-81-104.8-104.8c56-40.4 124.2-65.2 198.8-65.2 18.6 0 36.6 1.8 54.4 4.8 19.6 3.2 38.6 8.2 57 14.6 3.6 1.2 7.4 2.4 11.2 3.8 12.4 4.8 24.4 10 36 16.2 108.4 57 182.4 170.6 182.4 301.6 0 74.4-24.8 142.6-65.4 198.8l-108.8-108.8-72.6 80.8 104.8 104.8c-56 40.6-124.4 65.4-198.8 65.4-18.6 0-36.8-1.8-54.4-4.8-19.6-3.2-38.6-8.2-57-14.6-3.8-1.2-7.6-2.4-11.2-3.8-13-5-25.8-10.6-38-17.2-107.2-57.4-180.2-170.4-180.2-300.6 0-74.4 24.8-142.6 65.2-198.8z",
      "M419.4 779.6l278.4-309.6h-170.6l77.2-225.6-278.2 309.6h170.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-flash-off"
    ]
  },
  {
    "paths": [
      "M192 576h294l-102.2 384 448.2-512h-294l102-384z"
    ],
    "grid": 0,
    "tags": [
      "ion-flash"
    ]
  },
  {
    "paths": [
      "M860.2 384h-696.4c-35.4 0-37.2 18.4-35.2 41l26 366c1.8 22.4 7 41 42.2 41h632.4c36 0 40.2-18.4 42.2-41l24.2-370.6c1.8-22.4-0-36.4-35.4-36.4z",
      "M852.4 286.6c-1-24.8-9-30.6-30.2-30.6 0 0-242.8 0-286.4 0s-48.8 0.6-81.8-34.8c-27.4-29.6-16.6-29.2-73.2-29.2-45.2 0-150.6 0-150.6 0-34.8 0-47.2-3-50.4 33.2-3 33.4-10 114.4-11 126.8h686.8l-3.2-65.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-folder"
    ]
  },
  {
    "paths": [
      "M832 160h-96v-96h-128v96h-96v128h96v96h128v-96h96z",
      "M608 480c0 77.2-9 84.6-28.8 100.6-14.8 12-44.4 14.2-78.8 16.6-19 1.4-40.8 3-62.8 6.6-18.8 3-36.8 9.4-53.6 17.6v-318.6c38.2-22.2 64-63.4 64-110.8 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.4 25.8 88.6 64 110.8v418.4c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-31.4-11.4-60.2-30-82.4 13.4-9.6 27.8-17.4 40.4-19.4 16.2-2.6 33.2-3.8 51.2-5.2 48.8-3.4 104.2-7.4 150.4-45 61.8-50.2 75-104.2 76-189.8v0-10.2h-128zM320 128c35.2 0 64 28.8 64 64s-28.8 64-64 64-64-28.8-64-64 28.8-64 64-64zM320 896c-35.2 0-64-28.8-64-64s28.8-64 64-64 64 28.8 64 64-28.8 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-fork-repo"
    ]
  },
  {
    "paths": [
      "M540.4 297.8c0 0.2-0.2 0.2 0 0v0z",
      "M640 332c0-86.4-30-186.4-48-267.4v-0.6h-16l-0.4 233.8c0 12.2-5.8 22.2-18 22.2-11.4 0-16-8.6-17.2-19.8-0.2-0.8 0-1.6 0-2.4l-20.6-233.8h-16l-18 234-0.2 2.2c-1.2 11.2-7.4 19.8-19 19.8-12.2 0-18.2-10-18.2-22.2l-0.8-233.8h-16c-17.6 82-47.6 181.8-47.6 268.2 0 51.4 29.2 96.2 73.4 116.4 22.4 10.2 22.6 20.6 22.6 20.6s-32 403.4-32 426.2c0 22.8 8 37 19 48s28.4 16.4 44.8 16.4c0.2 0 0.2 0 0.4 0s0.2 0 0.4 0c16.4 0 33.6-5.4 44.8-16.4 11-11 18.6-21.8 18.6-48s-32-426.2-32-426.2-2-10 22.8-21.2c43.2-19.6 73.2-64.4 73.2-116z"
    ],
    "grid": 0,
    "tags": [
      "ion-fork"
    ]
  },
  {
    "paths": [
      "M576 596.2v184.6l320-268.8-320-288v160c-374.4 0-448 416-448 416 106-186 244.8-203.8 448-203.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-forward"
    ]
  },
  {
    "paths": [
      "M512.17 64c-247.58 0-448.192 71.634-448.192 160 0 16.952 7.458 33.284 21.146 48.618l-0.122 0.016c63.814 77.792 298.998 353.366 298.998 431.366v174c0 45.376 57.782 82 128 82s128-36.624 128-82v0-166.176c0-2.482 0.016-5.080 0.016-7.824 0-78 231.984-349.136 301.984-435.876v-0.004c12-14.014 17.954-28.816 17.954-44.12 0-88.366-200.204-160-447.784-160zM512.356 320c-184.116 0-352.224-44-352.224-96s166.106-96 352.224-96c186.12 0 352.222 44.826 352.222 96s-168.106 96-352.222 96z"
    ],
    "grid": 0,
    "tags": [
      "ion-funnel"
    ]
  },
  {
    "paths": [
      "M822.2 512c0-47.8 29.6-85.6 73.8-111.6-8-26.6-18.6-52.4-31.6-76.4-49.8 13-90-6.4-124-40.4-33.8-33.8-44.2-74.2-31.2-124-24-13-49.6-23.6-76.4-31.6-26 44.4-72.8 73.8-120.8 73.8-47.8 0-94.8-29.4-120.8-73.8-26.8 8-52.4 18.6-76.4 31.6 13 49.8 2.6 90-31.2 124-33.8 33.8-74.2 53.4-123.8 40.4-13.2 24-23.8 49.6-31.8 76.4 44.4 26 74 63.8 74 111.6s-29.6 94.8-74 120.8c8 26.8 18.6 52.4 31.6 76.4 49.8-13 90-2.6 123.8 31.2 34 33.8 44.2 74.2 31.2 124 24.2 13 49.6 23.6 76.4 31.6 26-44.4 73-73.8 120.8-73.8s94.8 29.4 120.8 73.8c26.8-8 52.4-18.6 76.4-31.6-13-49.8-2.6-90 31.2-124 33.8-33.8 74.2-53.4 124-40.4 13-24.2 23.6-49.8 31.6-76.4-44.2-26-73.6-63.8-73.6-111.6zM512 708.6c-108.4 0-196.6-88-196.6-196.6s88-196.6 196.6-196.6c108.6 0 196.6 88 196.6 196.6s-88 196.6-196.6 196.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-gear-a"
    ]
  },
  {
    "paths": [
      "M896 588.8v-153.6h-85.6c-6.8-28.8-17.8-56-32.2-81l59.6-59.4-108.6-108.6-58.2 58.2c-25.2-15.4-52.8-27-82.2-34.6v-81.8h-153.6v81.8c-29.4 7.6-57 19.4-82.2 34.6l-58.2-58.2-108.6 108.6 59.6 59.4c-14.4 25-25.2 52.2-32.2 81h-85.6v153.6h88.2c7.6 27.4 19 53.2 33.4 77.2l-63.4 63.4 108.6 108.6 64.6-64.6c23.4 13.6 49 23.8 75.8 30.8v92h153.6v-92c27-7 52.4-17.2 75.8-30.8l64.6 64.6 108.6-108.6-63.2-63.4c14.4-23.8 25.8-49.6 33.4-77.2h88zM512 619.6c-59.4 0-107.4-48.2-107.4-107.6s48-107.6 107.4-107.6 107.6 48.2 107.6 107.6-48.2 107.6-107.6 107.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-gear-b"
    ]
  },
  {
    "paths": [
      "M320 306.6c0 7.4-6 13.4-13.4 13.4h-101c-7.4 0-13.4-6-13.4-13.4v-101c0-7.4 6-13.4 13.4-13.4h101c7.4 0 13.4 6 13.4 13.4v101z",
      "M576 306.6c0 7.4-6 13.4-13.4 13.4h-101c-7.4 0-13.4-6-13.4-13.4v-101c0-7.4 6-13.4 13.4-13.4h101c7.4 0 13.4 6 13.4 13.4v101z",
      "M832 306.6c0 7.4-6 13.4-13.4 13.4h-101c-7.4 0-13.4-6-13.4-13.4v-101c0-7.4 6-13.4 13.4-13.4h101c7.4 0 13.4 6 13.4 13.4v101z",
      "M320 562.6c0 7.4-6 13.4-13.4 13.4h-101c-7.4 0-13.4-6-13.4-13.4v-101c0-7.4 6-13.4 13.4-13.4h101c7.4 0 13.4 6 13.4 13.4v101z",
      "M576 562.6c0 7.4-6 13.4-13.4 13.4h-101c-7.4 0-13.4-6-13.4-13.4v-101c0-7.4 6-13.4 13.4-13.4h101c7.4 0 13.4 6 13.4 13.4v101z",
      "M832 562.6c0 7.4-6 13.4-13.4 13.4h-101c-7.4 0-13.4-6-13.4-13.4v-101c0-7.4 6-13.4 13.4-13.4h101c7.4 0 13.4 6 13.4 13.4v101z",
      "M320 818.6c0 7.4-6 13.4-13.4 13.4h-101c-7.4 0-13.4-6-13.4-13.4v-101c0-7.4 6-13.4 13.4-13.4h101c7.4 0 13.4 6 13.4 13.4v101z",
      "M576 818.6c0 7.4-6 13.4-13.4 13.4h-101c-7.4 0-13.4-6-13.4-13.4v-101c0-7.4 6-13.4 13.4-13.4h101c7.4 0 13.4 6 13.4 13.4v101z",
      "M832 818.6c0 7.4-6 13.4-13.4 13.4h-101c-7.4 0-13.4-6-13.4-13.4v-101c0-7.4 6-13.4 13.4-13.4h101c7.4 0 13.4 6 13.4 13.4v101z"
    ],
    "grid": 0,
    "tags": [
      "ion-grid"
    ]
  },
  {
    "paths": [
      "M820 64h-104c-6.6 0-12 5.4-12 12v11.2c-8 8-21.8 19.6-35.6 19.6-21 0-29.6-32.8-52.2-36.8s-54.4-6-75.8-6-104 1.4-204 43c-100 41.6-143.4 129.8-144.6 162.8-0.6 17.4 5.4 42.2 20 22.2s70.6-84.6 115.4-89.4c44.6-4.6 91.4 1.6 127.4 34.4 34.6 31.4 42.6 61.6 42.6 147l-13.2 4c-8.6 2.6-14 11.4-14 18 0 0-0.4 13-0.4 140.8-0 189.2-21.6 401.2-21.6 401.2 0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12 0 0-21.6-212-21.6-401.2 0-127.8-0.4-140.8-0.4-140.8 0-6.6-4.6-15.6-14-18l-16-4c0-76.4-0.8-108 12.6-131.8 14-24.8 44.6-45.8 59.4-50.2 11.8-3.6 32 2.6 44 13v29c0 6.6 5.4 12 12 12h104c6.6 0 12-5.4 12-12v-168c0-6.6-5.4-12-12-12z"
    ],
    "grid": 0,
    "tags": [
      "ion-hammer"
    ]
  },
  {
    "paths": [
      "M774.938 579.186c-4.496-2.35-9.55-3.592-14.616-3.592-11.912 0-22.716 6.574-28.208 17.176-36.506 70.692-122.904 111.23-220.106 111.23-99.468 0-187.68-41.124-219.514-109.994-5.178-11.178-16.488-18.398-28.814-18.398-4.588 0-9.042 0.97-13.316 2.926-15.852 7.348-22.794 26.234-15.468 42.114 42.012 90.882 153.374 147.352 277.112 147.352 120.68 0 229.208-54.562 276.482-146.11 8.018-15.522 1.912-34.694-13.552-42.704z",
      "M825.586 462.348c-20.962-27.162-47.538-46.348-89.312-46.348s-68.124 19.146-89.222 46.234c-11.004 14.124-9.050 33.266 7.492 44.414 5.828 3.926 12.694 5.352 19.856 5.352 10.79-0.002 21.014-4.218 27.34-12.358 6.9-8.87 15.414-19.642 34.536-19.642 19.22 0 27.664 10.722 34.46 19.554 6.356 8.208 16.61 12.446 27.434 12.446 7.162 0 14.014-1.416 19.844-5.366 15.102-10.264 18.5-30.134 7.572-44.286z",
      "M377.584 462.348c-20.96-27.162-47.536-46.348-89.31-46.348s-68.126 19.146-89.224 46.234c-11.002 14.124-9.050 33.266 7.494 44.414 5.828 3.926 12.692 5.352 19.854 5.352 10.79-0.002 21.014-4.218 27.338-12.358 6.902-8.87 15.416-19.642 34.538-19.642 19.22 0 27.664 10.722 34.46 19.554 6.354 8.208 16.608 12.446 27.432 12.446 7.164 0 14.014-1.416 19.844-5.366 15.106-10.264 18.504-30.134 7.574-44.286z",
      "M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM783.53 783.53c-72.53 72.526-168.96 112.47-271.53 112.47s-199-39.944-271.53-112.47c-72.526-72.53-112.47-168.96-112.47-271.53s39.944-199 112.47-271.53c72.53-72.526 168.96-112.47 271.53-112.47s199 39.944 271.53 112.47c72.526 72.53 112.47 168.96 112.47 271.53s-39.944 199-112.47 271.53z"
    ],
    "grid": 0,
    "tags": [
      "ion-happy-outline"
    ]
  },
  {
    "paths": [
      "M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM206.544 506.648c-16.544-11.148-18.498-30.29-7.494-44.414 21.098-27.088 47.45-46.234 89.224-46.234s68.348 19.186 89.31 46.348c10.928 14.152 7.53 34.022-7.574 44.288-5.83 3.95-12.682 5.366-19.844 5.366-10.824 0-21.078-4.238-27.432-12.446-6.796-8.832-15.242-19.554-34.46-19.554-19.122 0-27.636 10.774-34.538 19.642-6.326 8.138-16.548 12.356-27.338 12.358-7.162-0.002-14.026-1.428-19.854-5.354zM788.49 621.89c-47.276 91.548-155.802 146.11-276.482 146.11-123.738 0-235.1-56.47-277.112-147.354-7.326-15.878-0.382-34.766 15.468-42.114 4.274-1.956 8.726-2.926 13.316-2.926 12.326 0 23.636 7.22 28.814 18.398 31.834 68.872 120.046 109.996 219.514 109.996 97.204 0 183.6-40.538 220.106-111.23 5.492-10.602 16.296-17.176 28.208-17.176 5.064 0 10.12 1.242 14.616 3.592 15.464 8.010 21.57 27.182 13.552 42.704zM818.012 506.634c-5.83 3.95-12.682 5.366-19.844 5.366-10.824 0-21.078-4.238-27.434-12.446-6.796-8.832-15.24-19.554-34.46-19.554-19.122 0-27.634 10.774-34.536 19.642-6.326 8.138-16.55 12.356-27.34 12.358-7.162 0-14.028-1.426-19.856-5.352-16.542-11.148-18.496-30.29-7.492-44.414 21.098-27.088 47.45-46.234 89.224-46.234 41.776 0 68.35 19.186 89.312 46.348 10.928 14.152 7.53 34.022-7.574 44.286z"
    ],
    "grid": 0,
    "tags": [
      "ion-happy"
    ]
  },
  {
    "paths": [
      "M894.8 476.4c-6.4-119.6-43.8-217.2-112-290.4-0.2-0.2-0.2-0.2-0.4-0.4-15.4-16.8-32.2-31.8-49.6-45.2-18-13.8-37.2-26-57-36.2-50.6-26.2-106-40-164.2-40-58 0-113.2 13.8-163.8 40-19.8 10.2-38.8 22.4-56.8 36.2-17.4 13.4-34 28.4-49.4 45.2-0.2 0.2-0.2 0.2-0.4 0.4-68 73.2-105.4 171-111.8 290.4-5.6 101.4 6.6 259.6 26 323.6 40.6 134 80.8 160 144.2 160s116.4-52.8 116.4-117.8v-212c0-65-46.6-118-106.6-118-36 0-68 19.4-87.6 48.8 0 0-22.2-16.2-26.2-46-4.2-29.8-6.2-64.8 11.2-126 17.4-61 41.6-40.4 71.2-78 5-6.6 10.4-12.8 16-19 6.4-6.8 12.8-13.4 19.6-19.4 3.2-3 6.4-5.6 9.6-8.4 22-18.6 42-34 67.4-45.6 37.8-17.2 78.8-26.6 121-26.6 42 0 83.4 9.4 121.4 26.6 25.4 11.6 45.8 27 67.8 45.6 3.2 2.8 6.4 5.4 9.6 8.4 6.8 6 13.2 12.6 19.6 19.4 5.6 6.2 11 12.4 16 19 29.6 37.6 53.8 17 71.2 78s15.2 96.2 11.2 126c-4.2 29.8-26.2 46-26.2 46-19.6-29.4-51.4-48.8-87.6-48.8-60 0-106.6 52.8-106.6 118v212.2c0 64.8 53 117.8 116.4 117.8s103.6-26 144.2-160c19.4-64.2 31.6-222.4 26.2-323.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-headphone"
    ]
  },
  {
    "paths": [
      "M458 576c2-36 0-76 16-110 4-10 2-20 2-30-8-42-28-80-30-120 0-2.78 2.008-9.542 2.010-12.314-6.432 4.468-15.214 8.048-22.010 10.314-40 12-35.020 5.146-69.020 27.146l-23.866 14.456c32.686-35.878 77.056-49.562 113.050-77.428 0.388-30.876 1.716-61.354 6.274-91.68-81.218-79.502-208.868-77.958-288.192 4.646-90.994 94.688-90.994 248.202 0 342.89l305.698 318.192c-0.17-21.312-0.886-42.352-3.944-62.222-12-72-8-142-8-214z",
      "M644 602c-22-52-66-88-126-100-1.7 0-3.758-1.086-5.872-2.638-0.046 0.214-0.082 0.426-0.128 0.638-22 96-46 188-42 284 0 24.454 7.966 50.234 7.666 76.262l34.334 35.738 208-216.5c-29.694-20.958-59.144-42.258-76-77.5z",
      "M859.748 191.14c-80.852-84.188-211.978-84.188-292.816 0l-38.932 39.666c0.15 26.35 0.426 52.404-6 77.194-4 20-38 38-32 62 6.006 26.426 16.332 51.41 21.464 77.118 30.564 17.050 58.078 38.674 82.536 64.882 45.602 53.532 75.494 114.918 130.566 162.742l135.182-140.71c91.002-94.69 91.002-248.204 0-342.892z"
    ],
    "grid": 0,
    "tags": [
      "ion-heart-broken"
    ]
  },
  {
    "paths": [
      "M859.8 191.2c-80.8-84.2-212-84.2-292.8 0l-55 57-55-57.2c-81-84.2-212-84.2-292.8 0-91 94.6-91 248.2 0 342.8l347.8 362.2 347.8-362c91-94.6 91-248.2 0-342.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-heart"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448 448-200.6 448-448-200.6-448-448-448zM868.6 369l-123 37.8c-12.6-28-30.2-53.6-52.6-76s-48-40-76-52.6l37.8-123c47.6 19 91.2 47.8 128.6 85 37.4 37.6 66.2 81.2 85.2 128.8zM512 704c-106 0-192-86-192-192s86-192 192-192 192 86 192 192c0 106-86 192-192 192zM240.4 240.4c37.4-37.4 81-66 128.6-85l37.8 123c-28 12.6-53.6 30.2-76 52.6s-40 48-52.6 76l-123-37.8c19.2-47.8 48-91.4 85.2-128.8zM155.4 655l123-37.8c12.6 28 30.2 53.6 52.6 76s48 40 76 52.6l-37.8 123c-47.6-19-91.2-47.8-128.6-85-37.4-37.6-66.2-81.2-85.2-128.8zM783.6 783.6c-37.4 37.4-81 66-128.6 85l-37.8-123c28-12.6 53.6-30.2 76-52.6s40-48 52.6-76l123 37.8c-19.2 47.8-48 91.4-85.2 128.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-help-buoy"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448c247.4 0 448-200.6 448-448s-200.6-448-448-448zM552.4 717.4c-1 35.6-27.4 57.6-61.6 56.6-32.8-1-58.6-24.4-57.6-60.2 1-35.6 28.2-58.2 61-57.2 34.4 1 59.4 25.2 58.2 60.8zM649.8 462.8c-8.4 11.8-27.2 27-50.8 45.4l-26.2 18c-12.8 9.8-20.8 21.4-25 34.6-2.2 7-3.8 25.2-4.2 37.4-0.2 2.4-1.6 7.8-9 7.8s-70 0-78.2 0c-8.2 0-9.2-4.8-9-7.2 1.2-33.2 6-60.6 19.8-82.6 18.6-29.6 71-60.8 71-60.8 8-6 14.2-12.4 19-19.4 8.8-12 16-25.4 16-39.8 0-16.6-4-32.4-14.6-45.6-12.4-15.4-25.8-22.8-51.6-22.8-25.4 0-40.2 12.8-50.8 29.6s-8.8 36.6-8.8 54.6h-97.4c0-68 17.8-111.4 55.4-137 25.4-17.4 57.8-25 95.6-25 49.6 0 89 9.2 123.8 35.6 32.2 24.4 49.2 58.8 49.2 105.2 0 28.6-10 52.6-24.2 72z"
    ],
    "grid": 0,
    "tags": [
      "ion-help-circled"
    ]
  },
  {
    "paths": [
      "M690.2 154.2c-55-41.8-117-56.2-195.6-56.2-59.6 0-110.6 12.2-151 39.4-59.6 40.6-87.6 108.8-87.6 216.6h153.6c0-28.8-2.8-59.8 14-86.4s40.2-47 80.4-47c40.8 0 61.8 11.8 81.6 36.2 16.8 20.8 23.2 45.6 23.2 72 0 22.8-11.6 43.8-25.4 62.8-7.6 11.2-17.6 21.2-30.2 30.8 0 0-83 49.4-112.2 96.2-21.8 34.8-29.6 78.4-31.4 130.6-0.2 3.8 1.2 11.6 14.4 11.6 13 0 112 0 123.6 0s14-8.8 14.2-12.4c0.8-19 3.2-48.2 6.6-59.2 6.6-20.8 19.4-39 39.4-54.6l41.4-28.6c37.4-29.2 67.2-53 80.4-71.8 22.6-30.8 38.4-68.8 38.4-113.8 0-73.4-27-127.6-77.8-166.2zM484 740.4c-51.8-1.6-94.6 34.4-96.4 90.6-1.6 56.4 39 93.4 91 95 54 1.6 95.8-33.2 97.4-89.4s-38-94.6-92-96.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-help"
    ]
  },
  {
    "paths": [
      "M896 576l-384-448-384 448h96v320h192v-256h192v256h192v-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-home"
    ]
  },
  {
    "paths": [
      "M256 512l256 448 256-448z",
      "M805 345.2c-1.6-0.8-3-1.6-4.6-2.6-8.8-5.6-16.8-17-17.4-25.4l0.2-1.4c6.4-18 10-38.4 10-59.6 0-106.2-86-192.2-192.2-192.2-62.8 0-118.4 30-153.6 76.6 0 0-18.2 28-21.6 58 0 0 2.2-38.8 8.4-63-14.8-5-30.8-7.6-47.2-7.6-83.4 0-151.2 67.6-151.2 151.2 0 12.8 1.6 25.2 4.6 37 0 0.8-0.2 1.4-0.4 2-1.8 10.2-8 19-16.8 24.6-1.4 1-3 1.8-4.4 2.6-16.4 10-27 27.2-27 46.8 0 30.8 27 56 59.8 56h520.4c32.8 0 59.6-25 59.6-56 0.4-19.6-10.4-37-26.6-47z"
    ],
    "grid": 0,
    "tags": [
      "ion-icecream"
    ]
  },
  {
    "paths": [
      "M736 448c53 0 96-43 96-96s-43-96-96-96c-53 0-96 43-96 96s43 96 96 96z",
      "M904 128h-784c-31.2 0-56 25.4-56 56.6v654.8c0 31.2 24.8 56.6 56 56.6h784c31.2 0 56-25.4 56-56.6v-654.8c0-31.2-24.8-56.6-56-56.6zM697.8 523.4c-6-7-15.2-12.4-25.6-12.4-10.2 0-17.4 4.8-25.6 11.4l-37.4 31.6c-7.8 5.6-14 9.4-23 9.4-8.6 0-16.4-3.2-22-8.2-2-1.8-5.6-5.2-8.6-8.2l-107.6-116.4c-8-9.2-20-15-33.4-15s-25.8 6.6-33.6 15.6l-253 305.2v-521c2-13.6 12.6-23.4 26.2-23.4h715.4c13.8 0 25 10.2 25.8 24l0.6 520.8-198.2-213.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-image"
    ]
  },
  {
    "paths": [
      "M915.2 280.4l-165-8-9.6-107.6c-2-22.6-22.2-38.4-45.8-36.6l-592 48.6c-23.6 2-40.6 21-38.8 43.4l42.4 471.6c2 22.6 22.4 38.4 45.8 36.6l30-2.4-4.8 91.6c-1.2 25.2 18.4 45.6 44.8 47l660.4 31.4c26.4 1.2 48.2-17.2 49.6-42.4l27.8-526.6c1.2-25-18.6-45.4-44.8-46.6zM205.2 291l-14.2 269.6-34.8 49.4-32-356c0-0.4 0-0.6 0-1s0-0.6 0-1c1-10 8.6-18 19-18.8l522-42.8c10.4-0.8 19.4 6 21 15.8 0 0.4 0.6 0.4 0.6 0.8 0 0.2 0.6 0.4 0.6 0.8l5.4 61.6-438-21c-26.4-0.8-48.4 17.6-49.6 42.6zM873.4 764.8l-93.4-110.6-55-65.4c-4.8-5.8-12.6-10.6-21.2-11s-15 3-22.2 8.2l-32.8 23.8c-7 4.2-12.4 7-19.8 6.6-7.2-0.4-13.6-3.2-18.2-7.6-1.6-1.6-4.6-4.4-7-6.8l-85.6-97.8c-6.2-7.8-16.4-12.8-27.6-13.4-11.4-0.6-22.4 4.2-29.6 11.2l-215.8 232.4 0.6-13.6 13.6-257.8 6.6-125.8c0-0.4 0-0.8 0-1 0-0.4 0-0.8 0-1 2.8-10.8 12.4-18.6 23.8-18l582.4 28c11.6 0.6 20.6 9.4 20.8 20.4 0 0.4 0.6 0.6 0.6 1s0.6 0.6 0.6 1l-20.8 397.2z",
      "M746.4 524.6c38.8 0 70.4-31.6 70.4-70.4s-31.4-70.4-70.4-70.4c-38.8 0-70.4 31.4-70.4 70.4s31.4 70.4 70.4 70.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-images"
    ]
  },
  {
    "paths": [
      "M960 506c-3.4-247.4-206.6-445.2-454-442s-445.2 206.6-442 454c3.4 247.4 206.6 445.2 454 442 247.4-3.4 445.4-206.6 442-454zM512 223.8c35.4 0 64 28.6 64 64s-28.6 64-64 64c-35.4 0-64-28.6-64-64s28.6-64 64-64zM600 790h-176v-22h44v-320h-44v-24h132v344h44v22z"
    ],
    "grid": 0,
    "tags": [
      "ion-information-circled"
    ]
  },
  {
    "paths": [
      "M576 896v-512h-192v32h64v480h-64v32h256v-32z",
      "M511.6 289c53.2 0 96.4-43.2 96.4-96.4s-43.2-96.4-96.4-96.4c-53.2 0-96.4 43.2-96.4 96.4s43.2 96.4 96.4 96.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-information"
    ]
  },
  {
    "paths": [
      "M847.184 265.608c6.828-10.18 10.816-22.428 10.816-35.608 0-35.35-28.66-64-64-64-13.18 0-25.428 3.988-35.61 10.818-68.972-50.788-154.17-80.818-246.39-80.818-229.75 0-416 186.25-416 416 0 229.754 186.25 416 416 416 229.746 0 416-186.246 416-416 0-92.222-30.032-177.42-80.816-246.392zM783.66 783.664c-35.292 35.292-76.382 62.998-122.128 82.348-47.344 20.024-97.652 30.178-149.532 30.178s-102.19-10.154-149.534-30.178c-45.746-19.35-86.834-47.054-122.128-82.348s-63-76.382-82.348-122.128c-20.026-47.344-30.18-97.656-30.18-149.536s10.154-102.19 30.178-149.534c19.348-45.746 47.054-86.834 82.348-122.128s76.382-63 122.128-82.348c47.346-20.026 97.656-30.18 149.536-30.18 51.878 0 102.188 10.154 149.532 30.178 26.892 11.374 52.16 25.66 75.604 42.654-4.55 8.796-7.136 18.772-7.136 29.358 0 35.35 28.654 64 64 64 10.586 0 20.56-2.586 29.356-7.136 16.996 23.442 31.282 48.71 42.654 75.602 20.026 47.344 30.18 97.654 30.18 149.534 0 51.878-10.154 102.192-30.18 149.536-19.35 45.746-47.054 86.836-82.35 122.128z",
      "M704.006 512c0 106.039-85.961 192-192 192s-192-85.961-192-192c0-106.039 85.961-192 192-192s192 85.961 192 192z"
    ],
    "grid": 0,
    "tags": [
      "ion-ionic"
    ]
  },
  {
    "paths": [
      "M876.8 384.8c24.4-28.4 39.2-64.6 39.2-104.4 0.2-87.6-71-159.2-160.8-164.2-3.2-0.2-6.2-0.2-9.6-0.2-40.8-0.2-78.2 13.6-107.6 36.2l107.6 104.8-21 20.8c-51.4-38.8-114-64-182-69.8v-0.2c0-17-14-31-31-31s-31 14-31 31v0.2c-67.8 5.8-130.2 31-181.4 69.8l-20.8-20.8 107.6-104.8c-29.4-22.8-66.8-36.4-107.4-36.2-3.2 0-6.4 0.2-9.6 0.2-90 5-161.2 76.6-160.8 164.2 0 39.6 14.8 76 39.2 104.4l108-105.2 19 19c-70.2 63.8-114.2 156-114.2 258.4 0 87.8 32.4 168 86 229.4l-72.8 89.2 24.6 20.4 70.4-85.8c63.2 60.4 148.8 97.8 243.2 97.8h0.2c0 0 0.4 0 0.6 0 94.4 0 180.4-37.4 243.6-97.8l70.4 86 24.6-20.2-73-89.4c53.6-61.6 86-141.8 86-229.4 0-102.2-44-194.6-114.4-258.6l19-19 108.2 105.2zM152.4 335.6c-8.4-17.2-12.8-36.8-13-56-0.2-70.2 56.8-129.2 131-133.6 25.4-1.4 46.2 2.8 64.2 12.2l-182.2 177.4zM831.8 553c0 175.4-144 314.2-320.2 314.2-176 0-319.6-138.8-319.6-314.2s143.6-317.4 319.8-317.4c176.2-0 320 141.8 320 317.4zM689.4 158.4c17.6-9.6 38.6-13.6 64.2-12.2 74.4 4 131.2 63 131 133.6 0 19.2-4.6 38.8-13 56.2l-182.2-177.6z",
      "M512 320v256h-192v32h224v-288z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-alarm-outline"
    ]
  },
  {
    "paths": [
      "M876.8 384.8c24.4-28.4 39.2-64.6 39.2-104.4 0.2-87.6-71-159.2-160.8-164.2-3.2-0.2-6.2-0.2-9.6-0.2-40.8-0.2-78.2 13.6-107.6 36.2l107.6 104.8-21.2 20.8c-51.4-38.8-114.4-64-182.4-69.8v-0.2c0-17-14-31-31-31s-31 14-31 31v0.2c-68 5.8-130 31-181.2 69.8l-20.8-20.6 107.6-104.8c-29.4-22.8-66.8-36.4-107.4-36.2-3.2 0-6.4 0.2-9.6 0.2-90 5-161.2 76.6-160.8 164.2 0 39.6 14.8 76 39.2 104.4l108-105.2 19 19c-70.2 63.8-114.2 156-114.2 258.4 0 87.8 32.4 168 86 229.4l-72.8 89.2 25 20.2 70.4-85.8c63.2 60.4 148.8 97.8 243.2 97.8h0.2c0 0 0.4 0 0.6 0 94.4 0 180.4-37.4 243.6-97.8l70.4 86 24.6-20.2-73-89.4c53.6-61.6 86-141.8 86-229.4 0-102.2-44-194.6-114.4-258.6l19-19 108.2 105.2zM544 608h-224v-32h192v-256h32v288z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-alarm"
    ]
  },
  {
    "paths": [
      "M928 288v576h-832v-576h832zM960 256h-896v640h896v-640z",
      "M144 192h736v32h-736v-32z",
      "M208 128h608v32h-608v-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-albums-outline"
    ]
  },
  {
    "paths": [
      "M960 256h-896v640h896v-640z",
      "M144 192h736v32h-736v-32z",
      "M208 128h608v32h-608v-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-albums"
    ]
  },
  {
    "paths": [
      "M757.21 266.79c-145.406-145.408-378.45-170.794-523.51-170.79-77.852 0.002-130.382 7.316-130.382 7.316s-59.968 430.454 163.472 653.894c145.408 145.408 378.444 170.79 523.508 170.79 77.852 0 130.384-7.316 130.384-7.316s59.97-430.452-163.472-653.894zM130.284 130.416c21.99-2.028 58.464-4.416 103.428-4.416h0.288l-0.136-0.142c54.334 0 106.334 3.508 155.584 10.44l-253.2 253.162c-2.050-14.566-3.82-29.394-5.28-44.492-9.172-94.87-4.172-176.456-0.684-214.552zM287.8 736.204c-47.7-47.704-85.586-109.876-112.608-184.792-13.946-38.664-25.020-80.746-33.14-125.732l283.624-283.58c21.344 3.858 42.128 8.382 62.282 13.608 104.054 26.984 187.566 71.416 248.278 132.128 47.702 47.7 85.572 109.856 112.594 184.772 13.948 38.666 25.018 80.75 33.134 125.742l-283.624 283.622c-21.32-3.86-42.082-8.382-62.208-13.602-104.060-26.978-187.612-71.452-248.332-132.166zM893.722 893.736c-21.988 2.024-58.46 4.55-103.42 4.55-54.384 0-106.45-3.54-155.752-10.5l253.214-253.214c2.048 14.558 3.816 29.376 5.276 44.466 9.176 94.874 4.172 176.596 0.682 214.698z",
      "M614.608 635.694l45.25 45.264-57.308 57.304 22.63 22.628 135.762-135.762-22.628-22.628-57.442 57.442-45.25-45.262 57.432-57.434-22.626-22.626-57.43 57.428-45.266-45.276 57.404-57.404-22.626-22.628-57.4 57.4-45.252-45.262 57.394-57.394-22.628-22.626-57.388 57.39-45.262-45.274 57.374-57.374-22.626-22.626-57.37 57.37-45.248-45.26 57.364-57.364-22.626-22.626-135.766 135.764 22.628 22.628 57.386-57.388 45.248 45.26-57.382 57.382 22.626 22.626 57.378-57.378 45.26 45.274-57.356 57.358 22.626 22.626 57.354-57.354 45.252 45.262-57.348 57.348 22.628 22.626 57.342-57.342 45.266 45.276-57.32 57.32 22.628 22.628z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-americanfootball-outline"
    ]
  },
  {
    "paths": [
      "M757.21 266.79c-145.406-145.408-378.448-170.794-523.51-170.79-77.852 0.002-130.382 7.316-130.382 7.316s-59.968 430.454 163.472 653.894c145.408 145.408 378.444 170.79 523.506 170.79 77.854 0 130.386-7.316 130.386-7.316s59.972-430.452-163.472-653.894zM136.248 389.456l253.166-253.164c12.246 1.722 24.328 3.65 36.224 5.798l-283.588 283.586c-2.14-11.874-4.076-23.952-5.802-36.22zM534.624 670.39l57.376-57.376-45.254-45.256-57.376 57.376-22.626-22.624 57.376-57.376-45.254-45.254-57.376 57.376-22.626-22.624 57.376-57.376-45.256-45.256-57.376 57.376-22.626-22.624 57.378-57.378-45.256-45.254-57.376 57.376-22.628-22.626 135.768-135.766 22.626 22.628-57.376 57.376 45.256 45.254 57.376-57.376 22.626 22.626-57.376 57.376 45.256 45.256 57.376-57.376 22.628 22.626-57.376 57.376 45.254 45.254 57.376-57.376 22.626 22.624-57.376 57.376 45.256 45.256 57.376-57.376 22.624 22.626-57.376 57.376 45.254 45.254 57.376-57.376 22.628 22.624-135.766 135.768-22.626-22.626 57.376-57.376-45.256-45.256-57.376 57.376-22.63-22.628zM634.518 887.782c-12.242-1.726-24.318-3.66-36.208-5.812l283.648-283.65c2.142 11.876 4.076 23.954 5.802 36.222l-253.242 253.24z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-americanfootball"
    ]
  },
  {
    "paths": [
      "M512 96c56.174 0 110.65 10.994 161.916 32.678 49.534 20.952 94.026 50.952 132.24 89.166s68.214 82.708 89.166 132.24c21.684 51.266 32.678 105.742 32.678 161.916s-10.994 110.65-32.678 161.916c-20.952 49.534-50.952 94.026-89.166 132.24s-82.708 68.214-132.24 89.166c-51.266 21.684-105.742 32.678-161.916 32.678s-110.65-10.994-161.916-32.678c-49.534-20.952-94.026-50.952-132.24-89.166s-68.214-82.708-89.166-132.24c-21.684-51.266-32.678-105.742-32.678-161.916s10.994-110.65 32.678-161.916c20.952-49.534 50.952-94.026 89.166-132.24s82.708-68.214 132.24-89.166c51.266-21.684 105.742-32.678 161.916-32.678zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448v0z",
      "M215.552 640c-50.504 0-82.336-36.896-83.804-38.634-5.682-6.718-4.802-16.742 1.964-22.384 6.748-5.626 16.802-4.776 22.496 1.896 1.208 1.402 29.212 33.194 71.212 26.372 24.208-3.928 56.16-51.362 77.304-82.752 8.502-12.622 15.844-23.522 22.43-31.712 33.546-41.73 67.798-46.666 90.65-43.452 48.278 6.788 88.716 54.996 107.378 99.764 14.908 35.768 38.084 56.512 65.256 58.416 30.816 2.122 63.078-19.77 86.21-58.672 2.456-4.128 5.124-8.992 7.956-14.14 18.964-34.524 47.628-86.7 103.5-86.7 62.292 0 103.914 68.572 105.656 71.492 4.504 7.548 1.992 17.296-5.612 21.77-7.6 4.474-17.416 1.976-21.92-5.572-0.074-0.124-8.986-14.826-23.718-29.136-12.572-12.214-32.216-26.774-54.406-26.774-36.876 0-58.242 38.89-75.41 70.14-2.96 5.392-5.76 10.486-8.49 15.076-29.436 49.502-72.8 77.27-116.020 74.216-39.902-2.796-72.778-30.484-92.568-77.96-20.026-48.040-56.558-76.834-82.298-80.456-21.2-2.988-41.79 7.722-61.156 31.812-5.744 7.146-13.078 18.034-20.842 29.558-27.098 40.228-60.822 90.292-98.74 96.446-5.882 0.954-11.566 1.386-17.028 1.386z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-analytics-outline"
    ]
  },
  {
    "paths": [
      "M512 64c-229.652 0-418.912 172.808-444.92 395.478-2.012 17.23-3.080 34.75-3.080 52.522 0 3.566 0.052 7.122 0.134 10.666 5.668 242.496 204.008 437.334 447.866 437.334 210.51 0 387.074-145.204 435.084-340.908 2.674-10.902 4.948-21.958 6.808-33.158 3.994-24.056 6.108-48.746 6.108-73.934 0-247.424-200.576-448-448-448zM925.17 560.704c-14.53-15.614-26.128-32.18-31.404-40.858-1.742-2.94-43.364-71.988-105.656-71.988-55.874 0-84.538 52.538-103.502 87.3-2.83 5.186-5.5 10.082-7.956 14.236-23.132 39.174-55.386 61.216-86.21 59.082-27.172-1.918-50.348-22.806-65.256-58.82-18.662-45.080-59.102-93.624-107.378-100.458-22.856-3.238-57.106 1.732-90.65 43.752-6.586 8.248-13.928 19.224-22.43 31.934-21.144 31.608-53.098 79.372-77.306 83.326-42.040 6.876-70.042-25.192-71.166-26.498l-0.974-1.16-1.174-0.958c-0.416-0.34-30.082-24.834-58.094-66.668 0-0.31-0.012-0.62-0.012-0.928 0-56.174 10.994-110.65 32.678-161.916 20.952-49.534 50.952-94.026 89.166-132.24s82.708-68.214 132.24-89.166c51.264-21.682 105.74-32.676 161.914-32.676s110.65 10.994 161.916 32.678c49.534 20.952 94.026 50.952 132.24 89.166s68.214 82.708 89.166 132.24c21.684 51.266 32.678 105.742 32.678 161.916 0 16.394-0.964 32.636-2.83 48.704z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-analytics"
    ]
  },
  {
    "paths": [
      "M704 256.8l-64.6-64.8-319.4 320 319.4 320 64.6-64.8-254.6-255.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-back"
    ]
  },
  {
    "paths": [
      "M793.2 320l38.8 41.4-320 342.6-320-342.6 38.6-41.4 281.4 301z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-down"
    ]
  },
  {
    "paths": [
      "M320 256.8l64.6-64.8 319.4 320-319.4 320-64.6-64.8 254.6-255.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-forward"
    ]
  },
  {
    "paths": [
      "M704 230.8l-41.4-38.8-342.6 320 342.6 320 41.4-38.6-301-281.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-left"
    ]
  },
  {
    "paths": [
      "M320 230.8l41.4-38.8 342.6 320-342.6 320-41.4-38.6 301-281.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-right"
    ]
  },
  {
    "paths": [
      "M699.4 644.4c-6.2-6.2-16-6-22.6 0l-148.8 132.8v-569.2c0-8.8-7.2-16-16-16s-16 7.2-16 16v569.2l-148.8-132.6c-6.8-5.8-16.2-6.4-22.4-0.2s-6.6 17-0.2 22.8c0 0 174 158.4 176 160s5.6 4.8 11.4 4.8 9.8-3.2 11.4-4.8 176-160 176-160c3-3 4.6-7.2 4.6-11.4s-1.6-8.2-4.6-11.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-thin-down"
    ]
  },
  {
    "paths": [
      "M379.6 699.4c6.2-6.2 6-16 0-22.6l-132.8-148.8h569.2c8.8 0 16-7.2 16-16s-7.2-16-16-16h-569.2l132.6-148.8c5.8-6.8 6.4-16.2 0.2-22.4s-17-6.6-22.8-0.2c0 0-158.4 174-160 176s-4.8 5.6-4.8 11.4 3.2 9.8 4.8 11.4 160 176 160 176c3 3 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-thin-left"
    ]
  },
  {
    "paths": [
      "M644.4 699.4c-6.2-6.2-6-16 0-22.6l132.8-148.8h-569.2c-8.8 0-16-7.2-16-16s7.2-16 16-16h569.2l-132.6-148.8c-5.8-6.8-6.4-16.2-0.2-22.4s17-6.6 22.8-0.2c0 0 158.4 174 160 176s4.8 5.6 4.8 11.4-3.2 9.8-4.8 11.4-160 176-160 176c-3 3-7.2 4.6-11.4 4.6s-8.2-1.6-11.4-4.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-thin-right"
    ]
  },
  {
    "paths": [
      "M699.4 379.6c-6.2 6.2-16 6-22.6 0l-148.8-132.8v569.2c0 8.8-7.2 16-16 16s-16-7.2-16-16v-569.2l-148.8 132.6c-6.8 5.8-16.2 6.4-22.4 0.2s-6.6-17-0.2-22.8c0 0 174-158.4 176-160s5.6-4.8 11.4-4.8 9.8 3.2 11.4 4.8 176 160 176 160c3 3 4.6 7.2 4.6 11.4s-1.6 8.2-4.6 11.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-thin-up"
    ]
  },
  {
    "paths": [
      "M793.2 704l38.8-41.4-320-342.6-320 342.6 38.6 41.4 281.4-301z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-arrow-up"
    ]
  },
  {
    "paths": [
      "M728.8 641.8c-10.6 15-23.2 29.4-37.6 42.8-14.2 13.2-30.2 25-47.4 34.8s-35.8 17.6-55 23-39.6 8.2-60.6 8.2c-31.8 0-62.4-5.2-91-15.2-28.4-10-53.6-25-75-44.8-21.4-19.6-43.4-51.8-56.4-82-11.6-26.8-16.2-55.6-16.2-99 0-31.2 7.2-66 19.6-95.2 12-28 28.6-52.8 49.8-73.8 20.8-20.6 46-37.2 75.2-49.6 26.2-11 57-16.4 94.2-16.4 29.8 0 58 4.8 83.8 14 25.6 9.2 47.8 22.4 66.2 39.2 17.4 15.8 28 34.8 39.4 60.4 10 22.4 13.6 41.8 13.6 71.8 0 24.8-4.4 48.2-13 69.8-8.6 21.2-15 34-28 50-13.2 15.8-21.2 25.4-36.2 34.2-17.2 10-30.6 14.8-42 14.8-7.2 0-12.6-1.4-15.6-4s-4.8-6-5.4-10.8c-0.8-5.6-0.2-12.6 2-20.8 2.2-8.8 5.6-17.2 9.8-27.4l75.8-203.8h-35.6l-12.4 33c-7.6-12.2-18.2-23-31.8-31-21-12.2-39-17.6-62.4-17.6-27 0-52 7-74.4 20.8-22 13.6-41 31.2-56.4 52.6-15 20.6-18.6 31.4-25.8 52.8l-1.2 3.4c-8.4 24.8-12.6 49.2-12.6 72.4 0 15.4 2.8 30 8.2 43.6s12.8 25.6 22.2 35.6c9.4 10.2 20.8 18.2 33.8 24.2s27.4 9 42.6 9c17 0 33.2-2.8 52.2-9.4 12.6-4.4 23.8-11.6 34.8-22.8 2 6.4 5.4 12 10.6 17 10 10 23.4 15.2 39.8 15.2 17.2 0 35.6-6 58-18.6 19.8-11.2 31.4-24 46.6-42.2 16.4-19.6 24.6-36 33.8-59.4 10-25 15-52 15-80.6 0-36-4.8-60.4-17-87.2-13.2-28.6-26.4-51.6-48-70.8-21.8-19.2-47.8-34.2-77-44.6-29-10.2-60.6-15.4-93.4-15.4-40.2 0-74.4 6-104.4 18.2-33 13.4-61.8 32-86 55.2-24.4 23.6-44 51.8-58 83.8-14.6 33.2-22.8 73.4-22.8 110.2 0 50.2 6.2 85.2 20.6 116.8 16 34.6 42 70.8 66.6 92 25.2 21.8 54.2 38.2 86.4 48.4 31.8 10.2 64.6 15.4 97.6 15.4 22.8 0 45.6-3.2 68-9.2 22.4-6.2 44-14.8 64.2-26.2 20.2-11.2 39-25 56.4-41.2 17.2-16.2 37.2-41.6 44-53.8 2.6-4.8 4.4-8.6 5.8-11.6h-37l-1 1.8zM551.6 588.8c-8.8 11.2-15.4 19-23.6 24.4-8.8 6-15.8 9.8-24.8 11.8-9.2 2.4-18.6 3.4-27.4 3.4-11.2 0-21.6-2-30.8-6-9.4-4-17.4-9.6-24.2-16.8s-12.2-15.8-16.2-25.4c-3.8-9.6-5.8-20.4-5.8-32 0-19 3.6-39.4 10.6-60.6 0.8-2.4 1.6-4.8 2.2-6.8 5.6-17.2 8.6-23 19-40 11.4-18.8 28.2-33.2 46-45 17.2-11.6 36.4-17.4 57-17.4 8.4 0 17.2 1 26.4 3 7.2 1.6 11.2 3.8 18 7.8 1.2 0.6 2.2 1.2 3.4 2 7.8 4.4 14.8 10.2 20.8 17.4 5.4 6.4 9.6 14.8 12.6 24.6l-41.2 115.6c-6.4 16.2-13.8 29.6-22 40z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-at-outline"
    ]
  },
  {
    "paths": [
      "M712 640c-19.4 26.6-59.8 57-76.2 66.2s-33.8 16.6-52 21.6c-18 5-37.2 7.8-56.8 7.8-29.8 0-58.8-4.8-86-14.4-26.6-9.4-50.4-23.6-70.2-42-19.8-18-40.6-48.4-53-77-10.6-24.8-15.2-51.6-15.2-93 0-29.4 6.8-61.8 18.4-89.4 11.2-26.4 27-49.8 46.6-69.2 19.4-19.2 43.2-35 70.6-46.6 24.6-10.2 53.4-15.4 88.8-15.4 27.8 0 54.4 4.4 78.8 13.2 23.8 8.6 44.6 20.8 61.8 36.6 16 14.6 25.8 32.2 36.4 56.2 9.2 20.4 12.6 38.4 12.6 66.6 0 23-4 44.8-12 64.8-8 19.6-14 31.6-26 46.6-12.6 15.2-19.6 23.6-33 31.2-15.6 9.2-27.4 13.4-37 13.4-7.6 0-10-1.8-10.2-2-1.2-1-2.2-2.4-2.8-5.6-0.6-4.4 0-10.4 1.8-17.2 2-7.8 4.8-15.4 9.2-25.8l78-208.6h-51.2l-9 24c-7-8.2-15.4-15-24.8-20.4-22.2-12.8-40.8-18-64.6-18-27.6 0-53.4 7.2-76.4 21.4-22.4 13.8-41.6 31.6-57 53-15.2 21-19 32.2-26 53l-1.2 3.6c-8.4 24.8-12.6 49.4-12.6 72.8 0 15.8 3 31 8.6 45.2 5.6 14.4 13.4 26.8 23.2 37 9.6 10.4 21.4 18.8 35.4 25.2 13.6 6.2 28.6 9.6 44.8 9.6 17.8 0 34.2-3 53.4-9.6 10.6-3.6 19.8-9 28.8-16.6 2 3.4 4.4 6.2 7.4 9 11.2 11.2 26.2 17 44.2 17 17.8 0 37.2-6 60.4-19 20.6-11.6 32.6-25 47.4-42.8 16.8-20 25-37.2 34-59.8 10.2-25 15.2-52.4 15.2-81.2 0-36.2-4.8-60.8-17.4-88-13.2-28.8-26.6-51.8-48.6-71.2-21.8-19.4-47.8-34.4-77.4-44.8-29.2-10.2-60.6-15.4-93.4-15.4-40 0-74.4 6-104.4 18.2-32.6 13.2-61.6 31.8-86.2 55.2-24.6 23.6-44.2 52-58.2 84-14.6 33-22.8 73-22.8 110.2 0 50 6.2 84.8 20.8 116.8 16.2 35 42.4 71 66.8 91.8 25.4 22.2 54.6 38.4 86.8 48.6 31.8 10.2 64.6 15.4 97.2 15.4 22.4 0 45.4-3.2 68.2-9.2 23.2-6.4 44.8-15.2 64.2-26.2 19.8-11 39-24.8 56.4-41.2 17.6-16.4 38.8-41.8 45.8-54.2 2.4-4.6 4.4-8.4 5.6-11.2h-56zM543.8 581.2c-8.8 11-14.4 17.8-21.2 22.4-7.6 5.2-13.6 8.4-21.4 10.4h-0.2c-7.8 2-16.2 3-24.8 3-10 0-18.8-1.8-26.8-5.4-8.2-3.4-15-8.2-21-14.6-5.8-6.2-10.8-13.6-14.2-22.2s-5-18-5-28.2c0-17.4 3.4-36.6 10-56.4 0.8-2.4 1.6-4.8 2.2-6.6 5.2-16.2 8-21.2 17.8-37.2 9-14.8 23-28.4 42.4-41.4 15.4-10.2 32.4-15.6 51.2-15.6 7.6 0 15.6 1 24 2.8 6 1.4 9.2 3.2 15.2 6.6l0.4 0.2c0.8 0.4 1.6 0.8 2.6 1.4l0.6 0.4c6.8 3.8 12.8 9 18 15.2 4 4.8 7.4 11 10 18.8l-39.6 109.6c-6 14.8-12.8 27.2-20.2 36.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-at"
    ]
  },
  {
    "paths": [
      "M96 768h160v-32h-128v-448h128v-32h-160z",
      "M768 256v32h128v448h-128v32h160v-512z",
      "M224 384h32v256h-32v-256z",
      "M768 384h32v256h-32v-256z",
      "M640 320h32v384h-32v-384z",
      "M352 320h32v384h-32v-384z",
      "M494 352h32v320h-32v-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-barcode-outline"
    ]
  },
  {
    "paths": [
      "M96 256v512h832v-512h-832zM256 640h-32v-256h32v256zM384 704h-32v-384h32v384zM526 672h-32v-320h32v320zM672 704h-32v-384h32v384zM800 640h-32v-256h32v256z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-barcode"
    ]
  },
  {
    "paths": [
      "M925.372 558.738c0.264-2.364 0.514-4.73 0.738-7.108 0.008-0.076 0.014-0.156 0.022-0.234 1.218-12.97 1.868-26.106 1.868-39.396 0-229.726-186.26-416-416-416-15.902 0-31.584 0.924-47.024 2.662-0.178 0.020-0.36 0.036-0.54 0.056 0 0.002 0 0.004 0 0.006-194.022 22.094-347.552 177.674-366.458 372.65-0.002 0-0.006 0-0.008 0-0.144 1.496-0.262 2.994-0.39 4.492-0.272 3.152-0.506 6.314-0.706 9.486-0.052 0.836-0.112 1.67-0.16 2.508-0.128 2.242-0.232 4.49-0.326 6.742-0.022 0.562-0.042 1.124-0.064 1.686-0.194 5.214-0.324 10.448-0.324 15.712 0 229.726 186.274 416 416 416 5.254 0 10.478-0.13 15.686-0.324 0.586-0.022 1.172-0.042 1.756-0.066 2.22-0.092 4.438-0.196 6.648-0.32 0.908-0.050 1.812-0.116 2.718-0.172 3.208-0.206 6.402-0.444 9.59-0.72 1.408-0.122 2.82-0.23 4.226-0.368 0-0.002 0-0.006 0-0.008 194.988-18.904 350.558-172.432 372.652-366.458 0.002 0 0.004 0 0.008 0 0.032-0.274 0.056-0.55 0.088-0.826zM893.33 512c0 5.136-0.132 10.244-0.334 15.332-20.668-0.936-41.104-3.38-61.228-7.328l12.22-38.112-30.464-9.768-12.976 40.47c-15.182-4.224-30.16-9.302-44.884-15.276-9.952-4.036-19.702-8.446-29.25-13.208l23.036-34.006-26.494-17.948-24.718 36.492c-24.482-14.7-47.406-31.954-68.61-51.624l29.46-29.46-22.626-22.626-29.46 29.46c-19.11-20.594-35.928-42.816-50.35-66.508l36.974-25.044-17.944-26.492-34.648 23.47c-5.194-10.262-9.996-20.75-14.348-31.48-5.686-14.018-10.552-28.268-14.654-42.704l41.624-13.346-9.77-30.468-39.422 12.64c-4.208-20.846-6.82-42.028-7.792-63.458 5.088-0.202 10.194-0.334 15.33-0.334 210.262-0.004 381.328 171.064 381.328 381.326zM130.674 512c0-2.634 0.046-5.258 0.1-7.878 18.128 1.118 36.078 3.374 53.782 6.818l-14.23 44.382 30.47 9.77 15-46.782c15.384 4.256 30.56 9.392 45.476 15.442 10.35 4.198 20.478 8.808 30.394 13.792l-26.81 39.58 26.492 17.946 28.438-41.984c24.076 14.558 46.64 31.586 67.53 50.966l-33.706 33.706 22.626 22.628 33.708-33.708c19.936 21.488 37.4 44.738 52.228 69.592l-41.506 28.116 17.944 26.492 38.946-26.38c4.566 9.222 8.8 18.634 12.694 28.232 6.322 15.59 11.668 31.458 16.032 47.556l-45.664 14.64 9.768 30.466 43.062-13.806c3.216 17.012 5.358 34.244 6.43 51.644-2.622 0.052-5.244 0.1-7.878 0.1-210.26-0.002-381.328-171.070-381.326-381.33zM551.786 891.258c-1.242-19.948-3.822-39.822-7.718-59.492l48.2-15.454-9.768-30.464-45.792 14.682c-7.892-28.83-18.712-57.020-32.468-84.108l40.344-27.328-17.946-26.492-37.976 25.724c-15.776-26.188-34.466-51.104-56.080-74.29l34.162-34.162-22.626-22.626-34.164 34.162c-22.576-21.042-46.786-39.32-72.216-54.828l25.392-37.486-26.492-17.944-26.892 39.7c-27.096-13.948-55.318-24.934-84.188-32.988l14.316-44.65-30.47-9.77-15.040 46.904c-20.362-4.136-40.954-6.848-61.62-8.134 18.336-176.074 156.984-316.908 332.046-338.622 1.148 23.716 4.19 47.352 9.086 70.678l-51.87 16.632 9.77 30.468 49.806-15.97c8.090 28.288 19.008 55.934 32.772 82.492l-44.644 30.242 17.946 26.492 42.472-28.77c15.376 25.056 33.47 48.91 54.232 71.18l-38.408 38.408 22.626 22.628 38.408-38.41c22.894 21.338 47.47 39.842 73.294 55.49l-29.11 42.972 26.496 17.948 30.656-45.256c26.56 13.578 54.2 24.31 82.458 32.236l-16.336 50.954 30.464 9.768 17.050-53.18c22.602 4.624 45.488 7.508 68.448 8.62-21.712 175.060-162.546 313.706-338.62 332.044z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-baseball-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-16.088 0-31.95 0.946-47.564 2.722v0 0c-207.326 23.61-368.436 199.638-368.436 413.278 0 229.726 186.274 416 416 416 213.654 0 389.666-161.106 413.276-368.436v0 0c1.778-15.61 2.724-31.474 2.724-47.564 0-229.726-186.26-416-416-416zM519.878 893.228c-1.078-17.386-3.21-34.61-6.418-51.608l-43.022 13.792-9.77-30.468 45.624-14.628c-4.366-16.112-9.712-31.988-16.040-47.588-3.886-9.588-8.122-18.994-12.682-28.21l-38.928 26.372-17.944-26.494 41.488-28.108c-14.832-24.858-32.298-48.114-52.238-69.606l-33.704 33.706-22.626-22.626 33.704-33.704c-20.884-19.378-43.442-36.404-67.514-50.96l-28.432 41.976-26.494-17.946 26.806-39.576c-9.92-4.982-20.054-9.598-30.412-13.8-14.91-6.042-30.076-11.18-45.45-15.434l-15 46.784-30.472-9.77 14.23-44.384c-17.712-3.446-35.67-5.706-53.808-6.824 0.218-10.746 0.876-21.39 1.968-31.906 20.678 1.294 41.278 3.996 61.654 8.136l15.036-46.908 30.474 9.772-14.318 44.656c28.866 8.054 57.084 19.042 84.18 32.988l26.898-39.708 26.496 17.946-25.4 37.496c25.424 15.508 49.63 33.784 72.2 54.822l34.164-34.164 22.628 22.628-34.166 34.164c21.618 23.19 40.312 48.11 56.088 74.302l37.998-25.738 17.946 26.496-40.366 27.34c13.756 27.092 24.578 55.284 32.464 84.116l45.838-14.698 9.77 30.472-48.244 15.468c3.894 19.656 6.462 39.522 7.708 59.454-10.518 1.096-21.164 1.75-31.914 1.97zM821.922 550.586l-17.058 53.208-30.472-9.77 16.348-50.986c-28.248-7.928-55.88-18.658-82.436-32.232l-30.67 45.282-26.496-17.946 29.128-42.998c-25.824-15.652-50.398-34.154-73.288-55.492l-38.41 38.408-22.624-22.628 38.404-38.406c-20.762-22.27-38.854-46.124-54.228-71.18l-42.496 28.786-17.948-26.496 44.67-30.254c-13.762-26.556-24.678-54.198-32.768-82.482l-49.836 15.98-9.77-30.474 51.902-16.642c-4.894-23.326-7.886-46.964-9.044-70.674 10.378-1.288 20.892-2.136 31.508-2.568 1.014 21.486 3.718 42.668 7.944 63.614l39.488-12.718 9.814 30.424-41.578 13.316c4.102 14.436 8.982 28.676 14.666 42.696 4.352 10.726 9.156 21.206 14.348 31.462l34.63-23.458 17.946 26.492-36.954 25.032c14.418 23.692 31.238 45.914 50.348 66.508l29.458-29.462 22.628 22.626-29.464 29.462c21.204 19.672 44.124 36.926 68.604 51.626l24.704-36.47 26.496 17.946-23.024 33.988c9.554 4.766 19.312 9.178 29.27 13.216 14.708 5.964 29.674 11.042 44.842 15.262l12.968-40.44 30.466 9.77-12.208 38.086c20.232 3.968 40.572 6.622 61.252 7.648-0.43 10.624-1.286 21.144-2.57 31.536-22.972-1.128-45.874-3.97-68.49-8.598z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-baseball"
    ]
  },
  {
    "paths": [
      "M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.742 0 416-186.276 416-416s-186.258-416-416-416zM893.328 512c0 0.096-0.004 0.194-0.004 0.29-44.63-3.442-87.978-13.944-129.24-31.398-35.776-15.132-68.906-35.010-98.958-59.268 41.38-59.002 76.884-122.424 105.648-189.43 75.316 69.706 122.554 169.338 122.554 279.806zM745.212 210.522c-0.56 1.352-1.1 2.708-1.67 4.056-27.816 65.766-62.124 127.912-102.572 185.974-3.076-2.898-6.126-5.828-9.126-8.826-38.214-38.214-68.214-82.708-89.166-132.24-17.394-41.126-27.866-84.326-31.342-128.802 0.222 0 0.442-0.008 0.664-0.008 87.768-0.002 168.694 29.822 233.212 79.846zM479.35 132.088c8.862 116.252 62.088 220.082 142.782 294.624-18.99 25.498-39.218 50.152-60.638 73.93-95.108-100.064-209.63-181.492-337.534-238.264 63.272-72.912 153.706-121.628 255.39-130.29zM561.374 547.68c72.458 81.34 130.96 172.876 174.37 272.906-50.8 36.934-111.020 61.658-176.324 69.796-4.544-95.632-39.042-183.414-94.358-254.142 33.904-27.526 66.074-57.106 96.312-88.56zM524.078 540.078c-25.408 25.406-51.954 49.324-79.556 71.74-77.474-85.77-187.662-141.412-310.9-147.27 8.14-65.292 32.864-125.5 69.792-176.292 118.39 51.376 224.89 123.894 316.664 215.666 6.646 6.646 13.18 13.378 19.624 20.178-5.148 5.372-10.348 10.702-15.624 15.978zM131.016 496.46c50.476 2.29 98.872 13.594 142.9 32.218 49.534 20.952 94.026 50.952 132.24 89.166 4.508 4.508 8.89 9.11 13.168 13.79-62.828 47.83-130.854 88.098-203.416 120.364-53.264-65.588-85.236-149.124-85.236-239.998 0-5.208 0.136-10.382 0.344-15.54zM238.134 777.052c71.976-32.868 139.62-73.574 201.828-121.042 22.498 28.744 41.044 60.23 55.36 94.074 19.228 45.458 30.026 93.448 32.228 142.9-5.16 0.208-10.34 0.344-15.55 0.344-107.366 0-204.498-44.622-273.866-116.276zM761.62 800.042c-44.978-101.342-105.44-194.28-178.382-275.818 22.202-24.538 43.268-50.122 63.112-76.672 68.342 54.684 153.042 89.77 245.602 96.726-8.58 101.838-57.33 192.416-130.332 255.764z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-basketball-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.742 0 416-186.276 416-416s-186.258-416-416-416zM761.594 800.064c-8.316 7.216-16.96 14.058-25.884 20.544-43.408-100.030-101.876-191.59-174.336-272.93-30.236 31.456-62.406 61.036-96.312 88.56 55.318 70.728 89.832 158.508 94.378 254.138-10.504 1.31-21.142 2.172-31.888 2.606-2.206-49.454-13-97.442-32.228-142.9-14.316-33.844-32.862-65.33-55.36-94.074-62.208 47.466-129.846 88.186-201.82 121.052-7.766-8.022-15.184-16.382-22.23-25.058 72.56-32.268 140.582-72.542 203.41-120.372-4.278-4.68-8.66-9.282-13.168-13.79-38.214-38.214-82.708-68.214-132.24-89.166-44.030-18.624-92.424-29.928-142.9-32.216 0.434-10.758 1.296-21.406 2.606-31.918 123.24 5.858 233.426 61.506 310.9 147.276 27.604-22.416 54.15-46.334 79.556-71.74 5.276-5.276 10.476-10.606 15.624-15.976-6.446-6.8-12.978-13.534-19.624-20.18-91.774-91.772-198.274-164.29-316.664-215.664 6.486-8.922 13.33-17.564 20.544-25.878 127.902 56.774 242.424 138.202 337.534 238.264 21.422-23.778 41.648-48.432 60.638-73.93-80.694-74.542-133.912-178.376-142.776-294.624 10.546-0.898 21.208-1.384 31.98-1.404 3.476 44.476 13.948 87.676 31.342 128.802 20.952 49.534 50.952 94.026 89.166 132.24 3 3 6.050 5.93 9.124 8.826 40.452-58.062 74.758-120.208 102.574-185.974 0.57-1.348 1.11-2.706 1.67-4.056 8.838 6.852 17.362 14.084 25.558 21.67-28.766 67.004-64.264 130.43-105.644 189.432 30.052 24.26 63.182 44.136 98.958 59.27 41.262 17.454 84.61 27.956 129.24 31.396-0.008 10.774-0.486 21.434-1.376 31.982-92.556-6.958-177.262-42.036-245.602-96.718-19.844 26.55-40.91 52.134-63.112 76.672 72.95 81.54 133.382 174.494 178.362 275.838z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-basketball"
    ]
  },
  {
    "paths": [
      "M763.4 451.8c0-195.2-105-261.6-203.2-276.4 0-1 0.2-2 0.2-3.2 0-24.6-21.8-44.2-48.4-44.2s-47.6 19.6-47.6 44.2c0 1.2 0 2.2 0.2 3.2-98.4 15-204 81.6-204 276.8 0 227.6-56.6 252-132.6 316h768c-75.6-64.2-132.6-88.8-132.6-316.4zM214.4 736c17.2-18 32.8-36.8 45.4-63.6 24-50.6 34.8-118.4 34.8-220.4 0-92.8 25-160.8 74.2-202.4 45.8-38.6 103.4-46.6 143.6-46.6s97.8 8 143.2 46.6c49 41.4 74 109 74 201.8 0 167.6 29.8 234.6 80.6 284.6h-595.8z",
      "M512.4 896c53.6 0 97.6-39.8 103.4-86h-206.8c5.6 46.2 49.8 86 103.4 86z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-bell-outline"
    ]
  },
  {
    "paths": [
      "M763.4 451.8c0-195.2-105-261.6-203.2-276.4 0-1 0.2-2 0.2-3.2 0-24.6-21.8-44.2-48.4-44.2s-47.6 19.6-47.6 44.2c0 1.2 0 2.2 0.2 3.2-98.4 15-204 81.6-204 276.8 0 227.6-56.6 252-132.6 316h768c-75.6-64.2-132.6-88.8-132.6-316.4z",
      "M512.4 896c53.6 0 97.6-39.8 103.4-86h-206.8c5.6 46.2 49.8 86 103.4 86z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-bell"
    ]
  },
  {
    "paths": [
      "M512 95.918c35.29 0 64 28.702 64 63.982s-28.71 63.98-64 63.98-64-28.702-64-63.98c0-35.28 28.71-63.982 64-63.982zM512 63.928c-53.020 0-96 42.966-96 95.972 0 53.004 42.98 95.97 96 95.97s96-42.966 96-95.97c0-53.006-42.98-95.972-96-95.972v0z",
      "M848 288h-672c-26.51 0-48 21.494-48 48s21.49 48 48 48h200.902c11.098 0 26.394 8.59 34.432 29.416 9.302 24.11 4.74 66.66-1.078 102.888l-7.846 42.52c-0.038 0.208-0.41 0.2-0.41 0.406l-64.458 344.476c-4.606 26.102 12.974 50.988 39.080 55.594 2.816 0.496 5.688 0.734 8.436 0.734 22.714 0 41.834-16.38 45.94-39.672l41.002-239.878v0.332c0 0 14.5-62.816 38.904-62.816h2.192c24.904 0 34.904 62.816 34.904 62.816v-0.164l42.966 239.79c4.104 23.284 24.662 39.63 47.526 39.63 2.774 0 5.71-0.242 8.536-0.736 26.106-4.606 43.642-29.52 39.038-55.622l-64.698-344.502c-0.004-0.016 0.022-0.040 0.018-0.054-0.038-0.208-0.064-0.434-0.104-0.644l-7.542-42.822c-5.818-36.238-10.376-78.166-1.076-102.274 8.038-20.828 24.336-29.418 34.434-29.418h200.902c26.51 0 48-21.494 48-48s-21.49-48-48-48zM176 352.226c-8.822 0-16-7.292-16-16.114s7.178-16.114 16-16.114h672c8.822 0 16 7.18 16 16s-7.178 16-16 16h-203c-31.076 0-54.876 29.476-61.964 47.844-9.692 25.114-10.008 63.884-0.776 121.376l-0.018 0.208 0.012 0.22 6.734 38.276 1.124 6.482 64.504 343.256c1 5.668-1.24 9.922-2.664 11.954-1.426 2.034-4.67 5.598-10.358 6.602-0.952 0.166-1.91 0.252-2.854 0.252-7.786 0-14.414-5.278-15.766-12.944l-42.464-239.524h-0.030c-0.542-4-3.656-20.1-10.044-37.542-4.556-12.434-9.688-22.068-15.688-30.010-14.182-18.776-30.478-22.448-41.652-22.448h-2.192c-10.94 0-27.006 3.462-41.42 21.876-6.1 7.792-11.458 17.342-16.38 29.604-7.256 18.074-11.010 35.308-11.416 37.226l-0.22 0.738-41.456 239.8c-1.386 7.772-7.5 13.192-14.882 13.192-0.918 0-1.864-0.086-2.806-0.254-5.68-1-8.91-4.55-10.33-6.576-1.418-2.026-3.648-6.272-2.646-11.95l64.87-345.016 7.594-42.91 0.042-0.252c9.258-57.658 9.054-96.6-0.664-121.782-7.086-18.362-27.152-47.474-63.52-47.474z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-body-outline"
    ]
  },
  {
    "paths": [
      "M608 159.676c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
      "M848 288h-672c-26.51 0-48 21.49-48 48s21.49 48 48 48h196.902c11.158 2 26.394 7.674 34.432 28.504 9.302 24.112 4.74 67.212-1.078 103.454l-7.55 42.79c-0.038 0.208-0.078 0.414-0.116 0.622-0.004 0.016-0.004 0.024-0.008 0.040l-60.75 344.536c-4.606 26.106 12.828 51 38.934 55.606 26.11 4.602 50.666-12.832 55.268-38.942l41.966-239.914v0.334c0 0 12.5-65.030 36.904-65.030h2.192c24.904 0 36.904 65.030 36.904 65.030v-0.166l41.966 239.826c4.602 26.11 29.326 43.498 55.436 38.896 26.106-4.606 43.456-29.524 38.85-55.628l-60.792-344.552c-0.004-0.016-0.026-0.040-0.030-0.054-0.038-0.208-0.088-0.434-0.126-0.644l-7.554-42.828c-5.818-36.242-10.382-79.262-1.082-103.376 8.040-20.828 23.272-26.504 34.43-28.504h196.902c26.51 0 48-21.49 48-48s-21.49-48-48-48z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-body"
    ]
  },
  {
    "paths": [
      "M547.8 264l-33 178.2-6.8 37.8h168l-199.6 280 33-178.2 6.6-37.8h-167.8l199.6-280zM605.4 128l-319.4 448h191.6l-59 320 319.4-448h-191.6l59-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-bolt-outline"
    ]
  },
  {
    "paths": [
      "M605.4 128l-319.4 448h191.6l-59 320 319.4-448h-191.6l59-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-bolt"
    ]
  },
  {
    "paths": [
      "M695.242 128c-81.882 0-158.242 28-183.156 88.99-27.086-60.99-101.27-88.99-183.154-88.99-110.402 0-200.932 51.96-200.932 158v566h44.28c25.72-52.668 88.476-84 156.65-84 80.448 0 147.754 55.056 163.234 128h39.428c15.478-72.944 82.99-128 163.444-128 68.17 0 122.298 23.332 156.858 84h44.106v-566c0-106.040-90.354-158-200.758-158zM496 821.852c-36-51.742-97.46-85.852-167-85.852-69.538 0-129 20.11-167 71.852l-2 1.074v-526.926c6-83.65 80.178-122 168.586-122 90.324 0 164.29 37.416 166.726 123.616-0.034 1.458 0.032 2.918 0.032 4.384l0.656 26.206v507.646zM864 296v511.852c-36-51.742-99.462-71.852-169-71.852-69.54 0-131 34.11-167 85.852v-533.852c0-88.224 75.318-128 167.174-128 88.406 0 162.826 22.35 168.826 106v30z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-book-outline"
    ]
  },
  {
    "paths": [
      "M328.932 128c-110.4 0-200.932 51.96-200.932 158v566h44.282c25.72-52.668 88.476-84 156.65-84 80.448 0 147.754 55.056 163.232 128h3.836v-705.308c-34.48-42.79-98.038-62.692-167.068-62.692z",
      "M695.242 128c-68.664 0-133.426 19.702-167.242 62.022v705.978h3.594c15.478-72.944 82.99-128 163.444-128 68.17 0 122.298 23.332 156.858 84h44.104v-566c0-106.040-90.354-158-200.758-158z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-book"
    ]
  },
  {
    "paths": [
      "M864 128h-300.8c-20.6 0-38.6 9.2-51.2 23.4v0 0c-12.4-14.4-30.6-23.4-51.2-23.4h-300.8c-37.6 0-66 26.6-66 64v572.2c0 37.6 28.4 67.8 66 67.8 0 0 259 0 286.6 0s49.4 8.4 49.4 38.8c0 18.2 0 25.2 0 25.2h32c0 0 0-6.8 0-25.2 0-30.6 21.8-38.8 49.4-38.8s286.6 0 286.6 0c37.6 0 66-30.2 66-67.8v-572.2c0-37.4-28.4-64-66-64zM496 822.2c-9.4-15.6-27-22.2-47.6-22.2h-288.4c-18.8 0-32-17-32-35.8v-572.2c0-18.8 13.2-32 32-32 0 0 261.2 0 286.6 0 25.6 0 49.4 25.6 49.4 44.4v617.8zM640 160c37.6 0 86 0 128 0v200.8l-45.8-29-18.2-12.8-18.2 12.8-45.8 29v-200.8zM896 764.2c0 18.8-13.2 35.8-32 35.8h-288.4c-20.6 0-38.2 4.6-47.6 22.2v-617.8c0-18.8 23.8-44.4 49.4-44.4 4.4 0 15.4 0 30.6 0v262l96-64 96 64v-262c37.2 0 64 0 64 0 18.8 0 32 13.4 32 32v572.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-bookmarks-outline"
    ]
  },
  {
    "paths": [
      "M685.8 330.8l18.2-12.8 18.2 12.8 45.8 29v-231.8c-41.4 0-89 0-128 0v231.8l45.8-29z",
      "M864 128c0 0-26.6 0-64 0v293l-96-64-96 64v-293c-24.2 0-41.2 0-44.8 0-16.2 0-35.2 14.4-35.2 30s0 658 0 658l-16 11-16-11c0 0 0-644 0-658s-18.4-30-35.2-30-300.8 0-300.8 0c-37.6 0-66 26.6-66 64v572.2c0 37.6 28.4 67.8 66 67.8 0 0 259 0 286.6 0s49.4 8.4 49.4 38.8c0 18.2 0 25.2 0 25.2h32c0 0 0-6.8 0-25.2 0-30.6 21.8-38.8 49.4-38.8s286.6 0 286.6 0c37.6 0 66-30.2 66-67.8v-572.2c0-37.4-28.4-64-66-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-bookmarks"
    ]
  },
  {
    "paths": [
      "M575.6 480c17.6 0 32.2 14.4 32.2 32s-14 32-31.8 32h-128c-17.6 0-32-14.4-32-32s14.4-32 32-32h126zM576 448h-128c-35.2 0-64 28.8-64 64s28.8 64 64 64h128c35.2 0 64-28.8 64-64s-28.8-64-64-64v0z",
      "M832 224h-640v160h32v416h576v-416h32v-160zM768 768h-512v-384h512v384zM800 352h-576v-96h576v96z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-box-outline"
    ]
  },
  {
    "paths": [
      "M224 800h576v-384h-576v384zM448 480h128c17.6 0 32 14.4 32 32s-14.4 32-32 32h-128c-17.6 0-32-14.4-32-32s14.4-32 32-32z",
      "M192 224v160h640v-160z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-box"
    ]
  },
  {
    "paths": [
      "M832 256v-32h-64v32h-96v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-96v-32h-64v32h-96v640h832v-640h-96zM384 255v-58.8c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v59.8h-256v-1zM896 864h-768v-448h768v448zM896 384h-768v-96h64v32h64v-32h512v32h64v-32h64v96z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-briefcase-outline"
    ]
  },
  {
    "paths": [
      "M192 224h64v32h-64v-32z",
      "M96 416h832v480h-832v-480z",
      "M768 224h64v32h-64v-32z",
      "M832 256v64h-64v-64h-96v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-96v64h-64v-64h-96v128h832v-128h-96zM640 255v1h-256v-59.8c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v58.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-briefcase"
    ]
  },
  {
    "paths": [
      "M128 288v608h607.8v-608h-607.8zM703.8 864h-543.8v-544h543.8v544z",
      "M896 128h-608v128h32v-96h544v544h-96v32h128z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-browsers-outline"
    ]
  },
  {
    "paths": [
      "M128 288v608h607.8v-608h-607.8z",
      "M288 128v128h480v480h128v-608z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-browsers"
    ]
  },
  {
    "paths": [
      "M288 320h448v-128h-448v128zM320 224h384v64h-384v-64z",
      "M736 128h-448c-35.4 0-64 28.6-64 64v640c0 35.4 28.6 64 64 64h448c35.4 0 64-28.6 64-64v-640c0-35.4-28.6-64-64-64zM768 832c0 17.6-14.4 32-32 32h-448c-17.6 0-32-14.4-32-32v-640c0-17.6 14.4-32 32-32h448c17.6 0 32 14.4 32 32v640z",
      "M320 480v-96h-32v128h128v-32h-32z",
      "M320 640v-96h-32v128h128v-32h-32z",
      "M320 800v-96h-32v128h128v-32h-32z",
      "M480 480v-96h-32v128h128v-32h-32z",
      "M640 480v-96h-32v128h128v-32h-32z",
      "M480 640v-96h-32v128h128v-32h-32z",
      "M480 800v-96h-32v128h128v-32h-32z",
      "M640 800v-256h-32v288h128v-32h-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-calculator-outline"
    ]
  },
  {
    "paths": [
      "M736 128h-448c-35.4 0-64 28.6-64 64v640c0 35.4 28.6 64 64 64h448c35.4 0 64-28.6 64-64v-640c0-35.4-28.6-64-64-64zM720 560v256h-96v-256h96zM720 400v96h-96v-96h96zM560 720v96h-96v-96h96zM560 560v96h-96v-96h96zM560 400v96h-96v-96h96zM400 720v96h-96v-96h96zM400 560v96h-96v-96h96zM400 400v96h-96v-96h96zM304 304v-96h416v96h-416z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-calculator"
    ]
  },
  {
    "paths": [
      "M704 192v-64h-32v64h-320v-64h-32v64h-192v704h768v-704h-192zM864 864h-704v-480h704v480zM864 352h-704v-128h160v64h32v-64h320v64h32v-64h160v128z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-calendar-outline"
    ]
  },
  {
    "paths": [
      "M128 384h768v512h-768v-512z",
      "M896 192h-192v96h-32v-96h-320v96h-32v-96h-192v160h768z",
      "M320 128h32v64h-32v-64z",
      "M672 128h32v64h-32v-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-calendar"
    ]
  },
  {
    "paths": [
      "M835 320h-123.4c-64.2-72-84.4-96-109-96h-177c-24.6 0-44.4 24-109 96h-26.6v-32h-68v32h-27c-35.2 0-67 26.4-67 61.4v352c0 35 31.8 66.6 67 66.6h640c35.2 0 61-31.6 61-66.6v-352c0-35-25.8-61.4-61-61.4zM864 733.4c0 18.6-12.4 34.6-29 34.6h-640c-17.4 0-35-17.4-35-34.6v-352c0-16.4 16.2-29.4 35-29.4h135.6l9.6-6.4c8-9 15.4-20 22.2-27.6 22.6-25.4 39-43.4 50.6-53.8 9.4-8.4 12.4-8.2 12.4-8.2h177c0 0 3.2-0.2 13.4 9 12.2 11 29.4 33 53.2 59.6 5.8 6.6 12 13.6 18.6 21l9.6 6.4h137.8c17.6 0 29 12 29 29.4v352z",
      "M512 379c-94.2 0-171 76.8-171 171s76.8 171 171 171 171-76.8 171-171-76.8-171-171-171zM512 689c-76.8 0-139-62.2-139-139s62.2-139 139-139 139 62.2 139 139-62.2 139-139 139z",
      "M704 384h34v34h-34v-34z",
      "M576 550c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-camera-outline"
    ]
  },
  {
    "paths": [
      "M835 320h-123.4c-64.2-72-84.4-96-109-96h-177c-24.6 0-44.4 24-109 96h-26.6v-32h-68v32h-27c-35.2 0-67 26.4-67 61.4v352c0 35 31.8 66.6 67 66.6h640c35.2 0 61-31.6 61-66.6v-352c0-35-25.8-61.4-61-61.4zM512 721c-94.2 0-171-76.8-171-171s76.8-171 171-171 171 76.8 171 171-76.8 171-171 171zM738 418h-34v-34h34v34z",
      "M512 411c-76.8 0-139 62.2-139 139s62.2 139 139 139 139-62.2 139-139-62.2-139-139-139zM512 614c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-camera"
    ]
  },
  {
    "paths": [
      "M320 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM320 864c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z",
      "M769 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM769 864c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z",
      "M896 256l-649.646-64.708c-3.256-13.944-8.738-29.32-23.676-41.334-18.628-14.98-48.714-21.958-94.678-21.958v32.002c37.228 0 62.334 5.012 74.624 14.894 8.916 7.17 11.288 16.846 14.33 31.978l-0.048 0.008 84.104 467.276c4.826 28.844 14.388 50.418 26.582 65.972 14.494 18.494 33.474 27.87 56.408 27.87h480v-32h-480c-9.454 0-38.272 0.246-51.498-67.51l-10.858-60.32 542.356-96.17 32-256zM837.18 484.696l-521.202 91.98-63.464-352.6 607.738 61.216-23.072 199.404z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cart-outline"
    ]
  },
  {
    "paths": [
      "M320 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48z",
      "M769 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48z",
      "M896 256l-649.646-64.708c-3.256-13.944-8.738-29.32-23.676-41.334-18.628-14.98-48.714-21.958-94.678-21.958v32.002c37.228 0 62.334 5.012 74.624 14.894 8.916 7.17 11.288 16.846 14.33 31.978l-0.048 0.008 84.104 467.276c4.826 28.844 14.388 50.418 26.582 65.972 14.494 18.494 33.474 27.87 56.408 27.87h480v-32h-480c-9.454 0-38.272 0.246-51.498-67.51l-10.858-60.32 542.356-96.17 32-256z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cart"
    ]
  },
  {
    "paths": [
      "M128 128h512v192h32v-224h-576v448h224v-32h-192z",
      "M352 352v448h325.2l128 128h26.8v-128h96v-448h-576zM896 768h-96v109.2l-110-109.2h-306v-384h512v384z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-chatboxes-outline"
    ]
  },
  {
    "paths": [
      "M672 96h-576v448h224v-224h352z",
      "M352 352v448h325.2l128 128h26.8v-128h96v-448h-576z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-chatboxes"
    ]
  },
  {
    "paths": [
      "M512 224c194 0 352 124 352 276.6 0 71.8-35.2 138.4-99 187.8-65.6 50.8-154.8 78.6-251 78.6-57.8 0-102-6-139.4-18.6-1.2-0.4-2.6-1-4-1.4-0.6-0.2-1.2-0.4-1.6-0.4-9.4-2.8-19.4-4.2-29.4-4.2-11.2 0-22.2 1.8-32.6 5.2v0l-0.6 0.2c-1.2 0.4-17.8 6.6-22 8.6v0l-79.2 34.4c27.6-87.8 27.6-89.6 27.6-95.2 0-14.2-4.4-28.2-12.6-40.4-1-1.4-2-2.8-3.2-4.2-1.4-1.8-2.6-3.4-3.6-4.6-34.8-43.8-53.2-94.2-53.2-146-0.2-152.4 157.8-276.4 351.8-276.4zM512 192c-212.2 0-384 138.2-384 308.6 0 61.4 22.4 118.6 60.8 166.6 1.8 1.8 5.8 7.6 7.2 9.8 0 0-2-3.2-2.2-3.8 0 0 0 0 0 0v0c0 0 0 0 0 0 4.6 6.6 7.2 14.2 7.2 22.4 0 2.8-35.8 116-35.8 116v0c-2.6 8.8 4.2 17.8 15.2 20 1.6 0.4 3.2 0.4 4.8 0.4 2.6 0 5-0.4 7.4-1l3.2-1.2 101.2-44c1.8-0.8 18-7 20-7.8 0 0 1.2-0.4 1.2-0.4s-0.2 0-1.2 0.4c6.8-2.4 14.4-3.6 22.4-3.6 7.2 0 14.2 1 20.6 3 0.2 0 0.4 0 0.4 0.2 1 0.4 2 0.6 3 1 46.2 15.8 96.8 20.6 150.2 20.6 212 0 382-128.2 382-298.6 0.4-170.4-171.6-308.6-383.6-308.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-chatbubble-outline"
    ]
  },
  {
    "paths": [
      "M512 192c-212.2 0-384 138.2-384 308.6 0 61.4 22.4 118.6 60.8 166.6 1.8 1.8 5.8 7.6 7.2 9.8 0 0-2-3.2-2.2-3.8 0 0 0 0 0 0v0c0 0 0 0 0 0 4.6 6.6 7.2 14.2 7.2 22.4 0 2.8-35.8 116-35.8 116v0c-2.6 8.8 4.2 17.8 15.2 20 1.6 0.4 3.2 0.4 4.8 0.4 2.6 0 5-0.4 7.4-1l3.2-1.2 101.2-44c1.8-0.8 18-7 20-7.8 0 0 1.2-0.4 1.2-0.4s-0.2 0-1.2 0.4c6.8-2.4 14.4-3.6 22.4-3.6 7.2 0 14.2 1 20.6 3 0.2 0 0.4 0 0.4 0.2 1 0.4 2 0.6 3 1 46.2 15.8 96.8 20.6 150.2 20.6 212 0 382-128.2 382-298.6 0.4-170.4-171.6-308.6-383.6-308.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-chatbubble"
    ]
  },
  {
    "paths": [
      "M447.8 659.4c-4.8 4.8-11.6 8.8-17.6 8.8s-12.8-4.2-17.8-9l-112-112 35.6-35.6 94.4 94.4 249.6-251.4 35 36.2-267.2 268.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-checkmark-empty"
    ]
  },
  {
    "paths": [
      "M680.2 354.6l-249.6 251.4-94.4-94.4-35.6 35.6 112 112c5 5 11.8 9 17.8 9s12.6-4 17.6-8.8l267.4-268.8-35.2-36z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-checkmark-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM447.8 659.4c-4.8 4.8-11.6 8.8-17.6 8.8s-12.8-4.2-17.8-9l-112-112 35.6-35.6 94.4 94.4 249.6-251.4 35 36.2-267.2 268.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-checkmark"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M512 192c-176.8 0-320 143.2-320 320s143.2 320 320 320c176.8 0 320-143.2 320-320s-143.2-320-320-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-circle-filled"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-circle-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M512 512h-192v34.6h226.6v-290.6h-34.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-clock-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM546 546h-226v-34h192v-256h34v290z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-clock"
    ]
  },
  {
    "paths": [
      "M680.4 320l-168.8 168.6-168-167.8-23.6 23.6 168 167.6-168 167.8 23.6 23.4 168-167.6 168.8 168.4 23.6-23.4-168.8-168.6 168.8-168.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-close-empty"
    ]
  },
  {
    "paths": [
      "M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0s162.4-426 0-588.4zM781.6 781.6c-148.6 148.6-390.6 148.6-539.2 0s-148.6-390.6 0-539.2 390.6-148.6 539.2 0c148.8 148.6 148.8 390.6 0 539.2z",
      "M680.4 320l-168.8 168.4-168-167.6-23.6 23.6 168 167.6-168 167.6 23.6 23.6 168-167.6 168.8 168.4 23.6-23.6-168.8-168.4 168.8-168.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-close-outline"
    ]
  },
  {
    "paths": [
      "M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0s162.4-426 0-588.4zM704 680.4l-23.6 23.6-168.8-168.4-168 167.6-23.6-23.6 168-167.6-168-167.6 23.6-23.6 168 167.6 168.8-168.4 23.6 23.6-168.8 168.4 168.8 168.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-close"
    ]
  },
  {
    "paths": [
      "M386.4 762.4l-23.2 22.8 149 146.8 149-146.8-23.2-22.8-109.4 107.6v-484.2h-32.8v484.2z",
      "M798.4 328.8c0-2.4 0.4-4.6 0.4-7 0-127-105.8-229.8-233.6-229.8-92.2 0-171.6 53.6-208.8 130.8-16.2-8-34.2-12.6-53.6-12.6-59.2 0-108.2 46.6-117.8 102.6-70.4 24-121.2 86.8-121.2 164.8 0 98.2 80.2 178.4 179.2 178.4h183v-32h-181.4c-81.8 0-148.4-66.4-148.4-147.4 0-62.8 40.4-115 100.4-135.4l16.8-5.6 3-17.4c7.2-42.6 44.2-77.6 87.8-77.6 13.8 0 27.4 3.2 39.8 9.4l27 13.4 13-27.2c33.2-68.8 104.2-113.2 180.8-113.2 110.6 0 201.8 85.6 201.8 195.2 0 26.2-0.4 40.2-0.4 40.2l30.4 0.2c73.4 1 131.2 60 131.2 132.8 0 72.6-59.6 132.2-133 132.6l-6.4 0.2h-194.4v32h202c90 0 163.8-74.4 163.8-164.2 0-90-70.8-163-161.4-163.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloud-download-outline"
    ]
  },
  {
    "paths": [
      "M496 870l-109.4-107.6-23.4 22.8 149 146.8 149-146.8-23.6-22.8-109.6 107.6v-214h-32z",
      "M798.4 328.8c0-2.4 0.4-4.6 0.4-7 0-127-105.8-229.8-233.6-229.8-92.2 0-171.6 53.6-208.8 130.8-16.2-8-34.2-12.6-53.6-12.6-59.2 0-108.2 46.6-117.8 102.6-70.4 24-121.2 86.8-121.2 164.8 0 98.2 80.2 178.4 179.2 178.4h253v-270h32v270h268c90 0 163.8-74.4 163.8-164.2s-70.8-162.8-161.4-163z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloud-download"
    ]
  },
  {
    "paths": [
      "M798.6 465.6c0-2.4 0.4-4.8 0.4-7.2 0-128.6-105.6-234.4-233.6-234.4-92.2 0-171.6 55.8-208.8 134-16.2-8.2-34.2-12.8-53.6-12.8-59.2 0-108.2 47.4-117.8 104-70.4 24.4-121.2 88.4-121.2 167.6 0 99.6 80.2 183.2 179.2 183.2h552.8c90 0 164-77.8 164-168.6 0-91.2-70.8-165.6-161.4-165.8zM795 767.2l-6.4 0.8h-543.8c-81.8 0-148.4-69.8-148.4-152.2 0-63.8 40.4-116.8 100.4-137.6l16.8-6 3-17.6c7.2-43.2 44.2-78.6 87.8-78.6 13.8 0 27.4 3.2 39.8 9.6l27 13.6 13-27.4c33.2-69.8 104.2-116.4 180.8-116.4 110.6 0 201.8 88.2 201.8 199.4 0 26.6-0.4 40.6-0.4 40.6l30.4 0.2c73.4 1 131.2 61 131.2 134.8s-59.6 136.4-133 136.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloud-outline"
    ]
  },
  {
    "paths": [
      "M386.6 520.8l-23.2-23.2 149-148.6 149 148.6-23.4 23.2-109.2-109.2v483.6h-33v-483.6z",
      "M798.6 367.2c0-2.4 0.4-4.8 0.4-7.2 0-128.6-105.6-232.8-233.6-232.8-92.2 0-171.6 54.2-208.8 132.6-16.2-8.2-34.2-12.8-53.6-12.8-59.2 0-108.2 47.2-117.8 104-70.4 24.2-121.2 93.4-121.2 172.6 0 99.4 80.2 180.4 179.2 180.4h182.8v-32h-181.2c-81.8 0-148.4-67-148.4-149.2 0-63.6 40.4-122.4 100.4-143.2l16.8-5.8 3-17.6c7.2-43.2 44.2-78.6 87.8-78.6 13.8 0 27.4 3.2 39.8 9.6l27 13.6 13-27.4c33.2-69.8 104.2-114.8 180.8-114.8 110.6 0 201.8 86.6 201.8 197.8 0 26.6-0.4 40.6-0.4 40.6l30.4 0.2c73.2 1 131.2 66.8 131.2 140.6 0 73.6-59.6 133.8-133 134.2h-201v32h202c90 0 164-74.6 164-165.6s-71-171-161.4-171.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloud-upload-outline"
    ]
  },
  {
    "paths": [
      "M496 704h32v192h-32v-192z",
      "M798.6 367.2c0-2.4 0.4-4.8 0.4-7.2 0-128.6-105.6-232.8-233.6-232.8-92.2 0-171.6 54.2-208.8 132.6-16.2-8.2-34.2-12.8-53.6-12.8-59.2 0-108.2 47.2-117.8 104-70.4 24.2-121.2 93.4-121.2 172.6 0 99.4 80.2 180.4 179.2 180.4h252.8v-292.4l-109.4 109-23.2-23.2 149-148.6 149 148.6-23.6 23.2-109.8-109v292.4h268c90 0 164-74.6 164-165.6s-71-171-161.4-171.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloud-upload"
    ]
  },
  {
    "paths": [
      "M798.6 465.6c0-2.4 0.4-4.8 0.4-7.2 0-128.6-105.6-234.4-233.6-234.4-92.2 0-171.6 55.8-208.8 134-16.2-8.2-34.2-12.8-53.6-12.8-59.2 0-108.2 47.4-117.8 104-70.4 24.4-121.2 88.4-121.2 167.6 0 99.6 80.2 183.2 179.2 183.2h552.8c90 0 164-77.8 164-168.6 0-91.2-70.8-165.6-161.4-165.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloud"
    ]
  },
  {
    "paths": [
      "M378 447.6c29 0 56.2 9.6 78.6 27.8 21.8 17.8 37.2 42.6 43.4 69.8l6.2 28 28.4-3.6c4.2-0.6 8.2-0.8 12.2-0.8 53.8 0 97.6 44.2 97.6 98.4s-43.8 98.4-97.6 98.4h-315.4c-19 0-37-7.8-50.8-21.6-13.6-14-21.2-32.4-21.2-51.8 0-37.2 29-67.6 66.4-73.8 3.2-0.6 17.6-2.4 28.4-3.4 0 0-1-10.6-1.2-19.2s-0.2-18.8-0.2-23c0.2-68.8 56.2-125.2 125.2-125.2zM378 416c-86.6 0-156.6 70.4-156.6 157 0 5.2 0.2 10.4 0.8 15.6-52.8 4.8-94.2 51-94.2 105.2 0 57.2 46.4 106.2 103.4 106.2h315.4c71.4 0 129.2-59.8 129.2-131.4s-57.8-130.6-129.2-130.6c-5.4 0-10.8 0-16 0.6-15.8-70-78.2-122.6-152.8-122.6v0z",
      "M849.2 611.2c-4 0.2-7.8 0.2-11.8 0.2-64.6 0-125.4-25.2-171-71s-70.8-106.6-70.8-171.4c0-36.8 8.2-72.4 23.6-104.8 6.8-14.2 15-27.8 24.6-40.4-16.8 1.8-33.2 5.4-48.8 10.2-74.4 23.6-134.2 80.4-162 153 11.8 2.4 23.2 6 34 10.8 20.2-51 58.8-92.8 107.6-117.2-9.2 27.8-14.2 57.4-14.2 88.2 0 54.6 15.8 105.6 42.8 148.4 27.6 43.6 67 79 113.6 101.8 30.6 14.8 64.4 24.2 100 27-28 24.4-62.4 41.8-100 49.6-3.8 13.8-9.8 26.8-17.2 38.6 67.2-7.2 126.6-40.2 168-89.2 10.8-12.6 20.4-26.4 28.4-41-15.2 4.2-30.8 6.4-46.8 7.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloudy-night-outline"
    ]
  },
  {
    "paths": [
      "M849.2 611.2c-4 0.2-7.8 0.2-11.8 0.2-64.6 0-125.4-25.2-171-71s-70.8-106.6-70.8-171.4c0-36.8 8.2-72.4 23.6-104.8 6.8-14.2 15-27.8 24.6-40.4-16.8 1.8-33.2 5.4-48.8 10.2-74.4 23.6-134.2 80.4-162 153-0.6 1.6-1.2 3-1.8 4.6 23.8 7 46.2 18.8 65.6 34.6 26 21.2 45.8 49 57.6 80.2 40.2 1.8 77.8 18.8 106.6 48 30.4 30.8 47 71.8 47 114.8 0 22.8-4.8 45-13.6 65.6 1.6-0.2 3.2-0.2 5-0.4 67.2-7.2 126.6-40.2 168-89.2 10.8-12.6 20.4-26.4 28.4-41-15 4-30.6 6.2-46.6 7z",
      "M378 418c-86.6 0-156.6 70.4-156.6 157 0 5.2 0.2 10.4 0.8 15.6-52.8 4.8-94.2 51-94.2 105.2 0 57.2 46.4 106.2 103.4 106.2h315.4c71.4 0 129.2-59.8 129.2-131.4s-57.8-130.6-129.2-130.6c-5.4 0-10.8 0-16 0.6-15.8-70-78.2-122.6-152.8-122.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloudy-night"
    ]
  },
  {
    "paths": [
      "M488 351.6c29 0 56.2 9.6 78.6 27.8 21.8 17.8 37.2 42.6 43.4 69.8l6.2 28 28.4-3.6c4.2-0.6 8.2-0.8 12.2-0.8 53.8 0 97.6 44.2 97.6 98.4s-43.8 98.4-97.6 98.4h-315.4c-19 0-37-7.8-50.8-21.6-13.6-14-21.2-32.4-21.2-51.8 0-37.2 29-67.6 66.4-73.8 3.2-0.6 17.4-2.4 28.4-3.4 0 0-1-10.6-1.2-19.2s-0.2-18.8-0.2-23c0.2-68.8 56.2-125.2 125.2-125.2zM488 320c-86 0-156.6 70.4-156.6 157 0 5.2 0.2 10.4 0.8 15.6-52.8 4.6-94.2 51-94.2 105.2 0 57.2 46.4 106.2 103.4 106.2h315.4c71.4 0 129.2-59.8 129.2-131.4s-57.8-130.6-129.2-130.6c-5.4 0-10.8 0-16 0.6-15.8-70-78.8-122.6-152.8-122.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloudy-outline"
    ]
  },
  {
    "paths": [
      "M488 320c-86 0-156.6 70.4-156.6 157 0 5.2 0.2 10.4 0.8 15.6-52.8 4.6-94.2 51-94.2 105.2 0 57.2 46.4 106.2 103.4 106.2h315.4c71.4 0 129.2-59.8 129.2-131.4s-57.8-130.6-129.2-130.6c-5.4 0-10.8 0-16 0.6-15.8-70-78.8-122.6-152.8-122.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cloudy"
    ]
  },
  {
    "paths": [
      "M896 545.508v-64.016l-66.582-17.406-5.202-26.408 55.188-41.81-24.394-59.216-68.784 9.604-14.996-21.206 35.392-59.416-45.188-45.21-60.384 34.808-21.394-14.604 10.596-70.018-58.984-24.606-43.188 56.616-24.594-5.202-17.396-69.418h-63.982l-18.394 69.818-24.196 4.8-42.988-58.016-59.184 24.608 9.598 71.418-23.394 14.404-62.584-37.41-45.188 45.212 37.59 63.016-13.396 21.004-70.98-10.002-24.394 59.216 57.786 43.412-4.798 24.406-69.586 17.806v64.016l69.38 17.806 4.8 25.006-56.788 42.612 24.594 59.016 69.982-10.004 14.198 22.606-35.792 61.216 45.19 45.21 60.384-36.408 22.392 14.604-8.996 68.62 59.184 24.404 41.19-55.614 26.792 5 17.598 66.218h63.982l16.596-66.218 27.194-5.202 41.388 54.214 59.186-24.408-9.996-67.416 20.392-14.802 57.984 33.808 45.19-45.212-33.59-57.814 15.792-22.806 67.582 9.604 24.596-59.016-54.386-41.012 5.4-27.006 66.582-17.206zM839.414 641.534l-5.6 13.404-63.782-9.002-37.792 55.614 31.39 54.212-10.396 10.404-54.586-31.808-53.186 36.408 9.598 63.618-13.396 5.604-39.19-51.214-65.784 13.002-15.596 62.418h-14.396l-16.794-62.618-65.184-13.002-38.99 52.812-13.396-5.602 8.798-65.018-54.986-36.608-57.586 35.008-10.198-10.202 33.992-58.216-36.192-55.212-66.382 9.402-5.398-13.206 53.788-40.41-12.398-63.618-65.982-17.004v-14.404l65.982-16.804 12.598-63.216-54.586-41.010 5.398-13.204 67.382 9.602 35.592-53.614-35.992-60.016 9.998-10.002 59.584 35.608 55.786-36.41-8.998-67.618 13.398-5.6 40.588 54.814 62.984-12.204 17.596-66.416h14.396l16.596 66.016 63.382 12.602 40.19-53.614 13.196 5.602-9.998 66.216 54.386 36.21 56.584-32.41 10.2 10.204-33.39 56.014 36.792 54.014 64.982-9.202 5.598 13.404-52.386 39.41 12.996 65.016 62.584 16.204v14.404l-62.782 16.206-12.998 65.418 51.986 39.614z",
      "M512 256c-141.384 0-256 114.616-256 256 0 141.386 114.616 256 256 256s256-114.614 256-256c0-141.384-114.616-256-256-256zM288 512c0-59.832 23.3-116.084 65.608-158.39 42.308-42.31 98.56-65.61 158.392-65.61 14.992 0 29.76 1.464 44.138 4.322l-55.538 207.878-208.31 55.776c-2.836-14.328-4.29-29.040-4.29-43.976zM512 736c-59.834 0-116.084-23.3-158.392-65.608-23.854-23.852-41.662-52.138-52.662-82.998l206.854-54.994 149.87 149.778c-40.554 34.824-91.652 53.822-145.67 53.822zM680.308 659.802l-149.908-150.002 56.1-209.16c31.208 10.974 59.808 28.886 83.89 52.968 42.31 42.308 65.61 98.56 65.61 158.392 0 54.972-19.682 106.914-55.692 147.802z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cog-outline"
    ]
  },
  {
    "paths": [
      "M586.5 300.64l-56.1 209.16 149.908 150c36.010-40.886 55.692-92.828 55.692-147.8 0-59.832-23.3-116.084-65.61-158.392-24.082-24.082-52.682-41.994-83.89-52.968z",
      "M556.136 292.322c-14.376-2.858-29.144-4.322-44.136-4.322-59.832 0-116.084 23.3-158.392 65.61-42.308 42.306-65.608 98.558-65.608 158.39 0 14.936 1.454 29.648 4.29 43.976l208.31-55.776 55.536-207.878z",
      "M300.946 587.394c11 30.86 28.808 59.144 52.662 82.996 42.308 42.31 98.558 65.61 158.392 65.61 54.018 0 105.116-18.998 145.67-53.822l-149.87-149.778-206.854 54.994z",
      "M896 545.508v-64.016l-66.582-17.406-5.202-26.408 55.188-41.81-24.394-59.216-68.784 9.604-14.996-21.206 35.39-59.416-45.188-45.21-60.382 34.808-21.394-14.604 10.596-70.018-58.984-24.606-43.188 56.616-24.594-5.202-17.396-69.418h-63.982l-18.394 69.818-24.196 4.8-42.988-58.016-59.184 24.608 9.598 71.418-23.394 14.404-62.584-37.41-45.188 45.212 37.59 63.016-13.396 21.004-70.98-10.002-24.394 59.216 57.786 43.412-4.798 24.406-69.586 17.806v64.014l69.38 17.806 4.8 25.006-56.788 42.614 24.594 59.016 69.982-10.004 14.198 22.606-35.792 61.214 45.19 45.21 60.384-36.408 22.392 14.604-8.996 68.622 59.184 24.404 41.19-55.616 26.792 5 17.598 66.22h63.982l16.596-66.218 27.194-5.202 41.388 54.212 59.186-24.406-9.996-67.418 20.392-14.8 57.984 33.808 45.19-45.212-33.59-57.814 15.792-22.804 67.582 9.604 24.596-59.016-54.386-41.014 5.4-27.004 66.582-17.208zM512 768c-141.384 0-256-114.614-256-256 0-141.384 114.616-256 256-256s256 114.616 256 256c0 141.386-114.616 256-256 256z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-cog"
    ]
  },
  {
    "paths": [
      "M732.39 424.244c2.37-13.056 3.612-26.504 3.612-40.244 0-123.712-100.29-224.002-224.002-224.002s-224.002 100.29-224.002 224.002c0 13.74 1.242 27.188 3.612 40.244-94.378 26.36-163.612 112.968-163.612 215.756 0 123.712 100.29 224.002 224.002 224.002 62.684 0 119.342-25.758 160-67.254 40.658 41.496 97.316 67.254 160 67.254 123.712 0 224.002-100.29 224.002-224.002 0-102.788-69.234-189.394-163.612-215.756zM319.998 384c0-105.87 86.13-192.002 192.002-192.002s192.002 86.132 192.002 192.002c0 11.552-1.026 22.87-2.99 33.866-9.498-1.228-19.18-1.868-29.012-1.868-62.684 0-119.342 25.758-160 67.254-40.658-41.496-97.316-67.254-160-67.254-9.832 0-19.514 0.638-29.012 1.868-1.964-10.996-2.99-22.314-2.99-33.866zM544.002 640c0 39.16-11.792 75.612-32.002 106.012-20.208-30.4-32.002-66.852-32.002-106.012 0-11.552 1.026-22.87 2.99-33.866 9.498 1.228 19.18 1.868 29.012 1.868s19.514-0.638 29.012-1.868c1.964 10.996 2.99 22.314 2.99 33.866zM512 576.002c-6.968 0-13.85-0.382-20.628-1.112 5.252-14.524 12.21-28.238 20.628-40.902 8.42 12.664 15.376 26.378 20.628 40.902-6.778 0.73-13.66 1.112-20.628 1.112zM459.582 568.728c-59.512-16.91-107.332-61.874-128.21-119.62 6.78-0.728 13.66-1.112 20.628-1.112 54.706 0 104.138 23 139.144 59.834-13.45 18.378-24.176 38.872-31.562 60.898zM532.856 507.834c35.006-36.836 84.438-59.836 139.144-59.836 6.968 0 13.85 0.382 20.628 1.112-20.878 57.746-68.7 102.708-128.21 119.62-7.386-22.028-18.112-42.522-31.562-60.896zM352 832.002c-105.872 0-192.002-86.13-192.002-192.002 0-87.704 59.11-161.862 139.584-184.728 23.464 69.966 80.53 124.514 152.028 144.486-2.37 13.054-3.612 26.504-3.612 40.242 0 49.434 16.026 95.118 43.146 132.168-35.006 36.834-84.438 59.834-139.144 59.834zM672 832.002c-54.708 0-104.138-23-139.144-59.836 27.122-37.048 43.146-82.732 43.146-132.166 0-13.738-1.242-27.188-3.612-40.242 71.498-19.972 128.562-74.52 152.028-144.486 80.474 22.868 139.584 97.026 139.584 184.728 0 105.872-86.13 192.002-192.002 192.002z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-color-filter-outline"
    ]
  },
  {
    "paths": [
      "M732.388 424.244c2.37-13.056 3.614-26.504 3.614-40.244 0-123.712-100.292-224-224.002-224-123.714 0-224.002 100.288-224.002 224 0 13.74 1.244 27.188 3.612 40.244-94.374 26.36-163.61 112.968-163.61 215.756 0 123.71 100.288 224 224 224 62.682 0 119.34-25.758 160-67.254 40.656 41.496 97.316 67.254 159.998 67.254 123.71 0 224.002-100.29 224.002-224 0-102.788-69.238-189.394-163.612-215.756zM511.996 790.746c-0.968 0.99-1.958 1.964-2.95 2.938-6.402-6.788-12.378-13.974-17.902-21.518-27.122-37.050-43.148-82.732-43.148-132.166 0-13.738 1.244-27.188 3.614-40.242-71.498-19.972-128.562-74.52-152.028-144.486-3.188-9.504-5.744-19.294-7.644-29.318 1.884-0.58 3.764-1.178 5.67-1.708-0.092-0.504-0.17-1.014-0.258-1.518 8.372-2.098 16.926-3.734 25.64-4.86 9.496-1.23 19.178-1.868 29.010-1.868 62.682 0 119.34 25.756 160 67.252 40.656-41.496 97.316-67.252 159.998-67.252 9.832 0 19.514 0.638 29.012 1.868 8.71 1.126 17.266 2.76 25.632 4.858-0.086 0.506-0.164 1.014-0.258 1.52 1.91 0.534 3.79 1.128 5.676 1.71-1.898 10.024-4.458 19.814-7.644 29.316-23.464 69.966-80.532 124.514-152.026 144.484 2.37 13.056 3.614 26.506 3.614 40.244 0 49.434-16.028 95.116-43.148 132.166-5.524 7.544-11.504 14.734-17.906 21.52-0.992-0.974-1.982-1.948-2.954-2.94z",
      "M541.012 606.134c-9.498 1.228-19.18 1.868-29.012 1.868s-19.516-0.638-29.012-1.868c-1.964 10.996-2.992 22.312-2.992 33.866 0 39.16 11.796 75.612 32.004 106.010 20.208-30.398 32.004-66.85 32.004-106.010 0-11.552-1.028-22.87-2.992-33.866z",
      "M692.626 449.11c-6.78-0.728-13.66-1.112-20.628-1.112-54.708 0-104.138 23-139.142 59.834 13.45 18.376 24.176 38.868 31.562 60.896 59.51-16.91 107.33-61.872 128.208-119.618z",
      "M532.628 574.89c-5.25-14.524-12.21-28.238-20.628-40.902-8.418 12.664-15.378 26.378-20.628 40.902 6.778 0.728 13.66 1.112 20.628 1.112s13.85-0.382 20.628-1.112z",
      "M352 447.998c-6.968 0-13.85 0.382-20.628 1.112 20.878 57.746 68.698 102.708 128.212 119.62 7.386-22.030 18.11-42.522 31.562-60.896-35.006-36.836-84.44-59.836-139.146-59.836z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-color-filter"
    ]
  },
  {
    "paths": [
      "M384.022 299.322l-68.086 68.082 512.194 512.192 67.87-68.082-511.978-512.192zM425.192 431.404l22.83-22.828 402.936 402.938-22.828 22.828-402.938-402.938z",
      "M368 128h32v80h-32v-80z",
      "M368 536h32v80h-32v-80z",
      "M560 352h80v32h-80v-32z",
      "M128 352h80v32h-80v-32z",
      "M279.35 245.117l-22.627 22.627-56.568-56.568 22.627-22.627 56.568 56.568z",
      "M222.778 556.256l-22.624-22.624 56.568-56.568 22.624 22.624-56.568 56.568z",
      "M511.282 267.755l-22.627-22.627 56.567-56.567 22.627 22.627-56.567 56.567z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-color-wand-outline"
    ]
  },
  {
    "paths": [
      "M396.022 318.44l-68.086 68.234 512.192 513.326 67.872-68.234z",
      "M364 124h64v128h-64v-128z",
      "M364 532h64v128h-64v-128z",
      "M548 356h128v64h-128v-64z",
      "M607.882 224.286l-45.254-45.356-90.508 90.71 45.254 45.356z",
      "M184.12 224.286l90.508 90.71 45.254-45.356-90.508-90.71z",
      "M184.12 558.282l45.254 45.35 90.508-90.708-45.254-45.356z",
      "M116 356h128v64h-128v-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-color-wand"
    ]
  },
  {
    "paths": [
      "M736 832h-576v-544h448.234l32-32h-512.234v608h640v-480.234l-32 32z",
      "M475.246 568.168l-19.412-19.414 342.646-342.646-22.626-22.628-359.854 359.822v64.698h64.432l360.090-359.968-22.628-22.572z",
      "M888.426 160.624l-24.93-24.932c-5.328-4.758-12.384-7.692-20.004-7.692-7.624 0-14.608 2.936-19.858 7.7l-24.302 24.3 64.786 64.786 24.3-24.3c4.766-5.25 7.582-12.234 7.582-19.858 0-7.62-2.816-14.678-7.574-20.004z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-compose-outline"
    ]
  },
  {
    "paths": [
      "M512 640h-128v-128l256-256h-512v608h640v-480z",
      "M775.854 183.48l-359.854 359.822v64.698h64.432l360.090-359.968z",
      "M888.426 160.624l-24.93-24.932c-5.328-4.758-12.384-7.692-20.004-7.692-7.624 0-14.608 2.936-19.858 7.7l-24.302 24.3 64.786 64.786 24.3-24.3c4.766-5.25 7.582-12.234 7.582-19.858 0-7.62-2.816-14.678-7.574-20.004z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-compose"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 130.6c210.2 0 381.4 171 381.4 381.4 0 93-33.4 178.2-88.8 244.4-40-16.4-131.8-48.2-185.8-64.2-4.8-1.4-5.4-1.8-5.4-21.4 0-16.2 6.6-32.6 13.2-46.6 7.2-15 15.4-40.4 18.4-63.2 8.4-9.8 20-29 27.2-65.8 6.4-32.4 3.4-44.2-0.8-55.2-0.4-1.2-1-2.4-1.2-3.4-1.6-7.6 0.6-47 6.2-77.6 3.8-21-1-65.6-29.8-102.6-18.2-23.4-53.2-52-117-56h-35c-62.8 4-97.6 32.6-116 56-29 37-33.8 81.6-30 102.6 5.6 30.6 7.8 70 6.2 77.6-0.4 1.4-0.8 2.4-1.2 3.6-4.2 11-7.4 22.8-0.8 55.2 7.4 36.8 18.8 56 27.2 65.8 3 22.8 11.4 48 18.4 63.2 5.2 11 7.6 26 7.6 47.2 0 19.8-0.8 20-5.2 21.4-56.2 16.6-145.2 48.6-180.8 64-55.8-66.4-89.4-151.8-89.4-245 0-210.2 171.2-381.4 381.4-381.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-contact-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-117.2 0-222.2-53.2-292.2-136.6 35.6-15.4 124.4-47.4 180.6-63.8 4.4-1.4 5.2-1.6 5.2-21.4 0-21.2-2.4-36.2-7.6-47.2-7-15-15.4-40.4-18.4-63.2-8.4-9.8-19.8-29-27.2-65.8-6.4-32.4-3.4-44.2 0.8-55.2 0.4-1.2 1-2.4 1.2-3.6 1.6-7.4-0.6-47-6.2-77.6-3.8-21 1-65.6 30-102.6 18.2-23.4 53.2-52 116-56h35c63.8 4 98.8 32.6 117 56 29 37 33.8 81.6 29.8 102.6-5.6 30.6-7.8 70-6.2 77.6 0.2 1.2 0.8 2.4 1.2 3.4 4.2 11 7.4 22.8 0.8 55.2-7.4 36.8-18.8 56-27.2 65.8-3 22.8-11.4 48-18.4 63.2-6.6 13.8-13.2 30.2-13.2 46.6 0 19.8 0.8 20 5.4 21.4 53.4 15.8 145.4 47.6 186 64.2-70 83.6-175 137-292.4 137z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-contact"
    ]
  },
  {
    "paths": [
      "M608 192h-32v160h160v-32h-128z",
      "M650.6 128h-330.6v96h-96v672h480v-96h96v-522l-149.4-150zM672 864h-416v-608h64v544h352v64zM768 768h-416v-608h285.4l130.6 131.2v476.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-copy-outline"
    ]
  },
  {
    "paths": [
      "M288 832v-608h-64v672h480v-64h-384z",
      "M650.6 128h-330.6v672h480v-522l-149.4-150zM736 352h-160v-160h32v128h128v32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-copy"
    ]
  },
  {
    "paths": [
      "M256 128h64v96h-64v-96z",
      "M320 704v-352h-64v416h416v-64z",
      "M800 704h96v64h-96v-64z",
      "M128 256v64h576v576h64v-640z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-crop-strong"
    ]
  },
  {
    "paths": [
      "M256 128h32v96h-32v-96z",
      "M288 736v-416h-32v448h448v-32z",
      "M800 736h96v32h-96v-32z",
      "M128 256v32h608v608h32v-640z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-crop"
    ]
  },
  {
    "paths": [
      "M576 288v32h224v544h-576v-544h224v-32h-256v608h640v-608z",
      "M386.2 504.6l-23.2 23.2 149 149 149-149-23.2-23.2-109.4 109.4v-486h-32.8v486z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-download-outline"
    ]
  },
  {
    "paths": [
      "M528 288v326l109.6-109.4 23.2 23.2-148.8 149-149-149 23.4-23.2 109.6 109.4v-326h-304v608h640v-608z",
      "M496 128h32v160h-32v-160z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-download"
    ]
  },
  {
    "paths": [
      "M160 608h704v32h-704v-32z",
      "M160 496h704v32h-704v-32z",
      "M160 384h704v32h-704v-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-drag"
    ]
  },
  {
    "paths": [
      "M128 256v512h768v-512h-768zM512 535.8l-325.6-247.8h651.2l-325.6 247.8zM160 736v-427.8l230.2 175.2-136.2 154.6 4 4 157.8-139.2 96.2 73.2 96.2-73.2 157.8 139.2 4-4-136.2-154.8 230.2-175v427.8h-704z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-email-outline"
    ]
  },
  {
    "paths": [
      "M896 768v-484.4l-262.2 199.6 136.2 154.8-4 4-157.8-139.2-96.2 73.2-96.2-73.2-157.8 139.2-4-4 136-154.8-262-199.2v484z",
      "M879.4 256h-735.4l368 279.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-email"
    ]
  },
  {
    "paths": [
      "M894.2 512.4c-90.6-104.4-215.8-224.4-382.2-224.4-67.2 0-128.8 19-193.8 59.6-54.8 34.4-111 82.8-188.2 162.4l-2 2 13.4 13.8c110.2 112.8 205.4 210.2 370.6 210.2 73 0 143.8-23.8 216.4-72.8 61.8-41.8 114.4-94.8 156.6-137.6l11-11-1.8-2.2zM512 320c66.2 0 129.8 19 194.4 61.2 47.8 31.2 94.8 73.4 147.4 132.2-76.6 77.4-191.6 190.6-341.8 190.6-68.4 0-128.4-16.8-188.4-56.4-55-36.2-104.6-86.6-152.4-135.6 118.2-119.4 216.8-192 340.8-192z",
      "M512 672c88.2 0 160-71.8 160-160s-71.8-160-160-160c-88.2 0-160 71.8-160 160s71.8 160 160 160zM512 384.6c70.4 0 128 57.2 128 127.4s-57.6 127.4-128 127.4c-70.4 0-127.8-57.2-127.8-127.4s57.4-127.4 127.8-127.4z",
      "M576 512v0c0 35-28.8 64-63.6 64s-64.4-30.4-64.4-65.4 31.6-62.6 64-62.6v-32c-53 0-95.8 43.2-95.8 96.4s43 96.2 95.8 96.2 96-43.2 96-96.2v-0.4h-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-eye-outline"
    ]
  },
  {
    "paths": [
      "M894.2 512.4c-90.6-104.4-215.8-224.4-382.2-224.4-67.2 0-128.8 19-193.8 59.6-54.8 34.4-111 82.8-188.2 162.4l-2 2 13.4 13.8c110.2 112.8 205.4 210.2 370.6 210.2 73 0 143.8-23.8 216.4-72.8 61.8-41.8 114.4-94.8 156.6-137.6l11-11-1.8-2.2zM512 672c-88.2 0-160-71.8-160-160s71.8-160 160-160c88.2 0 160 71.8 160 160s-71.8 160-160 160z",
      "M500.8 453.6c0-13.8 4-26.8 11-37.6-53 0-95.8 43.2-95.8 96.4s43 96.2 95.8 96.2 96-43 96-96.2v0c-10.8 7-23.8 11-37.6 11-38.2-0.2-69.4-31.4-69.4-69.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-eye"
    ]
  },
  {
    "paths": [
      "M96 310l367 202-367 201.8v-403.8zM544 311.6l352 200.4-352 200.8v-400.8zM512 256v246.4l-448-246.4v512l448-246.4v246.4l448-256-448-256z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-fastforward-outline"
    ]
  },
  {
    "paths": [
      "M512 256v246.4l-448-246.4v512l448-246.4v246.4l448-256-448-256z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-fastforward"
    ]
  },
  {
    "paths": [
      "M737 256h-450l-127 192v320h704v-320l-127-192zM826.8 448h-90.8v-136l90.8 136zM320 288h384v160h-96c0 53-43 96-96 96s-96-43-96-96h-96v-160zM288 312v136h-90.8l90.8-136zM832 736h-640v-256h196c14.2 55.2 64.4 96 124 96s109.8-40.8 124-96h196v256z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-filing-outline"
    ]
  },
  {
    "paths": [
      "M512 576c-59.6 0-109.8-40.8-124-96h-228v288h704v-288h-228c-14.2 55.2-64.4 96-124 96z",
      "M288 448h128c0 53 43 96 96 96s96-43 96-96h256l-127-192h-1v160h-32v-160h-384v160h-32v-160h-1l-127 192h128z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-filing"
    ]
  },
  {
    "paths": [
      "M112 176v672h800v-672h-800zM256 816h-112v-96h112v96zM256 688h-112v-96h112v96zM256 560h-112v-96h112v96zM256 432h-112v-96h112v96zM256 304h-112v-96h112v96zM736 816h-448v-288h448v288zM736 496h-448v-288h448v288zM880 816h-112v-96h112v96zM880 688h-112v-96h112v96zM880 560h-112v-96h112v96zM880 432h-112v-96h112v96zM880 304h-112v-96h112v96z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-film-outline"
    ]
  },
  {
    "paths": [
      "M112 176v672h800v-672h-800zM256 816h-112v-96h112v96zM256 688h-112v-96h112v96zM256 560h-112v-96h112v96zM256 432h-112v-96h112v96zM256 304h-112v-96h112v96zM736 528h-448v-32h448v32zM880 816h-112v-96h112v96zM880 688h-112v-96h112v96zM880 560h-112v-96h112v96zM880 432h-112v-96h112v96zM880 304h-112v-96h112v96z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-film"
    ]
  },
  {
    "paths": [
      "M736 224c-22 2.8-49.8 7-79.4 7-46.2 0-88-11.4-130.4-20.4-43-9.2-87.4-18.6-134.4-18.6-93.8 0-125.6 20.2-128.8 22.4l-6.8 4.8v612.8h32v-286.6c12-5 43.6-13.8 103.8-13.8 43.6 0 84.4 16.6 127.8 26 44 9.4 89.6 19.2 139 19.2 29.4 0 55.4-4 77.4-6.6 12-1.4 22.6-2.8 32-4.4v-346.8c-9.4 1.8-20.2 3.4-32.2 5zM736 538c-22 2.8-47.8 7-77.4 7-46.2 0-90-9.4-132.4-18.4-43-9.2-87.2-26.6-134.2-26.6-51.4 0-83.8 6-103.8 12v-274.6c12-5 43.8-13.6 103.8-13.6 43.6 0 84.4 8.6 127.8 18 44 9.4 87.6 21.2 137 21.2 29.4 0 57.4-4 79.4-6.6l-0.2 281.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-flag-outline"
    ]
  },
  {
    "paths": [
      "M736 224c-22 2.8-49.8 7-79.4 7-46.2 0-88-11.4-130.4-20.4-43-9.2-87.4-18.6-134.4-18.6-93.8 0-125.6 20.2-128.8 22.4l-6.8 4.8v612.8h32v-286.6c12-5 43.6-13.8 103.8-13.8 43.6 0 84.4 16.6 127.8 26 44 9.4 89.6 19.2 139 19.2 29.4 0 55.4-4 77.4-6.6 12-1.4 22.6-2.8 32-4.4v-346.8c-9.4 1.8-20.2 3.4-32.2 5z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-flag"
    ]
  },
  {
    "paths": [
      "M447.798 64c51.382 290-193.464 284-191.79 576 1.372 239.020 209.95 320 256.286 320 46.332 0 227.76-52 253.862-320 21.266-218.368-145.012-448-318.358-576zM512.294 944c0 0-81.402-71.632-81.402-160 0-88.366 81.11-160 81.11-160s80.664 71.634 80.664 160c-0.002 88.368-80.372 160-80.372 160zM734.306 636.898c-5.646 57.976-19.408 109.046-40.9 151.788-17.498 34.794-40.168 64.228-67.384 87.486-13.044 11.15-26.51 20.23-39.542 27.498 20.078-31.876 38.186-73.44 38.186-119.67 0-101.576-87.684-180.614-91.416-183.926l-21.188-18.82-21.242 18.762c-3.754 3.314-91.926 82.356-91.926 183.984 0 43.684 16.336 83.188 35.272 114.304-14.762-8.652-30.43-19.496-45.972-32.902-29.376-25.34-52.73-55.216-69.416-88.804-20.126-40.51-30.478-86.53-30.766-136.782-0.734-127.972 48.18-191.492 99.966-258.738 49.136-63.806 99.658-129.4 98.916-244.226 65.026 57.654 122.514 126.060 165.644 197.754 62.614 104.094 90.892 208.624 81.768 302.292z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-flame-outline"
    ]
  },
  {
    "paths": [
      "M447.798 64c51.382 290-193.464 284-191.79 576 1.372 239.020 209.95 320 256.286 320 46.332 0 227.76-52 253.862-320 21.266-218.368-145.012-448-318.358-576zM512.294 944c0 0-81.402-71.632-81.402-160 0-88.366 81.11-160 81.11-160s80.664 71.634 80.664 160c-0.002 88.368-80.372 160-80.372 160z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-flame"
    ]
  },
  {
    "paths": [
      "M873.824 740.882l-233.824-390.882v-254h32v-32h-64v294.836l5.028 7.582 233.15 389.668c13.5 25.636 18.628 51.9 18.002 75.914-0.486 18.678-3.916 35.876-13.090 51.138-16.938 28.194-46.43 44.862-81.128 44.862h-511.776c-35.008 0-64.922-16.87-82.070-45.41-23.794-39.602-21.778-76.29 4.55-126.278l182.976-308.312h116.358v-32h-97.366l29.374-49.512 3.992-7.688v-6.8h96v-32h-96v-64h64v-32h-64v-64h96v-32h-96v-64h-64v32h32v254l-231.748 390.882c-16.824 31.654-25.022 62.746-24.198 91.118 2.122 73.022 57.404 128 130.13 128h511.778c72.582 0 124.262-55.196 125.984-128 0.676-28.488-5.212-59.302-22.122-91.118z",
      "M216.584 749.232c-13.814 21.084-21.872 48.19-21.872 67.1 0 55.168 31.64 79.668 91.364 79.668h451.864c59.608 0 89.95-31.422 91.362-79.918 0.554-18.976-6.286-45.458-20.172-66.648l-143.672-237.434h-306.458l-142.416 237.232zM647.41 544l134.336 221.74 0.302 0.248 0.318 0.364c10.764 16.424 15.294 36.55 14.952 48.36-0.458 15.678-4.954 27.96-13.366 35.59-9.548 8.656-25.458 13.7-46.016 13.7h-451.862c-22.128 0-38.54-4.472-47.46-11.992-2.944-2.48-11.908-10.286-11.908-36.176 0-11.886 5.714-32.766 16.638-49.434l0.354-0.604 0.332-0.084 133.098-221.712h270.282z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-flask-outline"
    ]
  },
  {
    "paths": [
      "M782.032 765.988l-0.3-0.248-134.332-221.74h-270.292l-133.098 221.71-0.332 0.084-0.354 0.604c-10.922 16.668-16.638 37.546-16.638 49.434 0 25.89 8.962 33.696 11.908 36.176 8.92 7.52 25.334 11.992 47.462 11.992h451.864c20.556 0 36.464-5.042 46.014-13.7 8.41-7.628 12.908-19.912 13.366-35.59 0.344-11.808-4.186-31.936-14.952-48.36l-0.316-0.362z",
      "M873.824 740.882l-233.824-390.882v-254h32v-32h-320v32h32v254l-231.75 390.882c-16.82 31.654-25.018 62.746-24.194 91.118 2.122 73.022 57.402 128 130.13 128h511.776c72.584 0 124.264-55.196 125.986-128 0.676-28.488-5.214-59.302-22.124-91.118zM416 128h96v32h-96v-32zM416 224h64v32h-64v-32zM416 320h96v32h-96v-32zM382.522 416h97.478v32h-116.358l18.88-32zM829.28 816.082c-1.412 48.496-31.754 79.918-91.36 79.918h-451.866c-59.724 0-91.364-24.5-91.364-79.668 0-18.91 8.058-46.016 21.874-67.1l142.416-237.232h306.456l143.672 237.434c13.886 21.19 20.724 47.672 20.172 66.648z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-flask"
    ]
  },
  {
    "paths": [
      "M790.114 568.504c111.858 0 169.886-23.24 169.886-56.004s-58.032-56.006-169.886-56.006c-57.464 0-129.416 14.782-185.804 29.156-1.95-6.838-4.61-13.376-7.946-19.5 50.018-29.704 111.29-70.1 151.894-110.706 79.094-79.094 104.046-136.916 80.88-160.084-5.494-5.496-12.944-8.284-22.158-8.284-29.636 0-77.592 28.83-137.926 89.164-40.564 40.564-80.918 101.746-110.614 151.738-6.124-3.392-12.66-6.124-19.51-8.124 14.35-56.34 29.070-128.118 29.070-185.47 0.004-111.852-23.236-170.384-56-170.384s-56.004 58.532-56.004 170.388c0 57.352 14.724 129.13 29.072 185.47-6.85 2-13.386 4.73-19.51 8.124-29.694-49.992-70.046-111.174-110.61-151.738-60.33-60.33-108.288-89.164-137.928-89.164-9.218 0-16.662 2.788-22.158 8.284-23.168 23.166 1.788 80.988 80.88 160.082 40.606 40.606 101.876 81.002 151.894 110.706-3.336 6.124-5.998 12.662-7.948 19.5-56.388-14.376-128.338-29.156-185.802-29.156-111.854-0.002-169.886 22.74-169.886 55.504s58.032 56.504 169.888 56.504c57.554 0 129.64-14.826 186.068-29.222 2.006 6.784 4.736 13.25 8.11 19.312-50.096 29.726-111.602 70.238-152.322 110.958-79.094 79.096-104.046 136.918-80.88 160.086 5.496 5.496 12.942 8.284 22.156 8.284 29.638 0 77.592-28.83 137.926-89.166 40.764-40.762 81.318-102.354 111.052-152.476 6.064 3.314 12.534 5.976 19.302 7.934-14.422 56.476-29.308 128.734-29.308 186.402 0.004 111.852 23.244 169.384 56.008 169.384s56.004-57.532 56.004-169.386c0-57.668-14.882-129.926-29.304-186.402 6.77-1.958 13.236-4.62 19.3-7.934 29.734 50.124 70.29 111.714 111.054 152.478 60.328 60.33 108.288 89.164 137.926 89.164 9.216 0 16.66-2.788 22.156-8.284 23.168-23.168-1.788-80.99-80.878-160.086-40.722-40.718-102.228-81.23-152.324-110.958 3.376-6.062 6.106-12.532 8.11-19.312 56.43 14.398 128.516 29.224 186.070 29.224zM639.984 509.882c60.288-14.028 111.786-21.388 150.128-21.388 42.658 0 78.906 3.612 104.82 10.444 19.41 5.118 28.010 10.634 31.472 13.562-3.462 2.926-12.062 8.442-31.472 13.558-25.916 6.832-62.162 10.446-104.82 10.446-38.352 0-89.854-7.36-150.15-21.39l0.022-5.232zM691.682 298.872c70.764-70.766 105.364-78.824 113.636-79.692-0.422 4.61-2.686 14.652-12.808 31.982-13.572 23.24-36.7 51.476-66.878 81.656-27.066 27.068-68.6 58.222-121.026 90.876-1.238-1.296-2.5-2.566-3.79-3.808 32.648-52.428 63.802-93.95 90.866-121.014zM419.396 423.692c-52.426-32.652-93.958-63.808-121.024-90.874-30.18-30.182-53.306-58.416-66.878-81.656-10.122-17.33-12.388-27.374-12.808-31.984 8.276 0.87 42.872 8.926 113.636 79.69 27.066 27.066 58.216 68.59 90.866 121.014-1.292 1.244-2.556 2.514-3.792 3.81zM233.888 536.504c-42.678 0-78.966-3.69-104.942-10.67-19.378-5.208-27.922-10.788-31.35-13.74 3.5-2.902 12.154-8.354 31.592-13.378 25.854-6.686 62.058-10.22 104.702-10.22 38.344 0 89.844 7.36 150.128 21.388l0.020 5.23c-60.298 14.030-111.798 21.39-150.15 21.39zM332.32 726.128c-70.766 70.764-105.36 78.82-113.636 79.692 0.42-4.61 2.686-14.652 12.808-31.984 13.572-23.238 36.698-51.472 66.878-81.656 27.174-27.172 68.914-58.458 121.63-91.25 1.168 1.208 2.362 2.394 3.578 3.558-32.79 52.72-64.080 94.462-91.258 121.64zM604 600.93c52.712 32.79 94.454 64.074 121.628 91.25 30.182 30.184 53.306 58.418 66.878 81.656 10.124 17.332 12.386 27.376 12.806 31.984-8.276-0.872-42.872-8.928-113.634-79.692-27.178-27.18-58.468-68.926-91.26-121.64 1.218-1.162 2.412-2.352 3.582-3.558zM498.444 129.356c5.096-19.406 10.594-28.11 13.556-31.668 2.96 3.56 8.46 12.262 13.554 31.668 6.836 26.030 10.45 62.348 10.45 105.032 0 38.234-7.32 89.562-21.274 149.642h-5.46c-13.954-60.080-21.276-111.408-21.276-149.642 0.002-42.682 3.614-79.002 10.45-105.032zM525.564 895.224c-5.138 19.414-10.678 27.908-13.564 31.272-2.888-3.364-8.424-11.858-13.564-31.272-6.83-25.802-10.44-61.976-10.44-104.616 0-38.456 7.402-90.132 21.504-150.632h5c14.104 60.5 21.504 112.178 21.504 150.632 0 42.64-3.61 78.814-10.44 104.616zM512 576c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z",
      "M689.72 811.356c-49.058-35.348-96.788-103.464-96.788-103.464s14.062 82.118 3.708 151.892c23.356 43.558 52.278 70.506 73.286 70.506 3.498 0 6.864-0.648 10.084-1.952 23.748-9.594 28.77-49.968 9.71-116.982zM667.476 897.132c-5.476-2.92-18.814-12.738-37.984-44.54 1.376-15.744 2.196-32.674 2.438-50.564 10.024 9.76 19.894 18.874 29.494 27.226 10.208 39.562 8.484 60.304 6.052 67.878z",
      "M427.358 165.216c-26.584-47.020-52.278-70.51-73.288-70.51-3.498 0-6.862 0.65-10.084 1.952-23.736 9.59-28.994 46.422-9.74 116.882 42.504 31.96 96.748 103.1 96.748 103.1s-15.494-81.64-3.636-151.424zM392.076 222.738c-10.002-9.712-19.886-18.796-29.538-27.148-10.168-39.462-8.446-60.164-6.016-67.726 5.474 2.918 18.814 12.738 37.988 44.54-1.374 15.676-2.188 32.528-2.434 50.334z",
      "M164.714 597.136c-54.844 31.010-77.672 60.804-68.554 83.374 5.612 13.888 21.826 21.35 47.684 21.35 18.364 0 44.868-3.118 69.344-11.652 34.81-47.868 103.424-96.774 103.424-96.774s-82.614 12.238-151.898 3.702zM195.274 661.912c-20.176 5.212-37.818 7.948-51.432 7.948-8.184 0-13.466-1.004-16.446-1.94 2.954-5.51 12.814-18.822 44.506-37.932 15.744 1.378 32.676 2.198 50.568 2.44-9.74 10.008-18.84 19.872-27.196 29.484z",
      "M927.84 344.49c-5.612-13.89-21.828-21.35-47.688-21.35-18.356 0-42.8 3.43-69.308 11.644-36.176 47.548-103.398 96.774-103.398 96.774s81.556-14.56 151.836-3.698c54.846-31.008 77.676-60.804 68.558-83.37zM852.094 395.008c-15.734-1.378-32.654-2.194-50.534-2.436 9.738-10.008 18.84-19.878 27.2-29.498 20.162-5.204 37.79-7.936 51.394-7.936 8.186 0 13.466 1.004 16.45 1.94-2.956 5.51-12.818 18.824-44.51 37.93z",
      "M326.27 817.96c-16.84 60.68-11.912 97.876 10.488 107.38 3.348 1.422 6.874 2.132 10.55 2.132 22.214 0 49.396-26.248 79.056-78.030-8.368-64.44 4.702-141.558 4.702-141.558s-43.068 62.788-104.796 110.076zM349.962 894.414c-1.808-5.932-4.294-22.3 4.624-58.318 12.096-10.158 24.646-21.564 37.486-34.064 0.19 13.958 0.732 27.374 1.62 40.078-20.76 35.21-36.652 48.67-43.73 52.304z",
      "M687.244 99.652c-3.348-1.42-6.876-2.132-10.548-2.132-22.21 0-52.414 28.574-79.054 78.026 9.028 45.788-4.786 142.106-4.786 142.106s46.478-68.652 104.684-109.912c16.794-63.74 12.19-98.542-10.296-108.088zM669.254 189.562c-12.058 10.102-24.554 21.44-37.32 33.862-0.184-14.124-0.728-27.692-1.624-40.538 20.758-35.214 36.654-48.672 43.728-52.306 1.822 5.968 4.334 22.502-4.784 58.982z",
      "M206.418 326.734c-20.418-7.734-44.984-10.002-61.504-10.002-24.534 0-40.084 7.146-45.762 20.522-10.008 23.584 19.94 59.97 75.896 89.61 59.452-7.864 141.376 4.672 141.376 4.672s-74.424-57.402-110.006-104.802zM130.068 350.43c2.762-0.828 7.55-1.696 14.848-1.696 11.63 0 26.484 2.176 43.374 6.33 10.154 12.098 21.562 24.66 34.068 37.508-13.918 0.192-27.296 0.734-39.968 1.62-35.264-20.792-48.71-36.702-52.322-43.762z",
      "M848.954 598.132c-50.614 11.2-141.56-4.7-141.56-4.7s69.276 51.23 110.028 104.786c23.918 8.446 45.11 10.044 61.666 10.044 24.532 0 40.082-7.146 45.76-20.522 10.008-23.58-16.282-56.138-75.894-89.608zM879.084 676.264c-11.666 0-26.574-2.19-43.53-6.37-10.156-12.106-21.548-24.652-34.026-37.468 13.96-0.19 27.376-0.73 40.082-1.622 35.262 20.792 48.708 36.704 52.316 43.764-2.756 0.826-7.546 1.696-14.842 1.696z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-flower-outline"
    ]
  },
  {
    "paths": [
      "M790.114 456.494c-57.302 0-129.004 14.7-185.32 29.036-1.96-6.886-4.642-13.468-8.002-19.634 49.94-29.68 110.974-69.96 151.466-110.448 79.094-79.094 104.046-136.916 80.88-160.084-23.168-23.166-80.99 1.786-160.084 80.88-40.45 40.45-80.686 101.396-110.356 151.308-6.164-3.416-12.746-6.166-19.644-8.178 14.312-56.266 28.95-127.794 28.95-184.984-0-111.858-23.24-170.39-56.004-170.39s-56.004 58.532-56.004 170.388c0 57.19 14.638 128.718 28.95 184.984-6.898 2.012-13.48 4.762-19.644 8.178-29.67-49.912-69.906-110.86-110.352-151.306-79.096-79.094-136.916-104.048-160.084-80.88-23.168 23.166 1.788 80.988 80.88 160.082 40.492 40.488 101.524 80.768 151.464 110.448-3.36 6.166-6.042 12.748-8.002 19.634-56.316-14.336-128.016-29.036-185.318-29.036-111.858 0.002-169.89 22.744-169.89 55.508s58.032 56.504 169.888 56.504c57.394 0 129.226-14.742 185.584-29.102 2.020 6.828 4.768 13.342 8.166 19.448-50.018 29.704-111.29 70.098-151.892 110.702-79.094 79.096-104.046 136.918-80.88 160.086 23.168 23.168 80.99-1.79 160.084-80.882 40.646-40.646 81.084-102.002 110.796-152.048 6.106 3.342 12.62 6.020 19.436 7.99-14.384 56.406-29.184 128.414-29.184 185.918 0 111.858 23.24 169.386 56.004 169.386s56.004-57.532 56.004-169.386c0-57.504-14.8-129.512-29.184-185.918 6.816-1.97 13.33-4.648 19.436-7.99 29.71 50.046 70.146 111.402 110.798 152.050 79.094 79.094 136.914 104.048 160.082 80.88s-1.788-80.99-80.878-160.086c-40.608-40.604-101.876-80.998-151.894-110.702 3.398-6.106 6.146-12.62 8.166-19.448 56.36 14.36 128.192 29.102 185.584 29.102 111.858 0 169.886-23.24 169.886-56.004s-58.034-56.006-169.888-56.006z",
      "M592.934 707.89c0 0 14.062 82.118 3.708 151.892 23.356 43.558 52.278 70.506 73.286 70.506 3.498 0 6.864-0.648 10.084-1.952 23.748-9.594 28.77-49.968 9.71-116.982-49.060-35.346-96.788-103.464-96.788-103.464z",
      "M430.994 316.64c0 0-15.494-81.64-3.636-151.424-26.584-47.020-52.278-70.51-73.288-70.51-3.498 0-6.862 0.65-10.084 1.952-23.736 9.59-28.994 46.422-9.74 116.882 42.504 31.96 96.748 103.1 96.748 103.1z",
      "M316.612 593.434c0 0-82.616 12.238-151.898 3.704-54.844 31.010-77.672 60.804-68.554 83.374 5.612 13.888 21.826 21.35 47.684 21.35 18.364 0 44.868-3.118 69.344-11.652 34.81-47.87 103.424-96.776 103.424-96.776z",
      "M707.446 431.558c0 0 81.556-14.56 151.836-3.698 54.848-31.008 77.676-60.804 68.558-83.37-5.612-13.89-21.828-21.35-47.688-21.35-18.356 0-42.8 3.43-69.308 11.644-36.176 47.548-103.398 96.774-103.398 96.774z",
      "M326.27 817.96c-16.84 60.68-11.912 97.876 10.488 107.38 3.348 1.422 6.874 2.132 10.55 2.132 22.214 0 49.396-26.248 79.056-78.030-8.368-64.44 4.702-141.558 4.702-141.558s-43.068 62.788-104.796 110.076z",
      "M697.54 207.74c16.794-63.74 12.192-98.542-10.294-108.088-3.348-1.42-6.876-2.132-10.548-2.132-22.21 0-52.414 28.574-79.054 78.026 9.028 45.788-4.786 142.106-4.786 142.106s46.476-68.652 104.682-109.912z",
      "M175.048 426.864c59.452-7.864 141.376 4.672 141.376 4.672s-74.424-57.402-110.006-104.802c-20.418-7.734-44.984-10.002-61.504-10.002-24.534 0-40.084 7.146-45.762 20.522-10.008 23.584 19.94 59.97 75.896 89.61z",
      "M848.954 598.132c-50.614 11.2-141.56-4.7-141.56-4.7s69.276 51.23 110.028 104.786c23.918 8.446 45.11 10.044 61.666 10.044 24.532 0 40.082-7.146 45.76-20.522 10.008-23.58-16.282-56.138-75.894-89.608z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-flower"
    ]
  },
  {
    "paths": [
      "M914 192h-484c-5.582 0-8.542-1.17-12.188-4.816l-45.338-45.326c-9.744-9.192-17.752-13.858-34.474-13.858h-224c-27.57 0-50 20.634-50 46v672c0 26.634 23.366 50 50 50h800c25.366 0 46-22.43 46-50v-608c0-26.654-19.346-46-46-46zM114 160h224c6.994 0 7.474 0.378 12.35 4.976l44.834 44.836c9.68 9.68 20.744 14.188 34.816 14.188h484c8.896 0 14 5.104 14 14v84.752c-5.008-1.776-10.39-2.752-16-2.752h-800c-5.61 0-10.992 0.976-16 2.752v-148.752c0-8.646 9.344-14 18-14zM928 846c0 8.656-5.354 18-14 18h-800c-8.916 0-18-9.084-18-18v-478c0-8.822 7.178-16 16-16h800c8.822 0 16 7.178 16 16v478z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-folder-outline"
    ]
  },
  {
    "paths": [
      "M944 352h-864c-8.822 0-16 7.178-16 16v478c0 26.634 23.366 50 50 50h800c25.366 0 46-22.43 46-50v-478c0-8.822-7.178-16-16-16z",
      "M914 192h-484c-5.582 0-8.542-1.17-12.188-4.816l-45.338-45.326c-9.744-9.192-17.752-13.858-34.474-13.858h-224c-27.57 0-50 20.634-50 46v148.752c5.008-1.776 10.39-2.752 16-2.752h864c5.61 0 10.992 0.976 16 2.752v-84.752c0-26.654-19.346-46-46-46z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-folder"
    ]
  },
  {
    "paths": [
      "M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.744 0 416-186.276 416-416s-186.26-416-416-416zM594.302 884.358c-27.028 5.314-60.654 8.374-88 8.9-26.396-0.39-52.148-3.47-77-8.986-4.288-1.098-8.766-2.276-13.61-3.554l-48.834-130.87 39.29-77.848h211.708l1.14 2.152 38.68 77.704-47.236 128.564c-5.334 1.428-10.716 2.738-16.138 3.938zM178.634 327.044l36.726 105.576-84.608 73.22c1.032-64.77 18.288-125.664 47.882-178.796zM379.156 154.56l114.844 78.592v116.294l-141.994 120.134-107.14-48.818-44.664-128.038c44.018-62.408 106.276-111.064 178.954-138.164zM650.050 494.412l1.842 1.53-36.754 144.058h-206.276l-36.97-144.906 0.89-0.752 137.746-116.54 139.522 116.61zM893.252 505.842l-84.908-73.476 36.85-105.63c29.7 53.208 47.024 114.21 48.058 179.106zM823.128 292.134l-44.864 128.966-107.984 48.776-142.28-120.43v-116.294l115.192-78.83c72.724 26.966 135.81 75.504 179.936 137.812zM132.288 546.828l107.512-93.036 100.196 45.708 39.436 154.574-40.866 77.058-139.72-1.83c-36.696-52.72-60.428-115.092-66.558-182.474zM685.438 731.13l-40.868-77.058 39.504-154.832 99.994-45.562 107.644 93.15c-6.13 67.382-29.864 129.754-66.554 182.472l-139.72 1.83zM510.514 205.34l-92.252-62.996c30-7.612 61.402-11.672 93.738-11.67 31.922 0 62.932 3.964 92.586 11.388l-94.072 63.278zM332.846 763.058l1.696 5.022 39.892 99.562c-58.478-22.702-110.022-59.408-150.464-106.012l108.876 1.428zM649.126 867.808l35.868-97.216 3.254-7.496 111.784-1.464c-40.544 46.718-92.246 83.492-150.906 106.176z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-football-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.744 0 416-186.276 416-416s-186.26-416-416-416zM594.302 884.358c-27.028 5.314-60.654 8.374-88 8.9-26.396-0.39-52.148-3.47-77-8.986-4.288-1.098-8.766-2.276-13.61-3.554l-48.834-130.87 39.29-77.848h211.708l1.14 2.152 38.68 77.704-47.236 128.564c-5.334 1.428-10.716 2.738-16.138 3.938zM379.156 154.56l114.844 78.592v116.294l-141.994 120.134-107.14-48.818-44.664-128.038c44.018-62.408 106.276-111.064 178.954-138.164zM823.128 292.134l-44.864 128.966-107.984 48.776-142.28-120.43v-116.294l115.192-78.83c72.724 26.966 135.81 75.504 179.936 137.812zM132.288 546.828l107.512-93.036 100.196 45.708 39.436 154.574-40.866 77.058-139.72-1.83c-36.696-52.72-60.428-115.092-66.558-182.474zM685.438 731.13l-40.868-77.058 39.504-154.832 99.994-45.562 107.644 93.15c-6.13 67.382-29.864 129.754-66.554 182.472l-139.72 1.83z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-football"
    ]
  },
  {
    "paths": [
      "M389.644 480h-69.644v-69.524c0-5.634-5.208-10.476-10.606-10.476h-44.29c-5.396 0-9.104 4.744-9.104 10.356v69.644h-70.934c-5.23 0-9.066 4.286-9.066 9.542v42.854c0 5.396 4.062 11.606 9.722 11.606h70.278v70.934c0 5.23 4.286 9.066 9.542 9.066h42.854c5.396 0 11.606-4.062 11.606-9.722v-70.28h69.524c5.634 0 10.476-5.208 10.476-10.606v-44.29c-0.002-5.396-4.746-9.104-10.358-9.104z",
      "M724.628 558.126c-21.472 0-38.902 17.030-38.902 38.306 0 21.11 17.43 38.168 38.902 38.168 21.566 0 38.996-17.058 38.996-38.168 0-21.276-17.428-38.306-38.996-38.306z",
      "M639.532 474.33c-21.472 0-38.902 17.206-38.902 38.336 0 21.132 17.43 38.306 38.902 38.306 21.566 0 38.996-17.174 38.996-38.306 0-21.13-17.43-38.336-38.996-38.336z",
      "M809.724 474.33c-21.458 0-38.884 17.206-38.884 38.336 0 21.132 17.428 38.306 38.884 38.306 21.474 0 38.904-17.174 38.904-38.306 0-21.13-17.428-38.336-38.904-38.336z",
      "M724.628 390.602c-21.472 0-38.902 17.204-38.902 38.338 0 21.132 17.43 38.292 38.902 38.292 21.566 0 38.996-17.158 38.996-38.292 0-21.136-17.428-38.338-38.996-38.338z",
      "M738.538 324c51.676 0 99.408 18.628 134.408 52.458 35.504 34.314 55.054 82.036 55.054 134.378 0 52.606-19.612 100.81-55.222 135.738-35.126 34.452-82.8 53.426-134.24 53.426h-453.060c-51.424 0-99.096-18.974-134.234-53.43-35.624-34.934-55.244-83.136-55.244-135.734 0-52.334 19.56-100.056 55.078-134.376 35.008-33.83 82.74-52.46 134.4-52.46h453.060zM738.538 292h-453.060c-122.396 0-221.478 90.916-221.478 218.836 0 128.002 99.082 221.164 221.478 221.164h453.058c122.444 0 221.464-93.162 221.464-221.164 0-127.92-99.020-218.836-221.462-218.836v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-game-controller-a-outline"
    ]
  },
  {
    "paths": [
      "M738.538 292h-453.060c-122.396 0-221.478 90.916-221.478 218.836 0 128.002 99.082 221.164 221.478 221.164h453.058c122.444 0 221.464-93.162 221.464-221.164 0-127.92-99.020-218.836-221.462-218.836zM400 533.394c0 5.396-4.842 10.606-10.476 10.606h-69.524v70.278c0 5.66-6.208 9.722-11.606 9.722h-42.854c-5.256 0-9.542-3.836-9.542-9.066v-70.934h-70.276c-5.66 0-9.722-6.208-9.722-11.606v-42.854c0-5.256 3.836-9.542 9.066-9.542h70.934v-69.644c0-5.612 3.708-10.356 9.106-10.356h44.29c5.396 0 10.606 4.842 10.606 10.476v69.526h69.644c5.612 0 10.356 3.708 10.356 9.106v44.288zM639.532 550.972c-21.472 0-38.902-17.174-38.902-38.306 0-21.13 17.43-38.336 38.902-38.336 21.566 0 38.996 17.206 38.996 38.336 0 21.132-17.43 38.306-38.996 38.306zM724.628 634.602c-21.472 0-38.902-17.058-38.902-38.168 0-21.278 17.43-38.306 38.902-38.306 21.566 0 38.996 17.030 38.996 38.306 0 21.108-17.428 38.168-38.996 38.168zM724.628 467.23c-21.472 0-38.902-17.158-38.902-38.292s17.43-38.338 38.902-38.338c21.566 0 38.996 17.204 38.996 38.338s-17.428 38.292-38.996 38.292zM809.724 550.972c-21.458 0-38.884-17.174-38.884-38.306 0-21.13 17.428-38.336 38.884-38.336 21.474 0 38.904 17.206 38.904 38.336 0 21.132-17.428 38.306-38.904 38.306z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-game-controller-a"
    ]
  },
  {
    "paths": [
      "M616.152 407.858c-22.116 0-40.152 18.028-40.152 40.208 0 22.178 18.038 40.214 40.152 40.214 22.262 0 40.296-18.038 40.296-40.214 0.002-22.182-18.034-40.208-40.296-40.208z",
      "M703.976 495.756c-22.116 0-40.106 17.898-40.106 40.212 0 22.128 17.99 40.032 40.106 40.032 22.292 0 40.296-17.902 40.296-40.032 0.002-22.314-18.004-40.212-40.296-40.212z",
      "M270.468 368.734c-43.28 0-78.468 35.606-78.468 79.286 0 43.73 35.188 79.246 78.468 79.246 43.31 0 78.498-35.516 78.498-79.246 0-43.68-35.186-79.286-78.498-79.286zM270.246 486.914c-21.376 0-38.686-17.442-38.686-38.894 0-21.45 17.31-38.882 38.686-38.882 21.282 0 38.594 17.434 38.594 38.882 0 21.452-17.312 38.894-38.594 38.894z",
      "M703.976 320c-22.116 0-40.106 18.028-40.106 40.214 0 22.18 17.99 40.166 40.106 40.166 22.292 0 40.296-17.986 40.296-40.166 0.002-22.186-18.004-40.214-40.296-40.214z",
      "M791.894 407.858c-22.21 0-40.202 18.028-40.202 40.208 0 22.178 17.99 40.214 40.202 40.214 22.118 0 40.106-18.038 40.106-40.214 0-22.182-17.988-40.208-40.106-40.208z",
      "M932.558 497.732c-42.314-176.942-87.262-270.978-176.908-297.66-19.53-5.802-36.154-8.072-51.498-8.072-55.196 0-93.876 29.366-192.16 29.366-98.348 0-137.004-29.362-192.124-29.366-15.33 0-31.926 2.27-51.442 8.072-89.738 26.682-134.684 120.718-176.922 297.66-42.362 176.946-34.668 304.726 15.358 328.578 8.142 3.89 16.462 5.69 24.908 5.69 43.388 0 90.278-47.676 135.318-104.094 51.308-64.21 64.228-65.906 220.556-65.906h48.686c156.294 0 169.256 1.692 220.564 65.906 45.052 56.414 91.94 104.008 135.33 104.008 8.452 0 16.768-1.758 24.914-5.646 50.010-23.852 57.704-151.59 15.42-328.536zM903.354 797.432c-3.67 1.752-7.208 2.568-11.128 2.568-12.044 0-28.154-8.098-46.59-23.416-18.362-15.26-38.614-37.018-63.74-68.478-25.918-32.44-47.334-56.458-87.056-67.898-33.294-9.586-77.248-10.208-158.508-10.208h-48.686c-81.266 0-125.222 0.622-158.518 10.21-39.706 11.438-61.12 35.37-87.046 67.816-25.112 31.454-45.36 53.254-63.724 68.516-18.432 15.316-34.54 23.436-46.586 23.436-3.864 0-7.502-0.83-11.136-2.564-19.112-9.114-45.144-95.346 1.996-292.258 42.774-179.182 84.762-253.554 154.918-274.414 15.266-4.54 29.108-6.744 42.318-6.744 19.484 0 37.198 4.634 59.624 10.498 32.14 8.406 72.144 18.87 132.504 18.87 60.296 0 100.292-10.456 132.43-18.858 22.458-5.872 40.2-10.508 59.73-10.508 13.236 0 27.102 2.208 42.37 6.742 70.074 20.856 112.060 95.234 154.912 274.428 47.050 196.912 21.022 283.15 1.916 292.262z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-game-controller-b-outline"
    ]
  },
  {
    "paths": [
      "M270.246 409.136c-21.376 0-38.686 17.434-38.686 38.882 0 21.454 17.31 38.894 38.686 38.894 21.282 0 38.594-17.442 38.594-38.894 0-21.448-17.312-38.882-38.594-38.882z",
      "M932.558 497.732c-42.314-176.942-87.262-270.978-176.908-297.66-19.53-5.802-36.154-8.072-51.498-8.072-55.196 0-93.876 29.366-192.16 29.366-98.348 0-137.004-29.362-192.124-29.366-15.33 0-31.926 2.27-51.442 8.072-89.738 26.682-134.684 120.718-176.922 297.66-42.362 176.946-34.668 304.726 15.358 328.578 8.142 3.89 16.462 5.69 24.908 5.69 43.388 0 90.278-47.676 135.318-104.094 51.308-64.21 64.228-65.906 220.556-65.906h48.686c156.294 0 169.256 1.692 220.564 65.906 45.052 56.414 91.94 104.008 135.33 104.008 8.452 0 16.768-1.758 24.914-5.646 50.010-23.852 57.704-151.59 15.42-328.536zM270.468 527.266c-43.28 0-78.468-35.516-78.468-79.246 0-43.68 35.188-79.286 78.468-79.286 43.31 0 78.498 35.606 78.498 79.286 0 43.73-35.186 79.246-78.498 79.246zM616.152 488.28c-22.116 0-40.152-18.038-40.152-40.214 0-22.18 18.038-40.208 40.152-40.208 22.262 0 40.296 18.028 40.296 40.208 0.002 22.176-18.034 40.214-40.296 40.214zM703.976 576c-22.116 0-40.106-17.902-40.106-40.032 0-22.314 17.99-40.212 40.106-40.212 22.292 0 40.296 17.898 40.296 40.212 0.002 22.13-18.004 40.032-40.296 40.032zM703.976 400.38c-22.116 0-40.106-17.986-40.106-40.166 0-22.188 17.99-40.214 40.106-40.214 22.292 0 40.296 18.028 40.296 40.214 0.002 22.18-18.004 40.166-40.296 40.166zM791.894 488.28c-22.21 0-40.202-18.038-40.202-40.214 0-22.18 17.99-40.208 40.202-40.208 22.118 0 40.106 18.028 40.106 40.208 0 22.176-17.988 40.214-40.106 40.214z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-game-controller-b"
    ]
  },
  {
    "paths": [
      "M513.8 319.8c-51.402 0-99.602 20-135.8 56.2s-56.2 84.398-56.2 135.8c0 51.398 20 99.398 56.2 135.8 36.2 36.2 84.602 56.2 135.8 56.2 51.398 0 99.598-20 135.8-56.2 36.2-36.204 56.2-84.402 56.2-135.8 0-51.402-20-99.402-56.2-135.8-36.202-36.2-84.4-56.2-135.8-56.2zM513.8 671.8c-88.602 0-160-71.8-160-160 0-88.202 71.398-160 160-160 88.598 0 160 71.798 160 160 0 88.2-71.402 160-160 160z",
      "M403.574 165.656c8.916 13.256 20.238 24.812 33.55 34.138 22.024 15.43 47.914 23.586 74.876 23.586s52.856-8.156 74.878-23.586c13.308-9.326 24.632-20.882 33.546-34.136 20.652 6.456 40.668 14.756 59.854 24.822-3.064 15.68-3.228 31.86-0.406 47.866 4.666 26.47 17.208 50.538 36.266 69.596 24.67 24.672 57.474 38.258 92.37 38.258 8.484 0 16.848-0.798 25.040-2.39 10.064 19.2 18.362 39.226 24.81 59.894-13.244 8.92-24.792 20.242-34.108 33.552-15.41 22.016-23.554 47.892-23.552 74.836 0 26.934 8.138 52.802 23.536 74.812 9.306 13.302 20.842 24.624 34.072 33.542-6.464 20.68-14.774 40.708-24.856 59.914-8.162-1.578-16.492-2.374-24.944-2.374-34.896 0-67.7 13.59-92.366 38.262-19.030 19.028-31.562 43.054-36.246 69.48-2.83 15.976-2.686 32.13 0.352 47.79-19.214 10.080-39.254 18.384-59.934 24.842-8.922-13.22-20.242-24.748-33.542-34.044-22-15.378-47.856-23.508-74.772-23.508-26.914 0-52.77 8.128-74.77 23.51-13.298 9.296-24.62 20.824-33.542 34.042-20.678-6.456-40.718-14.762-59.932-24.84 3.038-15.658 3.182-31.812 0.352-47.79-4.684-26.428-17.216-50.456-36.246-69.482-24.67-24.672-57.474-38.26-92.37-38.26-8.452 0-16.78 0.792-24.942 2.374-10.080-19.204-18.39-39.236-24.856-59.916 13.23-8.92 24.766-20.238 34.072-33.542 15.398-22.008 23.538-47.878 23.538-74.816 0-26.942-8.144-52.82-23.554-74.836-9.316-13.308-20.864-24.632-34.108-33.552 6.45-20.666 14.744-40.692 24.81-59.892 8.192 1.592 16.554 2.392 25.042 2.392 34.892 0 67.698-13.588 92.37-38.26 19.058-19.060 31.598-43.126 36.266-69.598 2.822-16.006 2.66-32.186-0.406-47.864 19.188-10.064 39.2-18.364 59.852-24.822zM604.148 128c-14.206 37.058-50.094 63.38-92.148 63.38-42.050 0-77.938-26.322-92.146-63.38-40.932 9.79-79.384 25.946-114.256 47.376 16.136 36.244 9.364 80.208-20.364 109.94-19.262 19.262-44.5 28.886-69.74 28.886-13.708 0-27.412-2.838-40.166-8.51-21.412 34.876-37.554 73.342-47.328 114.276 37.020 14.224 63.304 50.098 63.304 92.124 0 42.016-26.266 77.872-63.262 92.108 9.796 40.932 25.954 79.384 47.386 114.256 12.72-5.642 26.394-8.464 40.062-8.464 25.242 0 50.476 9.624 69.742 28.886 29.682 29.682 36.476 73.562 20.43 109.778 34.876 21.42 73.328 37.566 114.262 47.346 14.254-36.958 50.092-63.192 92.074-63.192 41.984 0 77.82 26.23 92.074 63.192 40.936-9.78 79.386-25.928 114.264-47.35-16.046-36.212-9.252-80.092 20.432-109.774 19.258-19.264 44.496-28.888 69.736-28.888 13.672 0 27.34 2.822 40.066 8.466 21.432-34.872 37.588-73.324 47.384-114.256-36.996-14.236-63.26-50.096-63.26-92.108-0.002-42.026 26.286-77.896 63.302-92.124-9.774-40.932-25.914-79.4-47.328-114.278-12.75 5.672-26.46 8.508-40.164 8.508-25.242 0-50.476-9.622-69.742-28.884-29.726-29.726-36.496-73.692-20.36-109.94-34.866-21.428-73.322-37.584-114.254-47.374v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-gear-outline"
    ]
  },
  {
    "paths": [
      "M832.698 512.092c-0.002-42.026 26.286-77.896 63.302-92.124-9.774-40.932-25.914-79.4-47.328-114.278-12.75 5.672-26.46 8.508-40.164 8.508-25.242 0-50.476-9.622-69.742-28.884-29.726-29.726-36.496-73.692-20.36-109.94-34.87-21.428-73.326-37.584-114.258-47.374-14.206 37.058-50.094 63.38-92.148 63.38-42.050 0-77.938-26.322-92.146-63.38-40.932 9.79-79.386 25.946-114.256 47.376 16.136 36.244 9.366 80.208-20.362 109.94-19.262 19.262-44.5 28.886-69.742 28.886-13.708 0-27.412-2.838-40.166-8.51-21.412 34.876-37.556 73.342-47.328 114.276 37.018 14.224 63.304 50.098 63.304 92.124 0 42.016-26.264 77.872-63.26 92.108 9.796 40.932 25.952 79.384 47.384 114.256 12.722-5.642 26.396-8.464 40.064-8.464 25.244 0 50.478 9.624 69.742 28.886 29.682 29.682 36.478 73.562 20.43 109.778 34.876 21.42 73.328 37.566 114.26 47.346 14.256-36.958 50.092-63.192 92.076-63.192s77.82 26.23 92.074 63.192c40.936-9.78 79.386-25.928 114.264-47.35-16.046-36.212-9.252-80.092 20.432-109.774 19.258-19.264 44.496-28.888 69.736-28.888 13.672 0 27.34 2.822 40.066 8.466 21.432-34.872 37.588-73.324 47.384-114.256-36.996-14.238-63.258-50.096-63.258-92.108zM513.8 671.8c-88.6 0-160-71.8-160-160 0-88.202 71.4-160 160-160 88.598 0 160 71.798 160 160 0 88.2-71.402 160-160 160z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-gear"
    ]
  },
  {
    "paths": [
      "M930.8 494c-4.4-44-24.8-86-57.8-116.8-34.2-31.8-78.6-49.4-125.4-49.4-83 0-154.6 54.8-177 134-14-14-37-23.4-58.6-23.4s-44.6 9.4-58.6 23.4c-22.4-79.2-94-134-177-134-46.6 0-91.2 17.4-125.4 49.2-33 31-53.4 73-57.8 117h-29.2v36h29.2c4.4 44 24.8 86 57.8 116.8 34.2 31.8 78.6 49.4 125.4 49.4 101.6 0 184.2-82.4 184.2-184 0-0.2 0-0.2 0-0.2v0c0-19.8 23-43.2 51.4-43.2s51.4 23.4 51.4 43.2v0c0 0 0 0 0 0.2 0 101.6 82.6 184 184.2 184 46.6 0 91.2-17.4 125.4-49.4 33-30.8 53.4-73 57.8-117h29.2v-36h-29.2zM747.6 666c-85 0-154-69.2-154-154 0-85 69.2-154 154-154 85 0 154 69.2 154 154 0 85-69 154-154 154zM276.4 666c-85 0-154-69.2-154-154 0-85 69.2-154 154-154 85 0 154 69.2 154 154 0 85-69 154-154 154z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-glasses-outline"
    ]
  },
  {
    "paths": [
      "M930.8 494c-4.4-44-24.8-86-57.8-116.8-34.2-31.8-78.6-49.4-125.4-49.4-83 0-154.6 54.8-177 134-14-14-37-23.4-58.6-23.4s-44.6 9.4-58.6 23.4c-22.4-79.2-94-134-177-134-46.6 0-91.2 17.4-125.4 49.2-33 31-53.4 73-57.8 117h-29.2v36h29.2c4.4 44 24.8 86 57.8 116.8 34.2 31.8 78.6 49.4 125.4 49.4 101.6 0 184.2-82.4 184.2-184 0-0.2 0-0.2 0-0.2v0c0-19.8 23-43.2 51.4-43.2s51.4 23.4 51.4 43.2v0c0 0 0 0 0 0.2 0 101.6 82.6 184 184.2 184 46.6 0 91.2-17.4 125.4-49.4 33-30.8 53.4-73 57.8-117h29.2v-36h-29.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-glasses"
    ]
  },
  {
    "paths": [
      "M896 384v-32h-224v-224h-32v224h-256v-224h-32v224h-224v32h224v256h-224v32h224v224h32v-224h256v224h32v-224h224v-32h-224v-256h224zM640 640h-256v-256h256v256z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-grid-view-outline"
    ]
  },
  {
    "paths": [
      "M384 384h256v256h-256v-256z",
      "M128 128v768h768v-768h-768zM832 384h-160v256h160v32h-160v160h-32v-160h-256v160h-32v-160h-160v-32h160v-256h-160v-32h160v-160h32v160h256v-160h32v160h160v32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-grid-view"
    ]
  },
  {
    "paths": [
      "M718.77 160c-78.838 0-164.428 35.198-206.77 105.6-42.34-70.402-127.932-105.6-206.77-105.6-137.936 0-241.23 86.476-241.23 231.558 0 62.576 25.124 143.848 81.846 211.314 56.718 67.47 90.458 103.4 200.306 176 109.848 72.604 165.848 85.128 165.848 85.128s56-12.524 165.848-85.128c109.846-72.6 143.588-108.53 200.306-176 56.722-67.466 81.846-148.738 81.846-211.314 0-145.082-103.294-231.558-241.23-231.558zM853.66 582.282c-53.704 63.88-84.36 97.79-193.458 169.894-80.474 53.192-130.504 72.602-148.204 78.466-17.7-5.866-67.728-25.278-148.204-78.466-109.096-72.104-139.752-106.012-193.458-169.896-24.13-28.702-43.714-62.548-56.632-97.886-11.58-31.684-17.704-63.786-17.704-92.836 0-60.568 20.262-111.286 58.594-146.67 18.28-16.874 40.316-29.984 65.504-38.968 25.89-9.238 54.532-13.92 85.132-13.92 76.036 0 146.434 35.364 179.348 90.092l27.422 45.596 27.422-45.596c32.916-54.728 103.314-90.092 179.348-90.092 30.6 0 59.242 4.682 85.132 13.918 25.188 8.986 47.224 22.096 65.504 38.968 38.332 35.386 58.594 86.104 58.594 146.672 0 29.050-6.124 61.152-17.708 92.836-12.916 35.336-32.5 69.184-56.632 97.888z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-heart-outline"
    ]
  },
  {
    "paths": [
      "M718.77 160c-78.838 0-164.428 35.198-206.77 105.6-42.34-70.402-127.932-105.6-206.77-105.6-137.936 0-241.23 86.476-241.23 231.558 0 62.576 25.124 143.848 81.846 211.314 56.718 67.47 90.458 103.4 200.306 176 109.848 72.604 165.848 85.128 165.848 85.128s56-12.524 165.848-85.128c109.846-72.6 143.588-108.53 200.306-176 56.722-67.466 81.846-148.738 81.846-211.314 0-145.082-103.294-231.558-241.23-231.558z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-heart"
    ]
  },
  {
    "paths": [
      "M520.6 732c-18.8 0-34-15-34-33.8 0-18.6 15.2-33.6 34-33.6s34 15 34 33.6c0 18.8-15.2 33.8-34 33.8zM588.2 501.4c-45.6 45-44.4 54.8-46.6 106.6h-38c2.2-57 15-87.4 60.2-129 22-20.6 38.8-45.4 38.8-76.2 0-47.2-38.8-79.8-85.2-79.8-64.8 0-97 32.8-95.8 92.8h-37.6c0.6-84 48.8-124.2 135.2-124.2 66 0 120.8 40.8 120.8 109.2 0 43.8-21.4 72.4-51.8 100.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-help-empty"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M519.2 292c-86.4 0-134.6 40.6-135.2 124.4h37.6c-1.2-60.8 31-93 95.8-93 46.4 0 85.2 32.4 85.2 79.6 0 30.6-16.6 55.4-38.8 76.2-45.2 41.6-58 72-60.2 129h38c2.2-51.6 1-61.4 46.6-106.6 30.4-28.4 51.8-56.6 51.8-100.4-0-68.4-54.8-109.2-120.8-109.2z",
      "M520.6 664.6c-18.8 0-34 15-34 33.6s15.2 33.8 34 33.8c18.8 0 34-15 34-33.8 0-18.6-15.2-33.6-34-33.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-help-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM520.6 732c-18.8 0-34-15-34-33.8 0-18.6 15.2-33.6 34-33.6s34 15 34 33.6c0 18.8-15.2 33.8-34 33.8zM588.2 501.4c-45.6 45-44.4 54.8-46.6 106.6h-38c2.2-57 15-87.4 60.2-129 22-20.6 38.8-45.4 38.8-76.2 0-47.2-38.8-79.8-85.2-79.8-64.8 0-97 32.8-95.8 92.8h-37.6c0.6-84 48.8-124.2 135.2-124.2 66 0 120.8 40.8 120.8 109.2 0 43.8-21.4 72.4-51.8 100.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-help"
    ]
  },
  {
    "paths": [
      "M512 224l-320 256v416h224v-256h192v256h224v-416l-320-256zM800 864h-160v-256h-256v256h-160v-368.62l288-230.4 288 230.4v368.62z",
      "M512 128l-192 153.6v-89.6h-128v191.998l-64 50.998 23.020 22.768 360.98-288.784 360.98 288.786 23.020-22.77-384-306.996zM288 307.198l-64 51.2v-134.398h64v83.198z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-home-outline"
    ]
  },
  {
    "paths": [
      "M512 224l-320 256v416h224v-256h192v256h224v-416l-320-256z",
      "M512 128l-192 153.6v-89.6h-128v191.998l-64 50.998 23.020 22.768 360.98-288.784 360.98 288.786 23.020-22.77-384-306.996z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-home"
    ]
  },
  {
    "paths": [
      "M902.458 376.196c-37.094-36.262-86.558-56.196-139.288-56.196-52.726 0-102.19 19.934-139.284 56.196l-84.458 82.374 27.298 26.894 84.458-82.612c29.866-29.058 69.528-45.146 111.756-45.146 42.226 0 81.892 16.088 111.756 45.146 61.594 60.278 61.594 158.26 0 218.296-29.864 29.058-69.53 45.146-111.756 45.146-42.228 0-81.89-16.088-111.756-45.146l-251.042-244.952c-37.33-36.262-86.792-56.196-139.288-56.196-52.726 0-102.19 19.934-139.286 56.196-38.338 37.422-57.526 86.686-57.568 135.804-0.042 49.222 19.146 98.298 57.568 135.804 37.096 36.26 86.558 56.196 139.286 56.196 52.73 0 102.19-19.936 139.29-56.196l84.222-82.372-27.294-26.658-84.458 82.374c-29.864 29.058-69.528 45.146-111.758 45.146-42.226 0-81.888-16.088-111.752-45.146-61.598-60.28-61.598-158.26 0-218.296 29.864-29.058 69.526-45.146 111.752-45.146 42.23 0 81.894 16.088 111.758 45.146l251.040 244.954c37.326 36.258 86.79 56.194 139.286 56.194 52.726 0 102.19-19.936 139.286-56.196 38.496-37.344 57.744-86.604 57.774-135.804 0.030-49.202-19.16-98.34-57.542-135.804z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-infinite-outline"
    ]
  },
  {
    "paths": [
      "M913.642 364.754c-40.078-39.178-93.518-60.754-150.472-60.754s-110.39 21.576-150.42 60.708l-78.212 75.77 50.12 49.378 77.686-75.538c26.916-26.19 62.642-40.614 100.598-40.614 37.958 0 73.682 14.424 100.564 40.582 26.726 26.154 41.424 60.936 41.386 97.94-0.038 36.886-14.726 71.5-41.354 97.456-26.916 26.19-62.64 40.614-100.598 40.614-37.956 0-73.682-14.424-100.582-40.598l-251.066-244.98c-40.31-39.154-93.736-60.718-150.438-60.718-56.954 0-110.39 21.576-150.46 60.746-40.188 39.226-62.348 91.518-62.394 147.24-0.048 55.644 22.11 107.946 62.384 147.26 40.080 39.178 93.518 60.754 150.47 60.754 56.95 0 110.388-21.576 150.446-60.726l77.988-75.818-50.176-49.004-77.658 75.23c-26.916 26.19-62.642 40.614-100.6 40.614-37.954 0-73.678-14.424-100.56-40.582-26.728-26.154-41.428-60.938-41.388-97.942 0.038-36.886 14.726-71.498 41.356-97.454 26.916-26.19 62.64-40.614 100.594-40.614 37.958 0 73.684 14.424 100.584 40.598l251.064 244.978c40.308 39.156 93.734 60.72 150.436 60.72 56.952 0 110.388-21.576 150.426-60.71 40.358-39.146 62.602-91.454 62.634-147.28 0.034-55.676-22.116-107.974-62.358-147.256z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-infinite"
    ]
  },
  {
    "paths": [
      "M543 344c0 22.091-17.909 40-40 40s-40-17.909-40-40c0-22.091 17.909-40 40-40s40 17.909 40 40z",
      "M544 688v-256h-96v16h32v240h-32v16h128v-16z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-information-empty"
    ]
  },
  {
    "paths": [
      "M543 344c0 22.091-17.909 40-40 40s-40-17.909-40-40c0-22.091 17.909-40 40-40s40 17.909 40 40z",
      "M544 688v-256h-96v16h32v240h-32v16h128v-16z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-information-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM503 304c22.2 0 40 18 40 40s-18 40-40 40c-22 0-40-18-40-40s17.8-40 40-40zM576 704h-128v-16h32v-240h-32v-16h96v256h32v16z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-information"
    ]
  },
  {
    "paths": [
      "M851 269.6c9.4-11.8 15-27 15-43.2 0-38.4-31.2-69.8-69.6-69.8-16.4 0-31.4 5.6-43.2 15-68-48.4-150-75.6-239.8-75.6-229.8-0-417.4 185-417.4 415.2s187.4 416.8 417.2 416.8c229.8 0 414.8-186.6 414.8-416.8 0-90-28.6-173.4-77-241.6zM796 182.6c24.4 0 44 19.8 44 44 0 24.4-19.8 44-44 44-24.4 0-44-19.8-44-44s19.6-44 44-44zM783.6 783.4c-35.2 35.2-76.4 63.2-122.2 82.6-47.4 20-96.4 30.4-148.4 30.4-51.8 0-103.4-10.2-150.8-30.4-45.8-19.4-86.8-47-122.2-82.6-35.2-35.2-63-76.6-82.4-122.4-20-47.4-30.2-97.8-30.2-149.8 0-51.8 10.2-102.4 30.2-149.8 19.4-45.8 47-87 82.4-122.4s76.4-63.2 122.2-82.6c47.4-20 98.8-28.2 150.8-28.2 51.8 0 101 8 148.4 28.2 25.4 10.8 49.4 24.2 71.8 40-4.2 9-6.6 19-6.6 29.8 0 38.4 31.2 69.8 69.6 69.8 10.6 0 20.6-2.4 29.8-6.6 15.8 22.4 29.2 46.4 40 72 20 47.4 30.2 97.8 30.2 149.8 0 51.8-10.2 102.4-30.2 149.8-19.4 45.8-47 87-82.4 122.4z",
      "M513 320.2c-106 0-192 85.6-192 191.8s85.8 192.2 192 192.2c106 0 192-86 192-192.2s-86-191.8-192-191.8zM513 671.6c-88.2 0-159.4-71.6-159.4-159.6 0-88.2 71.2-159.2 159.4-159.2s159.4 71.2 159.4 159.2c0 88.2-71.4 159.6-159.4 159.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-ionic-outline"
    ]
  },
  {
    "paths": [
      "M789.2 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM789.2 864c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M512 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM512 864c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M234.8 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM234.8 864c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.4 74.8-74.8 74.8z",
      "M789.2 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM789.2 586.8c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M512 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM512 586.8c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M234.8 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM234.8 586.8c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.4 74.8-74.8 74.8z",
      "M789.2 341.6c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8zM789.2 160c41.2 0 74.8 33.6 74.8 74.8s-33.6 74.8-74.8 74.8-74.8-33.6-74.8-74.8c-0-41.2 33.4-74.8 74.8-74.8z",
      "M512 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM512 309.6c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M234.8 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM234.8 309.6c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.4 74.8-74.8 74.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-keypad-outline"
    ]
  },
  {
    "paths": [
      "M789.2 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M512 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M234.8 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M789.2 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M512 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M234.8 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M789.2 341.6c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8z",
      "M512 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M234.8 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-keypad"
    ]
  },
  {
    "paths": [
      "M800 345.8c0-155.6-132.2-281.8-288-281.8s-288 126.2-288 282c0 62 26.4 118 60.4 166h-0.6c21.8 30 42.8 55.4 63 90 44 75.6 37.2 148.6 37.4 163.2v2.8h256v-2.8c0-17.8-7.2-87.6 36.8-163.2 20.2-34.6 41.2-60 63-90h-0.2c33.8-48 60.2-104 60.2-166.2zM702 508.8c-1.2 1.6-2.2 3-3.4 4.6-16.2 21.8-33 44.4-49.4 72.2-34.6 59.4-40.8 115.8-41.6 150.2h-31.6v-223.8l64-128h-33.2l-62.8 128v224h-64v-224l-62.8-128h-33.2l64 128v224h-31.8c-1-34.4-7.8-91.4-41.8-150-9-15.4-18.2-30-27.4-42h0.4l-37.2-51.2c-31.6-43.2-54.2-94.2-54.2-147.2 0-66.8 32-129.6 79.2-176.8s110-73.4 176.8-73.4c66.8 0 129.6 26.2 176.8 73.4s79.2 110 79.2 176.8c0 53-22.6 103.8-54.2 147l-11.8 16.2z",
      "M448 928h128v32h-128v-32z",
      "M416 864h192v32h-192v-32z",
      "M416 800h192v32h-192v-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-lightbulb-outline"
    ]
  },
  {
    "paths": [
      "M800 345.8c0-155.6-132.2-281.8-288-281.8s-288 126.2-288 282c0 62 26.4 118 60.4 166h-0.6c21.8 30 42.8 55.4 63 90 44 75.6 37.2 148.6 37.4 163.2v2.8h64v-256l-64-128h33.2l62.8 128v256h64v-256l62.8-128h33l-64 128v256h64v-2.8c0-17.8-7.2-87.6 36.8-163.2 20.2-34.6 41.2-60 63-90h-0.2c34-48 60.4-104 60.4-166.2z",
      "M448 928h128v32h-128v-32z",
      "M416 864h192v32h-192v-32z",
      "M416 800h192v32h-192v-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-lightbulb"
    ]
  },
  {
    "paths": [
      "M864 160v704h-704v-704h704zM896 128h-768v768h768v-768z",
      "M384 304h384v32h-384v-32z",
      "M384 496h384v32h-384v-32z",
      "M384 688h384v32h-384v-32z",
      "M320 320c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M320 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M320 704c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-list-outline"
    ]
  },
  {
    "paths": [
      "M128 128v768h768v-768h-768zM288 736c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM288 544c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM288 352c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM768 720h-384v-32h384v32zM768 528h-384v-32h384v32zM768 336h-384v-32h384v32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-list"
    ]
  },
  {
    "paths": [
      "M512 96c68.38 0 132.668 26.628 181.020 74.98s74.98 112.64 74.98 181.020c0 85.84-48.184 214.254-139.34 371.36-44.558 76.792-89.542 143.268-116.664 181.862-27.036-38.464-71.824-104.654-116.322-181.29-91.376-157.37-139.674-285.98-139.674-371.932 0-68.38 26.628-132.668 74.98-181.020s112.64-74.98 181.020-74.98zM512 64c-159.058 0-288 128.942-288 288 0 224 288 608 288 608s288-384 288-608c0-159.058-128.942-288-288-288v0z",
      "M512 224c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128-57.4-128-128-128zM512 445.8c-51.8 0-93.8-42-93.8-93.8s42-93.8 93.8-93.8 93.8 42 93.8 93.8-42 93.8-93.8 93.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-location-outline"
    ]
  },
  {
    "paths": [
      "M512 64c-159.058 0-288 128.942-288 288 0 224 288 608 288 608s288-384 288-608c0-159.058-128.942-288-288-288zM512 445.8c-51.8 0-93.8-42-93.8-93.8s42-93.8 93.8-93.8 93.8 42 93.8 93.8-42 93.8-93.8 93.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-location"
    ]
  },
  {
    "paths": [
      "M720 448v-144c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-112zM336 304c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v144h-352v-144zM800 896h-576v-416h576v416z",
      "M512 576c-35.346 0-64 28.654-64 64 0 29.82 20.396 54.878 48 61.984v66.016h32v-66.016c27.604-7.106 48-32.164 48-61.984 0-35.346-28.654-64-64-64zM512 672c-17.644 0-32-14.356-32-32s14.356-32 32-32 32 14.356 32 32-14.356 32-32 32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-locked-outline"
    ]
  },
  {
    "paths": [
      "M720 448v-144c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-112zM528 701.984v66.016h-32v-66.016c-27.604-7.106-48-32.164-48-61.984 0-35.346 28.654-64 64-64s64 28.654 64 64c0 29.82-20.396 54.878-48 61.984zM688 448h-352v-144c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v144z",
      "M512 608c-17.644 0-32 14.356-32 32s14.356 32 32 32 32-14.356 32-32-14.356-32-32-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-locked"
    ]
  },
  {
    "paths": [
      "M512 96c-150.066 0-289.062 81.316-362.746 212.214l-3.926 6.97 41.83 23.542 3.924-6.97c65.194-115.81 188.16-187.756 320.918-187.756 202.916 0 368 165.084 368 368 0 25.018-2.524 50.014-7.498 74.294l-1.606 7.836 47.022 9.638 1.608-7.838c5.622-27.442 8.474-55.68 8.474-83.93 0-229.382-186.618-416-416-416z",
      "M832.918 692.238c-65.194 115.816-188.16 187.762-320.918 187.762-202.916 0-368-165.084-368-368 0-25.024 2.524-50.022 7.5-74.3l1.606-7.836-47.022-9.638-1.608 7.836c-5.624 27.438-8.476 55.678-8.476 83.938 0 229.382 186.618 416 416 416 150.066 0 289.062-81.316 362.746-212.218l3.926-6.97-41.83-23.542-3.924 6.968z",
      "M768 512l128 128 128-128z",
      "M0 512l128-128 128 128z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-loop-strong"
    ]
  },
  {
    "paths": [
      "M978.746 512l-82.746 82.746-84.746-82.746-21.628 21.626 106.374 106.374 105.374-105.374z",
      "M919.988 511.018c-0.004-1.154 0.026-2.314 0.014-3.466l-0.058-0.006c-2.402-222.924-184.46-403.546-407.944-403.546-147.18 0-283.506 79.756-355.776 208.142l27.886 15.696c66.608-118.33 192.25-191.838 327.89-191.838 206.546 0 374.71 167.416 375.97 373.672 0.076 13.764-0.562 27.66-2.034 41.662l31.824 3.348c1.51-14.336 2.21-28.572 2.222-42.682h0.018c0-0.328-0.012-0.654-0.012-0.982z",
      "M839.888 696.162c-66.606 118.33-192.248 191.838-327.888 191.838-206.95 0-375.376-168.064-375.986-374.874-0.030-13.372 0.62-26.868 2.048-40.46l-31.824-3.348c-1.508 14.336-2.208 28.572-2.216 42.682h-0.022c0 0.944 0.030 1.878 0.036 2.82 0.012 1.95-0.012 3.904 0.030 5.848l0.044-0.006c4.628 220.988 185.814 399.338 407.89 399.338 147.18 0 283.506-79.756 355.776-208.142l-27.888-15.696z",
      "M128 384l-105.374 105.374 22.628 22.626 82.746-82.746 82.746 82.746 22.628-22.626z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-loop"
    ]
  },
  {
    "paths": [
      "M876 375.426l-63.854-110.852-236.146 136.574v-273.148h-128v273.148l-236.146-136.574-63.876 110.852 236.206 136.574-236.188 136.574 63.856 110.852 236.148-136.574v273.148h128v-273.148l236.144 136.574 63.878-110.852-236.206-136.574 236.184-136.574zM832.352 660.25l-31.926 55.732-256.426-147.982v296h-64v-296l-256.426 148-31.938-55.57 256.456-148.394-256.448-148.314 31.928-55.718 256.428 147.996v-296h64v296l256.426-148 31.938 55.57-256.456 148.358 256.444 148.322z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-medical-outline"
    ]
  },
  {
    "paths": [
      "M876 375.426l-63.854-110.852-236.146 136.574v-273.148h-128v273.148l-236.146-136.574-63.876 110.852 236.206 136.574-236.188 136.574 63.856 110.852 236.148-136.574v273.148h128v-273.148l236.144 136.574 63.878-110.852-236.206-136.574 236.184-136.574z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-medical"
    ]
  },
  {
    "paths": [
      "M544 416v128h128v64h-128v128h-64v-128h-128v-64h128v-128h64zM576 384h-128v128h-128v128h128v128h128v-128h128v-128h-128v-128z",
      "M672 256v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-256v640h832v-640h-256zM384 196.2c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v59.8h-256v-59.8zM896 864h-768v-576h768v576z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-medkit-outline"
    ]
  },
  {
    "paths": [
      "M544 544v-128h-64v128h-128v64h128v128h64v-128h128v-64h-96z",
      "M672 256v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-256v640h832v-640h-256zM384 196.2c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v59.8h-256v-59.8zM704 640h-128v128h-128v-128h-128v-128h128v-128h128v128h128v128z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-medkit"
    ]
  },
  {
    "paths": [
      "M272.965 80.218l27.613-16.17 515.204 879.813-27.613 16.17-515.204-879.813z",
      "M512.4 706.8c24.6 0 47.6-5.8 68.4-16.4l-226.8-385.6v235.2c0 92 70.8 166.8 158.4 166.8z",
      "M670 540v-309c0-92-70.4-167-158-167-50.8 0-95.6 25.2-124.6 64.4l273.8 466.6c5.8-17.2 8.8-35.8 8.8-55z",
      "M768 543.4v-159.4h-34v159.4c0 43-12.4 83.2-34.2 117l19.8 34c30.6-42.4 48.4-94.6 48.4-151z",
      "M534 798.4c34-2.4 66-11.6 94.6-26l-18.8-32.2c-29 14-61.4 21.8-95.4 21.8-120.6 0-220.2-98-220.2-218.2v-159.8h-38v159.4c0 134.4 106 245.2 240 254.8v125.8h-146v36h322v-36h-138v-125.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-mic-off"
    ]
  },
  {
    "paths": [
      "M512 64c-87.4 0-158 75-158 167v309c0 92 70.6 167 158 167s158-75 158-167v-309c0-92-70.6-167-158-167zM638 540c0 74.4-56.6 135-126 135s-126-60.6-126-135v-309c0-74.4 56.6-135 126-135s126 60.6 126 135v309z",
      "M734 384v159.4c0 120.4-99.6 218.4-220 218.4s-220-98-220-218.4v-159.4h-38v159.4c0 134.4 106 245.2 240 255v125.6h-146v36h322v-36h-138v-125.6c132-9.8 234-120.6 234-255v-159.4h-34z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-mic-outline"
    ]
  },
  {
    "paths": [
      "M512 707c87.4 0 158-75 158-167v-309c0-92-70.6-167-158-167s-158 75-158 167v309c0 92 70.6 167 158 167z",
      "M734 384v159.4c0 120.4-99.6 218.4-220 218.4s-220-98-220-218.4v-159.4h-38v159.4c0 134.4 106 245.2 240 255v125.6h-146v36h322v-36h-138v-125.6c132-9.8 234-120.6 234-255v-159.4h-34z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-mic"
    ]
  },
  {
    "paths": [
      "M768 530h-512v-34h512v34z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-minus-empty"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M256 496h512v34h-512v-34z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-minus-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM768 530h-512v-34h512v34z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-minus"
    ]
  },
  {
    "paths": [
      "M992 768v-576h-960v576h350v32h-128v32h514v-32h-128v-32h352zM64 224h896v512h-896v-512z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-monitor-outline"
    ]
  },
  {
    "paths": [
      "M992 768v-576h-960v576h350v32h-128v32h514v-32h-128v-32h352zM64 224h896v512h-896v-512z",
      "M96 256h832v448h-832v-448z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-monitor"
    ]
  },
  {
    "paths": [
      "M686.2 630c-3.6 0.2-7 0.2-10.6 0.2-58.2 0-113-22.6-154.2-63.8s-63.8-96-63.8-154.2c0-33.2 7.4-65.2 21.2-94.2 6.2-12.8 13.6-25 22.2-36.4-15.2 1.6-29.8 4.8-44 9.2-93.6 29.6-161.4 117-161.4 220.4 0 127.6 103.4 231 231 231 70.6 0 133.6-31.6 176-81.4 9.6-11.4 18.4-23.8 25.6-37-13.6 3.4-27.6 5.6-42 6.2zM526.6 710.2c-109.8 0-199-89.2-199-199 0-78.2 45.2-145.8 110.8-178.4-8.4 25-12.8 51.6-12.8 79.4 0 131.8 102 239.8 231.2 249.4-34.8 30.4-80.4 48.6-130.2 48.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-moon-outline"
    ]
  },
  {
    "paths": [
      "M686.2 630c-3.6 0.2-7 0.2-10.6 0.2-58.2 0-113-22.6-154.2-63.8s-63.8-96-63.8-154.2c0-33.2 7.4-65.2 21.2-94.2 6.2-12.8 13.6-25 22.2-36.4-15.2 1.6-29.8 4.8-44 9.2-93.6 29.6-161.4 117-161.4 220.4 0 127.6 103.4 231 231 231 70.6 0 133.6-31.6 176-81.4 9.6-11.4 18.4-23.8 25.6-37-13.6 3.4-27.6 5.6-42 6.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-moon"
    ]
  },
  {
    "paths": [
      "M512 476c19.8 0 36 16.2 36 36s-16.2 36-36 36-36-16.2-36-36 16.2-36 36-36zM512 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.6-64-64-64v0z",
      "M256.8 476c19.8 0 36 16.2 36 36s-16.2 36-36 36c-19.8 0-36-16.2-36-36s16.2-36 36-36zM256.8 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.8-64-64-64v0z",
      "M768 476c19.8 0 36 16.2 36 36s-16.2 36-36 36-36-16.2-36-36 16.2-36 36-36zM768 448c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-more-outline"
    ]
  },
  {
    "paths": [
      "M512 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.6-64-64-64v0z",
      "M256.8 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.8-64-64-64v0z",
      "M768 448c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-more"
    ]
  },
  {
    "paths": [
      "M704.2 204.6c0-0.2 0-0.4 0-0.4-0.2-0.6-0.2-1-0.4-1.6 0 0 0-0.2 0-0.2-1.2-3-3.6-6-7-6.8l-4-0.8-180.8-38.8v545.2c-16 0-44.8 0.8-89 2.6-83.6 3.2-102.8 43.2-102.8 81.8 0 49.2 26.4 86.2 123 82 103.6-4.6 102.8-97 102.8-163.4v-385l147.2 27c6 1.2 10.8-4.6 10.8-10.6v-128.8c0-0.8 0.2-1.6 0.2-2.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-musical-note"
    ]
  },
  {
    "paths": [
      "M832 639.8v-483.8l-448 69.2v474.4c-18 0-41.8 0.8-87 2.6-85.2 3.2-105 43.6-105 82.6 0 49.8 27 87 125.2 82.8 105.6-4.6 100.6-98 100.6-165v-323l382-64v321.2c-18 0-39.8 0.8-85.2 2.6-85.2 3.2-105 43.6-105 82.6 0 49.8 26 87 124.4 82.8 106-4.6 98-98 98-165z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-musical-notes"
    ]
  },
  {
    "paths": [
      "M512 129c102.2 0 198.4 39.8 270.8 112.2s112.2 168.4 112.2 270.8-39.8 198.4-112.2 270.8-168.4 112.2-270.8 112.2-198.4-39.8-270.8-112.2c-72.2-72.4-112.2-168.6-112.2-270.8s39.8-198.4 112.2-270.8c72.4-72.2 168.6-112.2 270.8-112.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416v0z",
      "M704 320l-447.4 192h255.4v256z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-navigate-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 768v-256h-255.4l447.4-192-192 448z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-navigate"
    ]
  },
  {
    "paths": [
      "M716 467.71l0.826-0.078c-0.274-0.274-0.092-0.202-0.37-0.474l-156.868-157.158c-11.666-12-28.386-20.308-46.97-20.308-23.622 0-44.23 12.308-55.27 32.308h-0.014c0 0-14.18 21.988-36.54 57.748l65.062 79.274c5.878 7.538 6.592 15.602 2.822 19.378l-0.228 0.142c-1.818 1.818-4.042 2.66-6.548 2.66-3.816 0-8.284-1.98-12.97-5.536l-71.744-58.836c-47.092 75.31-113.354 181.268-166.9 266.902l38.144 46.674c5.878 7.54 6.592 15.768 2.82 19.544l-0.228 0.228c-1.822 1.826-4.056 2.684-6.574 2.684-3.81 0-8.272-1.962-12.944-5.51l-42.134-33.066c-39.904 63.816-69.372 110.642-73.372 114.446v0.006c-6 10.124-8.17 22.264-8.17 35.328 0 35.31 29.314 63.934 64.57 63.934 15.642 0 29.14-6.79 41.598-15l229.302-168.218-57.676-70.716c-5.88-7.538-6.536-15.774-2.764-19.55l0.256-0.228c1.824-1.824 4.068-2.682 6.588-2.682 3.81 0 8.28 1.962 12.952 5.51l75.728 63.18c109.676-80.492 211.78-154.296 211.78-154.296h0.010c15.678-12 24.946-31.422 24.946-52.476 0-17.408-7.12-34.28-19.12-45.808v-0.006zM691.062 539.668c-5.328 3.868-93.384 67.864-191.528 139.798l-57.612-47.834c-10.49-7.962-21.326-11.996-32.216-11.996-10.93 0-21.184 4.194-28.916 11.818l-0.128 0.124-0.166 0.164-0.166 0.166c-15.616 15.642-15.522 41.646 0.222 61.834l0.22 0.286 0.226 0.276 36.446 44.624-201.312 147.792c-10.132 6.608-16.854 9.314-23.084 9.314-17.644 0-32-14.342-32-31.966 0-6.172 1.388-12.090 4.034-17.246 4.782-6.322 13.2-19.752 37.31-58.702 5.086-8.216 10.504-16.974 16.268-26.258l13.17 10.664 0.4 0.304c10.49 7.962 21.33 12 32.222 12 11.034 0 21.384-4.278 29.142-12.046l0.228-0.226c15.612-15.634 15.512-41.64-0.236-61.832l-0.226-0.288-0.23-0.284-23.628-28.91 135.504-216.692 44.652 36.586c10.508 7.976 21.356 12.020 32.246 12.020 9.908 0 19.262-3.45 26.678-9.78l0.922-0.674 1.742-1.748c15.58-15.606 15.48-41.556-0.236-61.708l-0.24-0.306-50.726-61.378c5.914-9.406 10.914-16.982 14.81-22.976l10.418-16.988c5.554-10.050 15.522-16.314 27.346-16.314 8.734 0 17.52 4.084 24.114 10.86l9.402 9.856h0.244l137.622 138.57v0.752l10.372 9.432c5.586 5.38 9.078 13.564 9.078 22.454 0 10.392-4.516 20.246-12.388 26.458z",
      "M879.988 230.35l-192.832 111.51 132.504-229.876-27.638-15.984-4.976 8.626-141.55 245.57 33.34 33.392 217.112-125.552z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-nutrition-outline"
    ]
  },
  {
    "paths": [
      "M718 467.24l-0.212-0.078c-0.272-0.276-0.612-0.886-0.888-1.158l-157.806-158.004c-11.696-12-28.46-20.336-47.094-20.336-23.684 0-44.348 12.336-55.416 32.336h-0.014c0 0-14.218 22.702-36.636 58.498l65.234 79.7c5.894 7.544 6.61 15.79 2.828 19.57l-0.228 0.228c-4.592 4.592-11.788 3.070-19.57-2.828l-71.934-58.878c-47.216 75.386-113.654 181.462-167.342 267.184l38.246 46.724c5.894 7.544 6.61 15.79 2.828 19.57l-0.228 0.228c-4.592 4.592-11.788 3.070-19.57-2.828l-40.44-33.1c-40.010 63.88-69.37 110.754-71.758 114.562v0.006c-6 10.132-10 22.288-10 35.364 0 35.348 28.488 64 63.836 64 15.684 0 28.766-6.796 41.256-15.016l229.684-168.39-57.942-70.79c-5.894-7.544-6.61-15.79-2.828-19.57l0.228-0.228c4.592-4.592 11.788-3.068 19.57 2.83l75.926 62.43c109.97-80.57 212.34-155.266 212.34-155.266h0.010c15.718-12 26.048-30.638 26.048-51.714 0-17.426-6.128-33.5-18.128-45.042v-0.004z",
      "M896 277.562l-32.972-55.388-132.46 76.424 98.462-170.426-55.238-32.172-139.998 242.168 57.176 57.176z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-nutrition"
    ]
  },
  {
    "paths": [
      "M224 128v672h32v-640h608v674.286c0 16.41-13.304 29.714-29.714 29.714h-644.572c-16.41 0-29.714-13.304-29.714-29.714v-578.286h32v-32h-64v610.286c0 34.028 27.686 61.714 61.714 61.714h644.57c34.030 0 61.716-27.686 61.716-61.714v-706.286h-672z",
      "M320 224h256v32h-256v-32z",
      "M320 384h480v32h-480v-32z",
      "M320 544h384v32h-384v-32z",
      "M320 704h480v32h-480v-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-paper-outline"
    ]
  },
  {
    "paths": [
      "M224 128v672h-32v-576h-64v610.286c0 34.028 27.686 61.714 61.714 61.714h644.57c34.030 0 61.716-27.686 61.716-61.714v-706.286h-672zM320 224h256v32h-256v-32zM320 544h384v32h-384v-32zM800 736h-480v-32h480v32zM800 416h-480v-32h480v32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-paper"
    ]
  },
  {
    "paths": [
      "M192 499.2l233.2 102.6 114.4 230.2 292.4-640-640 307.2zM456.2 593l311.4-332.4-229.2 497.8-82.2-165.4zM763.6 256.6l-330 314.2-165.6-72.8 495.6-241.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-paperplane-outline"
    ]
  },
  {
    "paths": [
      "M192 499.2l212 93.4 428-400.6z",
      "M832 192l-396.2 431.4 103.8 208.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-paperplane"
    ]
  },
  {
    "paths": [
      "M416 192h32v108h-32v-108z",
      "M128 480h110v32h-110v-32z",
      "M215 298.2l22-22.2 62.8 63.2-22 22.2z",
      "M574.8 359.4l-22-22.2 62.6-63.2 22.2 22.2z",
      "M241 705l-22-22.2 62.8-63.2 22 22.2z",
      "M385.2 589.8c-40.4-16.2-69.2-55.8-69.2-102.2 0-60.6 49-110 109.4-110 31.2 0 59.4 13.2 79.2 34.4 9.6-7 19-12.4 27.2-16.4-25.8-30.2-64-49.4-106.6-49.4-77.4 0-140.6 63.4-140.6 141.4 0 54.8 31.2 102.4 76.6 125.8 7.4-10.4 15.8-18 24-23.6z",
      "M598 479.6c29 0 56.2 9.6 78.6 27.8 21.8 17.8 37.2 42.6 43.4 69.8l6.2 28 28.4-3.6c4.2-0.6 8.2-0.8 12.2-0.8 53.8 0 97.6 44.2 97.6 98.4s-43.8 98.4-97.6 98.4h-315.4c-19 0-37-7.8-50.8-21.6-13.6-14-21.2-32.4-21.2-51.8 0-37.2 29-67.6 66.4-73.8 3.2-0.6 17.6-2.4 28.4-3.4 0 0-1-10.6-1.2-19.2s-0.2-18.8-0.2-23c0.2-68.8 56.2-125.2 125.2-125.2zM598 448c-86.6 0-156.6 70.4-156.6 157 0 5.2 0.2 10.4 0.8 15.6-52.8 4.6-94.2 51-94.2 105.2 0 57.2 46.4 106.2 103.4 106.2h315.4c71.4 0 129.2-59.8 129.2-131.4s-57.8-130.6-129.2-130.6c-5.4 0-10.8 0-16 0.6-15.8-70-78.2-122.6-152.8-122.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-partlysunny-outline"
    ]
  },
  {
    "paths": [
      "M416 192h32v108h-32v-108z",
      "M128 480h110v32h-110v-32z",
      "M215 298.2l22-22.2 62.8 63.2-22 22.2z",
      "M574.8 359.4l-22-22.2 62.6-63.2 22.2 22.2z",
      "M241 705l-22-22.2 62.8-63.2 22 22.2z",
      "M598 448c-86.6 0-156.6 70.4-156.6 157 0 5.2 0.2 10.4 0.8 15.6-52.8 4.6-94.2 51-94.2 105.2 0 57.2 46.4 106.2 103.4 106.2h315.4c71.4 0 129.2-59.8 129.2-131.4s-57.8-130.6-129.2-130.6c-5.4 0-10.8 0-16 0.6-15.8-70-78.2-122.6-152.8-122.6v0z",
      "M529.4 392.6c-25.8-28.6-62.8-46.6-104-46.6-77.4 0-140.6 63.4-140.6 141.4 0 54.8 31.2 102.4 76.6 125.8 0 0 0-0.2 0-0.2s0.2 0.2 0.2 0.2c9-24.2 22.8-39.6 45.2-51.2 0.4-0.2 0.8-0.4 1.4-0.8 0.4-0.2 1-0.4 1.4-0.6-0.4-4.6-0.6-9.4-0.6-14-0.6-63.8 60.4-141 122-150.8 0.2-0.2 0.6-0.2 0.8-0.4-0.8-0.8-1.6-1.8-2.4-2.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-partlysunny"
    ]
  },
  {
    "paths": [
      "M382 224v576h-94v-576h94zM414 192h-158v640h158v-640z",
      "M736 224v576h-94v-576h94zM768 192h-158v640h158v-640z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pause-outline"
    ]
  },
  {
    "paths": [
      "M256 192h158v640h-158v-640z",
      "M610 192h158v640h-158v-640z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pause"
    ]
  },
  {
    "paths": [
      "M887.654 391c-8.766-23.46-23.506-40.424-42.634-49.048-8.778-3.95-17.99-5.952-27.376-5.952-40.050 0-80.744 37.334-101.264 92.908-25.396 68.84-10.63 136.27 34.346 156.846 9.044 4.142 18.73 6.246 28.788 6.246 40.792 0 82.252-34.238 103.162-85.192 15.8-38.566 17.66-81.854 4.978-115.808zM852.428 492.59c-15.672 37.796-45.988 64.196-73.724 64.196-5.618 0-10.976-1.138-15.936-3.388-28.242-12.788-35.724-62.118-17.036-112.304 15.55-41.634 44.896-70.71 71.366-70.71 5.020 0 9.958 1.066 14.68 3.176 13.76 6.134 21.244 19.424 25.102 29.49 9.82 25.614 8.156 59.086-4.452 89.54z",
      "M307.622 428.908c-20.52-55.574-61.214-92.908-101.264-92.908-9.386 0-18.6 2.002-27.378 5.952-19.13 8.624-33.868 25.588-42.634 49.048-12.682 33.954-10.822 77.242 4.98 115.808 20.91 50.954 62.37 85.192 103.162 85.192 10.056 0 19.742-2.104 28.788-6.246 44.976-20.576 59.742-88.006 34.346-156.846zM261.232 553.396c-4.958 2.25-10.32 3.388-15.936 3.388-27.736 0-58.052-26.398-73.724-64.196-12.608-30.454-14.272-63.926-4.452-89.542 3.858-10.066 11.342-23.356 25.102-29.49 4.722-2.11 9.66-3.176 14.68-3.176 26.468 0 55.814 29.076 71.366 70.71 18.69 50.19 11.206 99.52-17.036 112.306z",
      "M396.694 421.202c3.71 0.162 7.454 0.060 11.126-0.302 21.574-2.118 41.080-13.188 56.414-32.016 24.742-30.382 31.612-77.948 26.402-126.878-7.964-75.406-47.698-131.684-101.084-134.006 0 0-7.622 0.016-11.5 0.386-23.552 2.328-44.962 14.566-61.914 35.39-24.582 30.202-36.396 75.14-31.606 120.208 7.872 74.554 57.14 134.824 112.162 137.218zM342.094 183.662c7.846-9.478 21.020-21.154 39.24-22.952 2.286-0.226 4.576-0.292 6.808-0.196 36.414 1.584 63.718 46.542 69.872 104.856 4.292 40.3-0.296 80.11-19.69 103.558-9.748 11.796-21.112 18.408-33.762 19.65-2.162 0.208-4.334 0.266-6.458 0.174-38.514-1.676-74.828-50.182-80.946-108.134-3.936-37.060 5.388-73.306 24.936-96.956z",
      "M512 480c-128 0-256 152.148-256 298.256 0 43.596 21.864 78.662 43.334 93.034 26.516 17.742 45.204 24.71 84.074 24.71 46.186 0 58.65-16.156 80.272-30.41 15.638-10.304 29.144-19.21 48.322-19.21s32.684 8.906 48.32 19.21c21.622 14.254 34.084 30.41 80.272 30.41 38.868 0 57.556-6.968 84.072-24.71 21.47-14.372 43.334-49.438 43.334-93.034 0-146.108-128-298.256-256-298.256zM707.926 841.552c-21.928 14.674-34.732 19.556-67.332 19.556-28.45 0-37.248-6.402-51.822-17.020-3.696-2.688-7.518-5.472-11.892-8.354-17.238-11.364-36.78-24.246-64.878-24.246s-47.64 12.882-64.876 24.242c-4.378 2.884-8.2 5.67-11.894 8.358-14.574 10.618-23.372 17.020-51.822 17.020-32.6 0-45.406-4.882-67.334-19.556-11.286-7.552-28.076-30.64-28.076-63.296 0-60.554 26.754-128.462 71.566-181.646 21.772-25.842 47.034-47.2 73.052-61.77 26.808-15.006 53.516-22.84 79.382-22.84 25.868 0 52.574 7.834 79.382 22.84 26.020 14.57 51.28 35.928 73.050 61.77 44.814 53.182 71.568 121.092 71.568 181.646 0 32.656-16.79 55.744-28.074 63.296z",
      "M616.562 420.53c3.672 0.364 7.418 0.464 11.126 0.302 55.022-2.392 104.292-62.664 112.162-137.214 4.79-45.068-7.028-90.008-31.608-120.208-16.952-20.824-37.566-32.456-61.12-34.784-3.878-0.372-12.292-0.624-12.292-0.624-53.386 2.322-93.122 58.23-101.084 133.634-5.208 48.932 1.66 96.496 26.4 126.878 15.336 18.828 34.842 29.898 56.416 32.016zM566.372 265.002c6.152-58.312 33.458-103.272 69.872-104.856 2.23-0.096 4.522-0.032 6.808 0.196 18.218 1.796 31.392 13.472 39.238 22.952 19.548 23.65 28.872 59.896 24.936 96.958-6.12 57.954-42.432 106.458-80.948 108.134-2.122 0.092-4.292 0.034-6.458-0.174-12.648-1.242-24.014-7.854-33.762-19.65-19.39-23.45-23.98-63.26-19.686-103.56z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-paw-outline"
    ]
  },
  {
    "paths": [
      "M887.654 391c-8.766-23.46-23.506-40.424-42.634-49.048-8.778-3.95-17.99-5.952-27.376-5.952-40.050 0-80.744 37.334-101.264 92.908-25.396 68.84-10.63 136.27 34.346 156.846 9.044 4.142 18.73 6.246 28.788 6.246 40.792 0 82.252-34.238 103.162-85.192 15.8-38.566 17.66-81.854 4.978-115.808z",
      "M307.622 428.908c-20.52-55.574-61.214-92.908-101.264-92.908-9.386 0-18.6 2.002-27.378 5.952-19.13 8.624-33.868 25.588-42.634 49.048-12.682 33.954-10.822 77.242 4.98 115.808 20.91 50.954 62.37 85.192 103.162 85.192 10.056 0 19.742-2.104 28.788-6.246 44.976-20.576 59.742-88.006 34.346-156.846z",
      "M396.694 421.202c3.71 0.162 7.454 0.060 11.126-0.302 21.574-2.118 41.080-13.188 56.414-32.016 24.742-30.382 31.612-77.948 26.402-126.878-7.964-75.406-47.698-131.684-101.084-134.006 0 0-7.622 0.016-11.5 0.386-23.552 2.328-44.962 14.566-61.914 35.39-24.582 30.202-36.396 75.14-31.606 120.208 7.872 74.554 57.14 134.824 112.162 137.218z",
      "M512 480c-128 0-256 152.148-256 298.256 0 43.596 21.864 78.662 43.334 93.034 26.516 17.742 45.204 24.71 84.074 24.71 46.186 0 58.65-16.156 80.272-30.41 15.638-10.304 29.144-19.21 48.322-19.21s32.684 8.906 48.32 19.21c21.622 14.254 34.084 30.41 80.272 30.41 38.868 0 57.556-6.968 84.072-24.71 21.47-14.372 43.334-49.438 43.334-93.034 0-146.108-128-298.256-256-298.256z",
      "M616.562 420.53c3.672 0.364 7.418 0.464 11.126 0.302 55.022-2.392 104.292-62.664 112.162-137.214 4.79-45.068-7.028-90.008-31.608-120.208-16.952-20.824-37.566-32.456-61.12-34.784-3.878-0.372-12.292-0.624-12.292-0.624-53.386 2.322-93.122 58.23-101.084 133.634-5.208 48.932 1.66 96.496 26.4 126.878 15.336 18.828 34.842 29.898 56.416 32.016z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-paw"
    ]
  },
  {
    "paths": [
      "M512 224v0 0z",
      "M698.4 669.6c-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 15.6-53.6-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-19.4-5.8-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-35 25.8-53.2 66-53.2 109.4 166.6 0 333.2 0 499.8 0 18.8 0 37.4 0 56.2 0 0-59-35.6-111-91.6-130.4-22.4-7.8 22.6 7.8 0 0zM294.2 727.2c11.2-11.8 25.4-22.2 40.8-28 21-8 44.8-7.6 66.6-13.2 18-4.6 40.4-11.8 54.4-24.8 12.8-12 14.2-30.4 15.4-47 1-14 0.8-27.8 0.8-41.8 0-9.8-11.4-15.4-17-23.2-9-12.2-9.4-30.4-11.2-45-0.8-6.4-1-14.6-6.4-19-6-4.8-10.4-7.4-13.4-15-4-10.4-5.4-21.6-8.6-32.4-2-7 5-13.6 7.8-19.4 5.2-10.6-3.8-27-5.6-38-5.6-32.8-5.4-68.6 18.2-94.6 47.4-52.4 156-35.8 171.6 37.8 4.8 23 1.8 49.8-4.6 72.2-2.8 9.6-6 16.6-0.4 26 8.4 13.6 4.8 22.4 0.8 37.6-3.2 12.6-7.2 18.2-16.8 26-8 6.4-6.8 22.4-8.2 31.6-1.6 11.2-2.6 23-9.4 32.4-2.6 3.6-16.8 14.8-16.8 18.6 0 22-1 44.4 2.8 66.2 5.2 31 31.2 38.4 57.2 49 26.4 10.2 57 6.4 82.6 19 26.4 13 51.8 36.8 59.4 66.2-158.6 0-317.2 0-475.8 0-2.8 0-5.6 0-8.4 0 3.8-16.6 13-29.2 24.2-41.2 18.4-19.4-11.8 12.6 0 0z",
      "M288.2 644c14-7 29.2-8.6 44.6-10.2 5.6-0.6 8.2-4.4 4-9.8-8-10.2-35.6-12.2-47.2-16.8-7.2-2.8-9.2-5.4-9.8-13.4-0.2-3.6-2.2-19.6 0.6-22.2 2-2 14.6-1.2 17.4-1.6 11.4-1.4 23-3.8 33.8-8 4.6-1.8 9-4 13-6.8 4.8-3.6-3.6-12.4-5.8-17.2-6.8-15-9.8-31.4-10.8-47.8-2-32.2 3-64.6-3-96.6-9-49-46.8-73.6-95-73.6-29.8 0-59.2 10.2-75.8 36.2-18.4 28.6-17.4 64.2-16.4 96.8 0.6 18.6 1.4 37.4-1.2 56-1.2 8-3 15.8-5.8 23.4-2.2 5.8-13.4 20.2-9 23.2 16.6 11.8 44.6 15.8 64.6 14.2 0.6 9.8 2.4 22.4-1.2 31.6-5.6 14.4-47.4 18.2-60 22.4-35.2 11.8-61.2 41.2-61.2 80.2 36.6 0 73 0 109.6 0 16.4 0 32.8 0 49.4 0 2.6 0 12.6-18.6 15.4-21.6 14-15.6 31.2-29 49.8-38.4 18-9-29.2 14.8 0 0zM205.6 672c-32.6 0-65.2 0-97.8 0 14.2-23.6 49.8-22 73.2-30.4 21.6-7.8 35.4-21 37.6-44 0.2-2.6 0.4-58.4-1.8-58.4-17.4-0.6-35.6-0.2-53-2.8 13.8-44.6 0.6-90.6 8-135.6 5.4-32.6 26.2-50.6 59.4-50.6 31.8 0 55.4 14.8 62.2 46.8 9.6 46.4-4 93.8 10.8 139.8-11 2.8-22.6 3.2-34 3.6-5.6 0.2-11.4 0.4-17 0.6-3.6 0.2-2.4 6.4-2.6 9.4-2 21.8-10 56.2 7.4 73.8-19.2 12-40 28.6-52.4 47.8z",
      "M799.6 704c53.4 0 107 0 160.4 0 0-39-26.2-68.6-61.4-80.2-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2.6-24.8-2-33.2 8.8 0.8 18.4-0.6 27.4-1.8 8.2-1.2 16.2-2.8 24-5.6 3.6-1.4 7.2-2.8 10.6-4.8 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-27.4-17-68-17.6-97.4-5.6-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 7 3.6 14.6 6 22.2 7.8 11.6 2.8 23.6 4.4 35.6 4.8 2 0 0.6 25.2 0 27.8-2.2 9.8-23.6 12.6-31.6 14.8-8.2 2.2-21.8 2.8-25.8 11.4-6 12.8 19.8 9.6 26.2 10.8 20.6 3.8 38.8 15.2 54.8 28.2 11.8 9.6 27.8 23.2 32.2 38.8zM798.8 649.8c-10.2-9.4-20.8-18.6-32.6-26 17.6-17.6 9.4-51.8 7.4-73.8-1.2-12.6-4-9.4-16.6-9.8-12-0.4-25.6 0.2-37-3.6 14.4-44.6 2.6-90.4 10-135.8 5.6-34.2 29-51 63-51 30.8 0 52 15.4 58.4 46 9.8 46.2-5.2 94 9 140-17 2.6-34.6 2-51.8 2.6-4.2 0.2-3.8 50.2-3.4 54.6 1.4 23.4 12.2 37.6 34.4 46.6 24.2 9.8 62 7.2 76.8 31.8-18.6 0-37 0-55.6 0-11.2 0-22.4 0-33.8 0-14.2 0.2-17.8-12.2-28.2-21.6-10-9.2 8 7.2 0 0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-people-outline"
    ]
  },
  {
    "paths": [
      "M698.4 669.6c22.6 7.8-22.4-7.8 0 0v0z",
      "M698.4 669.6c-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 15.6-53.6-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-19.4-5.8-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-35 25.8-53.2 66-53.2 109.4 166.6 0 333.2 0 499.8 0 18.8 0 37.4 0 56.2 0 0-59-35.6-111-91.6-130.4z",
      "M286.6 645c1.2-0.6 2.4-1.2 3.2-1.6-0.6 0.2-1.2 0.6-1.6 0.8-0.6 0.2-1 0.4-1.6 0.8z",
      "M286.6 645c-6.8 3.4-15 7.6 1.6-0.8 6-3 4.8-2.4 1.6-0.8 13.6-6.4 28.2-8 42.8-9.4 5.6-0.6 8.2-4.4 4-9.8-8-10.2-35.6-12.2-47.2-16.8-7.2-2.8-9.2-5.4-9.8-13.4-0.2-3.6-2.2-19.6 0.6-22.2 2-2 14.6-1.2 17.4-1.6 11.4-1.4 23-3.8 33.8-8 4.6-1.8 9-4 13-6.8 4.8-3.6-3.6-12.4-5.8-17.2-6.8-15-9.8-31.4-10.8-47.8-2-32.2 3-64.6-3-96.6-9-49-46.8-73.6-95-73.6-29.8 0-59.2 10.2-75.8 36.2-18.4 28.6-17.4 64.2-16.4 96.8 0.6 18.6 1.4 37.4-1.2 56-1.2 8-3 15.8-5.8 23.4-2.2 5.8-13.4 20.2-9 23.2 16.6 11.8 44.6 15.8 64.6 14.2 0.6 9.8 2.4 22.4-1.2 31.6-5.6 14.4-47.4 18.2-60 22.4-35 11.6-61 40-61 80 36.6 0 73 0 109.6 0 16.4 0 32.8 0 49.4 0 2.6 0 12.6-18.6 15.4-21.6 13.6-15 30.2-28 48.2-37.4z",
      "M898.6 623.8c-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2.6-24.8-2-33.2 8.8 0.8 18.4-0.6 27.4-1.8 8.2-1.2 16.2-2.8 24-5.6 3.6-1.4 7.2-2.8 10.6-4.8 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-27.4-17-68-17.6-97.4-5.6-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 7 3.6 14.6 6 22.2 7.8 11.6 2.8 23.6 4.4 35.6 4.8 2 0 0.6 25.2 0 27.8-2.2 9.8-23.6 12.6-31.6 14.8-8.2 2.2-21.8 2.8-25.8 11.4-6 12.8 19.8 9.6 26.2 10.8 20.6 3.8 38.8 15.2 54.8 28.2 12 9.8 28.2 23 32.6 39 53.4 0 107 0 160.4 0-0.4-40.2-26.6-68.8-61.8-80.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-people"
    ]
  },
  {
    "paths": [
      "M404.8 403.4v0 0z",
      "M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36 13.8-62.8 13.8-62.8 13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19v0c0 0 9.8-27.2 11.2-84.8 1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8v0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2zM512 800h-274.6c4-6 9.4-10.2 16.4-15.2 14-10.2 32.2-19.6 54.2-27.2 13.6-4.8 33.4-8 50.8-10.6 11.4-1.8 22.2-3.4 31.8-5.6 6.8-1.6 41.6-10 57.6-29.2 9-10.8 11.6-25.4 11.2-64.6-0.2-20-1.2-38.6-1.2-39.4l-0.4-8.4-4.6-7c-3-4.6-11.6-19-16-30.6-3.6-9.4-9.2-38.4-12-56.2 0 0 0.8 2-1-7.4s-16.8-8.6-18.8-16c-1.8-7.2-3.6-13.8-8.6-36.4s5.6-22.4 7.8-32.4c1.2-6.2 0-11.4 0-11.6v0c-0.6-2-8.2-26.8-9.4-75.4-0.6-26.4 9.2-51.2 27.6-69.8 21.2-21.6 52-33 89-33 38 0 68 11.4 89.2 33 18.4 18.6 28.2 43.4 27.6 69.8-1 48.4-8.6 73.2-9.4 75.4v0c0 0.2-1.2 3.4-0.8 10.4 0.4 10.8 13.6 11 8.6 33.6s-6.8 29.2-8.6 36.4c-1.8 7.2-17 6.6-18.8 16s-1 7.4-1 7.4c-2.8 17.8-8.4 46.8-12 56.2-4.6 11.6-13.2 26-16 30.6l-4.6 7-0.4 8.4c0 0.8-1 19.4-1.2 39.4-0.4 39.2 2.2 53.8 11.2 64.6 16 19 50.8 27.6 57.6 29.2 9.6 2.2 20.4 3.8 31.8 5.6 17.4 2.6 37.2 5.8 50.8 10.6 22 7.8 40.4 17.2 54.2 27.4 7 5 12.4 9.2 16.4 15.2l-274.4-0.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-person-outline"
    ]
  },
  {
    "paths": [
      "M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36 13.8-62.8 13.8-62.8 13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19v0c0 0 9.8-27.2 11.2-84.8 1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8v0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-person"
    ]
  },
  {
    "paths": [
      "M832 306h-50v-50h-28v50h-50v28h50v50h28v-50h50z",
      "M404.8 403.4c0 0 0 0 0 0v0z",
      "M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36c6.6-16.8 13.8-62.8 13.8-62.8s13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19 0 0 0 0 0 0s9.8-27.2 11.2-84.8c1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8s0 0 0 0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2zM512 800h-274.6c4-6 9.4-10.2 16.4-15.2 14-10.2 32.2-19.6 54.2-27.2 13.6-4.8 33.4-8 50.8-10.6 11.4-1.8 22.2-3.4 31.8-5.6 6.8-1.6 41.6-10 57.6-29.2 9-10.8 11.6-25.4 11.2-64.6-0.2-20-1.2-38.6-1.2-39.4l-0.4-8.4-4.6-7c-3-4.6-11.6-19-16-30.6-3.6-9.4-9.2-38.4-12-56.2 0 0 0.8 2-1-7.4s-16.8-8.6-18.8-16c-1.8-7.2-3.6-13.8-8.6-36.4s5.6-22.4 7.8-32.4c1.2-6.2 0-11.4 0-11.6 0 0 0 0 0 0-0.6-2-8.2-26.8-9.4-75.4-0.6-26.4 9.2-51.2 27.6-69.8 21.2-21.6 52-33 89-33 38 0 68 11.4 89.2 33 18.4 18.6 28.2 43.4 27.6 69.8-1 48.4-8.6 73.2-9.4 75.4 0 0 0 0 0 0 0 0.2-1.2 3.4-0.8 10.4 0.4 10.8 13.6 11 8.6 33.6s-6.8 29.2-8.6 36.4c-1.8 7.2-17 6.6-18.8 16s-1 7.4-1 7.4c-2.8 17.8-8.4 46.8-12 56.2-4.6 11.6-13.2 26-16 30.6l-4.6 7-0.4 8.4c0 0.8-1 19.4-1.2 39.4-0.4 39.2 2.2 53.8 11.2 64.6 16 19 50.8 27.6 57.6 29.2 9.6 2.2 20.4 3.8 31.8 5.6 17.4 2.6 37.2 5.8 50.8 10.6 22 7.8 40.4 17.2 54.2 27.4 7 5 12.4 9.2 16.4 15.2h-274.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-personadd-outline"
    ]
  },
  {
    "paths": [
      "M832 306h-50v-50h-28v50h-50v28h50v50h28v-50h50z",
      "M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36c6.6-16.8 13.8-62.8 13.8-62.8s13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19 0 0 0 0 0 0s9.8-27.2 11.2-84.8c1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8s0 0 0 0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-personadd"
    ]
  },
  {
    "paths": [
      "M192 256v640h768v-640h-768zM928 864h-704v-576h704v576z",
      "M64 128v640h96v-32h-64v-576h704v64h32v-96z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-photos-outline"
    ]
  },
  {
    "paths": [
      "M192 256v640h768v-640h-768z",
      "M832 128h-768v640h96v-544h672z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-photos"
    ]
  },
  {
    "paths": [
      "M576 161.652c90.586 7.41 174.708 46.048 239.618 110.988 72.47 72.5 112.382 168.848 112.382 271.446 0 51.848-10.16 102.084-30.198 149.406-19.36 45.718-47.080 86.768-82.388 122.048-35.308 35.278-76.408 62.962-122.16 82.302-47.346 20.020-97.646 30.162-149.504 30.162-82.386 0-160.94-25.694-227.168-74.292-31.9-23.41-59.914-51.466-83.266-83.384-16.756-22.906-30.844-47.448-42.082-73.268l384.766-96.068v-438.992zM544 128v448l-395.51 98.752c54.816 165.69 211.192 285.248 395.26 285.248 229.75 0 416.25-186.25 416.25-416s-186-416-416-416v0z",
      "M480 96.362v429.886l-360.684 91.46c-18.234-47.136-22.394-113.946-22.316-138.992v-0.142c0-94.622 32.93-187.492 90.346-254.796 33.47-39.236 75.004-69.962 123.442-91.326 49.41-21.79 106.25-33.904 169.212-36.090zM512 64h-11c-320 0-437 232.5-437 414.574 0 0 0.5 113.332 37.82 176.582l410.18-104.010v-487.146z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pie-outline"
    ]
  },
  {
    "paths": [
      "M544 128v448l-395.51 98.752c54.816 165.69 211.192 285.248 395.26 285.248 229.75 0 416.25-186.25 416.25-416s-186-416-416-416v0z",
      "M512 64h-11c-320 0-437 232.5-437 414.574 0 0 0.5 113.332 37.82 176.582l410.18-104.010v-487.146z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pie"
    ]
  },
  {
    "paths": [
      "M736 340.17c0-42.044-1.946-177.108-38.616-250.026-8.896-17.688-24.884-26.144-63.386-26.144h-243.996c-38.5 0-54.492 8.394-63.386 26.082-36.67 72.918-38.616 208.418-38.616 250.462 0 196 64 200.706 64 361.706 0 79-32 142.804-32 198.804 0 54 18 58.946 64 58.946h256c46 0 64-5.070 64-59.070 0-56-32-119.43-32-198.43 0-161 64-166.33 64-362.33zM355.204 103.966c1.556-3.092 2.678-3.526 5.060-4.59 3.954-1.768 12.322-3.376 29.738-3.376h243.996c17.416 0 25.786 1.606 29.738 3.374 2.38 1.064 3.504 1.744 5.060 4.836 16.058 31.934 27.202 85.222 32.21 151.792h-378.014c5.010-66.696 16.152-120.1 32.212-152.036zM669.262 925.272c-3.742 1.482-13.574 2.728-29.262 2.728h-256c-15.688 0-25.522-1.246-29.278-2.718-0.788-1.86-2.722-8.332-2.722-24.54 0-21.712 6.032-46.32 13.016-74.668 8.898-36.118 18.984-77.114 18.984-123.886 0-81.994-15.986-127.604-31.448-171.684-16.004-45.628-32.552-92.828-32.552-190.194 0-18.050 0.382-35.512 1.116-52.31h381.772c0.73 16.752 1.114 34.166 1.114 52.17 0 97.376-16.552 144.604-32.56 190.338-15.456 44.158-31.44 89.79-31.44 171.774 0 46.78 10.086 87.644 18.986 123.712 6.982 28.3 13.014 52.736 13.014 74.444-0.002 16.272-1.954 22.988-2.74 24.834z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pint-outline"
    ]
  },
  {
    "paths": [
      "M736 340.17c0-42.044-1.946-177.108-38.616-250.026-8.896-17.688-24.884-26.144-63.386-26.144h-243.996c-38.5 0-54.492 8.394-63.386 26.082-36.67 72.918-38.616 208.418-38.616 250.462 0 196 64 200.706 64 361.706 0 79-32 142.804-32 198.804 0 54 18 58.946 64 58.946h256c46 0 64-5.070 64-59.070 0-56-32-119.43-32-198.43 0-161 64-166.33 64-362.33zM355.204 103.966c1.556-3.092 2.678-3.526 5.060-4.59 3.954-1.768 12.322-3.376 29.738-3.376h243.996c17.416 0 25.786 1.606 29.738 3.374 2.38 1.064 3.504 1.744 5.060 4.836 16.058 31.934 27.202 85.222 32.21 151.792h-378.014c5.010-66.696 16.152-120.1 32.212-152.036z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pint"
    ]
  },
  {
    "paths": [
      "M288 249.8l419.6 262.2-419.6 262.2v-524.4zM256 192v640l512-320-512-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-play-outline"
    ]
  },
  {
    "paths": [
      "M256 192v640l512-320-512-320z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-play"
    ]
  },
  {
    "paths": [
      "M768 530h-240v238h-34v-238h-238v-34h238v-240h34v240h240v34z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-plus-empty"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4s171.2-381.4 381.4-381.4 381.4 171.2 381.4 381.4-171.2 381.4-381.4 381.4z",
      "M528.2 256h-33.6v239.8h-238.6v33.6h238.6v238.6h33.6v-238.6h239.8v-33.6h-239.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-plus-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM768 530h-240v238h-34v-238h-238v-34h238v-240h34v240h240v34z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-plus"
    ]
  },
  {
    "paths": [
      "M928 64h-320l-512 576 320 320 512-576v-320zM896 368l-479.75 544-272.126-272 479.050-544h272.826v272z",
      "M736 320c35.29 0 64-28.71 64-64s-28.71-64-64-64-64 28.71-64 64 28.71 64 64 64zM736 224c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pricetag-outline"
    ]
  },
  {
    "paths": [
      "M768 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M608 64l-512 576 320 320 512-576v-320h-320zM736 320c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pricetag"
    ]
  },
  {
    "paths": [
      "M896 128v-64h-320l-512 576 320 320 46.942-47.808 49.058 47.808 480-544v-288h-64zM384 914.742l-275.22-274.742 480.462-544h274.758v274.754l-433.11 495.98-22.68 22.726-24.21 25.282zM928 402.754l-448 511.988-26.364-25.3 442.364-505.442v-224h32v242.754z",
      "M704 320c35.29 0 64-28.71 64-64s-28.71-64-64-64-64 28.71-64 64 28.71 64 64 64zM704 224c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pricetags-outline"
    ]
  },
  {
    "paths": [
      "M928 128v274.754l-473.694 532.206 25.694 25.040 480-544v-288z",
      "M576 64l-512 576 320 320 46.942-47.808 22.696-22.75 442.362-505.442v-320h-320zM704 320c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z",
      "M736 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pricetags"
    ]
  },
  {
    "paths": [
      "M865 224h-65v-96h-576v96h-63c-35.2 0-65 27.6-65 62.6v316.8c0 35 29.8 64.6 65 64.6h95v228h512v-228h97c35.2 0 63-29.6 63-64.6v-316.8c0-35-27.8-62.6-63-62.6zM256 160h512v64h-512v-64zM736 864h-448v-384h448v384zM896 603.4c0 17.4-13.4 32.6-31 32.6h-97v-188h-512v188h-95c-17.6 0-33-15.2-33-32.6v-316.8c0-17.4 15.4-30.6 33-30.6h704c17.6 0 31 13.2 31 30.6v316.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-printer-outline"
    ]
  },
  {
    "paths": [
      "M256 448h512v448h-512v-448z",
      "M255 449h512v448h-512v-448z",
      "M223 129h576v64h-576v-64z",
      "M865 225h-704c-35.29 0-66 25.684-66 60.618v316.786c0 34.936 30.71 66.598 66 66.598h62v-252h576v252h66c35.29 0 62-31.662 62-66.598v-316.786c0-34.934-26.71-60.618-62-60.618z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-printer"
    ]
  },
  {
    "paths": [
      "M896 546.002c-42.54 0-78.592 27.998-91.192 65.998h-77.714l-56.722-170.834c-4.352-13.106-16.606-21.912-30.366-21.912-0.224 0-0.448 0-0.67 0.008-14.032 0.29-26.234 9.688-30.098 23.176l-88.968 310.524-104.706-628.216c-2.494-14.96-14.898-28.746-31.564-28.746s-27.386 11.552-31.050 26.27l-121.958 489.73h-198.992v63.998h224c14.696 0 27.5-10.006 31.050-24.268l90.736-364.354 102.648 615.88c2.458 14.754 14.794 23.84 29.728 24.688 0.616 0.036 1.228 0.056 1.838 0.056 14.194 0 26.812-7.402 30.762-21.188l99.488-347.234 31.378 94.504c4.346 13.086 16.584 21.916 30.372 21.916h102.216c13.73 36 48.738 62.002 89.784 62.002 53.022 0 96-44.984 96-98 0-53.018-42.978-93.998-96-93.998z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pulse-strong"
    ]
  },
  {
    "paths": [
      "M896 576c-30.536 0-56.058 21.39-62.446 50h-118.008l-60.362-181.792c-2.21-6.658-8.492-11.086-15.518-10.956-7.016 0.144-13.118 4.844-15.048 11.59l-108.484 378.638-116.35-698.11c-1.248-7.48-7.574-13.056-15.152-13.358-7.618-0.278-14.322 4.764-16.156 12.122l-124.98 501.866h-179.496v32h192c7.348 0 13.75-5.004 15.526-12.132l109.37-439.182 115.322 691.946c1.23 7.376 7.406 12.918 14.874 13.344 0.306 0.018 0.614 0.026 0.918 0.026 7.098 0 13.398-4.7 15.374-11.594l113.744-396.992 47.69 143.626c2.174 6.542 8.292 10.958 15.186 10.958h130.584c7.78 26.578 32.322 46 61.416 46 35.348 0 64-28.654 64-64s-28.656-64-64.004-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-pulse"
    ]
  },
  {
    "paths": [
      "M664.2 358.8c-5.6 0-11.4-0.2-16.8 0.6-16.6-73.6-70.4-135.2-160.6-135.2-101.8 0-164.6 76-164.6 167.2 0 5.6 0.2 11 0.8 16.4-55.4 5-99 62.6-99 119.6 0 58.4 45.8 109.2 103.2 112.4l-49 68.8c-2.2 3.2-4 6.8-4 11 0 9.2 7.4 16.6 16.6 16.6 6 0 11.2-3.2 14.2-8l62-87.6h72.2l-92.2 131.6c-2.4 3.2-4.2 7.2-4.2 11.2 0 9.2 7.4 16.6 16.6 16.6 6 0 11.2-3.6 14.4-8.6l105.2-151h75.8l-49.8 68.8c-2.4 3.2-4.4 7.6-4.4 11.2 0 9.2 7.4 16.6 16.6 16.6 6.2 0 10.8-3.4 14.4-8.2l63.2-88.6h69.4c0.2 0 0.6-0.2 0.8-0.2l-92.2 131.8c-2.6 3.4-4.6 7.2-4.6 11.6 0 9.2 7.4 16.6 16.6 16.6 6.4 0 11-4 14.8-9l111-159.6c52-19.8 89.2-71.6 89.2-130.4 0.2-75.4-60.6-142.2-135.6-142.2zM664.2 604.2h-84.2l-0.2-0.2-0.2 0.2h-246.8c-20 0-39-9.2-53.4-23.8s-22.2-34.4-22.2-54.8c0-39.2 30.4-79.6 69.8-86 3.4-0.6 18.4-2.8 30-3.8 0 0-1-11.2-1.4-20.4-0.2-9.2-0.2-19.8-0.2-24.2 0-72.8 59-133.8 131.6-133.8 30.4 0 59 10.2 82.6 29.4 23 18.6 39.2 50.8 45.6 79.4l6.6 29.4 29.8-3.8c4.4-0.6 8.6-0.8 12.8-0.8 56.6 0 102.6 51.8 102.6 108.8-0.2 56.8-46.2 104.4-102.8 104.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-rainy-outline"
    ]
  },
  {
    "paths": [
      "M664.2 358.8c-5.6 0-11.4-0.2-16.8 0.6-16.6-73.6-70.4-135.2-160.6-135.2-101.8 0-164.6 76-164.6 167.2 0 5.6 0.2 11 0.8 16.4-55.4 5-99 62.6-99 119.6 0 58.4 45.8 109.2 103.2 112.4l-49 68.8c-2.2 3.2-4 6.8-4 11 0 9.2 7.4 16.6 16.6 16.6 6 0 11.2-3.2 14.2-8l62-87.6h72.2l-92.2 131.6c-2.4 3.2-4.2 7.2-4.2 11.2 0 9.2 7.4 16.6 16.6 16.6 6 0 11.2-3.6 14.4-8.6l105.2-151h75.8l-49.8 68.8c-2.4 3.2-4.4 7.6-4.4 11.2 0 9.2 7.4 16.6 16.6 16.6 6.2 0 10.8-3.4 14.4-8.2l63.2-88.6h69.4c0.2 0 0.6-0.2 0.8-0.2l-92.2 131.8c-2.6 3.4-4.6 7.2-4.6 11.6 0 9.2 7.4 16.6 16.6 16.6 6.4 0 11-4 14.8-9l111-159.6c52-19.8 89.2-71.6 89.2-130.4 0.2-75.4-60.6-142.2-135.6-142.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-rainy"
    ]
  },
  {
    "paths": [
      "M772.4 288c-121.2 0-219.6 100.2-219.6 224 0 80.8 42 151.4 105 190.8h-291.6c63-39.4 105-110 105-190.8 0-123.8-98.4-224-219.6-224s-219.6 100.2-219.6 224c0 123.8 98.4 224 219.6 224h520.8c121.2 0 219.6-100.2 219.6-224s-98.4-224-219.6-224zM64.6 512c0-105.2 84-190.8 187-190.8 103.2 0 187 85.6 187 190.8s-84 190.8-187 190.8c-103.2 0-187-85.6-187-190.8zM772.4 702.8c-103.2 0-187-85.6-187-190.8s84-190.8 187-190.8 187 85.6 187 190.8-83.8 190.8-187 190.8z",
      "M768 416c53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-53 43-96 96-96zM768 384c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z",
      "M256 416c53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-53 43-96 96-96zM256 384c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-recording-outline"
    ]
  },
  {
    "paths": [
      "M772.4 288c-121.2 0-219.6 99.8-219.6 223.6 0 80.8 42 152.4 105 190.4h-291.6c63-38 105-109.6 105-190.4 0-123.8-98.4-223.8-219.6-223.8s-219.6 100.4-219.6 224c0 123.8 98.4 224.2 219.6 224.2h520.8c121.2 0 219.6-100.2 219.6-224s-98.4-224-219.6-224zM256 640c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128c0 70.6-57.4 128-128 128zM768 640c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128c0 70.6-57.4 128-128 128z",
      "M768 416c-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-53-43-96-96-96z",
      "M256 416c-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-53-43-96-96-96z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-recording"
    ]
  },
  {
    "paths": [
      "M128 800h20.6l38.4-62.4c41-65.4 89.8-125.6 151.6-153.2 48.8-21.8 93.4-37.8 173.4-40v159.6l384-256-384-256v160.6c-126 5.6-216.2 41.4-286.6 112.4-104.6 105.4-97.4 238-97.4 271.4 0.2 17.8 0 43.4 0 63.6zM544 384v-129.4l296.2 193.6-296.2 193.4v-129.6c-182 0-289.2 49.2-384.4 210.8-0 0-17.6-338.8 384.4-338.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-redo-outline"
    ]
  },
  {
    "paths": [
      "M128 800h20.6l38.4-62.4c41-65.4 89.8-125.6 151.6-153.2 48.8-21.8 93.4-37.8 173.4-40v159.6l384-256-384-256v160.6c-126 5.6-216.2 41.4-286.6 112.4-104.6 105.4-97.4 238-97.4 271.4 0.2 17.8 0 43.4 0 63.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-redo"
    ]
  },
  {
    "paths": [
      "M512 768.2c-141.4 0-256-114.6-256-256.2s114.6-256.2 256-256.2v-87.8l192 128-192 111.4v-111.6c-119.2 0-216.2 97-216.2 216.2s97 216.2 216.2 216.2 216.2-96.2 216.2-216.2h39.8c0 142-114.6 256.2-256 256.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-refresh-empty"
    ]
  },
  {
    "paths": [
      "M728.2 512c0 120-97 216.4-216.2 216.4s-216.2-97-216.2-216.4c0-119.2 97-216.2 216.2-216.2v111.6l192-111.4-192-128v88c-141.4 0-256 114.8-256 256.2 0 141.6 114.6 256.2 256 256.2s256-114.2 256-256.2h-39.8z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-refresh-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 768.2c-141.4 0-256-114.6-256-256.2s114.6-256.2 256-256.2v-87.8l192 128-192 111.4v-111.6c-119.2 0-216.2 97-216.2 216.2s97 216.2 216.2 216.2 216.2-96.2 216.2-216.2h39.8c0 142-114.6 256.2-256 256.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-refresh"
    ]
  },
  {
    "paths": [
      "M512 128c211.8 0 383.4 171.4 383.8 383l110-105 18 18.2-140.6 135.8-133.2-135.8 18-18.2 102.2 104.8c-0.6-197-161-357.2-358.2-357.2-197.6 0-358.4 160.8-358.4 358.4s160.8 358.4 358.4 358.4c157.2 0 291-102 339-243.2l24.8 7c-51.2 152.2-194.6 261.8-363.8 261.8-212 0-384-172-384-384s172-384 384-384z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-reload"
    ]
  },
  {
    "paths": [
      "M603.63 637.216c-26.228 22.058-57.912 34.712-91.63 34.712-72.72 0-132.572-57.93-141.78-123.93h61.22l-77.74-100-75.068 100h58.958c9.392 84 83.434 156 174.41 156 41.8 0 82.34-15.132 114.152-42.436l4.74-4.318-23.198-23.324-4.064 3.296z",
      "M631.472 397.77c-32.376-29.55-74.804-45.678-119.472-45.678-41.8 0-82.338 15.112-114.15 42.412l-4.742 4.104 23.198 23.22 4.066-3.412c25.854-21.744 58.394-34.010 91.628-34.010 72.686 0 132.548 57.594 141.782 127.594h-61.288l77.692 102.45 75.252-102.45h-59.024c-4.482-40-23.864-85.872-54.942-114.23z",
      "M835 320h-123.45c-64.21-72-84.438-96-109.050-96h-177c-24.628 0-44.334 24-109.042 96h-26.458v-32h-68v32h-27c-35.29 0-67 26.434-67 61.368v352.036c0 34.934 31.71 66.596 67 66.596h640c35.29 0 61-31.662 61-66.598v-352.034c0-34.934-25.71-61.368-61-61.368zM864 733.402c0 18.526-12.458 34.598-29 34.598h-640c-17.476 0-35-17.328-35-34.598v-352.034c0-16.332 16.252-29.368 35-29.368h121.458c0 0 8.248 0 12.266 0s6.45-0.398 11.536-6.4 15.404-20.016 22.16-27.59c22.592-25.332 38.914-43.83 50.632-54.264 9.492-8.45 12.422-7.746 12.45-7.746h177c0.032 0 3.222-0.726 13.418 8.438 12.282 11.042 29.41 33.68 53.116 60.396 5.776 6.51 14.428 16.22 18.634 20.88s8.504 6.286 11.542 6.286 12.34 0 12.34 0h123.448c17.664 0 29 11.93 29 29.368v352.034z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-reverse-camera-outline"
    ]
  },
  {
    "paths": [
      "M835 320h-123.45c-64.21-72-84.438-96-109.050-96h-177c-24.628 0-44.334 24-109.042 96h-26.458v-32h-68v32h-27c-35.29 0-67 26.434-67 61.368v352.036c0 34.934 31.71 66.596 67 66.596h640c35.29 0 61-31.662 61-66.598v-352.034c0-34.934-25.71-61.368-61-61.368zM626.152 661.564c-31.812 27.304-72.352 42.436-114.152 42.436-90.974 0-165.018-72-174.41-156h-58.958l75.068-100 77.74 100h-61.22c9.208 66 69.060 123.93 141.78 123.93 33.718 0 65.402-12.654 91.63-34.712l4.064-3.294 23.198 23.324-4.74 4.316zM670.188 614.45l-77.692-102.45h61.288c-9.234-70-69.096-127.594-141.782-127.594-33.236 0-65.776 12.266-91.628 34.010l-4.066 3.412-23.198-23.22 4.742-4.104c31.81-27.3 72.35-42.412 114.15-42.412 44.666 0 87.096 16.126 119.472 45.678 31.076 28.358 50.458 74.23 54.94 114.23h59.024l-75.25 102.45z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-reverse-camera"
    ]
  },
  {
    "paths": [
      "M928 310v403.8l-367-201.8 367-202zM480 312v400.8l-352-200.8 352-200.4zM512 256l-448 256 448 256v-246.4l448 246.4v-512l-448 246.4v-246.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-rewind-outline"
    ]
  },
  {
    "paths": [
      "M512 256l-448 256 448 256v-246.4l448 246.4v-512l-448 246.4v-246.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-rewind"
    ]
  },
  {
    "paths": [
      "M759.538 306.862c-59.554 111.172-35.208 199.008-13.29 278.078 11.186 40.356 21.752 78.476 21.752 118.838 0 31.794-5.912 61.746-17.57 89.020-11.454 26.792-28.208 50.424-49.796 70.24-46.296 42.498-111.524 64.962-188.634 64.962s-142.338-22.464-188.632-64.962c-21.59-19.816-38.344-43.45-49.796-70.24-11.658-27.274-17.57-57.224-17.57-89.020 0-63.3 13.84-111.998 43.55-153.252 26.122-36.268 65.292-68.188 127.010-103.498l13.012-7.45c40.394-23.14 54.002-30.934 87.952-47.176 63.69-30.468 133.026-56.774 206.082-78.188 8.568-2.512 17.216-4.964 25.93-7.352zM832 256c-37.726 8.326-73.5 17.572-107.394 27.506-80.914 23.716-151.018 51.386-210.89 80.030-38.542 18.438-52.472 26.786-103.044 55.718-116.67 66.746-186.672 138.598-186.672 284.524s111.27 256.222 288 256.222 288-110.296 288-256.222-122.002-255.778 32-447.778v0z",
      "M267.032 246.294c42.864 13.91 95.448 33.954 139.598 59.692 12.77 7.446 24.184 14.986 34.184 22.582-11.008 5.81-21.79 11.71-32.276 17.666-14.424 8.192-28.718 16.724-42.486 25.358-20.968 13.148-40.87 26.616-59.578 40.312-1.2-51.836-11.364-109.604-39.442-165.61zM192 192c82.95 94.158 89.248 207.782 78.764 289.482 25.544-22.548 62.354-51.468 112.288-82.778 12.884-8.082 26.624-16.316 41.29-24.644 23.156-13.15 47.076-25.644 71.668-37.53-18.226-21.796-44.14-41.212-73.262-58.19-97.486-56.828-230.748-86.34-230.748-86.34v0z",
      "M689.258 161.394c10.618 14.454 24.786 35.322 35.32 55.452-59.726 16.866-131.988 42.29-189.934 66.952-11.926-12.47-25.964-24.588-42.012-36.27 34.874-31.514 77.546-55.336 127.304-71.012 29.1-9.166 54.096-13.292 69.322-15.122zM704 128c0 0-157.246 4.642-261.362 124.938 33.258 19.806 59.47 41.006 77.918 63.066l5.448 6.514c74.304-33.588 176.262-68.17 241.996-84.018-12.766-46.846-64-110.5-64-110.5v0z",
      "M362.458 107.064c18.482 12.244 45.36 32.962 71.998 63.848-9.702 8.402-18.974 17.246-27.776 26.494-28.048-14.176-49.902-24.384-73.652-33.204 7.32-16.942 17.162-36.626 29.43-57.138zM352 64c-30.512 44.812-51.368 90.598-60.672 119.994 42.222 12.71 70.95 26.43 122.778 53.148 19.010-22.8 40.83-43.252 65.21-61.086-58.632-80.746-127.316-112.056-127.316-112.056v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-rose-outline"
    ]
  },
  {
    "paths": [
      "M832 256c-37.726 8.326-73.5 17.572-107.394 27.506-80.914 23.716-151.018 51.386-210.89 80.030-38.542 18.438-52.472 26.786-103.044 55.718-116.67 66.746-186.672 138.598-186.672 284.524s111.27 256.222 288 256.222 288-110.296 288-256.222-122.002-255.778 32-447.778v0z",
      "M192 192c82.95 94.158 89.248 207.782 78.764 289.482 25.544-22.548 62.354-51.468 112.288-82.778 12.884-8.082 26.624-16.316 41.29-24.644 23.156-13.15 47.076-25.644 71.668-37.53-18.226-21.796-44.14-41.212-73.262-58.19-97.486-56.828-230.748-86.34-230.748-86.34v0z",
      "M704 128c0 0-157.246 4.642-261.362 124.938 33.258 19.806 59.47 41.006 77.918 63.066l5.448 6.514c74.304-33.588 176.262-68.17 241.996-84.018-12.766-46.846-64-110.5-64-110.5v0z",
      "M352 64c-30.512 44.812-51.368 90.598-60.672 119.994 42.222 12.71 70.95 26.43 122.778 53.148 19.010-22.8 40.83-43.252 65.21-61.086-58.632-80.746-127.316-112.056-127.316-112.056v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-rose"
    ]
  },
  {
    "paths": [
      "M689 596c30-47.2 47.6-103.2 47.6-163.4 0-168.2-136.2-304.6-304.2-304.6-168.2 0-304.4 136.4-304.4 304.6s136.2 304.6 304.2 304.6c61 0 117.8-18 165.4-48.8l13.8-9.6 217.2 217.2 67.4-68.6-217-217.2 10-14.2zM602.8 262.4c45.4 45.4 70.4 105.8 70.4 170s-25 124.6-70.4 170c-45.4 45.4-105.8 70.4-170 70.4s-124.6-25-170-70.4c-45.4-45.4-70.4-105.8-70.4-170s25-124.6 70.4-170c45.4-45.4 105.8-70.4 170-70.4s124.6 25 170 70.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-search-strong"
    ]
  },
  {
    "paths": [
      "M896.6 849.4l-226.6-226.8c41.6-52 66.6-118.2 66.6-190.2 0-168.2-136.2-304.4-304-304.4-168 0-304 136.4-304 304.4s136.2 304.4 304 304.4c72.4 0 138.8-25.4 191-67.6l226.4 226.8 46.6-46.6zM240.2 625.2c-51.4-51.4-79.6-119.8-79.6-192.6s28.4-141.2 79.6-192.6 119.8-80 192.4-80c72.6 0 141 28.4 192.4 79.8s79.6 119.8 79.6 192.6-28.4 141.2-79.6 192.6c-51.4 51.4-119.8 79.8-192.4 79.8-72.6 0.2-141-28.2-192.4-79.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-search"
    ]
  },
  {
    "paths": [
      "M64 752h566.7c12.372-28.224 40.562-48 73.3-48s60.93 19.776 73.3 48h182.7v64h-182.7c-12.372 28.224-40.562 48-73.3 48s-60.93-19.776-73.3-48h-566.7z",
      "M64 480h182.7c12.372-28.224 40.562-48 73.3-48s60.93 19.776 73.3 48h566.7v64h-566.7c-12.372 28.224-40.562 48-73.3 48s-60.93-19.776-73.3-48h-182.7z",
      "M64 208h566.7c12.372-28.224 40.562-48 73.3-48s60.93 19.776 73.3 48h182.7v64h-182.7c-12.372 28.224-40.562 48-73.3 48s-60.93-19.776-73.3-48h-566.7z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-settings-strong"
    ]
  },
  {
    "paths": [
      "M704 208c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zM704 176c-35.29 0-64 28.71-64 64s28.71 64 64 64 64-28.71 64-64-28.71-64-64-64v0z",
      "M704 752c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zM704 720c-35.29 0-64 28.71-64 64s28.71 64 64 64 64-28.71 64-64-28.71-64-64-64v0z",
      "M320 480c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zM320 448c-35.29 0-64 28.71-64 64s28.71 64 64 64 64-28.71 64-64-28.71-64-64-64v0z",
      "M414.64 496h545.36v32h-545.36c0.878-5.208 1.36-10.546 1.36-16s-0.48-10.792-1.36-16z",
      "M224 512c0 5.454 0.48 10.792 1.36 16h-161.36v-32h161.36c-0.88 5.208-1.36 10.546-1.36 16z",
      "M798.64 768h161.36v32h-161.36c0.878-5.208 1.36-10.546 1.36-16s-0.48-10.792-1.36-16z",
      "M608 784c0 5.454 0.48 10.792 1.36 16h-545.36v-32h545.36c-0.88 5.208-1.36 10.546-1.36 16z",
      "M798.64 224h161.36v32h-161.36c0.878-5.208 1.36-10.546 1.36-16s-0.48-10.792-1.36-16z",
      "M609.36 224c-0.878 5.208-1.36 10.546-1.36 16s0.48 10.792 1.36 16h-545.36v-32h545.36z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-settings"
    ]
  },
  {
    "paths": [
      "M730.838 304h27.62l-101.476 83.168 40.616 49.144 198.402-164.312-198.272-168-40.736 49.956 102.366 86.044h-28.52c-207.454 0-292.988 159.24-361.714 287.454-2.724 5.084-5.43 9.98-8.12 14.976l-0.118 0.19c-3.182 5.906-6.352 12.228-9.52 18.076-71.124 131.26-133.786 166.428-223.368 167.282v64.022c75.25 0 115.126-18.902 144.472-36.356 49.87-29.662 94.084-89.118 135.166-164.934 3.082-5.688 6.166-11.504 9.264-17.252l0.45-0.876c2.918-5.422 5.844-10.546 8.78-16.028 66.608-124.328 135.486-252.554 304.708-252.554z",
      "M697.596 587.688l-40.616 49.144 101.478 83.168h-27.62c-141.456 0-212.792-89.602-271.298-191.624l-35.296 65.236c62.868 99.64 149.988 190.388 306.594 190.388h28.52l-102.366 86.044 40.736 49.956 198.272-168-198.404-164.312z",
      "M351.368 463.304c3.168 5.848 6.338 12.17 9.52 18.076l0.118 0.19c2.436 4.524 4.884 8.98 7.35 13.554 11.64-21.46 23.96-43.496 37.39-65.298-40.546-74.158-84.166-132.264-133.272-161.47-29.348-17.454-69.224-36.356-144.474-36.356v64.022c89.582 0.854 152.244 36.022 223.368 167.282z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-shuffle-strong"
    ]
  },
  {
    "paths": [
      "M724.242 414.292l-20.242-24.584 123.568-101.708h-92.234c-186.654 0-258.294 149.022-327.574 277.664-3.24 6.016-6.466 12.008-9.692 17.958-39.672 73.214-81.958 122.484-129.28 150.628-27.642 16.442-65.986 33.75-140.788 33.75v-32.5c95.874 0 166.196-27.346 241.932-167.122 3.212-5.93 6.428-11.898 9.654-17.888 70.3-130.536 149.982-294.49 355.748-294.49h92.56l-123.894-103.708 20.242-24.292 171.758 144-171.758 142.292z",
      "M398.068 440.378c-39.672-73.214-81.958-122.484-129.28-150.628-27.642-16.442-65.986-33.75-140.788-33.75v32.5c95.874 0 166.196 27.346 241.932 167.122 3.212 5.928 6.428 11.896 9.654 17.888 0.876 1.624 1.75 3.254 2.628 4.888 6.020-10.876 12.214-21.834 18.678-32.788-0.938-1.74-1.884-3.498-2.824-5.232z",
      "M724.242 609.708l-20.242 24.584 123.568 101.708h-92.234c-145.386 0-220.992-90.414-280.056-191.184-3.536 6.55-7.050 13.102-10.546 19.628-2.35 4.384-4.688 8.74-7.026 13.090 61.536 100.020 144.802 190.466 297.628 190.466h92.56l-123.894 103.708 20.242 24.292 171.758-144-171.758-142.292z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-shuffle"
    ]
  },
  {
    "paths": [
      "M192 192v640h158v-283.6l482 283.6v-640l-482 283.6v-283.6h-158zM351.2 512l15.2-8.8 433.6-255.2v528l-448.8-264zM224 224h94v576h-94v-576z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-skipbackward-outline"
    ]
  },
  {
    "paths": [
      "M192 192v640h158v-283.6l482 283.6v-640l-482 283.6v-283.6h-158z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-skipbackward"
    ]
  },
  {
    "paths": [
      "M674 192v283.6l-482-283.6v640l482-283.6v283.6h158v-640h-158zM657.8 520.8l-433.8 255.2v-528l449 264-15.2 8.8zM800 800h-94v-576h94v576z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-skipforward-outline"
    ]
  },
  {
    "paths": [
      "M674 192v283.6l-482-283.6v640l482-283.6v283.6h158v-640h-158z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-skipforward"
    ]
  },
  {
    "paths": [
      "M759.8 634l-57.4-32.6c12.2-11.6 26-19.4 41.4-24.6 8.6-2.8 13-11.8 10.2-20.2s-12-13-20.6-10.2c-23.2 7.6-44.4 22-60.2 38.4l-128.6-72.8 128.4-72.8c16.8 18.2 37.2 30.8 60.4 38.4 8.6 2.8 17.8-1.6 20.6-10s-1.6-17.4-10.2-20.2c-15.6-5.2-29.6-13-41.8-24.6l57.6-32.6c7.8-4.4 10.4-14.2 6-21.8s-14.4-10.2-22.2-5.8l-57.4 32c-4-16.2-4.2-31.8-1-47.6 1.8-8.6-4-17-12.8-18.8s-17.4 3.8-19.2 12.4c-4.8 23.6-2.8 48.8 3.6 70.4l-128.6 73.4v-146c22-5.4 44.8-16.2 63-32.2 6.6-5.8 7.2-16 1.4-22.6s-15.8-7.2-22.6-1.4c-12 10.6-25.8 18.4-41.8 23v-65.2c0-8.8-7.2-16-16-16s-16 7.2-16 16v65.4c-16-4.6-29.6-12.4-41.8-23.2-6.6-5.8-16.8-5.2-22.6 1.4s-5.2 16.8 1.4 22.6c18.2 16 39 27 63 32.2v146l-129-73.2c6.4-21.8 8.4-47 3.8-70.4-1.8-8.6-10.4-14.2-19.2-12.4s-14.4 10-12.8 18.8c3.2 15.8 3.2 31.4-1 47.6l-57.2-32.8c-7.8-4.4-17.8-1.8-22.2 5.8s-1.8 17.4 6 21.8l57.6 32.6c-12.2 11.6-26 19.4-41.6 24.6-8.6 2.8-13 12-10.2 20.2 2.8 8.4 12.2 12.8 20.6 10 23.2-7.8 43.6-20.2 60.4-38.4l128.6 73-128.8 73c-15.8-16.4-37.2-30.6-60.2-38.4-8.6-2.8-17.6 1.8-20.6 10.2-2.8 8.4 1.6 17.4 10.2 20.2 15.4 5.2 29.2 13 41.4 24.6l-57.4 32.6c-7.8 4.4-10.4 14.2-6 21.8s14.4 10.2 22.2 5.8l57.6-32.6c4.2 16.2 4.2 31.8 0.8 47.8-1.8 8.6 4 17 12.8 18.8s17.4-3.8 19.2-12.6c4.8-23.6 3.8-47.2-3.8-70.6l129-73.2v146.2c-24 5.2-44.8 16.2-63 32.2-6.6 5.8-7.2 16-1.4 22.6s15.8 7.2 22.6 1.4c12.2-10.8 25.8-18.6 41.8-23.2v65.8c0 8.8 7.2 16 16 16s16-7.2 16-16v-65.2c16 4.6 29.6 12.4 41.8 23 6.6 5.8 16.6 5.2 22.6-1.4 5.8-6.6 5.2-16.8-1.4-22.6-18-15.8-40.8-26.8-62.8-32.2v-146.2l128.8 73c-7.6 23.4-8.4 47-3.6 70.6 1.8 8.6 10.4 14.2 19.2 12.6 8.8-1.8 14.6-10.2 12.8-18.8-3.2-16-3.2-31.6 0.8-47.8l57.6 32.6c7.8 4.4 17.8 1.8 22.2-5.8 4.2-7.6 1.4-17.4-6.4-21.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-snowy"
    ]
  },
  {
    "paths": [
      "M512 128c-247.424 0-448 200.452-448 447.876 0 113.95 42.566 217.94 112.632 297 7.102 8.012 14.482 15.64 22.132 23.124 6.118-6.98 12.464-13.668 19.078-20.282 0.96-0.96 1.944-1.894 2.912-2.844 37.56-36.852 81.042-65.898 129.328-86.322 51.266-21.684 105.742-32.678 161.916-32.678s110.65 10.994 161.916 32.678c48.288 20.424 91.768 49.47 129.328 86.322 0.968 0.95 1.952 1.882 2.912 2.844 6.614 6.614 12.96 13.3 19.078 20.282 7.65-7.484 15.032-15.114 22.132-23.124 70.066-79.060 112.632-183.050 112.632-297 0.004-247.424-200.572-447.876-447.996-447.876zM895.322 738.354c-17.326 40.962-40.858 78.184-70.088 111.552-80.78-79.020-191.306-127.89-313.234-127.89s-232.456 48.66-313.234 127.68c-29.23-33.37-52.762-70.344-70.088-111.306-19.62-46.38-30.456-95.388-32.346-145.388h62.668v-32h-62.668c1.89-50 12.726-100.096 32.346-146.478 18.744-44.314 44.752-84.862 77.384-120.22l53.864 53.786 10.992-11.076 10.554-10.528-0.040-0.054 1.094-1.104-53.902-53.968c35.724-33.294 76.008-59.788 120.958-78.8 46.382-19.62 95.416-30.458 145.416-32.348v74.788h32v-74.792c52 1.89 100.034 12.726 146.416 32.346 44.874 18.98 85.842 45.412 121.524 78.624l-53.95 54.138 1.154 1.094-0.008 0.038 10.57 10.492 11 11.006 54.052-54.114c32.712 35.406 58.784 76.296 77.56 120.69 19.62 46.382 30.458 96.478 32.348 146.478h-64.664v32h64.668c-1.89 50-12.726 98.972-32.346 145.354z",
      "M736.958 349.090l-170.968 147.454c-15.394-10.51-33.984-16.668-53.988-16.668-52.934 0-96 43.066-96 96 0 20.958 6.77 40.356 18.212 56.16l-23.896 23.896 22.624 22.626 24.066-24.066c15.59 10.938 34.546 17.382 54.992 17.382 52.934 0 96-43.066 96-96 0-20.774-6.654-40.010-17.912-55.736l149.698-168.22-2.828-2.828zM512 639.876c-35.346 0-64-28.652-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-speedometer-outline"
    ]
  },
  {
    "paths": [
      "M834 557.484v-1.484h59.628c-1.862-46-12.112-91.218-29.662-132.302-17.286-40.456-41.006-77.33-70.514-109.124l-49.734 49.292-22.458-21.984 49.576-49.358c-32.374-29.672-69.72-53.484-111.030-70.784-42.848-17.946-87.806-27.556-133.806-29.368v67.628h-30v-67.628c-46 1.788-89.9 11.398-132.808 29.37-40.706 17.046-77.916 40.914-110.63 70.942l49.592 49.166-1.098 1.098 0.002 0.012-0.58 0.67-20.54 20.406-49.558-48.958c-29.54 31.864-53.208 68.486-70.352 108.618-17.546 41.080-27.794 86.304-29.654 132.304h57.626v32h-57.626c1.852 44 11.83 88.864 29.658 130.594 15.378 36.002 36.796 69.328 63.662 99.852 77.57-74.754 179.916-115.856 288.308-115.856 108.226 0 210.572 41.352 288.308 116.27 26.708-30.35 48.122-63.958 63.66-100.332 17.83-41.736 27.808-86.528 29.658-130.528h-59.628v-30.516zM608 575.876c0 52.934-43.066 96-96 96-20.446 0-39.402-6.446-54.992-17.382l-24.066 24.066-22.624-22.626 23.896-23.896c-11.444-15.804-18.212-35.204-18.212-56.16 0-52.934 43.066-96 96-96 20.004 0 38.594 6.158 53.988 16.668l146.968-131.454 2.828 2.828-125.698 152.22c11.258 15.726 17.912 34.962 17.912 55.736z",
      "M512 128c-247.424 0-448 200.452-448 447.876 0 113.95 42.566 217.94 112.632 297 7.102 8.012 14.482 15.64 22.132 23.124h44.386c63.426-78.206 160.288-128.192 268.848-128.192s205.424 49.986 268.85 128.192h44.386c7.65-7.484 15.032-15.114 22.132-23.124 70.066-79.060 112.632-183.050 112.632-297 0.002-247.424-200.574-447.876-447.998-447.876zM821.488 841.594c-6.102 6.816-12.784 13.726-20.426 21.128l-0.752 0.73-0.696-0.786c-5.258-5.94-10.986-11.97-17.518-18.44-0.55-0.542-1.11-1.078-1.668-1.614l-1.008-0.97c-34.516-33.532-74.468-59.934-118.75-78.476-47.070-19.712-97.090-29.708-148.672-29.708s-101.602 9.996-148.672 29.708c-44.28 18.542-84.234 44.946-118.75 78.476l-1.008 0.97c-0.558 0.536-1.116 1.070-1.666 1.614-6.532 6.468-12.26 12.5-17.518 18.44l-0.696 0.786-0.754-0.73c-7.642-7.402-14.324-14.312-20.424-21.128-67.028-74.882-103.942-171.258-103.942-271.37 0-109.332 43.004-212.106 121.090-289.388 78.082-77.278 181.904-119.836 292.342-119.836 110.44 0 214.26 42.558 292.34 119.836 78.086 77.284 121.090 180.058 121.090 289.388 0 100.112-36.912 196.486-103.942 271.37z",
      "M576 575.876c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-speedometer"
    ]
  },
  {
    "paths": [
      "M344.496 609.862l-109.354 318.146 276.858-197.268 276.89 197.268-109.37-318.134 280.48-195.874h-342.774l-105.226-317.99-105.196 317.99h-342.804l280.496 195.862zM512 201.5l82 246.5h262l-216 149.422 85.246 244.962-213.246-151.87v-489.014z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-star-half"
    ]
  },
  {
    "paths": [
      "M960 414h-342.8l-105.2-318.2-105.2 318.2h-342.8l280.4 195.8-109.2 318.2 276.8-197.2 276.8 197.2-109.4-318.2 280.6-195.8zM725.2 842.4l-213.2-152-213.2 152 85.2-245-216-149.4h262l82-246.6 82 246.6h262l-216 149.2 85.2 245.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-star-outline"
    ]
  },
  {
    "paths": [
      "M960 414h-342.8l-105.2-318.2-105.2 318.2h-342.8l280.4 195.8-109.2 318.2 276.8-197.2 276.8 197.2-109.4-318.2 280.6-195.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-star"
    ]
  },
  {
    "paths": [
      "M795.2 293.4l-3.6-3.4h36.8l17 15.6 45-45.6-81.6-80.6-46.4 44.6 17.6 18.4v37.2l-10-9.4c-62.6-56.6-140-90.4-226-97.8v-76.4h-64v76h-4c-87.4 6-170 45-232 106v-35.6l17.8-18.4-45.8-44.4-81.6 80.4 45 45.6 17-15.6h35.6c-0.6 0-1.4 1.4-2 2.2-65.6 70.2-102 161.8-102 257 0 208.8 172.2 378.8 384.2 378.8 211.6 0 383.8-169.8 383.8-378.6 0-95.2-36-186.2-100.8-256zM512.6 891.4c-191 0-346.2-153.4-346.2-341.8 0-188.6 155.4-341.8 346.2-341.8 191 0 346.2 153.4 346.2 341.8 0.2 188.4-155.2 341.8-346.2 341.8z",
      "M528 514.6v-258.6h-32v258.8c-25 8.6-48 33-48 60.6 0 29.4 20 54 48 61l16 35.6 16-35.6c28-7 48-31.6 48-61 0-29-21-53.4-48-60.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-stopwatch-outline"
    ]
  },
  {
    "paths": [
      "M795.2 293.4l-3.6-3.4h36.8l17 15.6 45-45.6-81.6-80.6-46.4 44.6 17.6 18.4v37.2l-10-9.4c-62.6-56.6-140-90.4-226-97.8v-76.4h-64v76h-4c-87.4 6-170 45-232 106v-35.6l17.8-18.4-45.8-44.4-81.6 80.4 45 45.6 17-15.6h35.6c-0.6 0-1.4 1.4-2 2.2-65.6 70.2-102 161.8-102 257 0 208.8 172.2 378.8 384.2 378.8 211.6 0 383.8-169.8 383.8-378.6 0-95.2-36-186.2-100.8-256zM528 636.4l-16 35.6-16-35.6c-28-7-48-31.6-48-61 0-27.6 23-52 48-60.6v-258.8h32v258.6c27 7.4 48 31.8 48 60.8 0 29.4-20 54-48 61z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-stopwatch"
    ]
  },
  {
    "paths": [
      "M494 192h36v112h-36v-112z",
      "M494 712h36v120h-36v-120z",
      "M720 494h112v36h-112v-36z",
      "M192 494h120v36h-120v-36z",
      "M740.521 704.572l-23.759 23.759-67.599-67.599 23.759-23.759 67.599 67.599z",
      "M387.088 350.959l-23.759 23.759-67.74-67.74 23.759-23.759 67.74 67.74z",
      "M716.67 283.491l23.759 23.759-67.599 67.599-23.759-23.759 67.599-67.599z",
      "M363.126 636.808l23.755 23.762-67.75 67.731-23.755-23.762 67.75-67.731z",
      "M512 663.6c-83.6 0-151.6-68-151.6-151.6s68-151.6 151.6-151.6c83.6 0 151.6 68 151.6 151.6s-68 151.6-151.6 151.6zM512 394.2c-65 0-117.8 52.8-117.8 117.8s52.8 117.8 117.8 117.8c65 0 117.8-52.8 117.8-117.8s-52.8-117.8-117.8-117.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-sunny-outline"
    ]
  },
  {
    "paths": [
      "M494 192h36v112h-36v-112z",
      "M494 712h36v120h-36v-120z",
      "M720 494h112v36h-112v-36z",
      "M192 494h120v36h-120v-36z",
      "M740.521 704.572l-23.759 23.759-67.599-67.599 23.759-23.759 67.599 67.599z",
      "M387.088 350.959l-23.759 23.759-67.74-67.74 23.759-23.759 67.74 67.74z",
      "M716.67 283.491l23.759 23.759-67.599 67.599-23.759-23.759 67.599-67.599z",
      "M363.126 636.808l23.755 23.762-67.75 67.731-23.755-23.762 67.75-67.731z",
      "M512 663.6c-83.6 0-151.6-68-151.6-151.6s68-151.6 151.6-151.6c83.6 0 151.6 68 151.6 151.6s-68 151.6-151.6 151.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-sunny"
    ]
  },
  {
    "paths": [
      "M831.8 671c-29.2-30-112.2-86.2-166.6-86.2-12.6 0-23.6 2.8-32.6 8.6-26.6 17-47.8 30.2-58 30.2-5.6 0-11.6-5-24.8-16.4l-2.2-2c-36.6-31.8-44.4-40-58.6-54.8l-3.6-3.8c-2.6-2.6-4.8-5-7-7.2-12.4-12.8-21.4-22-53.2-58l-1.4-1.6c-15.2-17.2-25.2-28.4-25.8-36.6-0.6-8 6.4-21 24.2-45.2 21.6-29.2 22.4-65.2 2.6-107-15.8-33-41.6-64.6-64.4-92.4l-2-2.4c-19.6-24-42.4-36-67.8-36-28.2 0-51.6 15.2-64 23.2-1 0.6-2 1.4-3 2-27.8 17.6-48 41.8-55.6 66.4-11.4 37-19 85 35.6 184.8 47.2 86.4 90 144.4 158 214.2 64 65.6 92.4 86.8 156 132.8 70.8 51.2 138.8 80.6 186.4 80.6 44.2 0 79 0 128.6-59.8 52-62.8 30.4-101.2-0.8-133.4zM808.8 782.8c-40 48.4-63 48.4-104.6 48.4-40.6 0-103.6-28-168.4-74.6-62-44.8-89.6-65.4-151.8-129.2-65.8-67.4-107.2-123.6-152.8-207-48.2-88.2-42.8-126.8-33-158.6 5.2-17 20.8-35.2 42-48.4 1-0.6 2-1.4 3.2-2 10.6-6.8 28.2-18.2 47.4-18.2 16 0 30.2 8 43.8 24.6l2 2.4c51 62.4 90.8 117.6 60.8 158.4-21.2 28.6-32.4 48-30.6 68 1.6 19.4 14.6 34 34.2 56l1.4 1.6c32.2 36.4 41.4 46 54.2 59 2.2 2.2 4.4 4.6 7 7.2l3.6 3.8c14.8 15.4 23 23.8 60.6 56.8l2.2 2c16 14 27.8 24.2 45 24.2 17.8 0 37.4-11.2 74.6-35 3.8-2.4 9.2-3.8 16-3.8 43.4 0 118.2 49.6 144.4 76.6 24 24.4 36 42.8-1.2 87.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-telephone-outline"
    ]
  },
  {
    "paths": [
      "M831.8 671c-29.2-30-112.2-86.2-166.6-86.2-12.6 0-23.6 2.8-32.6 8.6-26.6 17-47.8 30.2-58 30.2-5.6 0-11.6-5-24.8-16.4l-2.2-2c-36.6-31.8-44.4-40-58.6-54.8l-3.6-3.8c-2.6-2.6-4.8-5-7-7.2-12.4-12.8-21.4-22-53.2-58l-1.4-1.6c-15.2-17.2-25.2-28.4-25.8-36.6-0.6-8 6.4-21 24.2-45.2 21.6-29.2 22.4-65.2 2.6-107-15.8-33-41.6-64.6-64.4-92.4l-2-2.4c-19.6-24-42.4-36-67.8-36-28.2 0-51.6 15.2-64 23.2-1 0.6-2 1.4-3 2-27.8 17.6-48 41.8-55.6 66.4-11.4 37-19 85 35.6 184.8 47.2 86.4 90 144.4 158 214.2 64 65.6 92.4 86.8 156 132.8 70.8 51.2 138.8 80.6 186.4 80.6 44.2 0 79 0 128.6-59.8 52-62.8 30.4-101.2-0.8-133.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-telephone"
    ]
  },
  {
    "paths": [
      "M928 512c0-229.726-186.26-416-416-416-229.726 0-416 186.272-416 416 0 229.726 186.274 416 416 416 5.082 0 10.136-0.124 15.174-0.304 0.958-0.034 1.914-0.068 2.87-0.11 1.884-0.080 3.768-0.166 5.646-0.272 1.7-0.094 3.396-0.208 5.094-0.322 1.278-0.088 2.558-0.16 3.834-0.26 2.708-0.208 5.41-0.442 8.11-0.704 0-0.006 0-0.012 0-0.018 194.94-18.948 350.458-172.458 372.548-366.446 0.040-0.002 0.076 0 0.114-0.002 1.208-10.63 2.004-21.334 2.392-32.1-0.032 0.002-0.064 0.002-0.098 0.002 0.19-5.132 0.316-10.282 0.316-15.464zM893.33 512c0 5.136-0.132 10.242-0.334 15.328-47.278-2.152-93.354-12.212-137.232-30.010-51.582-20.916-97.876-51.662-137.594-91.382-39.72-39.72-70.466-86.014-91.384-137.594-17.806-43.912-27.87-90.028-30.012-137.34 5.054-0.2 10.126-0.33 15.228-0.33 210.258-0.002 381.328 171.066 381.328 381.328zM130.674 512c0-2.636 0.046-5.262 0.1-7.884 44.952 2.758 88.776 12.674 130.6 29.634 51.582 20.916 97.876 51.662 137.596 91.382 39.72 39.718 70.464 86.014 91.382 137.596 16.948 41.792 26.86 85.584 29.628 130.498-2.656 0.054-5.312 0.102-7.98 0.102-210.26-0-381.328-171.068-381.326-381.328zM551.886 891.246c-6.546-105.132-49.948-208.396-130.29-288.738-80.372-80.372-183.68-123.778-288.854-130.3 18.344-176.106 157.040-316.956 332.148-338.626 5.19 107.28 48.72 213.050 130.652 294.98 81.898 81.904 187.622 125.426 294.866 130.644-21.706 175.030-162.494 313.658-338.522 332.040z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-tennisball-outline"
    ]
  },
  {
    "paths": [
      "M96.1 503.112c-0.002 0.078-0.006 0.154-0.008 0.232 0 0 0.004 0 0.006 0 0-0.076 0-0.154 0.002-0.232z",
      "M520.622 927.83c0.132-0.004 0.266-0.012 0.398-0.014-0.132 0.002-0.266 0.002-0.398 0.008 0-0 0 0.002 0 0.006z",
      "M512 96.002c-5.172 0-10.58 0.128-15.704 0.316l-0.296-0.012c0 0.006 0 0.008 0 0.012-10 0.398-20 1.204-32 2.41 0-0.004 0-0.008 0-0.016 0 0.010 0.166 0.016 0.144 0.024-193.948 22.122-347.308 177.95-366.26 372.82-0.008 0.036 0.090 0.444 0.084 0.444 0.006 0 0.008 0 0.014 0-1.026 10-1.652 20-1.872 32-0.002 0-0.006 0-0.008 0l0.006-0.304c-0.056 2.86-0.108 5.554-0.108 8.43 0 229.704 185.954 415.876 415.682 415.876 13.712 0 28.318-0.766 40.318-2.062 0 0.004 0 0.012 0 0.012 0-0.008 0.426-0.016 0.48-0.028 194.872-18.972 350.494-172.172 372.624-366.072 0.008-0.028 0.176 0.148 0.184 0.148-0.004 0-0.012 0-0.016 0 1.778-16 2.726-31.718 2.726-47.808 0.002-229.702-186.258-416.19-415.998-416.19zM261.26 533.706c-41.79-16.948-85.576-26.86-130.488-29.632 0.22-10.748 0.876-21.39 1.972-31.904 105.136 6.55 208.406 49.954 288.75 130.292s123.752 183.594 130.304 288.718c-10.514 1.096-21.158 1.752-31.908 1.97-2.77-44.906-12.684-88.688-29.632-130.472-20.918-51.58-51.668-97.874-91.392-137.59-39.722-39.72-86.020-70.466-137.606-91.382zM595.444 428.53c-81.928-81.918-125.462-187.67-130.664-294.934 10.5-1.304 21.136-2.16 31.882-2.586 2.146 47.3 12.21 93.404 30.014 137.308 20.922 51.58 51.67 97.872 91.392 137.59 39.724 39.718 86.020 70.464 137.606 91.382 43.908 17.802 90.016 27.866 137.32 30.014-0.426 10.74-1.286 21.378-2.586 31.878-107.28-5.204-213.036-48.732-294.964-130.652z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-tennisball"
    ]
  },
  {
    "paths": [
      "M624 544h-80l32-96h-144l-30 160h104.6l-58.6 192z",
      "M656.8 345.4c-5.4 0-10.8 0-16 0.6-15.8-70-78.2-122.8-152.8-122.8-86.6 0-156.6 70.4-156.6 157 0 5.2 0.2 10.4 0.8 15.6-52.8 4.6-94.2 51.4-94.2 105.6 0 57.2 46.4 106.6 103.4 106.6h22.6v-34h-22.6c-19 0-37-8.2-50.8-22-13.6-14-21.2-32.6-21.2-52 0-37.2 29-67.6 66.4-73.8 3.2-0.6 17.6-2.6 28.4-3.6 0 0-1-10.6-1.2-19.2s-0.2-18.8-0.2-23c0-69.2 56.2-125.4 125.2-125.4 29 0 56.2 9.6 78.6 27.8 21.8 17.8 37.2 42.6 43.4 69.8l6.2 28 28.4-3.6c4.2-0.6 8.2-0.8 12.2-0.8 53.8 0 97.6 44.6 97.6 98.8s-43.8 98.8-97.6 98.8h-16.8v34h16.8c71.4 0 129.2-60.2 129.2-131.8 0-71.2-57.8-130.6-129.2-130.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-thunderstorm-outline"
    ]
  },
  {
    "paths": [
      "M544 544l32-96h-144l-30 160h104.6l-58.6 192 176-256z",
      "M405.4 416h215l-32 96h96.4l-66 96h38c71.4 0 129.2-60.2 129.2-131.8s-57.8-131-129.2-131c-5.4 0-10.8 0-16 0.6-15.8-70-78.2-122.8-152.8-122.8-86.6 0-156.6 70.4-156.6 157 0 5.2 0.2 10.4 0.8 15.6-52.8 4.6-94.2 51.4-94.2 105.6 0 57.2 46.4 106.6 103.4 106.6h28z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-thunderstorm"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448c247.4 0 448-200.6 448-448s-200.6-448-448-448zM806.2 806.2c-38.2 38.2-82.8 68.2-132.2 89.2-51.2 21.6-105.8 32.6-162 32.6s-110.6-11-162-32.6c-49.6-21-94-51-132.2-89.2s-68.2-82.8-89.2-132.2c-21.6-51.4-32.6-105.8-32.6-162s11-110.6 32.6-162c21-49.6 51-94 89.2-132.2s82.8-68.2 132.2-89.2c51.4-21.6 105.8-32.6 162-32.6s110.6 11 162 32.6c49.6 21 94 51 132.2 89.2s68.2 82.8 89.2 132.2c21.6 51.2 32.6 105.8 32.6 162s-11 110.6-32.6 162c-21 49.4-51 94-89.2 132.2z",
      "M528 160c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M528 864c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M880 512c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M176 512c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M352 207.2c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M704 816.8c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M832.8 336c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M223.2 688c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M223.2 336c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M832.8 688c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M704 207.2c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M352 816.8c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M539.8 496c-5.8-10-16.2-15.6-26.8-16l-76-126.8c-4.6-7.6-14.4-10-22-5.4s-10 14.4-5.4 22l75.2 125.8c-5.8 9.6-6.4 22.2-0.4 32.6 3 5 7 9 11.8 11.6v244.2c0 8.8 7.2 16 16 16s16-7.2 16-16v-244.2c15.2-9 20.4-28.4 11.6-43.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-time-outline"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448c247.4 0 448-200.6 448-448s-200.6-448-448-448zM512 144c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zM160 528c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM215.2 701.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8c7.6-4.4 17.4-1.8 21.8 5.8s1.8 17.4-5.8 21.8zM221 344c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8 14.2-10.2 21.8-5.8c7.6 4.4 10.2 14.2 5.8 21.8zM328 193.4c7.6-4.4 17.4-1.8 21.8 5.8s1.8 17.4-5.8 21.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8zM349.8 824.8c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8zM512 880c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM528 539.8v244.2c0 8.8-7.2 16-16 16s-16-7.2-16-16v-244.4c-4.8-2.8-8.8-6.6-11.8-11.6-6-10.4-5.4-23 0.4-32.6l-75.2-125.8c-4.6-7.6-2-17.4 5.4-22 7.6-4.6 17.4-2 22 5.4l76 126.8c10.8 0.2 21.2 6 26.8 16 9 15.6 3.8 35-11.6 44zM696 830.6c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8c7.6-4.4 17.4-1.8 21.8 5.8s1.8 17.4-5.8 21.8zM701.8 215.2c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8zM830.6 696c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8c4.4-7.6 14.2-10.2 21.8-5.8s10.4 14.2 5.8 21.8zM824.8 349.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8c7.6-4.4 17.4-1.8 21.8 5.8 4.6 7.6 1.8 17.4-5.8 21.8zM864 528c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-time"
    ]
  },
  {
    "paths": [
      "M473.2 543.2c9.2 11.4 23 18.8 38.8 18.8 27.6 0 50-22.4 50-50 0-14.6-6.4-27.6-16.4-36.8-1.2-1.4-2.6-3-4.4-4.4 0 0-235.4-175-240.6-170.4s170.6 240.4 170.6 240.4c0.4 0.8 1.4 1.6 2 2.4z",
      "M512.4 96v0h-0.4v224h32v-189.4c195.6 16.6 350.6 181 350.6 381 0 211-171.4 382.8-382.4 382.8s-382.6-171.6-382.6-382.6c0-105.6 43-201.2 112.2-270.4l-23.8-23.6c-75.4 75.4-122 179.4-122 294.2 0 229.8 186.2 416 416 416s416-186.2 416-416c0-229.8-186-416-415.6-416z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-timer-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM301 301c5.2-4.6 239.8 169.8 239.8 169.8 2 1.4 3.2 3 4.4 4.4 10 9.2 16.4 22 16.4 36.6 0 27.4-22.2 49.8-49.8 49.8-15.6 0-29.4-7.4-38.6-18.8-0.8-0.8-1.6-1.4-2.2-2.2 0.2 0.2-175-234.8-170-239.6zM512.2 894.4c-211.4 0-382.8-171.4-382.8-382.8 0-105.6 42.8-201.4 112-270.6l23.6 23.6c-63.2 63.2-102.4 150.6-102.4 247 0 192.6 156.8 349.4 349.4 349.4s349-156.8 349-349.4c0-180.6-141-330.2-317-348v156.4h-32v-191.2c211.4 0 383 171.4 383 382.8s-171.6 382.8-382.8 382.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-timer"
    ]
  },
  {
    "paths": [
      "M256 640c52.934 0 96 43.066 96 96s-43.066 96-96 96-96-43.066-96-96 43.066-96 96-96zM256 608c-70.692 0-128 57.308-128 128 0 70.694 57.308 128 128 128s128-57.306 128-128c0-70.692-57.308-128-128-128v0z",
      "M766.5 576c88.776 0 161.25 72.224 161.25 161s-71.974 159-160.75 159h-510c-88.776 0-161-70.224-161-159s72.224-161 161-161h509zM767 544h-510c-106.59 0-193 86.41-193 193s86.41 191 193 191h510c106.59 0 193-84.41 193-191s-86.41-193-193-193v0z",
      "M768 192c52.934 0 96 43.066 96 96s-43.066 96-96 96-96-43.066-96-96 43.066-96 96-96zM768 160c-70.692 0-128 57.308-128 128 0 70.694 57.308 128 128 128s128-57.306 128-128c0-70.692-57.308-128-128-128v0z",
      "M258 128h509c88.776 0 161 72.224 161 161s-72.224 159-161 159h-510c-88.776 0-160.75-70.224-160.75-159s72.474-161 161.25-161zM257 96c-106.59 0-193 86.41-193 193s86.41 191 193 191h510c106.59 0 193-84.41 193-191s-86.41-193-193-193h-510z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-toggle-outline"
    ]
  },
  {
    "paths": [
      "M256 640c-52.934 0-96 43.066-96 96s43.066 96 96 96 96-43.066 96-96-43.066-96-96-96z",
      "M767 544h-510c-106.59 0-193 86.41-193 193s86.41 191 193 191h510c106.59 0 193-84.41 193-191s-86.41-193-193-193zM256 864c-70.692 0-128-57.306-128-128 0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.694-57.308 128-128 128z",
      "M768 384c52.934 0 96-43.066 96-96s-43.066-96-96-96-96 43.066-96 96 43.066 96 96 96z",
      "M257 480h510c106.59 0 193-84.41 193-191s-86.41-193-193-193h-510c-106.59 0-193 86.41-193 193s86.41 191 193 191zM768 160c70.692 0 128 57.308 128 128 0 70.694-57.308 128-128 128s-128-57.306-128-128c0-70.692 57.308-128 128-128z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-toggle"
    ]
  },
  {
    "paths": [
      "M800 226.6h-160v-40c0-32.4-26.2-58.6-58.6-58.6h-139c-32.2 0-58.4 26.2-58.4 58.6v40h-160v29.4h42.2l47.2 581.4c0 32.4 26.2 58.6 58.6 58.6h282c32.4 0 58.6-26.2 58.6-58.6l46.6-581.4h40.8v-29.4zM413.2 186.6c0-16.2 13.2-29.4 29.2-29.4h139c16.2 0 29.2 13.2 29.2 29.4v40h-197.4v-40zM683.2 835.8v1.6c0 16.2-13.2 29.4-29.2 29.4h-282c-16.2 0-29.2-13.2-29.2-29.4v-1.6l-47.4-579.8h434.4l-46.6 579.8z",
      "M498 320h28v482h-28v-482z",
      "M640 320h-29.2l-21.4 482h29.2z",
      "M413 320h-29l21.4 482h29.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-trash-outline"
    ]
  },
  {
    "paths": [
      "M640 226v-39.4c0-32.4-26.2-58.6-58.6-58.6h-139c-32.2 0-58.4 26.2-58.4 58.6v39.4h-160v30h42.2l47.2 581.4c0 32.4 26.2 58.6 58.6 58.6h282c32.4 0 58.6-26.2 58.6-58.6l46.6-581.4h40.8v-30h-160zM414 186.6c0-16.2 12.4-28.6 28.6-28.6h139c16.2 0 28.6 12.4 28.6 28.6v39.4h-196v-39.4h-0.2zM405.4 802l-21.4-482h29l21.8 482h-29.4zM526 802h-28v-482h28v482zM618.6 802h-29.2l21.6-482h29l-21.4 482z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-trash"
    ]
  },
  {
    "paths": [
      "M895.8 736.4c0-33.6 7.2-166.2-97.4-271.4-70.4-70.8-160.6-106.8-286.6-112.4v-160.6l-383.8 256 384 256v-159.6c80 2.2 124.8 18.2 173.4 40 61.8 27.6 110.6 88 151.6 153.2l38.4 62.4h20.6c0-20.2-0.2-45.8-0.2-63.6zM864.4 722.8c-95.2-161.6-202.4-210.8-384.4-210.8v129.6l-296.2-193.4 296.2-193.6v129.4c402 0 384.4 338.8 384.4 338.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-undo-outline"
    ]
  },
  {
    "paths": [
      "M895.8 736.4c0-33.6 7.2-166.2-97.4-271.4-70.4-70.8-160.6-106.8-286.6-112.4v-160.6l-383.8 256 384 256v-159.6c80 2.2 124.8 18.2 173.4 40 61.8 27.6 110.6 88 151.6 153.2l38.4 62.4h20.6c0-20.2-0.2-45.8-0.2-63.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-undo"
    ]
  },
  {
    "paths": [
      "M512 576c-35.346 0-64 28.654-64 64 0 29.82 20.396 54.878 48 61.984v66.016h32v-66.016c27.604-7.106 48-32.164 48-61.984 0-35.346-28.654-64-64-64zM512 672c-17.644 0-32-14.356-32-32s14.356-32 32-32 32 14.356 32 32-14.356 32-32 32z",
      "M336 448v-144c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v16h32v-16c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-496zM800 896h-576v-416h576v416z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-unlocked-outline"
    ]
  },
  {
    "paths": [
      "M512 608c-17.644 0-32 14.356-32 32s14.356 32 32 32 32-14.356 32-32-14.356-32-32-32z",
      "M336 448v-144c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v16h32v-16c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-496zM528 701.984v66.016h-32v-66.016c-27.604-7.106-48-32.164-48-61.984 0-35.346 28.654-64 64-64s64 28.654 64 64c0 29.82-20.396 54.878-48 61.984z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-unlocked"
    ]
  },
  {
    "paths": [
      "M576 288v32h224v544h-576v-544h224v-32h-256v608h640v-608z",
      "M386.2 236.2l-23.2-23.2 149-149 149 149-23.2 23.2-109.4-109.4v486h-32.8v-486z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-upload-outline"
    ]
  },
  {
    "paths": [
      "M528 288v324h-32v-324h-304v608h640v-608z",
      "M528 126.8l109.6 109.4 23.2-23.2-148.8-149-149 149 23.4 23.2 109.6-109.4v161.2h32z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-upload"
    ]
  },
  {
    "paths": [
      "M607.4 256h-442c-37.6 0-71.4 28.2-71.4 65.4v375.8c0 37.2 33.8 70.8 71.4 70.8h442c37.6 0 66.6-33.6 66.6-70.8v-375.8c0-37.2-29-65.4-66.6-65.4zM640 697.2c0 18.6-13.8 36.8-32.6 36.8h-442c-18.8 0-37.4-18.2-37.4-36.8v-375.8c0-18.6 18-31 36.8-31l442 0.2c18.8 0 33.2 12.2 33.2 30.8v375.8z",
      "M734 426v171.2l196 106.8v-384l-196 106zM896 380v264.6l-128-67v-131.2l128.2-67.2-0.2 0.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-videocam-outline"
    ]
  },
  {
    "paths": [
      "M607.4 256h-442c-37.6 0-71.4 28.2-71.4 65.4v375.8c0 37.2 33.8 70.8 71.4 70.8h442c37.6 0 66.6-33.6 66.6-70.8v-375.8c0-37.2-29-65.4-66.6-65.4z",
      "M734 426v171.2l196 106.8v-384l-196 106z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-videocam"
    ]
  },
  {
    "paths": [
      "M748.2 256l-27.2 20.6c48.2 65.8 77 147.2 77 235.4s-28.8 169.6-77.2 235.4l27.2 20.6c52.6-71.4 83.8-160 83.8-256s-31-184.6-83.6-256z",
      "M640 703.6c40-53.6 64-119.8 64-191.6s-24-138-64-191.6l-27.2 20.2c35.8 48 57.2 107.2 57.2 171.4s-21.4 123.4-57.2 171.4l27.2 20.2z",
      "M546.2 639.8c27.4-35.8 43.8-79.8 43.8-127.8s-16.4-92-43.8-127.8l-27 19.6c23.2 30.2 37 67.6 37 108.2s-13.8 77.8-37 108.2l27 19.6z",
      "M307.8 432h-115.8v160h115.8l140.2 112v-384z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-volume-high"
    ]
  },
  {
    "paths": [
      "M499.8 432h-115.8v160h115.8l140.2 112v-384z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-volume-low"
    ]
  },
  {
    "paths": [
      "M528 617.976c0-43.95 40.916-77.348 80.494-109.648 15.814-12.906 30.74-25.094 43.038-37.924 53.094-55.394 52.468-103.488 52.468-142.116v-8.288c0-88.5-61.632-249.116-64.040-256h-255.96c-2.406 6.884-64 167-64 256v8.288c0 38.546-0.646 86.722 52.45 142.118 12.296 12.83 27.234 25.018 43.046 37.924 39.578 32.3 80.504 65.7 80.504 109.648v310.022h-144v32h320v-32h-144v-310.024zM405.458 96h213.044c10.718 31.98 39.018 125.424 49.672 192h-312.386c10.654-66.576 38.952-160.020 49.67-192zM512 546.832c-5.936 0-10.496-1.84-14.34-5.508 0.002 0.018 0.006 0.036 0.010 0.052-17.608-21.614-40.468-40.316-61.942-57.84-15.034-12.27-29.234-23.858-40.178-35.274-44.108-46.016-43.856-81.832-43.59-119.75 0.020-2.856-0.136-5.698 0.040-8.51h319.96c0.176 2.812 0.020 5.656 0.042 8.51 0.266 37.918 0.518 73.734-43.59 119.75-10.944 11.416-25.14 23.004-40.174 35.274-21.474 17.524-44.33 36.228-61.938 57.84 0.004-0.018 0.018-0.036 0.020-0.052-3.844 3.668-8.32 5.508-14.32 5.508z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-wineglass-outline"
    ]
  },
  {
    "paths": [
      "M528 617.976c0-43.95 40.916-77.348 80.494-109.648 15.814-12.906 30.74-25.094 43.038-37.924 53.094-55.394 52.468-103.488 52.468-142.116v-8.288c0-88.5-61.632-249.116-64.040-256h-255.96c-2.406 6.884-64 167-64 256v8.288c0 38.546-0.646 86.722 52.45 142.118 12.296 12.83 27.234 25.018 43.046 37.924 39.578 32.3 80.504 65.7 80.504 109.648v310.022h-144v32h320v-32h-144v-310.024zM405.458 96h213.044c10.718 31.98 39.018 125.424 49.672 192h-312.386c10.654-66.576 38.952-160.020 49.67-192z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-wineglass"
    ]
  },
  {
    "paths": [
      "M512 96c-0.2 0-0.2 0-0.4 0 0 0 0 0-0.2 0s-0.4 0-0.4 0c-229.4 0.6-415 186.6-415 416s185.6 415.4 415 416c0.2 0 0.4 0 0.4 0s0.2 0 0.2 0 0.2 0 0.4 0c229.8 0 416-186.2 416-416s-186.2-416-416-416zM528.6 345c44.2-1.2 87-7 128.4-17 12.4 49 20.2 105.6 21.4 167.6h-149.8v-150.6zM528.6 311.6v-179.6c44.8 12.4 90.4 72.2 119.2 164-38.4 9.2-78.2 14.4-119.2 15.6zM495.4 131.6v180.2c-41.4-1.2-81.6-6.6-120.2-16 29.2-92.4 75-152.6 120.2-164.2zM495.4 345v150.4h-150.8c1.2-62 9-118.6 21.4-167.6 41.6 10 85 16 129.4 17.2zM311 495.4h-181.2c3.6-85.6 35.6-164 86.6-226 37 20.4 76.4 37.2 117.6 49.6-13.6 53-21.6 112.8-23 176.4zM311 528.6c1.2 63.4 9.2 123.4 22.8 176.4-41.2 12.6-80.4 29.2-117.6 49.6-51-62-82.8-140.4-86.6-226h181.4zM344.6 528.6h150.8v150.2c-44.4 1.2-87.8 7.2-129.4 17.4-12.4-49-20.2-105.6-21.4-167.6zM495.4 712.2v180.4c-45.2-11.8-91-71.8-120.2-164.2 38.6-9.6 78.8-15 120.2-16.2zM528.6 892v-180c41 1.2 80.8 6.6 119.4 15.8-29 92-74.4 151.8-119.4 164.2zM528.6 678.8v-150.2h149.8c-1.2 61.8-9 118.4-21.4 167.4-41.4-10-84.2-16-128.4-17.2zM711.8 528.6h182.4c-3.6 85.6-35.6 163.8-86.6 226-37.4-20.6-77-37.4-118.6-50 13.6-53 21.6-112.6 22.8-176zM711.8 495.4c-1.2-63.4-9.2-123.2-22.6-176.2 41.6-12.6 81.2-29.4 118.4-49.8 51 62 83 140.4 86.6 226.2h-182.4zM784.8 243.8c-33.2 17.6-68 32.2-104.6 43.2-19.4-62.6-46.8-113.6-79-147.2 70.8 17 134 53.8 183.6 104zM421.6 140.2c-32.2 33.4-59.4 84.4-78.6 146.6-36.2-11-70.8-25.4-103.6-43 49-50 111.8-86.6 182.2-103.6zM239.2 780c32.8-17.6 67.6-32 103.6-43 19.4 62.4 46.6 113.2 78.8 146.8-70.4-17-133.2-53.6-182.4-103.8zM601.2 884.2c32.4-33.6 59.6-84.6 79.2-147.4 36.6 11 71.4 25.6 104.6 43.2-49.6 50.4-113 87.2-183.8 104.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-world-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-0.2 0-0.2 0-0.4 0 0 0 0 0-0.2 0s-0.4 0-0.4 0c-229.4 0.6-415 186.6-415 416s185.6 415.4 415 416c0.2 0 0.4 0 0.4 0s0.2 0 0.2 0 0.2 0 0.4 0c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 894.8c-0.2 0-0.2 0-0.4 0 0 0 0 0-0.2 0s-0.4 0-0.4 0c-210.8-0.6-381.8-171.8-381.8-382.8s170.8-382.2 381.8-382.6c0.2 0 0.2 0 0.4 0 0 0 0.2 0 0.2 0 0.2 0 0.2 0 0.4 0 211.4 0 382.8 171.4 382.8 382.8 0 211.2-171.4 382.6-382.8 382.6z",
      "M644.6 343.6c-37.4 9-76 14.4-115.8 15.6v136.2h135.2c-1.2-56.2-8.2-107.2-19.4-151.8z",
      "M528.6 165v163.8c37-1.2 73-6 107.6-14.4-26.2-82.8-67-137.2-107.6-149.4z",
      "M386.8 314.2c35 8.4 71.2 13.4 108.4 14.6v-164.2c-40.6 11.8-82 66.2-108.4 149.6z",
      "M761.2 266.8c-45.2-46-103-79.6-167.8-95 29.6 30.6 54.4 77.4 72.2 134.6 33.4-10.2 65.4-23.4 95.6-39.6z",
      "M694.6 495.4h166.6c-3.6-77.6-32.6-148.8-79-205.2-34.2 18.8-70.4 34.2-108.2 45.6 12.2 48 19.4 102.2 20.6 159.6z",
      "M359 495.4h136.4v-136.2c-40.2-1.2-79.2-6.6-116.8-15.8-11.4 44.6-18.4 95.8-19.6 152z",
      "M664 528.6h-135.4v136c39.8 1.2 78.6 6.4 116 15.6 11.2-44.4 18.2-95.6 19.4-151.6z",
      "M378.6 680.4c37.6-9.2 76.6-14.6 116.8-15.8v-136h-136.4c1.2 56.2 8.2 107.4 19.6 151.8z",
      "M495.4 859.2v-164.2c-37.2 1.2-73.6 6.2-108.6 14.6 26.4 83.4 67.8 138 108.6 149.6z",
      "M593.4 852.2c64.8-15.6 122.6-49 168-95.2-30.2-16.2-62.2-29.4-95.6-39.6-17.8 57.4-42.8 104-72.4 134.8z",
      "M429.4 172.2c-64.2 15.6-121.6 49-166.6 94.8 30 16 61.6 29.2 94.6 39.2 17.8-57 42.6-103.4 72-134z",
      "M674 688.2c38 11.4 74.2 26.8 108.4 45.6 46.4-56.4 75.4-127.6 79-205.2h-166.6c-1.4 57.4-8.6 111.4-20.8 159.6z",
      "M528.6 695v164c40.6-12.2 81.4-66.6 107.6-149.6-34.6-8.4-70.6-13.2-107.6-14.4z",
      "M349.2 335.6c-37.6-11.4-73.6-26.6-107.4-45.4-46.4 56.4-75.4 127.6-79 205.2h165.8c1-57.6 8.4-111.8 20.6-159.8z",
      "M328.4 528.6h-165.8c3.6 77.6 32.6 148.8 79 205.2 33.8-18.6 69.8-34 107.4-45.4-12-48-19.4-102.2-20.6-159.8z",
      "M262.6 757c45 45.8 102.4 79.2 166.8 94.8-29.4-30.6-54.2-77.2-72-134.2-33 10.2-64.8 23.4-94.8 39.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ios-world"
    ]
  },
  {
    "paths": [
      "M224 145.6v732.8c0 9.8 7.8 17.6 17.6 17.6h540.8c9.8 0 17.6-7.8 17.6-17.6v-732.8c0-9.8-7.8-17.6-17.6-17.6h-540.8c-9.8 0-17.6 7.8-17.6 17.6zM512 875.2c-15 0-27.2-12-27.2-27s12.2-27.2 27.2-27.2c14.8 0 27 12.2 27 27.2 0.2 15-12 27-27 27zM288 237.2c0-7 5.4-13.2 12-13.2h422.4c6.8 0 13.6 6.2 13.6 13.2v550.4c0 7-6.8 12.6-13.6 12.6h-422.4c-6.8 0-12-5.6-12-12.6v-550.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-ipad"
    ]
  },
  {
    "paths": [
      "M656.4 128h-288.8c-26.2 0-47.6 21.4-47.6 47.8v672.6c0 26.2 21.4 47.6 47.6 47.6h288.6c26.2 0 47.6-21.4 47.6-47.6v-672.6c0.2-26.4-21.2-47.8-47.4-47.8zM480 199.8c0-4.2 3.4-7.8 7.8-7.8h48.6c4.2 0 7.8 3.4 7.8 7.8v0.6c0 4.2-3.4 7.8-7.8 7.8h-48.6c-4.2 0-7.8-3.4-7.8-7.8v-0.6zM456 192c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8c0-4.4 3.6-8 8-8zM512 864.2c-17.8 0-32.2-14.4-32.2-32.2s14.4-32.2 32.2-32.2c17.8 0 32.2 14.4 32.2 32.2s-14.6 32.2-32.2 32.2zM672 768h-320v-512h320v512z"
    ],
    "grid": 0,
    "tags": [
      "ion-iphone"
    ]
  },
  {
    "paths": [
      "M512 622c-35.4 0-64 28.6-64 64 0 35.2 28.6 64 64 64 35.2 0 64-28.6 64-64s-28.6-64-64-64z",
      "M680.8 128h-337.6c-30.4 0-55.2 24.4-55.2 55.4v657.4c0 31 24.8 55.4 55.2 55.4h337.6c30.4 0 55.2-24.4 55.2-55.4v-657.4c0-31-24.8-55.4-55.2-55.4zM512.2 832.2c-79.6 0-144.2-64.4-144.2-144 0-79.4 64.6-144 144.2-144 79.4 0 143.8 64.6 143.8 144 0 79.6-64.4 144-143.8 144zM671.8 453.6c-1.6 15.2-14 26.4-29.4 26.4h-262c-16.4 0-28.4-12.4-28.4-29.2v-229c0-15 10-27.4 24-29.8h271.6c13 2.4 23 13.2 24.4 26.6l-0.2 235z"
    ],
    "grid": 0,
    "tags": [
      "ion-ipod"
    ]
  },
  {
    "paths": [
      "M629.6 737l208.4 69-6-105.4-228-206.6c0 0-51.8-347.4-56.4-384.6-10.6-80.6-35.8-109.4-35.8-109.4s-25 28.8-35.2 109.2c-4.8 37.4-56.6 384.8-56.6 384.8l-228 206.6-6 105.4 208.4-69 2.8 24.6-105.4 116.6 36.6 54.8 146.6-18.2 36.6 109.2 37-109.2 146.8 18.2 36.6-54.8-105.4-116.6 3-24.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-jet"
    ]
  },
  {
    "paths": [
      "M608.6 602c0 0-10.8-56-14.6-180s-18-285-18-285c-5-56-23.6-73-64-73-18.8 0-41 4.6-46.6 6.6-18.8 7.2-17.4 23.2-17.4 45v35.6c0 6.4 2.4 12 6.4 16.4l9.8 9.8c0.8 0.6 0.2 1.4 0.8 2 3.8 4.4 6.2 10 6.2 16.2v49c0 6.4-2.4 6.4-6.4 10.6-0.4 0.6-1 1.2-1.6 1.6l-8.8 8.8c-0.2 0.2-0.6 0.6-0.8 0.8-4.2 4.4-6.8 10.4-6.8 16.8v14.4c0 6.2 2.2 11.8 6.2 16.2 0 0 0.2 0.2 0.2 0.2l1.6 1.6c0 0 0.2 0.2 0.2 0.2l8 8c0.8 0.6 1.4 1.4 2 2 3.8 4.4 6.2 10 6.2 16.2 0 1.4-0.2 16.2-0.4 17.6-0.8 4.6-3 8.8-6 12.2-0.4 0.6-1 1.2-1.6 1.6l-7.8 7.8-2.8 3c-1 1.2-1.4 2.6-2.2 4.2-1.8 3.4-2.4 7.4-2.4 11.8v15.6c0 5.8-0.2 11.4-0.4 17.2 0.4 4.8 14.4 11.4 14.4 21v40.8c0 12.4-21 14-22 22.6-9.4 50.8-23.8 83.6-23.8 83.6-57.4 33.2-96 95.2-96 166.4 0 106 86 192 192 192s192-86 192-192c-0.2-70.2-38.6-132-95.6-165.4zM512 896c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-key"
    ]
  },
  {
    "paths": [
      "M571.4 64c-6.6 0-12 2.8-16 7.6-37.4 45.8-107.4 160.6-107.4 428.6 0 78.4 66 78.4 64 138.8 0 0.2 0 0.6 0 0.8-4 94.2-29.8 222.2-32 260.6-0.8 30.4 19.4 59.6 48.2 59.6 0.2 0 0.2 0 0.4 0 0 0 0.2 0 0.4 0 28.8 0 47-28.8 47-59.2v-824.2c0-10-1-12.6-4.6-12.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-knife"
    ]
  },
  {
    "paths": [
      "M960 212.6c0-11.2-8.2-20.6-19.2-20.6h-856.4c-11 0-20.4 9.2-20.4 20.6v523.4h896v-523.4zM896 672h-768v-416h768v416z",
      "M0 777.4c140.4 39.8 231.6 54.6 512 54.6s371.6-14.6 512-54.6v-9.4h-1024v9.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-laptop"
    ]
  },
  {
    "paths": [
      "M913.4 757.4c-105-16-113-31.4-113-31.4 21.6-129.8-45.4-294.2-154.8-383.2-145.6-118.4-367-32.4-539.4-212.4-40.2-42-16.8 471 199 665.4 157.8 142 343.6 98.4 394.6 75.2 46.2-21.2 78.6-59.8 78.6-59.8 84.2 26 125.8 24.4 125.8 24.4 29.6 3.6 44.6-72.8 9.2-78.2zM721.2 766.2c-276.4-81.8-484.2-369-484.2-369s182.4 215.4 504 320.4c0.4 16.2-9.2 39.4-19.8 48.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-leaf"
    ]
  },
  {
    "paths": [
      "M254 198.4v-38.4c0-17.6-14.4-32-32-32s-32 14.4-32 32v43c-17 11.6-28 31-28 53s11 41.4 28 53v555c0 17.6 14.4 32 32 32s32-14.4 32-32v-550.4c21.4-10.4 36-32.2 36-57.6s-14.6-47.2-36-57.6z",
      "M446 585.8v-425.8c0-17.6-14.4-32-32-32s-32 14.4-32 32v423.4c-20.2 10.8-34 32-34 56.6s13.8 45.8 34 56.6v167.4c0 17.6 14.4 32 32 32s32-14.4 32-32v-169.8c18-11.4 30-31.4 30-54.2s-12-42.8-30-54.2z",
      "M638 326.6v-166.6c0-17.6-14.4-32-32-32s-32 14.4-32 32v166.6c-19.2 11-32 31.8-32 55.4s12.8 44.4 32 55.4v426.6c0 17.6 14.4 32 32 32s32-14.4 32-32v-426.6c19.2-11 32-31.8 32-55.4s-12.8-44.4-32-55.4z",
      "M862 766c0-23.6-12.8-44.4-32-55.4v-550.6c0-17.6-14.4-32-32-32s-32 14.4-32 32v550.6c-19.2 11-32 31.8-32 55.4s12.8 44.4 32 55.4v42.6c0 17.6 14.4 32 32 32s32-14.4 32-32v-42.6c19.2-11 32-31.8 32-55.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-levels"
    ]
  },
  {
    "paths": [
      "M512 64c-141.4 0-256 110.8-256 247.6 0 9.8 0.6 19.4 1.8 29 1.2 10.8 3.2 21.2 6 31.4 0.2 1 0.6 2.2 0.8 3.2 33.2 125.6 90.6 143 117.8 335.2 0 0.4 0.2 0.8 0.2 1 3 18.4 19.6 24.6 39.6 24.6h179.8c20 0 36.4-6.2 39.4-24.6 0-0.4 0.2-0.8 0.2-1 27.2-192.2 84.6-209.4 117.8-335.2 0.4-1 0.6-2 0.8-3.2 2.6-10.2 4.6-20.8 6-31.4 1.2-9.4 1.8-19.2 1.8-29 0-136.8-114.6-247.6-256-247.6z",
      "M635.6 793c0.2-0.4 0.6-0.8 0.8-1.2 2.2-3.4 3.4-7.2 3.4-11.4 0-7 3.2-12.4-13-12.4h-229.6c-16.2 0-13 4.2-13 12.4 0 4.2 1.2 8 3.4 11.4 0.2 0.4 0.6 0.8 1 1.2 0 0.2 0.2 0.2 0.2 0.4 3.4 5.2 5.4 8.8 5.4 15.2 0 6.2-1.8 9.8-5.2 15-0.6 0.8-1 1.4-1.4 2-2 3.4-3.2 7.2-3.2 11.2 0 4.2 1.2 8 3.4 11.6 0.2 0.4 0.6 0.8 0.8 1.2 3.6 5.4 5.6 9 5.6 15.6 0 6.2-1.8 9.8-5.2 14.8-0.4 0.8-1 1.4-1.6 2.2-2 3.4-3.2 7.2-3.2 11.2 0 10.8 8.6 20.2 20.4 23.2 0.6 0.2 1.2 0.2 1.8 0.4 12 2.8 24.4 3.2 37 5 1.4 0.2 2.8 0.4 4.4 0.6 11.2 2 20.6 7.8 26.8 15.4v0c7.6 10.6 21.6 22 37.6 22 15.2 0 28.6-10.8 36.4-20.8v0c6-8.4 16-14.6 27.8-16.8 1.4-0.2 2.8-0.6 4.4-0.6 12.6-1.8 25-2.2 37-5 0.6-0.2 1.2-0.2 1.8-0.4 11.8-3.2 20.4-12.4 20.4-23.2 0-4-1.2-7.8-3.2-11.2-0.6-0.8-1-1.4-1.6-2.2-3.2-5.2-5.2-8.6-5.2-14.8 0-6.4 2-10.2 5.6-15.6 0.2-0.4 0.6-0.8 0.8-1.2 2.2-3.4 3.4-7.4 3.4-11.6 0-4-1.2-7.8-3.2-11.2-0.6-0.6-1-1.4-1.4-2-3.2-5.2-5.2-8.6-5.2-15s2-10 5.4-15.2c0 0.2 0 0 0.2-0.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-lightbulb"
    ]
  },
  {
    "paths": [
      "M513 416h-1c0.4 0 0.6 0 1 0z",
      "M737 320h-97c0 0 52 34 63.2 96h33.8c35.2 0 63 27.8 63 63v64c0 35.2-27.8 65-63 65h-224c-35.2 0-65-29.8-65-65v-63h-96v63c0 23 5 45 13.8 65 25.2 56.4 81.8 96 147.2 96h224c88.4 0 159-72.6 159-161v-64c0-88.4-70.6-159-159-159z",
      "M659.2 416c-24.2-56.6-80.2-96-146.2-96h-224c-88.4 0-161 70.6-161 159v64c0 88.4 72.6 161 161 161h95c0 0-51.6-34-64.2-96h-30.8c-35.2 0-65-29.8-65-65v-64c0-35.2 29.8-63 65-63h224c35.2 0 63 27.8 63 63v64c0 0.4 0 0.6 0 1h96c0-0.4 0-0.6 0-1v-64c0-22.4-4.6-43.8-12.8-63z"
    ],
    "grid": 0,
    "tags": [
      "ion-link"
    ]
  },
  {
    "paths": [
      "M640 192c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128s128 57.308 128 128z",
      "M288 512c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
      "M752 288c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M360.2 215.2c-39.8-40.2-104.4-40.2-144.2 0s-39.8 105.4 0 145.6c39.8 40.2 104.4 40.2 144.2 0s39.8-105.4 0-145.6z",
      "M864 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M786 738c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M576 832c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
      "M368 736c0 44.183-35.817 80-80 80s-80-35.817-80-80c0-44.183 35.817-80 80-80s80 35.817 80 80z"
    ],
    "grid": 0,
    "tags": [
      "ion-load-a"
    ]
  },
  {
    "paths": [
      "M576 320c0 35.4-28.6 64-64 64v0c-35.4 0-64-28.6-64-64v-192c0-35.4 28.6-64 64-64v0c35.4 0 64 28.6 64 64v192z",
      "M512 640c-35.4 0-64 28.6-64 64v192c0 35.4 28.6 64 64 64s64-28.6 64-64v-192c0-35.4-28.6-64-64-64v0z",
      "M896 448h-192c-35.4 0-64 28.6-64 64s28.6 64 64 64h192c35.4 0 64-28.6 64-64s-28.6-64-64-64v0z",
      "M320 448h-192c-35.4 0-64 28.6-64 64s28.6 64 64 64h192c35.4 0 64-28.6 64-64s-28.6-64-64-64v0z",
      "M693 421.4c-25 25-65.6 25-90.6 0v0c-25-25-25-65.6 0-90.6l135.8-135.8c25-25 65.6-25 90.6 0v0c25 25 25 65.6 0 90.6l-135.8 135.8z",
      "M421.4 602.6c-25-25-65.6-25-90.6 0l-135.8 135.8c-25 25-25 65.6 0 90.6s65.6 25 90.6 0l135.8-135.8c25-25.2 25-65.6 0-90.6v0z",
      "M828.8 738.2l-135.8-135.8c-25-25-65.6-25-90.6 0s-25 65.6 0 90.6l135.8 135.8c25 25 65.6 25 90.6 0s25-65.6-0-90.6v0z",
      "M421.4 331l-135.8-135.8c-25-25-65.6-25-90.6 0s-25 65.6 0 90.6l135.8 135.8c25 25 65.6 25 90.6 0s25-65.6 0-90.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-load-b"
    ]
  },
  {
    "paths": [
      "M959.6 452.2c-2.8-17.4-6.2-34.6-10.6-51.6-5.6-21.6-12.8-43-21.6-63.6-17.8-42.4-42.2-82-71.8-117.2-32-37.8-70.6-70.4-113.4-95.4-42.2-24.8-88.2-42.4-136.2-52.2-24.8-5-49.8-8-75.2-8.2-19.8-0.2-39.6 0.6-59.2 2.4-51 5-101.4 19.2-147.8 41-39.8 18.8-76.8 43.2-109.6 72.4s-61.4 63.2-84.4 100.6c-25.4 41.6-44.4 87-54.8 134.6-8.4 38-12.4 77.2-10.4 116.2 1.8 37.8 7.6 75.6 19 111.8 7.2 23 15.8 45.4 26.6 67.2 10.6 21.4 23 42 36.8 61.4 27.6 38.6 61.2 72.8 99.6 101 39.2 29 83.4 51.4 129.8 66.2 48.4 15.4 99.8 22.6 150.6 20.8 49.6-1.6 98.8-11.2 145.2-29 44.6-17.2 86.4-41.8 123-72.6 18.4-15.6 34.8-33.2 50.2-51.8 15.6-18.8 29.6-38.6 41.2-60 10-18.4 18.4-37.6 25.6-57 3.6-9.6 7-19.2 9.8-29.2 3-10.6 5.2-21.6 7.2-32.4 3-17 4.2-34.6 2.6-51.8-1.4 7.6-2.6 15-4.4 22.4-2.2 8.6-5 17-8.2 25.2-6.4 17.4-14.4 34.2-22 51-9.8 21.4-21.2 41.8-33.6 61.6-6.4 10.2-13 20.2-20.2 29.8s-15.4 18.8-23.6 27.8-34.2 34.4-54 48.8c-20.2 14.8-41.6 27.8-64.2 38.6-45.2 22-94.6 35.2-144.6 39.6-51.2 4.4-103.4-0.6-152.6-15.2-46.8-13.8-91.2-36.2-130.2-65.6-37.8-28.6-70.6-63.8-96.4-103.6-27-40.6-45.6-86.4-55.8-134.2-2.6-12.4-4.6-25.2-6-37.8-1.2-10.8-2.2-21.8-2.6-32.8-0.6-22.6 0.8-46 4.2-68.4 7.4-49.2 23.4-96.6 48.2-139.8 22-38.6 50.6-73.4 84.2-102.8 33.6-29.6 72-53.4 113.6-70.2 24-9.8 49.2-17 74.8-21.8 13-2.4 26-4.4 39-5.4 6.4-0.6 12.6-0.6 19-1.2 2.6 0 5.2 0.2 7.8 0.2 43.4-0.8 87 4.8 128.4 17.8 44.6 14 86.6 36.6 123 66 38.2 30.8 70 68.8 94 111.6 20.4 36.4 35 75.6 43.8 116.4 2 9.4 3.6 18.8 5.2 28.2 1.4 8.6 6.2 16.6 13.6 21.4 15.6 10.4 37.4 3.4 45-13.4 2.6-5.8 3.4-12 2.4-17.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-load-c"
    ]
  },
  {
    "paths": [
      "M864 480h-160c-17.6 0-32 14.4-32 32s14.4 32 32 32h160c17.6 0 32-14.4 32-32s-14.4-32-32-32z",
      "M352 512c0-17.6-14.4-32-32-32h-160c-17.6 0-32 14.4-32 32s14.4 32 32 32h160c17.6 0 32-14.4 32-32z",
      "M512 672c-17.6 0-32 14.4-32 32v160c0 17.6 14.4 32 32 32s32-14.4 32-32v-160c0-17.6-14.4-32-32-32z",
      "M512 128c-17.6 0-32 14.4-32 32v160c0 17.6 14.4 32 32 32s32-14.4 32-32v-160c0-17.6-14.4-32-32-32z",
      "M650.6 432c8.8 15.4 28.4 20.6 43.8 11.8l138.6-80c15.4-8.8 20.6-28.4 11.8-43.8s-28.4-20.6-43.8-11.8l-138.6 80c-15.4 9-20.6 28.4-11.8 43.8z",
      "M373.4 592c-8.8-15.4-28.4-20.6-43.8-11.8l-138.6 80c-15.4 8.8-20.6 28.4-11.8 43.8s28.4 20.6 43.8 11.8l138.6-80c15.4-9 20.6-28.4 11.8-43.8z",
      "M635.8 662.2c-8.8-15.4-28.4-20.6-43.8-11.8s-20.6 28.4-11.8 43.8l80 138.6c8.8 15.4 28.4 20.6 43.8 11.8s20.6-28.4 11.8-43.8l-80-138.6z",
      "M363.8 191.2c-8.8-15.4-28.4-20.6-43.8-11.8s-20.6 28.4-11.8 43.8l80 138.6c8.8 15.4 28.4 20.6 43.8 11.8s20.6-28.4 11.8-43.8l-80-138.6z",
      "M592 373.4c15.4 8.8 34.8 3.6 43.8-11.8l80-138.6c8.8-15.4 3.6-34.8-11.8-43.8-15.4-8.8-34.8-3.6-43.8 11.8l-80 138.6c-8.8 15.4-3.6 35 11.8 43.8z",
      "M432 650.6c-15.4-8.8-34.8-3.6-43.8 11.8l-80 138.6c-8.8 15.4-3.6 34.8 11.8 43.8 15.4 8.8 34.8 3.6 43.8-11.8l80-138.6c8.8-15.4 3.6-35-11.8-43.8z",
      "M832.8 660.2l-138.6-80c-15.4-8.8-34.8-3.6-43.8 11.8-8.8 15.4-3.6 34.8 11.8 43.8l138.6 80c15.4 8.8 34.8 3.6 43.8-11.8 8.8-15.4 3.6-34.8-11.8-43.8z",
      "M191.2 363.8l138.6 80c15.4 8.8 34.8 3.6 43.8-11.8s3.6-34.8-11.8-43.8l-138.6-80c-15.4-8.8-34.8-3.6-43.8 11.8-8.8 15.4-3.6 34.8 11.8 43.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-load-d"
    ]
  },
  {
    "paths": [
      "M512 128c-131.8 0-238.6 107.4-238.6 240 0 229.2 238.6 528 238.6 528s238.6-298.8 238.6-528c0-132.6-106.8-240-238.6-240zM512 484.4c-62.4 0-112.8-50.8-112.8-113.4s50.6-113.6 112.8-113.6c62.4 0 112.8 50.8 112.8 113.6 0 62.6-50.4 113.4-112.8 113.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-location"
    ]
  },
  {
    "paths": [
      "M768 353.81v-97.81c0-141.384-114.616-256-256-256s-256 114.616-256 256v97.812c-78.55 70.312-128 172.47-128 286.188 0 212.078 171.924 384 384 384 212.078 0 384-171.922 384-384 0-113.718-49.45-215.876-128-286.19zM320 256c0-105.87 86.13-192 192-192s192 86.13 192 192v51.384c-56.482-32.674-122.054-51.384-192-51.384s-135.518 18.71-192 51.386v-51.386zM512 960c-176.732 0-320-143.268-320-320s143.268-320 320-320 320 143.268 320 320-143.268 320-320 320z",
      "M512 352c-159.058 0-288 128.944-288 288s128.942 288 288 288 288-128.944 288-288-128.942-288-288-288zM757.066 706.974l-48.24-15.792-7.852 24.38 48.322 15.824c-7.322 19.552-16.924 37.93-28.504 54.818l-21.12-15.474-7.48 10.368 21.11 15.468c-12.258 16.094-26.378 30.648-42.056 43.364l-29.964-41.574-20.568 15.064 29.952 41.552c-16.958 11.112-35.314 20.24-54.796 27.064l-7.92-24.588-12.098 3.964 9.848 24.524c-19.030 5.604-39.7 9.058-57.7 10.064v-38h-32v38c-22-1.012-39.41-4.488-58.486-10.13l7.896-22.412-12.5-4.212-7.078 22.448c-19.114-6.786-37.062-15.79-53.728-26.718l29.994-41.548-20.54-15.068-29.954 41.574c-15.618-12.666-29.682-27.15-41.906-43.166l19.112-13.996-7.942-11.014-19.124 14c-11.436-16.762-20.938-34.994-28.186-54.372l48.324-15.828-7.852-24.376-48.242 15.794c-4.98-18.862-7.908-36.976-8.516-58.974h10.728v-13.61l-11.986-0.004c0.446-21.212 1.344-41.76 6.532-61.364l49.842 15.8 8.694-24.376-47.932-15.828c7.17-19.14 16.72-37.166 27.97-53.758l20.678 15.066 7.518-10.368-20.584-15.090c12.442-16.506 26.848-31.414 42.868-44.394l29.968 41.574 20.568-15.072-29.95-41.548c16.81-11.028 35.024-20.1 54.32-26.898l7.91 24.494 12.088-3.96-9.24-24.462c19.156-5.688 36.736-9.188 58.736-10.204v38h32v-38c18 0.996 38.318 4.396 57.17 9.902l-9.522 26.56 12.364 4.212 8.348-26.624c19.392 6.816 37.556 15.914 54.416 26.982l-30.004 41.55 20.534 15.070 29.95-41.574c15.87 12.864 30.138 27.624 42.51 43.954l-22.598 16.536 7.95 11.024 22.552-16.52c11.19 16.542 20.494 34.486 27.632 53.55l-48.33 15.828 7.856 24.376 48.24-15.8c5.172 19.604 10.502 40.15 10.94 61.366l-16.008-0.008v13.616h13.578c-0.606 21.998-3.538 40.114-8.512 58.974z",
      "M674 640c0 89.47-72.53 162-162 162s-162-72.53-162-162c0-89.47 72.53-162 162-162s162 72.53 162 162z"
    ],
    "grid": 0,
    "tags": [
      "ion-lock-combination"
    ]
  },
  {
    "paths": [
      "M172.8 960h678.4c24.6 0 44.8-19.8 44.8-44.2v-423.8c0-24.4-20-44-44.8-44h-43.2v-61.8c0-83-32.4-175.2-85.2-230.8-52.6-55.6-128-91.4-210.6-91.4-0.2 0-0.2 0-0.2 0s-0.2 0-0.2 0c-82.6 0-158 35.8-210.6 91.2-52.8 55.6-85.2 147.8-85.2 230.8v62h-43.2c-24.8 0-44.8 19.8-44.8 44v423.8c0 24.4 20 44.2 44.8 44.2zM322 386.2c0-54.6 19.8-122.2 56.2-160.6v0-0.6c35.2-37.2 83.8-59 133.6-59h0.4c49.8 0 98.4 21.8 133.6 59v0.4l-0.2 0.2c36.6 38.4 56.2 106 56.2 160.6v61.8h-379.8v-61.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-locked"
    ]
  },
  {
    "paths": [
      "M511.976 64c-191.030 0-354.108 119.608-418.522 288h69.278c18.792-40.968 44.914-78.7 77.736-111.524 72.526-72.53 168.95-112.476 271.508-112.476 102.572 0 199.008 39.946 271.542 112.478 72.536 72.532 112.482 168.96 112.482 271.522 0 102.57-39.946 199.002-112.478 271.53-72.534 72.528-168.972 112.47-271.546 112.47-102.562 0-198.986-39.942-271.51-112.468-32.824-32.824-58.946-70.56-77.742-111.532h-69.274c64.412 168.402 227.492 288 418.528 288 247.428 0 448.022-200.57 448.022-448 0-247.404-200.594-448-448.024-448z",
      "M413.726 647.766l45.254 45.254 181.020-181.020-181.020-181.020-45.256 45.256 103.766 103.764h-453.49v64h453.49z"
    ],
    "grid": 0,
    "tags": [
      "ion-log-in"
    ]
  },
  {
    "paths": [
      "M733.726 647.766l45.254 45.254 181.020-181.020-181.020-181.020-45.256 45.256 103.766 103.764h-453.49v64h453.49z",
      "M782.982 783.532c-72.524 72.526-168.946 112.468-271.51 112.468-102.574 0-199.012-39.942-271.544-112.47-72.534-72.528-111.928-168.96-111.928-271.53 0-102.562 39.394-198.99 111.93-271.522 72.534-72.532 168.97-112.478 271.542-112.478 102.558 0 198.982 39.946 271.51 112.476 5.054 5.056 9.932 10.242 14.666 15.524h81.462c-80.948-116.056-215.418-192-367.638-192-247.43 0-447.472 200.596-447.472 448 0 247.43 200.042 448 447.472 448 152.224 0 286.7-75.94 367.644-192h-81.46c-4.736 5.286-9.614 10.472-14.674 15.532z"
    ],
    "grid": 0,
    "tags": [
      "ion-log-out"
    ]
  },
  {
    "paths": [
      "M546.8 601l-0.6 116c97.8-16.4 172.6-102 172.6-205 0-31.8-7.2-62-20-89-5.6-11.6-12-22.6-19.6-33l94.2-87c2.2 2.6 4.2 5.4 6.2 8 41.8 56 66.4 125.6 66.4 201 0 2.4 0 5 0 7.4-3 143-95.2 264-222.8 309.2-24.6 8.6-50.4 14.6-77 17.4l-0.2 114-204.8-180 205.6-179z",
      "M178 504.6c3.2-144.2 96.6-266 225.8-310.4 23.4-8 48-13.6 73.6-16.2l0.2-114 204.6 180-205.4 179 0.4-115.8c-97.6 16.6-172 102.2-172 204.8 0 32 7.2 62.2 20.2 89.4 5.4 11.6 12 22.4 19.4 32.6l-94 87.2c-2.6-3.2-5.2-6.6-7.6-10-41-55.8-65.2-124.6-65.2-199.2 0-2.4 0-5 0-7.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-loop"
    ]
  },
  {
    "paths": [
      "M512 64c-230 1-384 155.2-384 399.6 0 97.6 4.2 153.6 29 255.6 31.8 131.4 78.2 226.6 78.2 226.6l1.2 2.6c3.8 6.8 11 11.6 19.6 11.6 2.8 0 5.4-0.4 8-1.4l3.4-1.6 100.6-41.4 3.6-1.6c6.6-3.8 11-10.6 11-18.6-0.4-2.8-0.8-5.6-2-8-0.2-0.2-0.2-0.4-0.4-0.8-14-32-54.4-118.4-74-202.2-19.8-83.8-27-124.8-27-215.4-0-142.2 104.8-245 232.8-245s232.8 102.8 232.8 245c0 90.6-7.4 131.6-27.2 215.4s-60 170.4-74 202.2c-0.2 0.4-0.2 0.6-0.4 0.8-1.2 2.4-1.6 5.2-2 8 0 8 4.4 14.8 11 18.6l3.6 1.6 100.6 41.4 3.4 1.6c2.6 1 5.2 1.4 8 1.4 8.6 0 15.8-4.8 19.6-11.6l1.2-2.6c0 0 46.4-95.2 78.2-226.6 24.8-102 29-158 29-255.6 0.2-244.4-153.8-398.6-383.8-399.6zM346 888.4c0.2 0.4 0.4 1 0.6 1.4l-85.6 35.2c-10.8-23.6-45.4-102-71.4-208.8l85-24.6c18.4 78.4 54.2 158.4 71.4 196.8zM762.8 925l-85.6-35.2c0.2-0.4 0.4-0.8 0.6-1.4 17.2-38.4 52.8-118.4 71.2-196.8l85 24.6c-25.8 106.8-60.4 185.2-71.2 208.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-magnet"
    ]
  },
  {
    "paths": [
      "M960 384v-320h-320l126 126-137.4 137.4c-59-44.8-132.8-71.4-212.6-71.4-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352c0-79.8-26.6-153.6-71.4-212.6l137.4-137.4 126 126zM597 789c-48.4 48.4-112.6 75-181 75s-132.6-26.6-181-75c-48.4-48.4-75-112.6-75-181s26.6-132.6 75-181c48.4-48.4 112.6-75 181-75s132.6 26.6 181 75 75 112.6 75 181-26.6 132.6-75 181z"
    ],
    "grid": 0,
    "tags": [
      "ion-male"
    ]
  },
  {
    "paths": [
      "M512 213.2c41.2 0.2 74.6-33.2 74.6-74.6 0-41.2-33.4-74.6-74.6-74.6s-74.6 33.4-74.6 74.6c0 41.2 33.4 74.6 74.6 74.6z",
      "M586.8 230h-149.6c-56.4 0-93.2 49.6-93.2 96.8v227.2c0 44 62 44 62 0v-210h12v571.2c0 60.8 84 58.8 86 0v-329.2h16v329.4c3.4 62.4 86 56.4 86-0.2v-571.2h10v210c0 44 64 44 64 0v-227.2c0-47-37-96.8-93.2-96.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-man"
    ]
  },
  {
    "paths": [
      "M946.304 273.16l-209.116-140.546c-9.288-6.152-20.73-6.152-30.062 0l-194.188 130.39-194.218-130.39c-9.286-6.152-20.888-6.152-30.124 0l-209.908 140.546c-8.798 5.898-14.688 16.544-14.688 28.1v561.94c0 11.808 6.14 22.694 15.326 28.542 9.24 5.754 20.764 5.658 29.808-0.446l194.376-130.394 194.362 130.394c9.332 6.2 20.88 6.2 30.168 0l194.316-130.394 194.302 130.394c4.622 3.1 9.824 4.706 15.076 4.706 4.91 0 9.418-1.494 13.938-4.26 9.188-5.848 14.33-16.732 14.33-28.542v-561.94c-0.002-11.556-4.852-22.202-13.698-28.1zM270 706.496l-142 98.808v-483.5l142-98.856v483.548zM334 705.532v-245.4c2.334 1.512 4.62 3.052 6.778 4.602l18.666-25.992c-7.808-5.608-16.584-11.002-25.444-15.41v-201.348l146 97.984v217.148c-10.744-3.71-21.172-8.74-31.786-15.364l-16.942 27.148c13.696 8.546 27.242 14.934 41.408 19.53l7.32-22.572v257.612l-146-97.938zM544 803.468v-226.73c0.698-0.042 1.386-0.060 2.086-0.108 5.82-0.396 11.554-1.034 17.036-1.892l-4.958-31.614c-4.536 0.71-9.3 1.238-14.164 1.572v-224.728l146-97.984v237.576l-9.688-8.744c-5.994 6.638-11.666 13.15-17.15 19.45-3.612 4.146-7.156 8.216-10.678 12.19l23.948 21.226c3.582-4.042 7.19-8.182 10.862-12.4 0.886-1.018 1.81-2.070 2.708-3.098v217.35l-146.002 97.934zM896 803.304l-142-96.876v-273.82c7.57-3.43 15.358-5.984 23.278-7.584l-6.332-31.366c-5.716 1.154-11.374 2.678-16.946 4.562v-175.342l142 96.922v483.504z",
      "M258.57 442.222c4.436-2.39-2.706-2.142 2.024-3.674l-9.856-30.444c-6.564 2.124-13.004 4.878-19.142 8.186-7.648 4.124-15.49 9.832-22.678 16.506l21.776 23.448c5.232-4.856 22.584-11.168 27.876-14.022z",
      "M593.604 532.254l13.97 28.79c13.192-6.402 25.684-14.89 38.19-25.948l-21.198-23.974c-10.296 9.104-20.424 16.016-30.962 21.132z",
      "M198.728 512.012c3.786-11.852 7.056-22.088 14.258-32.608l-26.408-18.074c-9.848 14.388-14.162 27.888-18.334 40.942l-0.484 1.516 30.476 9.758 0.492-1.534z",
      "M396.622 475.506c-2.014-2.408-4.028-4.816-6.064-7.206l-24.356 20.758c1.972 2.312 3.922 4.644 5.872 6.976 7.186 8.592 14.616 17.478 23.22 25.618l21.992-23.248c-7.246-6.854-13.764-14.648-20.664-22.898z",
      "M816.312 459.314l20.688-20.686 20.688 20.686 22.624-22.63-20.684-20.684 20.684-20.686-22.624-22.63-20.688 20.686-20.688-20.686-22.624 22.63 20.684 20.686-20.684 20.684z"
    ],
    "grid": 0,
    "tags": [
      "ion-map"
    ]
  },
  {
    "paths": [
      "M944.4 288h-240.4v-61.4c-2-56.4-43.4-98.6-102.4-98.6h-179.2c-58.8 0-100.4 42.2-102.4 98.6v61.4h-240.4c-8.8 0-15.6 7.2-15.6 16v576c0 8.8 6.6 16 15.6 16h865c8.8 0 15.6-7.2 15.6-16v-576c-0.2-8.8-6.8-16-15.8-16zM384 234.4c0-0.8 0-1.4 0-2s0-1.2 0-2c0-19.4 17.2-38.6 37.6-38.6h180.8c20.2 0 37.6 19 37.6 38.6 0 0.6 0 1.2 0 2s0 1.2 0 2v53.6h-256v-53.6zM704 640h-128v128h-128v-128h-128v-128h128v-128h128v128h128v128z"
    ],
    "grid": 0,
    "tags": [
      "ion-medkit"
    ]
  },
  {
    "paths": [
      "M768 448c-47.274 0-88.614 25.78-110.782 64h-19.218c-84.928 0-159.98-35.808-223.070-106.428-40.712-45.574-66.986-97.738-75.712-116.436 27.384-23.492 44.782-58.31 44.782-97.136 0-70.58-57.42-128-128-128s-128 57.42-128 128c0 47.274 25.78 88.614 64 110.782v418.438c-38.22 22.166-64 63.506-64 110.78 0 70.58 57.42 128 128 128s128-57.42 128-128c0-47.274-25.78-88.614-64-110.782v-229.834c87.106 97.23 196.936 148.616 318 148.616h19.218c22.168 38.22 63.508 64 110.782 64 70.58 0 128-57.42 128-128s-57.42-128-128-128zM256 128c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM256 896c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM768 640c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-merge"
    ]
  },
  {
    "paths": [
      "M224.2 476.2l-0.2 27.2c0.2 131.2 92 241.2 216.2 272.4 2.6 0.2 5.2 1 7.6 1.8 11.8 4 20.2 13.8 24.2 25.6v117.4c0 21.8 17.8 39.4 40 39.4h0.2c22.2 0 39.8-17.6 39.8-39.4v-117.6c4-11.8 12.2-21.4 24-25.4 2.4-0.8 5-1.6 7.8-1.8 124.2-31.2 216.2-141.2 216.2-272.4v-27.2c0-20.8-17.8-37.8-39-37.8s-39 16.8-39 37.8v27.2c0 57-23 108.2-61.2 145.6-38.4 37.2-90.6 60.4-149 60.4s-110.2-23-148.4-60.4c-38.2-37.4-61.4-88.8-61.4-145.6v-27.2c0-20.8-17.6-37.8-39-37.8-21.2 0-38.8 17-38.8 37.8z",
      "M358 215.4v287.6c0 83.6 69.4 151.4 155 151.4s155-67.8 155-151.4v-287.6c0-83.6-69.4-151.4-155-151.4s-155 67.8-155 151.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-mic-a"
    ]
  },
  {
    "paths": [
      "M512.8 64c-70.2 0.2-131.6 46.4-153.6 118.6-11.2 37-7 89.6-2.4 109s14.6 39.8 26.4 56.6c5.6 8.4 13.4 14.8 22.4 18.4 1.2 0.6 2.6 1 4 1.6 6.6 2.2 13 4.4 20.2 6.2 23.6 6 54.2 9.4 82.2 9.6v0c0 0 1.2 0 1.4 0 0.6 0 0.6 0 2.6 0v-0.2c28-0.2 54.6-3.4 78.2-9.6 7.2-1.8 13.8-4 20.4-6.2 1.4-0.4 2.6-1 3.8-1.6 9-3.6 16.8-10 22.4-18.4 11.8-16.8 21.6-37.2 26.4-56.6 4.6-19.4 8.8-72-2.4-109-22-72-81.6-118.2-152-118.4z",
      "M590.6 402.2c-0.8 0-1.4 0-2.2 0.2-1.2 0.2-2.6 0.6-3.8 0.8-4 0.8-8.2 1.6-12.2 2.4-18.4 3-37.8 4.6-58 4.8-20.2-0.2-44.6-1.8-62-4.8-4.2-0.8-8.4-1.6-12.4-2.4-1.2-0.2-2.6-0.6-3.8-0.8-0.8-0.2-1.6-0.2-2.2-0.2-12.2 0-22 10.6-22.4 23.8 0.2 1.6 0.4 3.2 0.4 4.8 9.6 134.4 33.6 481.4 36.4 504 0 0 5.6 25.4 64.2 25.2 0 0 0 0 0 0 58.4 0.2 64.2-25.2 64.2-25.2 2.8-22.6 26.8-369.6 36.4-504 0-1.6 0.2-3.2 0.4-4.8-1-13.2-10.8-23.8-23-23.8zM532 563.4c0 12-9 21.8-20 21.8s-20-9.8-20-21.8v-65.4c0-12 9-21.8 20-21.8s20 9.8 20 21.8v65.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-mic-b"
    ]
  },
  {
    "paths": [
      "M658.4 64h-292.6c-60.8 0-109.8 46.8-109.8 104.8v55.2h304v74h-304v86h304v74h-304v86h304v74h-304v83.6c0 58 49 104.4 109.8 104.4h60.2v154h172v-154h60.4c60.6 0 109.6-46.4 109.6-104.4v-83.6h-118v-74h118v-86h-118v-74h118v-86h-118v-74h118v-55.2c0-58-49-104.8-109.6-104.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-mic-c"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448 448-200.6 448-448-200.6-448-448-448zM768 544h-512v-64h512v64z"
    ],
    "grid": 0,
    "tags": [
      "ion-minus-circled"
    ]
  },
  {
    "paths": [
      "M834.8 448h-645.6c-33.8 0-61.2 28.6-61.2 64s27.4 64 61.2 64h645.6c33.8 0 61.2-28.6 61.2-64s-27.4-64-61.2-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-minus-round"
    ]
  },
  {
    "paths": [
      "M128 448h768v128h-768v-128z"
    ],
    "grid": 0,
    "tags": [
      "ion-minus"
    ]
  },
  {
    "paths": [
      "M1017.6 781.8c-1.2 8.2-3.2 16.2-6.2 22.4-5.4 11-10.6 12-31 11-26.4-1.2-64.2 0-104.2 1.6 0 11 0.4 16.2 0.4 16.2 2.6 30.2 16.2 31.2 21.6 31.2 6 0 78.4 0 86 0s14.6 0 20-3.6c7-4.6 10-18 12.6-41.4 0.4-3.4 0.6-7.8 0.8-13 0 0 0-0.2 0-0.2 0-1.6 0.2-3.6 0.2-5.8 0-0.8 0-1.6 0-2.2 0 0 0 0 0 0 0-5.4 0-11.4-0.2-16.2z",
      "M6 781.8c1.2 8.2 3.2 16.2 6.2 22.4 5.4 11 10.6 12 31 11 26.4-1.2 64.2 0 104.2 1.6 0 11-0.4 16.2-0.4 16.2-2.6 30.2-16.2 31.2-21.6 31.2-6 0-78.4 0-86 0s-14 0-20-3.6c-7.2-4.2-10-18-12.6-41.4-0.4-3.4-0.6-7.8-0.8-13 0 0 0-0.2 0-0.2 0-1.6-0.2-3.6-0.2-5.8 0-0.8 0-1.6 0-2.2 0 0 0 0 0 0 0.2-5.4 0.2-11.4 0.2-16.2z",
      "M1024 593.2c0-61.4-8-121.4-11.2-128-2.4-4.8-17.8-17.4-52.8-41.2-35.4-24.2-34.6-20.6-41-36.4 5.8-1.8 11.4-5.2 14.8-5.6 7.6-0.8 8 6.4 23.8 6.4s50-4.2 57-11.2c7-7 9.2-9.4 9.2-15.6s-3.6-19-10.4-26.6-35.8-11.4-52.8-13.6-19.4 0-23.8 2.8c-7 4.4-7.4 44.6-7.4 44.6l-16.6 0.4c-10.8-26.6-25.8-80.2-49.2-122.4-25.6-46-52.4-60.4-63.6-64-11-3.4-21-5.8-96-13.4-76.6-8-137.6-9-192-9s-115.4 1.2-192 9c-75 7.8-85 10-96 13.4s-38 18-63.6 64c-23.4 42.2-38.4 95.8-49.2 122.4l-16.6-0.4c0 0-0.2-40.2-7.4-44.6-4.4-2.8-6.8-5.2-23.8-2.8s-46 6-52.8 13.6-10.4 20.4-10.4 26.6 2.2 8.8 9.2 15.6c7 7 41.2 11.2 57 11.2s16.2-7.2 23.8-6.4c3.4 0.4 9.2 3.8 14.8 5.6-6.6 15.8-5.6 12.2-41 36.4-35 24-50.6 36.4-52.8 41.2-3.2 6.6-11.2 66.6-11.2 128s4.4 116.6 4.4 136.2c0 8.2 0 22.6 1.8 36.4 1.2 8.2 3 16.2 6.2 22.4 5.4 11 10.4 12 31 11 26.4-1.2 64.6 0 104 1.6 26.4 1 53.4 2 77.4 2.6 60 1.2 42.4-8.8 68-8.4s126.6 4.6 219 4.6 193.6-4.2 219-4.6c25.6-0.4 8 9.6 68 8.4 24-0.4 51-1.6 77.4-2.6 39.4-1.4 77.8-2.8 104-1.6 20.6 1 25.6 0 31-11 3-6.2 5-14.2 6.2-22.4 2-13.8 1.8-28.2 1.8-36.4 0.4-19.4 4.8-74.8 4.8-136.2zM172.4 290.4c9.6-22.4 38.4-67.4 52.4-75.4 3.4-2 33.2-11.4 107.8-16.4 68.6-4.6 144.4-6.4 179.6-6.4s111 1.8 179.6 6.4c74.4 5 104.6 14.2 107.8 16.4 18 12.4 42.8 53 52.4 75.4s22.4 66.4 20 72.4c-2.4 6 2.4 9-30 6.4-32.2-2.4-234.4-5-329.6-5-95 0-297.2 2.6-329.6 5s-27.6-0.4-30-6.4c-2.8-6 10-49.8 19.6-72.4zM246 540.8c-14.4 3.6-23 11.4-41 11.2-18 0-66.6-8.2-77-8.6s-19.6 7-25 8.4-16-2.4-32-7.4-25.4-3.6-30.6-25.4c-5.4-21.6 0-52.6 0-52.6 34.6-1.6 68 1.6 130.6 19.2s97.4 51.4 97.4 51.4-8 0.2-22.4 3.8zM716.4 698.4c-28.6 3.8-148.4 4.8-204.4 4.8s-175.8-1.2-204.4-4.8c-29.2-3.8-67.2-38.8-41-66.6 35.4-37.8 28.8-36.6 109.2-47 69.6-9 122.4-9.4 136.2-9.4 13.6 0 66.6 0.6 136.2 9.4 80.4 10.4 73.8 9.2 109.2 47 26.2 27.8-11.8 62.8-41 66.6zM983.6 519.2c-5.4 21.6-14.6 20.4-30.6 25.4s-26.6 8.6-32 7.4-14.6-8.6-25-8.4c-10.4 0.4-59 8.6-77 8.6s-26.6-7.6-41-11.2c-14.4-3.6-22.4-3.6-22.4-3.6s34.6-34 97.4-51.4c62.6-17.6 96-20.8 130.6-19.2 0-0.4 5.4 30.6 0 52.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-model-s"
    ]
  },
  {
    "paths": [
      "M937.4 128h-850.8c-12 0-22.6 10-22.6 22.2v531.4c0 12.4 10.4 22.2 22.6 22.2h850.8c12 0 22.6-10 22.6-22.2v-531.4c0-12.2-10.4-22.2-22.6-22.2zM896 640h-768v-448h768v448z",
      "M605 896c56-1 83-7.8 58-25-25-17.4-57-30.6-58-45-0.6-7.4-3.4-90-3.4-90h-179.2c0 0-3 82.6-3.4 90-1 14.2-33 27.6-58 45s2 24 58 25h186z"
    ],
    "grid": 0,
    "tags": [
      "ion-monitor"
    ]
  },
  {
    "paths": [
      "M227.4 608c-55 0-99.4-42.8-99.4-96 0-53 44.4-96 99.4-96 55.2 0 99.6 43 99.6 96 0 53.2-44.4 96-99.6 96z",
      "M512 608c-55 0-99.6-42.8-99.6-96 0-53 44.6-96 99.6-96s99.4 43 99.4 96c0 53.2-44.4 96-99.4 96z",
      "M796.4 608c-55 0-99.6-42.8-99.6-96 0-53 44.4-96 99.6-96 55 0 99.6 43 99.6 96 0 53.2-44.4 96-99.6 96z"
    ],
    "grid": 0,
    "tags": [
      "ion-more"
    ]
  },
  {
    "paths": [
      "M512 64c-0.92 0-1.834 0.022-2.752 0.030l11.494 0.114c-2.902-0.086-5.814-0.144-8.742-0.144z",
      "M757.106 386.422c-0.39 0.128-0.828 0.32-1.238 0.538-68.468 26.578-152.674 45.040-243.772 44.95-91.040-0.152-175.252-18.796-243.62-45.544-0.38-0.208-0.858-0.384-1.294-0.53-3.062-1.108-6.292-1.794-9.682-1.834-0.508-0.002-1-0.026-1.5 0v352.024c0 123.758 114.616 223.974 256 223.974 43.984 0 85.374-9.606 121.532-26.71 0.19-0.090 0.382-0.174 0.572-0.266 0.052-0.026 0.108-0.052 0.16-0.078 9.74-4.688 19.162-9.926 28.244-15.656 63.93-40.74 105.492-106.748 105.492-181.266v-352.024c-0.382-0.016-0.992 0-1.378 0-3.454 0.028-6.438 1.302-9.516 2.422zM634.264 932.848c-0.052 0.026-0.108 0.052-0.16 0.078-0.19 0.090-0.382 0.176-0.572 0.266 0.19-0.090 0.382-0.176 0.572-0.266 0.052-0.026 0.106-0.052 0.16-0.078 9.74-4.684 19.162-9.922 28.244-15.65-8.992 5.728-18.42 10.968-28.244 15.65z",
      "M662.508 917.198c-9.082 5.728-18.504 10.966-28.244 15.65 9.824-4.682 19.252-9.922 28.244-15.65z",
      "M520.742 64.144l-11.494-0.114c-140.116 1.294-253.248 101.064-253.248 223.97v45.416c4.316 4.048 9.186 7.51 14.502 10.23 1.346 0.674 2.772 1.318 4.118 1.992 0.064 0.054 0.154 0.020 0.218 0.072 45.514 20.7 102.858 31.602 166.83 38.012 1.388 0.156 2.794 0.214 4.296 0.24 22.516 0.032 34.028 0.038 34.036-21.14v-170.822c0-17.672 14.328-32 32-32s32 14.328 32 32v172.656c-0.176 19.344 11.852 19.44 34.4 19.498 1.434-0.032 2.83-0.090 4.162-0.21 0.124-0.006 0.282 0.010 0.488-0.040 63.364-6.238 120.286-16.81 165.616-37.18 2.324-1.090 4.582-2.112 6.814-3.162 4.542-2.464 8.73-5.486 12.52-8.932v-46.63c0-121.15-109.922-219.82-247.258-223.856z"
    ],
    "grid": 0,
    "tags": [
      "ion-mouse"
    ]
  },
  {
    "paths": [
      "M852 64.2c-4.4 0-10.2 1.2-10.2 1.2l-435.2 66.4c-27.6 7.4-52.6 34.2-54.6 63.2v573h-122v-0.2c-56 0-102.2 40-102.2 96s46.2 96 102.6 96h72.4c30.6 0 57.8-13.8 76.6-35 0.2-0.2 0.6-0.2 0.8-0.4 1.2-1.2 2-3 3-4.2 2.6-3.2 4.8-6.4 6.8-10 19.2-28.2 26-65.6 26-82.2v-464l416-76c0 0 0 272 0 384h-121c-56.6 0-102.4 39.8-102.4 96s45.8 96 102.4 96h74.4c36.4 0 68.2-12 86.4-42 0 0 0.2 0 0.4 0 18-24 24-60.4 24-109.8 0-49.6 0-605.6 0-605.6-0.2-23.4-20-42.4-44.2-42.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-music-note"
    ]
  },
  {
    "paths": [
      "M834.8 448h-645.6c-33.8 0-61.2 28.6-61.2 64s27.4 64 61.2 64h645.6c33.8 0 61.2-28.6 61.2-64s-27.4-64-61.2-64z",
      "M834.8 192h-645.6c-33.8 0-61.2 28.6-61.2 64s27.4 64 61.2 64h645.6c33.8 0 61.2-28.6 61.2-64s-27.4-64-61.2-64z",
      "M834.8 704h-645.6c-33.8 0-61.2 28.6-61.2 64s27.4 64 61.2 64h645.6c33.8 0 61.2-28.6 61.2-64s-27.4-64-61.2-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-navicon-round"
    ]
  },
  {
    "paths": [
      "M192 482h640v64h-640v-64z",
      "M192 290h640v64h-640v-64z",
      "M192 674h640v64h-640v-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-navicon"
    ]
  },
  {
    "paths": [
      "M960 64l-896 384h512v512z"
    ],
    "grid": 0,
    "tags": [
      "ion-navigate"
    ]
  },
  {
    "paths": [
      "M896 192c0-70.58-57.42-128-128-128s-128 57.42-128 128c0 47.274 25.78 88.614 64 110.782v105.664l-192 96-192-96v-105.664c38.22-22.168 64-63.508 64-110.782 0-70.58-57.42-128-128-128s-128 57.42-128 128c0 47.274 25.78 88.614 64 110.782v184.774l256 128v105.664c-38.22 22.168-64 63.508-64 110.782 0 70.58 57.42 128 128 128s128-57.42 128-128c0-47.274-25.78-88.614-64-110.782v-105.664l256-128v-184.774c38.22-22.168 64-63.508 64-110.782zM256 128c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zM512 896c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM768 256c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-network"
    ]
  },
  {
    "paths": [
      "M720 512h32v96h-32v-96z",
      "M224 608h275.2l-96-96h-179.2z",
      "M729 120.2c-0.8-0.4-1.4-0.8-2-1.2-21.8-12-45-21.4-68.8-29.6-3.6-1.2-7.2-2.4-10.8-3.6-42.8-13.6-88.2-21.8-135.4-21.8-247.4 0-448 200.6-448 448 0 168.6 93.2 315.2 230.8 391.6 0.8 0.4 1.4 1 2.2 1.4 21.8 12 45 21.4 68.8 29.6 3.6 1.2 7.2 2.4 10.8 3.6 42.8 13.6 88 21.8 135.4 21.8 247.4 0 448-200.6 448-448 0-168.6-93.2-315.4-231-391.8zM512 852.8c-18.6 0-36.8-1.8-54.4-4.8-19.6-3.2-38.6-8.2-57-14.6-3.8-1.2-7.6-2.4-11.2-3.8-13-5-25.8-10.6-38-17.2-107.2-57.4-180.2-170.4-180.2-300.6 0-74.4 24.8-142.8 65.4-198.8l474.4 474.4c-56.2 40.6-124.6 65.4-199 65.4zM787.6 710.8l-474.4-474.4c56-40.4 124.2-65.2 198.8-65.2 18.6 0 36.6 1.8 54.4 4.8 19.6 3.2 38.6 8.2 57 14.6 3.6 1.2 7.4 2.4 11.2 3.8 12.4 4.8 24.4 10 36 16.2 108.4 57 182.4 170.6 182.4 301.6-0.2 74.4-25 142.6-65.4 198.6z",
      "M704 596v-84h-84z",
      "M768 512h32v96h-32v-96z",
      "M720.2 425.4c-17.6-8.2-44-11.4-91.2-11.4-2.4 0-4.8 0-7.2 0-25.4 0.2-31.8-0.2-40-12.2-5.6-8.4-2-29.6 7.4-43.8 3.2-4.8 3.6-11.2 0.8-16.4s-8.2-8.4-14-8.6c-0.2 0-18.8-0.2-36.6-7.8-21.2-9-31.2-24.2-31.2-46.2 0-51.6 43.6-55.4 45.6-55.4v-32c-24 0-77.6 22-77.6 87.4 0 35 18 62 51.4 76 8.4 3.4 16.8 5.8 24 7.2-6.6 19.6-7.2 41.8 3.4 57.4 18 26.6 40.6 26.4 66.6 26.2 2.2 0 4.6 0 7 0 52.6 0 69.2 4.6 77.8 8.6 11.4 5.2 13.6 23 13.2 39.4 0 1.4 0 0.8 0 2h32c0-0.8 0-0.8 0-2 0-14.2 0.6-53.6-31.4-68.4z",
      "M800 496c0-51.4-6-86.4-18.2-107.2-17.2-28.8-44.8-44.8-77.8-44.8h-34.8c5.8-16.6 10.8-39.6 7-61.8-6.4-37.6-38.2-60-86.2-60v32c42 0 52.2 18.2 54.8 33.4 5 29-13.6 64.2-13.8 64.6-2.8 5-2.6 11 0.2 15.8s8.2 7.8 13.8 7.8h59c21.8 0 38.8 9.8 50.2 29.2 6.2 10.6 13.8 35 13.8 90.8h32z"
    ],
    "grid": 0,
    "tags": [
      "ion-no-smoking"
    ]
  },
  {
    "paths": [
      "M608 544c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
      "M960 544h-320c0 47.8-26.2 89.4-65.2 111.4l156.4 272.6c135-77.2 228.8-217.4 228.8-384z",
      "M512 416c23.4 0 45.4 6.4 64.2 17.4l161.2-276.6c-66.2-38.6-143.2-60.8-225.4-60.8-82.4 0-159.8 22.4-226.2 61.2l159.6 277.6c19.4-12 42.2-18.8 66.6-18.8z",
      "M384 544h-320c0 166.6 93.8 306.8 228.8 384l156.4-272.6c-39-22-65.2-63.6-65.2-111.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-nuclear"
    ]
  },
  {
    "paths": [
      "M739.082 64h-454.364c-121.676 0-220.718 101.148-220.718 225.208v445.58c0 124.064 99.042 225.212 220.718 225.212h454.364c121.876 0 220.918-101.148 220.918-225.21v-445.58c0-124.062-99.042-225.21-220.918-225.21zM350 501.908v1.34c0 21.764-18.18 40.752-39.75 40.752h-46.54c-21.564 0-39.71-18.988-39.71-40.752v-206.926c2-21.536 18.386-40.322 39.71-40.322h46.54c21.772 0 39.75 19.694 39.75 41.662v204.246zM594 791.48v5.36c0 22.878-17.744 35.16-40.2 35.16h-83.596c-22.46 0-40.204-16.282-40.204-39.16v-58.634c0-46.66 36.236-84.574 81.998-84.574 45.766 0 82.002 37.914 82.002 84.574v57.274zM800 501.908v1.34c0 21.764-18.142 40.752-39.71 40.752h-48.54c-21.564 0-39.75-18.988-39.75-40.752v-206.926c2-21.536 18.43-40.322 39.75-40.322h48.54c21.568 0 39.71 19.694 39.71 41.662v204.246z"
    ],
    "grid": 0,
    "tags": [
      "ion-outlet"
    ]
  },
  {
    "paths": [
      "M299.030 566.698c-103.842 0-167.878 91.322-167.878 190.17 0 45.382-20.142 78.306-67.15 96.208 35.814 69.356 175.554 82.314 235.030 71.594 71.284-12.852 160.154-49.746 181.308-153.938 24.62-121.254-77.472-204.034-181.31-204.034z",
      "M935.276 120.712c-25.91-25.896-59.928-34.584-89.84-10.7l-350.24 308.188c-17.296-4.742-33.050-3.738-45.818 4.692l-117.586 97.908c-3.222 3.222-3.090 8.608 0.132 11.828 0.998 1.002 2.128 1.58 3.394 1.96 1.284 0.068 2.528 0.118 3.798 0.206 0.038-0.004 0.072-0.020 0.108-0.028 95.876 6.864 182.068 73.508 178.6 179.012-0.032 1.010-0.058 2.014-0.108 3.032 0.246 1.696 1 3.328 2.298 4.63 3.19 3.186 8.336 3.21 11.562 0.088 0.036-0.036 0.074-0.054 0.11-0.088 0.126-0.126 0.212-0.274 0.328-0.4l100.914-114.684c8.432-12.748 9.44-28.48 4.71-45.75l308.338-350.094c23.902-29.896 15.208-63.896-10.7-89.8z",
      "M331.774 520.818l0.018-0.018-0.016 0.014z"
    ],
    "grid": 0,
    "tags": [
      "ion-paintbrush"
    ]
  },
  {
    "paths": [
      "M256 128l79.334 144.204-303.334 303.796 395.208 384 326.656-320 116.66-24.614-550.524-551.386-64 64zM650.262 576h-440.548l220.286-220.274 220.262 220.274z",
      "M870.524 615.386c0 0-121.468 132.358-121.464 198.414 0 66.056 54.384 119.606 121.462 119.602 67.096 0.004 121.48-53.544 121.478-119.602 0.002-66.056-121.476-198.414-121.476-198.414z"
    ],
    "grid": 0,
    "tags": [
      "ion-paintbucket"
    ]
  },
  {
    "paths": [
      "M64 544l256 96 32 320 160-224 224 224 224-896-896 480zM701.4 834.8l-189.4-194.8 256-352-384 307.6-165.2-62 644-345-161.4 646.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-paper-airplane"
    ]
  },
  {
    "paths": [
      "M649.2 309.8c-12.6-0.2-22.8 10.2-22.8 23.2l-0.4 389.6c-0.2 87.6-59.4 126.8-114.4 126.4-55-0.6-114.2-40.8-114-128.2 0-67 0.4-335.4 0.6-469.6 0-30.8 12-54.8 33.6-67.4 21.2-12.4 48.8-12.2 70 0.6 21.6 13 33.4 37.2 33.4 68l-0.6 449c0 14.6-3.4 26.6-9.4 34.2-3.8 4.8-8.8 7.6-13.8 7.6-11.2-0.2-22.8-14.6-22.6-41.6 0 0 0.4-332.6 0.6-345.4 0-13-10.2-23.6-22.8-23.6s-22.8 10.4-22.8 23.4l-0.6 345.4c0 58 34.4 88.6 68.4 89 18.8 0.2 36.6-8.8 49.2-24.8s19.4-38 19.4-63.6l0.6-449c0-47.6-20.4-87.2-56.2-108.6-35-21.2-80.6-21.6-115.8-1-35.8 21-56.4 60.2-56.6 107.8-0.2 134-0.4 402.4-0.6 469.6-0.2 114.4 80.2 174.8 159.6 175.6 41 0.4 82.2-15.4 112.6-46.2 28.4-29 47.4-71.4 47.4-126.8l0.2-389.8c0.6-13.2-9.6-23.8-22.2-23.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-paperclip"
    ]
  },
  {
    "paths": [
      "M448 871.6v-719.4c0-13.4-10.8-24.2-24.4-24.2h-143.2c-13.6 0-24.4 10.8-24.4 24.2v719.4c0 13.4 10.8 24.4 24.4 24.4h143.2c13.6 0 24.4-10.8 24.4-24.4z",
      "M743.6 128h-143.2c-13.4 0-24.4 10.8-24.4 24.2v719.4c0 13.4 10.8 24.4 24.4 24.4h143.2c13.4 0 24.4-10.8 24.4-24.4v-719.4c-0-13.4-10.8-24.2-24.4-24.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-pause"
    ]
  },
  {
    "paths": [
      "M858 656v-102h102v-84h-102v-102h-84v102h-102v84h102v102z",
      "M832 896c0 0 0-52.8-4.4-80.4-3.6-21.8-33.8-50.6-162.2-97.8-126.4-46.4-118.6-23.8-118.6-109.2 0-55.4 28.2-23.2 46.2-128.4 7-41.4 12.6-13.8 27.8-80.2 8-34.8-5.4-37.4-3.8-54s3.2-31.4 6.2-65.4c3.6-42-35.4-152.6-175.2-152.6s-178.8 110.6-175 152.8c3 33.8 4.6 48.8 6.2 65.4s-11.8 19.2-3.8 54c15.2 66.2 20.8 38.6 27.8 80.2 18 105.2 46.2 73 46.2 128.4 0 85.6 7.8 63-118.6 109.2-128.4 47-158.8 76-162.2 97.8-4.6 27.4-4.6 80.2-4.6 80.2h768z"
    ],
    "grid": 0,
    "tags": [
      "ion-person-add"
    ]
  },
  {
    "paths": [
      "M850.6 649.6c-82.8-31.4-77.8-18.8-77.8-77 0-37.6 18.6-23.8 30.4-95.4 4.6-28.2 8.4-9.4 18.2-54.6 5.2-23.6-3.6-25.4-2.4-36.6 1-11.2 2-21.4 4-44.4 2.4-28.8-23.2-104-114.8-104s-117.2 75.2-114.8 104c1.8 23.2 3 33.2 4 44.4s-7.6 13-2.4 36.6c9.8 45.2 13.6 26.2 18.2 54.6 11.8 71.6 30.2 58 30.2 95.4 0 26.8 6.2 38-29.8 55 10.8 3.8 23.4 8.4 38.6 14.2 108.8 41.4 106.2 81.6 109 100.6 2 13 3 116.6 3.4 153.6h195.4c0 0 0-161-3-179.8-2.2-14.8-22-34.4-106.4-66.6z",
      "M714 896c0 0 0-28.2-0.4-60.8-0.4-37.2-1.4-80-3.4-92.8-3-19-28.6-44.4-137.2-85.8-15-5.6-27.6-10.2-38.6-14.2-66.6-23.6-61.8-31.4-61.8-96 0-48.6 24-17 39.2-109.2 6-36.4 10.8-12.2 23.4-70.4 6.8-30.4-4.6-32.8-3.2-47.4s2.8-27.6 5.2-57.4c3.2-37-29.8-134.2-148.2-134.2s-151.2 97-148.2 134.2c2.4 29.8 3.8 42.8 5.4 57.4 1.4 14.6-10 16.8-3.2 47.4 12.8 58.2 17.6 34 23.6 70.4 15.2 92.2 39 60.6 39 109.2 0 75.2 6.6 69.6-100.4 110.2-108.6 41.4-134.2 66.8-137.2 85.8-4 24.2-4 153.6-4 153.6h650z"
    ],
    "grid": 0,
    "tags": [
      "ion-person-stalker"
    ]
  },
  {
    "paths": [
      "M896 896c0 0 0-52.8-4.4-80.4-3.6-21.8-33.8-50.6-162.2-97.8-126.4-46.4-118.6-23.8-118.6-109.2 0-55.4 28.2-23.2 46.2-128.4 7-41.4 12.6-13.8 27.8-80.2 8-34.8-5.4-37.4-3.8-54s3.2-31.4 6.2-65.4c3.6-42-35.4-152.6-175.2-152.6s-178.8 110.6-175 152.8c3 33.8 4.6 48.8 6.2 65.4s-11.8 19.2-3.8 54c15.2 66.2 20.8 38.6 27.8 80.2 18 105.2 46.2 73 46.2 128.4 0 85.6 7.8 63-118.6 109.2-128.4 47-158.8 76-162.2 97.8-4.6 27.4-4.6 80.2-4.6 80.2h768z"
    ],
    "grid": 0,
    "tags": [
      "ion-person"
    ]
  },
  {
    "paths": [
      "M65.2 512h446.8v-446.8c-10-0.8-21.2-1.2-32-1.2-229.8 0-416 186.2-416 416 0 10.8 0.4 22 1.2 32z",
      "M219.6 804.4c76.2 94.8 193.2 155.6 324.4 155.6 229.8 0 416-186.2 416-416 0-131.2-60.8-248.2-155.6-324.4-63.4-51-142.4-83.8-228.4-90.4v446.8h-446.8c6.6 86 39.4 165 90.4 228.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-pie-graph"
    ]
  },
  {
    "paths": [
      "M663.6 456c0 0 0 0 0 0-2.4-1-4.8-2-7-3.4-14-8-24.4-21.8-27.8-38.4l-37-235.4-0.4-11.6c0-14.2 8.2-20.4 20-26v0c1.4-0.6 2.8-1.2 4.2-1.8 14.4-6.8 24.2-15.6 24.2-32.6 0-40.2-13-42.8-36.4-42.8h-182.6c-23.4 0-36.4 2.4-36.4 42.8 0 17 9.8 25.8 24.2 32.6 1.4 0.6 2.8 1 4.2 1.8 0 0 0 0 0 0 11.8 5.8 20 12 20 26l-0.4 11.6-37 235.4c-3.4 16.6-13.8 30.4-27.8 38.4-2.2 1.4-4.6 2.4-7 3.4 0 0 0 0 0 0-39.4 20.4-72.4 61.6-72.4 109.4 0 31.8 7 42.6 30.4 42.6h161.4l24 352h16l24-352h161.6c23.4 0 30.4-9.4 30.4-42.6 0-47.8-33-89-72.4-109.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-pin"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448c247.4 0 448-200.6 448-448s-200.6-448-448-448zM783.6 783.6c-65 65-149.2 103.8-239.6 111.2l-16-126.8h-32l-15.8 126.6c-90.6-7.4-174.8-46.2-239.6-111.2-65-65-103.8-149.2-111.2-239.6l126.6-15.8v-32l-126.6-15.8c7.4-90.6 46.2-174.8 111.2-239.6 65-65 149.2-103.8 239.6-111.2l15.8 126.6h32l15.8-126.6c90.6 7.4 174.8 46.2 239.6 111.2 65 65 103.8 149.2 111.2 239.6l-126.6 15.8v32l126.6 15.8c-7.4 90.6-46.2 174.8-111 239.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-pinpoint"
    ]
  },
  {
    "paths": [
      "M789.238 260.89c-85.316-37.848-178.532-56.944-277.298-56.85-98.746-0.094-198.54 20.524-277.282 55.958-14.792 6.624-28.008 17.914-18.592 38.958s295.816 661.044 295.816 661.044l295.242-659.748c5.78-13.752 1.512-30.756-17.886-39.362zM383.966 384.030c-35.34 0-63.99-28.646-63.99-63.986 0-35.338 28.65-63.984 63.99-63.984 35.342 0 63.992 28.646 63.992 63.984s-28.65 63.986-63.992 63.986zM511.95 677.962c-35.342 0-63.99-28.646-63.99-63.986s28.648-63.984 63.99-63.984c35.34 0 63.99 28.644 63.99 63.984s-28.65 63.986-63.99 63.986zM639.93 448.014c-35.34 0-63.99-28.644-63.99-63.984s28.65-63.986 63.99-63.986c35.342 0 63.992 28.646 63.992 63.986s-28.65 63.984-63.992 63.984z",
      "M843.58 132c-95.616-41.206-213.734-67.954-331.622-68-117.862 0-233.888 24.272-331.64 66.892-8.658 3.776-20.318 11.14-20.318 27.562 0 5.046 1.814 9.844 1.814 9.844l15.96 38.388c5.062 9.73 15.888 16.36 27.596 16.36 3.29 0 7.872-0.662 13.3-2.952 89.8-37.858 188.942-59.176 293.288-59.128 104.35-0.046 211.26 23.28 293.268 59.122 6.592 2.88 10.346 2.944 13.326 2.944 12.018 0 22.316-6.548 27.454-16.106l16.080-38.684c1.154-3.116 1.914-6.574 1.914-9.536 0-14.706-8.772-21.686-20.42-26.706z"
    ],
    "grid": 0,
    "tags": [
      "ion-pizza"
    ]
  },
  {
    "paths": [
      "M563.4 623.8c0.8-13.8 16.6-9 16.6-9l124 25.2 256 97.4c0-48-7.6-53-18.8-61.4l-365.2-262c0 0-9.8-120-9.8-225.8 0-49-23.6-156.2-54.2-156.2s-54.2 108.8-54.2 156.2c0 100.4-9.8 225.8-9.8 225.8l-365.2 262c-14.2 10-18.8 15.4-18.8 61.4l256-97.4 123.8-25.2c0 0 15.8-4.8 16.6 9s-2.4 138.2 11.8 204.2c1.8 8.8-5 9.4-9.6 14.8l-103.8 65.6c-3.4 3.8-5 14.6-5 14.6l-2 37 136-32 24 64 24-64 136 32-2-37c0.2 0-1.4-10.8-4.8-14.6l-103.8-65.6c-4.6-5.4-11.4-6-9.6-14.8 13.8-66 11-190.4 11.8-204.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-plane"
    ]
  },
  {
    "paths": [
      "M192.596 531.41c10.034 167.69 149.178 300.59 319.38 300.59 75.914 0 145.636-26.454 200.5-70.622-78.016-22.27-164.476-53.534-253.352-92.144-97.662-42.426-189.21-89.88-266.528-137.824z",
      "M214.762 393.258c79.822 54.22 184.14 110.26 295.358 158.574 87.182 37.876 174.226 69.11 251.718 90.328 12.992 3.558 25.668 6.812 37.976 9.766 3.37-6.924 6.498-13.988 9.376-21.182 14.682-36.716 22.772-76.786 22.772-118.744 0-6.52-0.218-12.986-0.602-19.41-10.038-167.69-149.18-300.59-319.384-300.59-75.912 0-145.634 26.454-200.496 70.622-36.592 29.458-66.568 66.796-87.34 109.452-3.374 6.924-6.502 13.99-9.378 21.184z",
      "M859.334 569.062c-2.512 23.124-4.754 27.254-11.782 49.39 33.756 24.078 62.064 47.412 82.274 67.876 6.57 6.656 11.75 12.45 15.824 17.404-3.368 0.168-7.114 0.266-11.262 0.266-43.772 0-108.052-11-181.002-30.976-78.934-21.612-167.46-53.37-256.016-91.84-117.862-51.2-228.316-111.082-311.020-168.614-38.162-26.55-70.054-52.452-92.226-74.9-6.57-6.656-11.75-12.45-15.824-17.404 3.366-0.168 7.112-0.266 11.264-0.266 30.616 0 71.274 5.388 117.904 15.458 11.65-20.008 13.958-25.402 29.326-42.818-51.468-18.638-103.544-31.594-147.226-36.638-48.806-5.636-80.68 11.042-87.968 34.28-22.148 70.634 188.4 227.156 470.272 349.604 189.124 82.16 362.336 128.116 462.516 128.116 49.13 0 80.676-11.042 87.964-34.282 12.68-40.432-48.422-93.718-163.018-164.656z"
    ],
    "grid": 0,
    "tags": [
      "ion-planet"
    ]
  },
  {
    "paths": [
      "M810.4 465.8l-556.8-331.4c-6.8-4-13.8-6.4-21.8-6.4-21.8 0-39.6 18-39.6 40h-0.2v688h0.2c0 22 17.8 40 39.6 40 8.2 0 15-2.8 22.4-6.8l556.2-331c13.2-11 21.6-27.6 21.6-46.2s-8.4-35-21.6-46.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-play"
    ]
  },
  {
    "paths": [
      "M799.6 406c-1.6-34.2-6.6-69-21.6-100.2-8.2-17.2-19.4-33-33-46.4-12.6-12.8-27.2-23.4-42.6-32.6-34.2-20.4-75-34-168.8-62s-149.6-36.8-149.6-36.8v716.6l159.8 51.4c0 0 0.2-397.6 0.2-599v-7.6c0-18.6 15-33.6 32.2-33.6h1c17 0 31 15 31 33.6v266.6c22 10.6 58.4 18.6 83.6 18.2 16.6 0.4 33.4-3.4 48-11.4 15.2-8.2 27.8-20.8 36.8-35.6 10.2-16.6 16.4-35.6 19.8-54.6 3.8-21.6 4-44.2 3.2-66.6z",
      "M173.4 715.6c54.8-19.6 178.6-59 178.6-59v-94.4c0 0-153 49.6-222.6 74.2-17.2 6.2-34.6 11.8-51.4 19-19.6 8.2-38.8 17.4-56.2 29.6-7.6 5.2-14.4 11.8-18.4 20.2s-4.4 18.4-1 27.2c4 10.2 11.6 18.6 20.2 25.2 15.6 11.8 34.2 19 52.8 24.4 56.8 18.8 116.8 28 176.8 26.6 29-0.4 72-3.8 100-8.8v-84c0 0-22 5-82.6 25-9.2 3-18.4 6.6-28 8.6-14.2 3.2-28.8 4.2-43.2 4.4-13-0.6-26.4-1.4-38.6-6.2-4.4-2-9.2-4.4-11-9.2-1.6-4 0.6-8 3.4-10.8 5.6-5.8 13.6-9 21.2-12z",
      "M1024 691.8c-0.2-12-7.4-22.4-15.8-30-14.2-12.6-31.8-20.6-49.4-27-11-3.8-18.6-6.6-29.4-10-50.4-16.4-103.8-22.4-156.6-22.6-16 0.6-46.2 1-62 2.8-43.8 5-134.6 30.8-134.6 30.8v97.6c0 0 135-43.2 193-63.6 19.4-6.6 40.2-9.2 60.6-9.2 13 0.4 26.4 1.4 38.8 6.2 4.4 1.8 9 4.4 11 9 1.8 5.2-1.8 10-5.8 13-9.4 7.6-21.4 10.6-32.4 14.8-82 29-265.4 89.4-265.4 89.4v94c0 0 234.4-79.2 341.6-117.6 17.8-6.6 35.8-12.2 52.8-20.8 15.8-8 31.6-17.2 43.6-30.6 6.2-7.2 10-16 10-26.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-playstation"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448 448-200.6 448-448-200.6-448-448-448zM768 544h-224v224h-64v-224h-224v-64h224v-224h64v224h224v64z"
    ],
    "grid": 0,
    "tags": [
      "ion-plus-circled"
    ]
  },
  {
    "paths": [
      "M834.8 448h-258.8v-258.8c0-33.8-28.6-61.2-64-61.2s-64 27.4-64 61.2v258.8h-258.8c-33.8 0-61.2 28.6-61.2 64s27.4 64 61.2 64h258.8v258.8c0 33.8 28.6 61.2 64 61.2s64-27.4 64-61.2v-258.8h258.8c33.8 0 61.2-28.6 61.2-64s-27.4-64-61.2-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-plus-round"
    ]
  },
  {
    "paths": [
      "M896 448h-320v-320h-128v320h-320v128h320v320h128v-320h320z"
    ],
    "grid": 0,
    "tags": [
      "ion-plus"
    ]
  },
  {
    "paths": [
      "M64 512h256v384h-256v-384z",
      "M384 320h256v576h-256v-576z",
      "M704 640h256v256h-256v-256z"
    ],
    "grid": 0,
    "tags": [
      "ion-podium"
    ]
  },
  {
    "paths": [
      "M250.4 704.6h-186.4v-109.2h202.4l26.2-166.6h-198.6v-109.2h214.4l43.6-255.6h127.8l-43.6 255.4h211.2l43.6-255.4h126.2l-43.6 255.4h186.4v109.2h-203.8l-24.6 166.6h198.4v109.2h-213l-45 255.6h-126.2l43.6-255.4h-212.8l-43.6 255.4h-126.2l43.6-255.4zM418.8 428.6l-24.8 166.8h211.2l24.6-166.6h-211z"
    ],
    "grid": 0,
    "tags": [
      "ion-pound"
    ]
  },
  {
    "paths": [
      "M512 512c-35.4 0-64-28.6-64-64v-320c0-35.4 28.6-64 64-64s64 28.6 64 64v320c0 35.4-28.6 64-64 64z",
      "M758 137.6v0c-10-6-21.6-9.6-34-9.6-35.4 0-64 28.6-64 64 0 12.4 3.6 24 9.6 33.8 4 6.4 9.2 12.2 15.2 16.8 2.4 1.8 4.8 3.4 7.4 5 16.2 11.2 31.6 23.8 46 38.2 60.6 60.4 93.8 140.8 93.8 226.2s-33.2 165.8-93.8 226.2c-60.4 60.6-140.8 93.8-226.2 93.8s-165.8-33.2-226.2-93.8c-60.6-60.4-93.8-140.8-93.8-226.2s33.2-165.8 93.8-226.2c14.2-14.2 29.6-27 45.8-38 2.8-1.6 5.2-3.2 7.8-5.2 6-4.6 11-10.2 15-16.6 6.2-9.8 9.6-21.4 9.6-33.8 0-35.4-28.6-64-64-64-12.4 0-24 3.6-33.8 9.6l-0.2-0.2c-121.6 80-202 217.8-202 374.4 0 247.4 200.6 448 448 448s448-200.6 448-448c0-156.6-80.4-294.4-202-374.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-power"
    ]
  },
  {
    "paths": [
      "M942 522.8v0c0 0 0 0 0 0l-420.2-423.2c0 0 0 0 0 0l-3-3c0 0-0.8 0-0.8 0-16.6-15.8-35.8-24-59.8-24.6v0l-208.2-7.8c-22.4 0.4-44.4 9-61.4 26.2l-98.4 98.2c-18 18-26.2 41.8-26.2 65.4 0 0 0 0 0 0.2l0.6 8.4 13.4 194.6c0 0.2 0 0.4 0 0.4v3.8c0 0 0 0 0 0 2 17.4 9 34.6 20.8 48.8l11 10.8 418.8 423.8c23.8 21 60 20 82.6-2.8l330.8-333.2c23.6-23.6 24-62.2 0-86zM288 384c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ],
    "grid": 0,
    "tags": [
      "ion-pricetag"
    ]
  },
  {
    "paths": [
      "M944 478.4v0c0 0-0.2 0 0 0l-379.8-382.2c0 0 0 0 0 0l-2.8-2.8c0 0-1 0-1 0-15-14.4-32.2-21.8-54.2-22.2v0l-187.6-6.8c-20.2 0.2-40 8.2-55.4 23.6l-54.2 54.4c14.8-13.2 33.2-20 52-20.2l7.6 0.2 179.6 6.6c22 0.4 39.4 7.8 54.4 22.2 0 0 0.8 0 1 0l2.8 2.8c0 0 0 0 0 0l379.6 382.2c0 0 0 0 0 0v0c20 21.6 21.4 56.4 0 77.8l58-57.8c21.2-21.4 20-56.2 0-77.8z",
      "M856 565c0 0 0.6 0 0.6 0l-379.4-382.2c0 0 0 0 0 0l-2.6-2.8c0 0-0.6 0-0.6 0-15-14.4-31.8-21.8-53.8-22.2v0l-188.2-6.8c-18.4 0.2-36.4 6.8-51.2 19.6-0.6 0.6-1.4 1.2-2 1.8-0.8 0.8-1.6 1.6-2.4 2.4l-88.6 89c-16.2 16.2-23.8 37.8-23.8 59 0 0 0 0 0 0.2l0.2 7.6 11.8 175.8c0 0.2 0 0.2 0 0.4v3.4c0 0 0 0 0 0 2 15.8 8.4 31.2 19.2 44l10.2 9.8 378.2 382.4c21.4 18.8 54.2 18 74.6-2.6l26.2-26.4c1-0.8 1.8-1.6 2.8-2.6l53.8-54c-0.4 0.2-0.6 0.4-1 0.8l216.6-218.6c21.2-21.4 21.4-56.4-0.6-78v0zM221.2 279c13.2-8 28.6-12.6 45.2-12.6 47.8 0 86.8 38.8 86.8 86.8 0 16.6-4.6 32-12.6 45.2-15.2 25-42.6 41.6-74 41.6-47.8 0-86.8-38.8-86.8-86.8-0.2-31.6 16.4-59 41.4-74.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-pricetags"
    ]
  },
  {
    "paths": [
      "M847.6 256h-79.6v-128h-512v128h-79.6c-55.8 0-112.4 33.8-112.4 109.2v247.6c0 76 56.6 123.2 112.4 123.2 0 0 60.8 0 79.6 0v224h512v-224c20.6 0 79.6 0 79.6 0 55.8 0 112.4-45.2 112.4-107.2v-263.6c0-71.4-56.4-109.2-112.4-109.2zM736 928h-448v-352h448v352zM736 256h-448v-96h448v96zM832 384h-34v-32h34v32z",
      "M320 640h384v32h-384v-32z",
      "M320 736h384v32h-384v-32z",
      "M320 832h384v32h-384v-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-printer"
    ]
  },
  {
    "paths": [
      "M256 128c-70.58 0-128 57.42-128 128 0 47.274 25.78 88.614 64 110.782v354.438c-38.22 22.166-64 63.506-64 110.78 0 70.58 57.42 128 128 128s128-57.42 128-128c0-47.274-25.78-88.614-64-110.782v-354.436c38.22-22.168 64-63.508 64-110.782 0-70.58-57.42-128-128-128zM256 896c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM256 320c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z",
      "M830 720.068v-310.090c0-67.974-20.98-122.004-62.36-160.588-44.222-41.236-108.628-60.776-191.64-58.212v-127.178l-192 192 192 192v-128c53 0 85.34 5.284 104.35 23.008 14.366 13.396 21.65 35.928 21.65 66.97v312.392c-37.124 22.434-62 63.178-62 109.628 0 70.58 57.42 128 128 128s128-57.42 128-128c0-48.096-26.676-90.060-66-111.93zM768 896c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-pull-request"
    ]
  },
  {
    "paths": [
      "M192 248.342c0-13.876 10.464-24.342 24.342-24.342h135.658v-96h-133.658c-66.908 0-122.342 53.434-122.342 120.342v135.658h96v-135.658z",
      "M807.158 128h-135.158v96h134.438c13.876 0 25.562 10.464 25.562 24.342v135.658h96v-135.658c0-66.908-53.934-120.342-120.842-120.342z",
      "M832 773.658c0 13.876-10.464 24.342-24.342 24.342h-135.658v98h135.658c66.908 0 120.342-55.434 120.342-122.342v-133.658h-96v133.658z",
      "M216.342 798c-13.878 0-24.342-10.464-24.342-24.342v-133.658h-96v133.658c0 66.908 55.434 122.342 122.342 122.342h133.658v-98h-135.658z"
    ],
    "grid": 0,
    "tags": [
      "ion-qr-scanner"
    ]
  },
  {
    "paths": [
      "M384 128c-81.292 0-144.966 22.458-189.254 66.746s-66.746 107.962-66.746 189.254v512h320v-512h-192c0-46.112 9.844-79.332 29.254-98.746 19.414-19.41 52.634-29.254 98.746-29.254z",
      "M832 128c-81.292 0-144.966 22.458-189.254 66.746s-66.746 107.962-66.746 189.254v512h320v-512h-192c0-46.112 9.844-79.332 29.254-98.746 19.414-19.41 52.634-29.254 98.746-29.254z"
    ],
    "grid": 0,
    "tags": [
      "ion-quote"
    ]
  },
  {
    "paths": [
      "M640 512c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128s128 57.308 128 128z",
      "M288 512c0-73.8 37.106-138.416 92.628-174.068l-46.282-49.024c-12.52 9.216-24.36 19.666-35.368 31.326-48.35 51.224-74.978 119.328-74.978 191.766s26.628 140.542 74.98 191.766c11.008 11.658 22.848 22.11 35.368 31.324l46.282-49.022c-55.524-35.652-92.63-100.268-92.63-174.068z",
      "M736 512c0 73.8-37.106 138.416-92.628 174.068l46.282 49.022c12.52-9.214 24.36-19.666 35.368-31.324 48.35-51.224 74.978-119.328 74.978-191.766s-26.628-140.542-74.98-191.764c-11.008-11.66-22.848-22.11-35.368-31.326l-46.282 49.024c55.524 35.65 92.63 100.266 92.63 174.066z",
      "M128 512c0-111.156 50.502-209.814 128.526-271.634l-45.66-48.366c-11.998 10-23.478 20.792-34.394 32.356-35.244 37.338-62.924 80.834-82.268 129.282-20.042 50.196-30.204 103.474-30.204 158.362 0 54.886 10.162 108.168 30.204 158.362 19.344 48.452 47.024 91.946 82.268 129.284 10.916 11.562 22.396 22.354 34.394 32.356l45.658-48.366c-78.022-61.822-128.524-160.48-128.524-271.636z",
      "M896 512c0 111.156-50.502 209.814-128.524 271.634l45.656 47.696c12-10.002 23.48-20.124 34.396-31.686 35.244-37.338 62.924-80.832 82.268-129.284 20.040-50.192 30.204-103.474 30.204-158.36 0-54.888-10.164-108.166-30.204-158.362-19.344-48.45-47.024-91.944-82.268-129.282-10.914-11.564-22.396-22.356-34.396-32.356l-45.658 48.366c78.024 61.82 128.526 160.478 128.526 271.634z"
    ],
    "grid": 0,
    "tags": [
      "ion-radio-waves"
    ]
  },
  {
    "paths": [
      "M512 928c229.8 0 416-186.2 416-416s-186.2-416-416-416c-229.8 0-416 186.2-416 416s186.2 416 416 416z"
    ],
    "grid": 0,
    "tags": [
      "ion-record"
    ]
  },
  {
    "paths": [
      "M832 704l192-223.8h-129.4c-4.6-55.8-21-108-47-154.6-54.8-98.4-151.6-170.2-266-191.2-1.4-0.2-3-0.6-4.4-0.8-1-0.2-1.8-0.4-2.8-0.4-20.2-3.4-41.2-5.2-62.4-5.2-0.2 0-0.6 0-0.8 0 0 0 0 0 0 0-181.8 0.4-334 127.2-373.4 297.2 0 0 0 0.2 0 0.2-0.6 2.2-1 4.4-1.4 6.6-0.2 1-0.4 1.8-0.6 2.8-0.2 1.4-0.6 2.8-0.8 4.2-0.4 1.8-0.6 3.4-1 5.2-0.2 0.8-0.2 1.4-0.4 2.2-0.4 2.4-0.8 4.8-1.2 7.2 0 0.2 0 0.2 0 0.4-2 12.6-3.2 25.4-3.8 38.2 0 0.6 0 1.2 0 1.6-0.2 2.8-0.2 5.4-0.4 8.2 0 3.2-0.2 6.6-0.2 10s0 6.6 0.2 10c0 2.8 0.2 5.4 0.4 8.2 0 0.6 0 1.2 0 1.8 0.6 13 2 25.8 3.8 38.2 0 0.2 0 0.2 0 0.4 0.4 2.4 0.8 4.8 1.2 7.2 0.2 0.8 0.2 1.4 0.4 2.2 0.4 1.8 0.6 3.6 1 5.2 0.2 1.4 0.6 2.8 0.8 4.2 0.2 1 0.4 2 0.6 2.8 0.4 2.2 1 4.4 1.4 6.4 0 0 0 0.2 0 0.2 39.4 170 192.2 296.8 374.2 297.2 85.8-0.2 166.2-28.4 233.8-81.4l15-11.8-86.4-92.4-12.4 9.2c-44.2 32.6-95 48.4-150 48.4-141.2 0-256-114-256-256s114.8-256 256-256c132.8 0 245.6 93.2 259 224h-147l208 224z"
    ],
    "grid": 0,
    "tags": [
      "ion-refresh"
    ]
  },
  {
    "paths": [
      "M609 384v-160l-303.6 287.6 303.6 268.4v-183.8c136 0 215.8 17.8 318.2 203.8 0 0-12.2-416-318.2-416z",
      "M95 512l288 253v-117l-164.4-136 164.4-157.2v-114z"
    ],
    "grid": 0,
    "tags": [
      "ion-reply-all"
    ]
  },
  {
    "paths": [
      "M896 800c0 0-73.6-416-448-416v-160l-320 288 320 268.8v-184.6c203.2 0 342 17.8 448 203.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-reply"
    ]
  },
  {
    "paths": [
      "M704 64l-165.8 353.224c79.992 7.216 150.546 47.108 198.192 106.256l127.608-267.48-160-192z",
      "M320 64l165.8 353.224c-79.992 7.216-150.546 47.108-198.192 106.256l-127.608-267.48 160-192z",
      "M538.184 64h-186.184l105.144 224h109.712l105.144-224z",
      "M512 448c-141.384 0-256 114.616-256 256s114.616 256 256 256 256-114.616 256-256-114.616-256-256-256zM512 896c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z",
      "M512 528c-97.046 0-176 78.954-176 176s78.954 176 176 176 176-78.954 176-176-78.954-176-176-176z"
    ],
    "grid": 0,
    "tags": [
      "ion-ribbon-a"
    ]
  },
  {
    "paths": [
      "M512 144c-97.046 0-176 78.954-176 176s78.954 176 176 176 176-78.954 176-176-78.954-176-176-176z",
      "M512 64c-141.384 0-256 114.616-256 256s114.616 256 256 256 256-114.616 256-256-114.616-256-256-256zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z",
      "M294.184 508.42l-166.184 291.58h192l96 160 163.282-359.922c-21.586 5.168-44.112 7.922-67.282 7.922-87.010 0-165.006-38.586-217.816-99.58z",
      "M729.816 508.422c-30.154 34.824-68.52 62.344-112.086 79.548l-89.504 196.184 79.774 175.846 96-160h192l-166.184-291.578z"
    ],
    "grid": 0,
    "tags": [
      "ion-ribbon-b"
    ]
  },
  {
    "paths": [
      "M798.566 567.594c-10.2-32.758-28.44-59.99-67.604-74.526s-70.53-5.754-99.736 12.3c-15.23 9.414-20.058 28.038-8.428 44.246 4.098 5.708 10.038 9.434 16.752 11.926 10.118 3.752 21.168 3.356 29.93-2.072 9.556-5.914 21.288-13.052 39.214-6.398 18.020 6.686 22.206 19.678 25.504 30.322 3.102 9.904 11.24 17.448 21.386 21.212 6.714 2.492 13.632 3.548 20.472 1.876 17.734-4.368 27.832-21.814 22.51-38.886z",
      "M393.098 505.37c-29.206-18.054-60.572-26.836-99.736-12.3s-57.404 41.768-67.604 74.526c-5.322 17.072 4.778 34.518 22.51 38.886 6.84 1.674 13.756 0.618 20.472-1.876 10.146-3.766 18.286-11.308 21.386-21.212 3.298-10.644 7.486-23.636 25.504-30.322 17.928-6.654 29.658 0.484 39.214 6.398 8.762 5.428 19.814 5.824 29.93 2.072 6.714-2.492 12.654-6.216 16.752-11.926 11.63-16.21 6.802-34.832-8.428-44.246z",
      "M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM783.53 783.53c-72.53 72.526-168.96 112.47-271.53 112.47s-199-39.944-271.53-112.47c-72.526-72.53-112.47-168.96-112.47-271.53s39.944-199 112.47-271.53c72.53-72.526 168.96-112.47 271.53-112.47s199 39.944 271.53 112.47c72.526 72.53 112.47 168.96 112.47 271.53s-39.944 199-112.47 271.53z",
      "M698.238 718.352c-2.212-3.172-56.238-78.352-186.238-78.352-130.522 0-184.028 75.18-186.242 78.352-10.114 14.494-6.566 34.442 7.926 44.556 5.578 3.892 11.964 5.762 18.286 5.762 10.104 0 20.048-4.776 26.27-13.69 0.352-0.502 37.8-50.98 133.76-50.98 96 0 133.406 50.478 133.758 50.98 6.22 8.914 16.162 13.69 26.268 13.69 6.322 0 12.708-1.87 18.288-5.762 14.49-10.116 18.040-30.062 7.924-44.556z"
    ],
    "grid": 0,
    "tags": [
      "ion-sad-outline"
    ]
  },
  {
    "paths": [
      "M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM290.124 583.392c-3.102 9.904-11.24 17.448-21.386 21.212-6.716 2.492-13.632 3.548-20.472 1.876-17.732-4.37-27.832-21.814-22.51-38.886 10.202-32.758 28.44-59.99 67.604-74.526s70.53-5.754 99.736 12.3c15.23 9.414 20.058 28.038 8.428 44.246-4.098 5.708-10.038 9.434-16.752 11.926-10.118 3.752-21.168 3.356-29.93-2.072-9.556-5.914-21.286-13.052-39.214-6.398-18.018 6.686-22.204 19.678-25.504 30.322zM690.312 762.908c-5.578 3.892-11.964 5.762-18.288 5.762-10.106 0-20.046-4.776-26.268-13.69-0.35-0.502-37.756-50.98-133.756-50.98-95.96 0-133.408 50.478-133.758 50.98-6.222 8.914-16.166 13.69-26.27 13.69-6.322 0-12.708-1.87-18.286-5.762-14.492-10.116-18.042-30.062-7.926-44.556 2.212-3.172 55.718-78.352 186.24-78.352 130 0 184.026 75.18 186.238 78.352 10.116 14.494 6.566 34.44-7.926 44.556zM776.058 606.48c-6.84 1.674-13.758 0.618-20.472-1.876-10.146-3.766-18.286-11.308-21.386-21.212-3.298-10.644-7.484-23.636-25.504-30.322-17.928-6.654-29.658 0.484-39.214 6.398-8.762 5.428-19.812 5.824-29.93 2.072-6.714-2.492-12.654-6.216-16.752-11.926-11.63-16.208-6.802-34.832 8.428-44.246 29.208-18.054 60.572-26.836 99.736-12.3s57.404 41.768 67.604 74.526c5.32 17.072-4.778 34.518-22.51 38.886z"
    ],
    "grid": 0,
    "tags": [
      "ion-sad"
    ]
  },
  {
    "paths": [
      "M810.356 231.334c26.628-65.334 34.618-128-10.652-167.334l-288.252 384-33.952 46c0 0-55.254 80.022-74.56 117.334s-38.612 78.666-54.588 108c-14.020 25.742-20.876 30.442-28.644 23.096-1.012-1.182-2.052-2.336-3.106-3.472-0.074-0.094-0.146-0.18-0.22-0.276-2.286-2.944-5.5-6.004-9.27-8.934-18.722-16.158-42.016-25.748-67.272-25.748-61.766 0-111.84 57.306-111.84 128s50.074 128 111.84 128c50.564 0 93.27-38.41 107.106-91.122l-0.008 0.086c0 0 26.71-82.964 65.322-142.964s99.192-86 99.192-86l63.908-64c0 0 208.366-279.332 234.996-344.666zM239.84 896c-30.836 0-55.836-28.706-55.836-64s25-64 55.836-64c30.838 0 55.836 28.706 55.836 64s-24.998 64-55.836 64zM512 576c-17.672 0-32-14.326-32-32 0-17.672 14.328-32 32-32 17.674 0 32 14.328 32 32 0 17.674-14.326 32-32 32z",
      "M414.56 530.51c18.36-28.228 35.342-52.86 36.608-54.692l0.286-0.416 0.3-0.406 34.106-46.208 5.882-7.836-267.95-356.952c-45.268 39.334-37.28 102-10.652 167.334 19.906 48.84 141.358 217.246 201.42 299.176z",
      "M783.656 704c-25.256 0-48.55 9.59-67.274 25.748-3.77 2.93-6.984 5.99-9.27 8.934-0.074 0.096-0.144 0.182-0.218 0.276-1.052 1.136-2.094 2.292-3.106 3.472-7.768 7.346-14.624 2.646-28.644-23.096-15.976-29.334-35.282-70.688-54.588-108-3.54-6.842-8.292-15.122-13.686-24.076-2.544 3.424-4.528 6.086-5.864 7.876l-1.376 1.848-1.626 1.63-57.376 57.458c20.866 13.71 49.13 36.552 70.612 69.93 38.61 60 65.32 142.964 65.32 142.964l-0.008-0.086c13.834 52.712 56.54 91.122 107.104 91.122 61.766 0 112.344-57.306 112.344-128s-50.578-128-112.344-128zM783.656 896c-30.84 0-55.836-28.706-55.836-64s24.996-64 55.836-64c30.836 0 55.836 28.706 55.836 64s-25 64-55.836 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-scissors"
    ]
  },
  {
    "paths": [
      "M890 773.4l-169.6-171.8c27.6-48.2 42-101.8 42-155.8 0-175.2-142.4-317.8-317.2-317.8s-317.2 142.6-317.2 317.8c0 175.2 142.4 317.8 317.2 317.8 55.8 0 111-15.4 160.2-44.8l168.8 171.2c3.8 3.8 9.2 6.2 14.6 6.2s10.8-2.2 14.6-6.2l86.6-87.6c8-8.2 8-21-0-29zM445.2 251.8c106.8 0 193.6 87 193.6 194s-86.8 194-193.6 194c-106.8 0-193.6-87-193.6-194s86.8-194 193.6-194z"
    ],
    "grid": 0,
    "tags": [
      "ion-search"
    ]
  },
  {
    "paths": [
      "M900 276.6l-95.4 97-5.4 5.6-3.2 3.4c-2.2 1.6-4.8 2.4-7.8 2.4-3.2 0-6.2-1.2-8.6-3.2l-7.2-7.2-87-88.6-3.4-3.4c-2-3-3.2-6.8-3.2-10.6 0-3.4 1.2-6.4 3.2-8.8l1.4-1.6 5.2-5.2 95.8-97.4c-10.2-20.2-49.4-29.8-70.2-28.2-34.2 2.6-69.4 14-105.6 51-1.4 1.6-3 3.2-4.4 4.6-49.2 53.6-59 125.6-39 191.6 1.4 2.8 2.6 6.2 3.2 9.2 2.2 11-0.8 20.4-8 27l-75.8 72.8c-23.6-24-27-27.2-27-27.2-4-4-12-6.6-19-2.4l-11.8 7.2c-45.4-46.2-64.6-64.8-70.8-87.2-6.4-23.4-0.6-54.6 5.4-66.2 5-9.2 20.6-17.8 33.8-18.8l17.2 17.6c4 4 10.2 4 14.2 0l61.8-62.8c4-4 4-10.6 0-14.6l-99.8-101.4c-4-4-10.4-4-14.2 0l-61.8 62.8c-4 4-4 10.6 0 14.6l6.6 6.8c0 9.8-1.4 25-9.4 33.2-12.4 12.6-37-2-53 9.4-15.8 11.2-35.8 29.2-48.6 42-12.6 12.8-61 63.6-95.6 149.2s-8 165 10.8 185.8c10 11 28.2 22.2 25 1.4-3.2-21-8.4-93.8 15.4-123.6s55.2-54.2 96-56.2c39.2-2 61.8 11.4 112.6 63l-5.6 10.4c-3.6 6.8-1.6 15.4 2.4 19.4 0 0 3 3.2 24.2 24.8l-194.4 186.4c-32.4 28.6-30.6 81-0.6 112 30.4 30.4 82.2 32.6 110.4-0.4l182.8-197.2c98.2 104.6 186.6 214.8 186.6 214.8 4 4 10.4 4 14.2 0l99.8-101.4c4-4 4-10.4 0-14.6 0 0-110.4-91.4-214-192.4l71-76.6c6.6-7.4 15.8-10.4 26.6-8.2 3 0.6 6.2 2 9 3.4 64.8 20.4 135.6 10.4 188-39.6 1.6-1.4 3-3 4.6-4.6 36.2-36.8 47.4-72.8 50-107.6 2-21.2-7-60.6-27.4-71.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-settings"
    ]
  },
  {
    "paths": [
      "M704 755.8h-499.2v-359.4h115c0 0 28.2-39.4 85.4-76.4h-238.8c-21.2 0-38.4 17-38.4 38.2v435.8c0 21 17.2 38.2 38.4 38.2h576c21.2 0 38.4-17 38.4-38.2v-218l-76.8 62.8v117zM640 448v127.8l256-191-256-192.8v119.4c-309.6 0-320 328.6-320 328.6 87.6-143 152-192 320-192z"
    ],
    "grid": 0,
    "tags": [
      "ion-share"
    ]
  },
  {
    "paths": [
      "M740.2 362.6h57.8v94.6l162-166.4-162-162.8v108h-57.8c-165.4 0-258.8 123.8-341.2 233-74 98.2-138 190.8-241.2 190.8h-93.8v126.6h93.8c165.4 0 258.8-131.6 341.2-240.8 74-98.2 137.8-183 241.2-183zM306.4 435c7-9.2 14.2-18.6 21.4-28.2 17.6-23.2 36-47.8 56-72.2-59.2-55.8-130.6-97-226-97h-93.8v126.6c0 0 26.6-1.2 93.8 0 65 1.4 105.8 28.2 148.6 70.8zM798 660.8h-57.8c-63 0-111.4-31.6-156.4-78.6-4.4 6-9 12-13.6 18-19.8 26.2-41 54.4-64.4 82.2 60.8 59.8 134.4 105 234.4 105h57.8v108.6l162-162.8-162-166.4v94z"
    ],
    "grid": 0,
    "tags": [
      "ion-shuffle"
    ]
  },
  {
    "paths": [
      "M151.4 192h16.2c13.4 0 24.4 10 24.4 23.4v227l374.2-245c5-3.4 10.2-4.6 16.2-4.6 16.6 0 30.8 14 30.8 34v126.2l237-156.4c5-3.4 10-4.6 16.2-4.6 16.6 0 29.8 14.8 29.8 34.8v572c0 20-13.4 33-30 33-6.2 0-10.8-2.4-16.4-5.8l-236.6-155.2v128c0 20-14.4 33-31 33-6.2 0-11-2.4-16.4-5.8l-373.8-244.4v226c0 13.4-10.8 24.4-24.4 24.4h-16.2c-13.4 0-23.4-11-23.4-24.4v-592.2c0-13.4 9.8-23.4 23.4-23.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-skip-backward"
    ]
  },
  {
    "paths": [
      "M872.6 192h-16.2c-13.4 0-24.4 10-24.4 23.4v227l-374.2-245c-5-3.4-10.2-4.6-16.2-4.6-16.6 0-30.8 14-30.8 34v126.2l-237-156.4c-5-3.4-10.2-4.6-16.2-4.6-16.6 0-29.8 14.8-29.8 34.8v572c0 20 13.4 33 30 33 6.2 0 10.8-2.4 16.4-5.8l236.6-155.2v128c0 20 14.4 33 31 33 6.2 0 11-2.4 16.4-5.8l373.8-244.4v226c0 13.4 10.8 24.4 24.4 24.4h16.2c13.4 0 23.4-11 23.4-24.4v-592.2c0-13.4-9.8-23.4-23.4-23.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-skip-forward"
    ]
  },
  {
    "paths": [
      "M704 416v298h-78v134c0 8.8-6 15.8-14.6 16v0h-0.2c-0.2 0-0.4 0-0.6 0-3.2 0-6.2-1.2-8.6-3.2l-0.2-0.2-0.8-0.2c-4-3.2-6.8-8-6.8-12.4v-134h-162.2v134c0 8.8-7.2 16-16 16s-16-7.2-16-16v-134h-80v-298h384zM736 384h-448v332c0 13.8 11 30 24.8 30h55.2v102c0 26.6 21.4 48 48 48s48-21.4 48-48v-102h98v102c0 15 7.8 28.4 18.6 37.2 7.8 6.8 18.6 10.8 30 10.8 0.2 0 0.6 0 0.8 0s-0.6 0-0.4 0c26.6 0 47.2-21.4 47.2-48v-102h57.2c14 0 20.8-16.2 20.8-29.8v-332.2h-0.2z",
      "M816 384c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16s-16-7.2-16-16v-192c0-8.8 7.2-16 16-16zM816 352c-26.6 0-48 21.4-48 48v192c0 26.6 21.4 48 48 48s48-21.4 48-48v-192c0-26.6-21.4-48-48-48v0z",
      "M208 384c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16s-16-7.2-16-16v-192c0-8.8 7.2-16 16-16zM208 352c-26.6 0-48 21.4-48 48v192c0 26.6 21.4 48 48 48s48-21.4 48-48v-192c0-26.6-21.4-48-48-48v0z",
      "M510 188.6h1.8c28.4 0 54.6 3.8 77.6 11.2l20 8.8c57.4 25.2 79.8 74.8 88.8 111.4h-372.6c8.8-37.2 31.2-87.2 88.2-112l20.6-9c22.6-6.8 48-10.4 75.6-10.4zM370.8 128c-1 0-2.4 0.4-3.6 1.6-2.2 1.6-3.4 3.6-2.6 5l36.6 44.2c-96.4 41.8-110.8 143.4-112.8 173.4h447.2c-2.2-30-16.4-130.2-113.2-172.8l37-44.4c0.8-1-0.4-3.4-2.6-5.2-1.4-1-3-1.6-4-1.6-0.6 0-1 0.2-1.4 0.6l-38.4 45.4c-27.2-10.8-60.4-17.6-101.2-17.6-0.6 0-1.2 0-2 0-40 0-72.8 6.6-99.6 17l-38-45c0-0.4-0.6-0.6-1.4-0.6v0z",
      "M413.2 277.8c-14.8 0-27-12-27-26.6s12-26.6 27-26.6c14.8 0 27 12 27 26.6s-12 26.6-27 26.6z",
      "M610 277.8c-14.8 0-27-12-27-26.6s12-26.6 27-26.6c14.8 0 27 12 27 26.6s-12.2 26.6-27 26.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-android-outline"
    ]
  },
  {
    "paths": [
      "M288 536.8v179.2c0 13.8 9 28 22.8 28h57.2v104c0 26.6 21.4 48 48 48s48-21.4 48-48v-104h98v104c0 15 6.8 28.4 17.6 37.2 7.8 6.8 18.2 10.8 29.4 10.8 0.2 0 0.4 0 0.6 0s0.2 0 0.4 0c26.6 0 48-21.4 48-48v-104h55.2c14 0 22.8-14.2 22.8-27.8v-332.2h-448v152.8z",
      "M816 352c-26.6 0-48 21.4-48 48v192c0 26.6 21.4 48 48 48s48-21.4 48-48v-192c0-26.6-21.4-48-48-48z",
      "M208 352c-26.6 0-48 21.4-48 48v192c0 26.6 21.4 48 48 48s48-21.4 48-48v-192c0-26.6-21.4-48-48-48z",
      "M622.4 178.2l37-43.8c0.8-1-0.4-3.2-2.6-5-2.2-1.6-4.8-2-5.4-0.8l-38.4 45.6c-27.2-10.8-60.4-17.6-101.2-17.6-41-0.2-74.4 6.4-101.6 17l-38-44.8c-0.8-1-3.2-0.8-5.4 0.8s-3.4 3.6-2.6 5l36.6 43.2c-96.4 41.8-110.8 144.4-112.8 174.4h447.2c-1.8-30.2-16-131.4-112.8-174zM413.6 277.8c-14.8 0-27-12-27-26.6s12-26.6 27-26.6c14.8 0 27 12 27 26.6s-12 26.6-27 26.6zM610.4 277.8c-14.8 0-27-12-27-26.6s12-26.6 27-26.6c14.8 0 27 12 27 26.6s-12.2 26.6-27 26.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-android"
    ]
  },
  {
    "paths": [
      "M511.964 128l375.934 138.21-78.34 460.778-297.762 159.898-297.624-160.102-78.11-460.564 375.902-138.22zM511.962 64l-447.962 160 92.24 544 355.76 192 355.5-192 92.5-544-448.038-160z",
      "M688 704h80l-256-560-256 560h80l53.168-112h245.654l53.178 112zM427.146 512l84.838-178.712 84.854 178.712h-169.692z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-angular-outline"
    ]
  },
  {
    "paths": [
      "M427.146 512h169.692l-84.854-178.712z",
      "M511.962 64l-447.962 160 92.24 544 355.76 192 355.5-192 92.5-544-448.038-160zM688 704l-53.178-112h-245.654l-53.168 112h-80l256-560 256 560h-80z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-angular"
    ]
  },
  {
    "paths": [
      "M667.2 339.8c32.6 0 66.4 14.8 94.8 40.8-19.8 17-35.8 37.4-47.4 60.4-16 32-23.2 68.6-20.4 105.4 2.6 37.4 15.2 73.2 36 103.6 16 23.2 36.4 42.4 60 56.6-10 21.4-18.4 36.8-33.6 61-16.8 26.2-61 96-104 96.4h-0.8c-14.8 0-24.4-4.4-38.6-11.2-20-9.4-44.6-21.2-86.8-21.2h-1.2c-42.2 0.2-67.6 11.8-87.8 21.2-14.8 6.8-24.6 11.4-39.8 11.4h-0.8c-39.2-0.4-75-48.6-101.6-90.4-38.6-60.8-63.4-131.2-69.8-198.2-5.8-61 4-117 27-153.4 16-25.4 37-46.6 60.8-61.2 22.4-13.6 46-20.8 68.4-20.8 24.8 0 45.4 7.6 67.4 15.6 23 8.4 47 17.2 75.4 17.2 27.2 0 48.6-8.4 69.2-16.4 22.4-8.8 42.8-16.8 73.6-16.8zM667.2 307.8c-67.2 0-95.6 33-142.4 33-48 0-84.6-32.8-142.8-32.8-57 0-117.8 35.8-156.4 96.8-54.2 86-45 248 42.8 386 31.4 49.4 73.4 104.8 128.4 105.4 0.4 0 0.6 0 1 0 47.8 0 62-32.2 127.8-32.6 0.4 0 0.6 0 1 0 64.8 0 77.8 32.4 125.4 32.4 0.4 0 0.6 0 1 0 55-0.6 99.2-62 130.6-111.2 22.6-35.4 31-53.2 48.4-93.2-127-49.6-147.4-234.8-21.8-305.8-38.4-49.4-92.2-78-143-78v0z",
      "M619.8 169c-5.4 29.8-21 53.6-29.2 64.4-14.8 19.6-36 34.8-57.6 42.2 1-6 2.6-12.2 4.8-18.4 7-20.4 17.8-36.4 25.6-46.2 14.2-17.6 35.2-32.8 56.4-42zM652.4 128c-40 2.8-86.6 29-114 63.2-24.8 31-45.2 77-37.2 121.6 1 0 2 0 3.2 0 42.6 0 86.2-26.4 111.6-60.2 24.6-32.2 43.2-77.8 36.4-124.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-apple-outline"
    ]
  },
  {
    "paths": [
      "M667.2 307.8c-67.2 0-95.6 33-142.4 33-48 0-84.6-32.8-142.8-32.8-57 0-117.8 35.8-156.4 96.8-54.2 86-45 248 42.8 386 31.4 49.4 73.4 104.8 128.4 105.4 0.4 0 0.6 0 1 0 47.8 0 62-32.2 127.8-32.6 0.4 0 0.6 0 1 0 64.8 0 77.8 32.4 125.4 32.4 0.4 0 0.6 0 1 0 55-0.6 99.2-62 130.6-111.2 22.6-35.4 31-53.2 48.4-93.2-127-49.6-147.4-234.8-21.8-305.8-38.4-49.4-92.2-78-143-78v0z",
      "M652.4 128c-40 2.8-86.6 29-114 63.2-24.8 31-45.2 77-37.2 121.6 1 0 2 0 3.2 0 42.6 0 86.2-26.4 111.6-60.2 24.6-32.2 43.2-77.8 36.4-124.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-apple"
    ]
  },
  {
    "paths": [
      "M559.4 96v124.2l30.2 1.6c33.8 1.8 57.6 6.6 81.4 15.8 27.6 10.6 48.4 25.2 62.2 43.4 11.4 15.2 18 38.8 20 72.4 1.2 17.6-2 34.2-5.2 44-3 8.8-10.6 22.6-22.2 32.8-10.8 9.6-17.2 13.4-24.6 16.8l-84.2 38.6 90 21.6c14.8 3.6 28 8.8 42.8 17 26.4 14.6 36 30.2 42.4 45 5.8 13.4 9.2 44.4 7.8 72.4-1.4 26.8-8.8 63-25.2 84.6-17.2 22.4-42.6 40.2-75.6 52.6-27.2 10.2-62.2 16.2-109 18.6l-30.4 1.4v129.2h-16v-128h-127.8v128h-18v-128h-166.4l6-32h25.6c17.2 0 24.2-0.8 35-6 0.4-0.2 0.8-0.4 1.4-0.6 16.2-7.4 22-21.2 24.4-27.2 0.2-0.6 0.6-1.4 0.6-1.6 5.8-11.8 6-26.2 6-48.8v-356c0-23.4-0.2-27.2-6.2-39-5.8-11.6-14.6-20.2-26.8-26-11.8-5.6-26.4-6.8-49-6.8h-25.8v-32h175.2v-128h18v128h127.6v-128h15.8zM591.4 64h-79.8v128h-63.6v-128h-81.8v128h-174.2v96h56.8c17.4 0 29 0.6 35.2 3.6s9.4 6.6 12 11.6c2.6 5 2.8 6.2 2.8 24.6v356c0 18-0.2 29.4-1.8 35.2-2.4 5.4-4.4 10.4-10.6 13.2s-5.8 3.8-23.2 3.8h-54.8l-16.4 96h174.2v128h81.8v-128h63.6v128h79.8v-130.8c52-2.6 88.8-9.4 118.6-20.6 38.6-14.4 68.6-35.4 89.8-63 21-27.6 30-69.8 31.8-102.4 1.6-29-1.4-66.4-10.4-86.8-10-23-25.4-43.2-56.2-60.2-16.2-9-32.2-15.6-50.8-20 10.8-5 19.8-10.8 32.6-22 15-13.2 26-31.4 31.2-46.6 5.2-15 8.2-36 7-56.4-2.2-33.6-8.8-66.2-26.4-89.6s-43.4-41.4-76.2-54c-25.2-9.6-51-15.6-91-17.8v-125.8z",
      "M512 300h-64v148h64v-148z",
      "M512 544h-64v180h64v-180z",
      "M592 307.8v131.2c12-5.8 19-13.6 26.6-23.4 9.2-12 14-25.8 14-41.4 0-16.2-4.8-30-13.4-41.6-7.8-10.2-15.2-19.8-27.2-24.8v0z",
      "M592 547.2v165.6c4-1.2 7.6-1.6 11.6-3.2 19.6-7.6 31.6-15.8 47.2-29.4 15-13.2 19.4-31.8 19.4-53.2 0-18.2-6.6-33.8-15.8-46.4s-23.4-19.8-38.8-26.4c-7.4-3.4-13.6-5.4-23.6-7v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-bitcoin-outline"
    ]
  },
  {
    "paths": [
      "M821 558.4c-10-23-25.4-43.2-56.2-60.2-16.4-9-32.2-15.6-50.8-20 10.8-5 20-10.8 32.6-22 15-13.2 26.2-31.4 31.2-46.6 5.2-15 8.2-36 7-56.4-2.2-33.6-8.8-66.2-26.4-89.6s-42.4-41.4-75.2-54c-25.2-9.6-51-15.6-91-17.8v-127.8h-80v128h-64v-128h-82v128h-174.2v96h55.8c17.4 0 29.2 1.6 35.2 4.6 6.2 3 10.6 7 13 12 2.6 5 3.8 16.8 3.8 35v346.4c0 18-1.2 29.6-3.8 34.8s-4 9.8-10.2 12.6c-6.2 2.8-6.4 2.6-23.6 2.6h-52.8l-17.4 96h174v128h82v-128h64v128h80v-128.8c52-2.6 89-9.4 118.8-20.6 38.6-14.4 68.2-35.4 89.4-63s29.8-69.8 31.6-102.4c1.4-29-1.8-66.4-10.8-86.8zM448 300h64v148h-64v-148zM448 724v-180h64v180h-64zM592 307.8c12 5 19.8 15 27.6 25.4 8.6 11.4 13 26.6 13 42.8 0 15.6-5.8 29-15 41-7.6 9.8-13.6 16.6-25.6 22.2v-131.4zM649.6 681.2c-15.6 13.8-24.6 20.2-44.2 27.6-4 1.6-9.4 2.8-13.4 3.8v-165.6c10 1.6 15.2 3.6 22.6 6.8 15.6 6.6 30.4 13.8 39.6 26.4s16 31.2 16 49.4c0 21.8-5.6 38.4-20.6 51.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-bitcoin"
    ]
  },
  {
    "paths": [
      "M141.4 329l338.4 163.4c8.8 4.2 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c17.8-8.6 17.8-22.6 0-31.2l-338.4-163.4c-8.8-4.2-20.6-6.4-32.2-6.4s-23.4 2.2-32.2 6.4l-338.4 163.4c-17.8 8.6-17.8 22.6 0 31.2zM493.6 163.2c3.2-1.6 9.8-3.2 18.4-3.2s15 1.6 18.4 3.2l311 150.2-311 150.2c-3.2 1.6-9.8 3.2-18.4 3.2s-15-1.6-18.4-3.2l-311-150.2 311-150.2z",
      "M882.6 496.4c0 0-61.8-29.8-70-33.8s-10.4-3.8-19 0.2-249.6 120.4-249.6 120.4c-9 4.2-20.6 6.4-32.2 6.4s-23.4-2.2-32.2-6.4c0 0-234.6-113.2-245.6-118.6-12-5.8-15.4-5.8-26.2-0.6-11.2 5.4-66.8 32.2-66.8 32.2-17.8 8.6-17.8 22.6 0 31.2l338.4 163.4c8.8 4.2 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c18.2-8.4 18.2-22.4 0.4-31zM530.4 662.2c-3.2 1.6-9.8 3.2-18.4 3.2s-15-1.6-18.4-3.2l-311-150.2 37.8-18.2 245.4 118.6c12.8 6.2 29.2 9.6 46.2 9.6s33.2-3.4 46.2-9.6l245.4-118.6 37.8 18.2-311 150.2z",
      "M882.6 695c0 0-61.8-29.8-70-33.8s-10.4-3.8-19 0.2-249.4 120.6-249.4 120.6c-9 4.2-20.6 6.4-32.2 6.4s-23.4-2.2-32.2-6.4c0 0-234.6-113.2-245.6-118.6-12-5.8-15.4-5.8-26.2-0.6-11.2 5.4-66.8 32.2-66.8 32.2-17.8 8.6-17.8 22.6 0 31.2l338.4 163.4c8.8 4.4 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c18-8.6 18-22.6 0.2-31.2zM530.4 860.8c-3.2 1.6-9.8 3.2-18.4 3.2s-15-1.6-18.4-3.2l-311-150.2 37.8-18.2 245.4 118.6c12.8 6.2 29.2 9.6 46.2 9.6s33.2-3.4 46.2-9.6l245.4-118.6 37.8 18.2-311 150.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-buffer-outline"
    ]
  },
  {
    "paths": [
      "M141.4 329l338.4 163.4c8.8 4.2 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c17.8-8.6 17.8-22.6 0-31.2l-338.4-163.4c-8.8-4.2-20.6-6.4-32.2-6.4s-23.4 2.2-32.2 6.4l-338.4 163.4c-17.8 8.6-17.8 22.6 0 31.2z",
      "M882.6 496.4c0 0-61.8-29.8-70-33.8s-10.4-3.8-19 0.2-249.6 120.4-249.6 120.4c-9 4.2-20.6 6.4-32.2 6.4s-23.4-2.2-32.2-6.4c0 0-234.6-113.2-245.6-118.6-12-5.8-15.4-5.8-26.2-0.6-11.2 5.4-66.8 32.2-66.8 32.2-17.8 8.6-17.8 22.6 0 31.2l338.4 163.4c8.8 4.2 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c18.2-8.4 18.2-22.4 0.4-31z",
      "M882.6 695c0 0-61.8-29.8-70-33.8s-10.4-3.8-19 0.2-249.4 120.6-249.4 120.6c-9 4.2-20.6 6.4-32.2 6.4s-23.4-2.2-32.2-6.4c0 0-234.6-113.2-245.6-118.6-12-5.8-15.4-5.8-26.2-0.6-11.2 5.4-66.8 32.2-66.8 32.2-17.8 8.6-17.8 22.6 0 31.2l338.4 163.4c8.8 4.4 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c18-8.6 18-22.6 0.2-31.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-buffer"
    ]
  },
  {
    "paths": [
      "M512 64c-246.4 0-448 201.6-448 448s201.6 448 448 448 448-201.6 448-448-201.6-448-448-448zM512 153.598c132.168 0 248.63 71.686 309.116 179.204h-309.116c-87.37 0-159.034 62.716-174.716 143.368l-107.516-185.938c64.948-82.862 168-136.634 282.232-136.634zM646.4 512c0 73.914-60.486 134.4-134.4 134.4s-134.4-60.486-134.4-134.4 60.486-134.4 134.4-134.4 134.4 60.486 134.4 134.4zM153.598 512c0-64.968 17.916-125.432 49.288-179.2l154.544 268.8c31.37 53.77 87.37 89.6 154.57 89.6 20.17 0 40.314-4.482 58.232-11.2l-107.516 185.916c-174.716-22.4-309.118-172.486-309.118-353.916zM512 870.402l154.57-268.802c15.662-26.884 24.628-56 24.628-89.6 0-53.77-24.628-100.798-62.716-134.4h215.034c17.914 42.568 26.886 87.37 26.886 134.4 0 197.114-161.288 358.402-358.402 358.402z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-chrome-outline"
    ]
  },
  {
    "paths": [
      "M377.6 511.85c0 73.892 60.486 134.356 134.4 134.356s134.398-60.462 134.398-134.356c0-73.89-60.484-134.358-134.398-134.358s-134.4 60.468-134.4 134.358z",
      "M953.504 435.59c-0.018 0.010-0.032 0.076-0.048 0.084-3.402-19.754-8.080-39.676-13.978-57.676h-0.214c5.966 18 10.704 38 14.144 58h-0.004c-3.438-20-8.176-40-14.14-58h-310.78c38.088 34 62.716 80.35 62.716 134.104 0 33.592-8.968 62.568-24.628 89.448l-204.484 355.354c0 0-0.018 0.528-0.028 0.528l-0.020 0.568c0.010 0 0.018 0 0.030 0l-0.010-0.524c16.406 1.84 33.062 2.524 49.94 2.524 13.684 0 27.218-0.786 40.598-2.004 20.27-1.822 40.154-5.038 59.554-9.466 199.208-45.48 347.848-223.722 347.848-436.648 0-25.998-2.242-51.506-6.496-76.292z",
      "M512 690.992c-67.202 0-123.202-35.82-154.57-89.57l-205.692-355.8c-20.586 27.792-38.030 58.044-51.806 90.246-23.118 54.022-35.932 113.504-35.932 175.982 0 125.39 51.568 238.72 134.632 320.018 58.684 57.438 133.090 98.866 216.176 117.238l0.058-0.102 155.366-269.208c-17.918 6.716-38.062 11.196-58.232 11.196z",
      "M182.584 209.15l154.7 266.5c15.682-80.624 87.346-143.65 174.716-143.65h410.344c-13.842-30-31.188-60.648-51.558-87.876 0.078 0.042 0.156 0.106 0.234 0.148 20.268 27.152 37.536 57.728 51.324 87.728h0.344c-13.768-30-31.028-60.76-51.336-87.98-0.23-0.12-0.458-0.336-0.684-0.514-81.718-108.972-211.95-179.506-358.668-179.506-52.744 0-103.346 9.138-150.344 25.872-69.23 24.654-130.606 65.834-179.374 118.812l0.284 0.486c0.006-0.008 0.012-0.014 0.018-0.020z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-chrome"
    ]
  },
  {
    "paths": [
      "M775.094 407.448c-82.27-54.652-164.45-109.442-246.522-164.39-11.688-7.824-22.24-7.604-33.876 0.19-81.57 54.626-163.636 109.092-245.448 163.352-10.206 6.768-15.248 15.15-15.248 27.432v159.458c0 12.348 4.968 20.684 15.188 27.46 81.812 54.26 163.682 108.722 245.25 163.352 11.62 7.782 22.262 8.11 33.968 0.274 82.070-54.948 164.29-109.746 246.572-164.376 9.716-6.452 15.022-14.618 15.022-26.188v-161.246c-0-11.432-5.55-19.106-14.906-25.318zM536 304.968l186.11 124.436-79.502 52.934c-1.838 1.206-5.846 1.208-7.678 0-31.888-21.002-63.632-42.226-95.254-63.63-2.066-1.398-3.656-4.638-3.676-7.040v-106.7zM488 305.53v103.412c-0.048 3.65-2.626 8.632-5.598 10.668-30.516 20.902-61.31 41.402-92.218 61.72-2.34 1.54-7.094 2.296-9.132 0.97-26.232-17.062-52.174-34.568-79.574-52.886 62.456-41.636 186.522-123.884 186.522-123.884zM282 474.232l59.244 39.542-59.244 39.676v-79.218zM488 722.634c0 0-124.068-82.824-186.392-124.374l77.742-52.308c4.144-2.884 6.946-2.688 11.004 0.058 30.64 20.72 61.48 41.144 92.124 61.86 2.416 1.63 5.498 4.742 5.522 7.192v107.572zM517.898 565.784c-3.648 2.216-9.024 2.092-12.52-0.222l-77.684-51.73c0 0 34.216-22.986 50.712-34.046 9.402-6.304 18.692-12.786 28.328-18.71 2.264-1.392 7.064-1.94 9.486-0.336 11.546 7.658 79.708 53.060 79.708 53.060l-78.030 51.984zM536 722.204v-102.692c-0.052-5.742 0.898-9.204 5.722-12.378 30.396-20.012 60.664-40.22 90.772-60.664 4.67-3.172 7.84-3.246 12.53-0.038l77.054 51.764-186.078 124.008zM740 553.352l-59.18-39.486 59.18-39.746v79.232z",
      "M512 128c102.57 0 199 39.944 271.53 112.47 72.526 72.53 112.47 168.96 112.47 271.53s-39.944 199-112.47 271.53c-72.53 72.526-168.96 112.47-271.53 112.47s-199-39.944-271.53-112.47c-72.526-72.53-112.47-168.96-112.47-271.53s39.944-199 112.47-271.53c72.53-72.526 168.96-112.47 271.53-112.47zM512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-codepen-outline"
    ]
  },
  {
    "paths": [
      "M482.478 607.872c-30.644-20.714-61.484-41.138-92.124-61.86-4.060-2.746-6.86-2.944-11.004-0.058l-77.742 52.308c62.324 41.548 186.392 124.372 186.392 124.372v-107.572c-0.024-2.448-3.106-5.56-5.522-7.19z",
      "M390.184 481.332c30.908-20.32 61.702-40.818 92.218-61.72 2.972-2.036 5.55-7.018 5.598-10.668v-103.412c0 0-124.066 82.248-186.524 123.884 27.4 18.318 53.342 35.826 79.574 52.886 2.040 1.324 6.792 0.568 9.134-0.97z",
      "M539.676 418.708c31.622 21.406 63.366 42.628 95.254 63.63 1.832 1.208 5.84 1.204 7.678 0l79.502-52.934-186.11-124.436v106.7c0.020 2.402 1.61 5.642 3.676 7.040z",
      "M516.218 460.738c-2.42-1.604-7.222-1.056-9.486 0.336-9.634 5.924-18.926 12.406-28.328 18.71-16.496 11.060-50.712 34.046-50.712 34.046l77.684 51.73c3.496 2.314 8.872 2.44 12.52 0.222l78.028-51.986c0.002 0-68.158-45.402-79.706-53.058z",
      "M282 474.232v79.218l59.244-39.676z",
      "M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM790 594.012c0 11.57-5.304 19.736-15.022 26.188-82.284 54.628-164.502 109.428-246.572 164.376-11.708 7.836-22.348 7.508-33.968-0.274-81.566-54.628-163.438-109.092-245.25-163.352-10.22-6.778-15.188-15.114-15.188-27.46v-159.458c0-12.282 5.042-20.664 15.248-27.432 81.812-54.26 163.878-108.726 245.448-163.352 11.636-7.792 22.188-8.014 33.876-0.19 82.072 54.948 164.252 109.738 246.522 164.39 9.356 6.212 14.906 13.886 14.906 25.32v161.244z",
      "M632.494 546.468c-30.108 20.444-60.376 40.652-90.772 60.664-4.824 3.176-5.776 6.636-5.722 12.378v102.692l186.078-124.008-77.054-51.764c-4.69-3.208-7.86-3.134-12.53 0.038z",
      "M740 553.352v-79.232l-59.18 39.746z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-codepen"
    ]
  },
  {
    "paths": [
      "M709.352 733.796l-197.216 56.25-196.916-56.496-13.492-155.55h96.506l6.866 79.126 107.172 30.326 0.264 0.546h0.068l106.934-29.704 11.224-128.294h-224.762l-8-100h241.292l8.792-102h-368.084l-8-98h481.16l-43.808 503.796z",
      "M128 64l69.872 806.602 313.666 89.398 314.49-89.41 69.972-806.59h-768zM766.082 821.020l-254.524 72.374-253.734-72.338-60.032-693.056h628.408l-60.118 693.020z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-css3-outline"
    ]
  },
  {
    "paths": [
      "M512.564 678.976v0z",
      "M128 64l69.892 806.438 313.642 89.562 314.518-89.7 69.948-806.3h-768zM709.352 733.796l-197.214 56.25-196.916-56.496-13.494-155.55h96.506l6.866 79.124 107.172 30.326 0.264 0.546h0.068l106.934-29.704 11.224-128.292h-224.762l-8-100h241.292l8.792-102h-368.084l-8-98h481.16l-43.808 503.796z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-css3"
    ]
  },
  {
    "paths": [
      "M581.8 291.8l-128.8-99.8 129.2 205.6z",
      "M65 520z",
      "M658 192v328h-71.8l-126.4-196 3.4 196h-81.2v-214.2l-74.2-58.2c2 2.4 4.2 4.8 6 7.2 20 27.6 30 61.4 30 101 0 97.8-61 164-153.6 164h-126.2l400.2 312h495.8v-402.4l-302-237.4zM928 800h-452.6l-318.2-248h33c27 0 52.4-5.4 75.4-14.8s42.8-23.6 59.6-41.4c9.6-10.2 18.8-22 24.8-34.2v90.4h146l-0.6-33-1.4-83.8 65.2 101.4 9.4 15.2h121.4v-293.2l0.4 0.6 237.6 185.6v355.2z",
      "M181.2 300.8c22 0 47.4 6.4 47.4 57.6 0 13.8-2 32.6-12 43.6-7.2 7.8-19.2 12-35.4 12h-7.2v-114h6zM181.4 268h-39.4v178h39c52 0 79.8-31.2 79.8-87.8 0-57.6-28.6-90.2-79.4-90.2v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-designernews-outline"
    ]
  },
  {
    "paths": [
      "M580.8 290l-126.8-98 127.2 204.4z",
      "M658 192v326h-72.8l-126.4-197.2 3.4 197.2h-80.2v-214l-74.6-58.6c2 2.4 4 4.8 5.8 7.4 20 27.8 30 61 30 101 0 98.4-61.2 164.2-153.8 164.2h-125.4v0.8l399.2 313.2h496.8v-403.8l-302-236.2z",
      "M259.8 356.2c0-58-28.4-90.2-79.4-90.2h-38.4v178h38c52 0 79.8-30.8 79.8-87.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-designernews"
    ]
  },
  {
    "paths": [
      "M512 128c-212 0-384 172-384 384 0 212.2 172 384 384 384s384-171.8 384-384c0-212-172-384-384-384zM755.8 305c43.2 50.8 70.6 115.2 75.4 185.8-69.2-3.6-152-3.6-218.4 2.6-8.4-21.2-17-42-26.4-62 76.6-33.2 135.6-76.8 169.4-126.4zM512 192c77.6 0 148.8 27.6 204.2 73.6-34.8 44-89.4 82.2-157.4 111.2-37.2-68.8-80-128-125.6-174.6 25.4-6.4 51.6-10.2 78.8-10.2zM367.2 227c46.2 46 89.6 104.6 127.6 173.2-72.2 22-155 34.6-243.4 34.6-16.8 0-33.2-0.6-49.4-1.6 23-90.2 84-165 165.2-206.2zM192.6 496.8c18.2 0.8 36.6 1.2 55.2 1 100.8-1.2 194.6-17 275.2-42.8 7.6 15.8 14.8 32 21.6 48.6-11 2.6-20.8 5.4-28.6 8.6-110.2 46.2-197 120.8-244 211-49.6-56.4-80-130.2-80-211.2 0-5.2 0.2-10.2 0.6-15.2zM512 832c-74 0-142-25.2-196.2-67.4 42.6-84.4 118.6-154.2 214.4-197.6 9-4.2 21-7.6 34.8-10.6 11.4 31.6 21.6 64.4 30.6 98.4 13.8 53 23.6 105.4 29.6 156.2-35.2 13.4-73.2 21-113.2 21zM685 781c-6-51.4-15.8-104.2-29.8-157.8-6.8-26-14.6-51.2-23-75.8 62.8-5.2 138-4.4 197.8 0-10.8 98.2-66 182.6-145 233.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-dribbble-outline"
    ]
  },
  {
    "paths": [
      "M512 128c-212 0-384 172-384 384 0 212.2 172 384 384 384s384-171.8 384-384c0-212-172-384-384-384zM512 831c-176.2 0-319-142.8-319-319s142.8-319 319-319c176.2 0 319 142.8 319 319s-142.8 319-319 319z",
      "M612.6 493.4c46.8-4.4 101.8-5.8 154.4-4.8-4.6-50.8-24-97.4-54-135.2-33 29.8-76 56.2-126.6 78 9.2 20 17.8 40.8 26.2 62z",
      "M670.8 311.2c-43.6-34.6-98.8-55.2-158.8-55.2-10.2 0-20.4 0.6-30.4 1.8 27.6 35.4 53.4 75.2 77.2 119 43.4-18.4 81.2-40.6 112-65.6z",
      "M411.8 276.4c-68.2 29-121.4 86.8-144 158.2 82.2-1.4 159.2-14 226.8-34.6-25.2-46-53.2-87.4-82.8-123.6z",
      "M766 544.4c-44.6-1.2-92-0.4-133.8 3 8.2 24.6 16.2 49.8 23 75.8 7.6 29.2 14 58.2 19.2 86.8 49.2-40.6 83.2-99.2 91.6-165.6z",
      "M516 512.2c7.8-3.2 17.6-6 28.6-8.6-6.8-16.6-14.2-32.8-21.6-48.6-78.2 25.2-169.2 40.6-266.6 42.6-0.2 4.8-0.4 9.6-0.4 14.6 0 58.2 19.4 111.8 52 154.8 49.8-65 121.8-118.6 208-154.8z",
      "M565.2 556.4c-13.8 3-25.8 6.4-34.8 10.6-74.2 33.6-136.6 83.2-180.8 143 44.2 36.4 100.8 58 162.4 58 37 0 72-7.8 103.6-21.8-5.4-30.2-12-60.6-20-91.4-8.8-33.8-19.2-66.8-30.4-98.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-dribbble"
    ]
  },
  {
    "paths": [
      "M354 154.2l-226 147.8 156.6 126 227.4-141.6-158-132.2zM182.8 306.6l169-113.6 105.8 92-170.8 105-104-83.4z",
      "M739.6 426l-227.6 142.2 158 132.2 38-25.2v40.4l-196 118.4-196-117v-41l38 24.4 158-132.2-227.6-142.2-156.4 126.6 156 103v78.8l228 135.6 228-137v-78.4l156-102.4-156.4-126.2zM286.8 461.8l170.8 110.8-105.8 88.2-169-111.6 104-87.4zM566.4 572.6l170.8-110.8 104.2 87.2-169 111.6-106-88z",
      "M896 302l-226-147.8-158 132.2 227.6 141.6 156.4-126zM566.4 285.2l105.8-92 169 113.6-104 83.2-170.8-104.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-dropbox-outline"
    ]
  },
  {
    "paths": [
      "M354 154l-226 147.8 156.2 125.4 227.8-141z",
      "M128 552.6l226 147.8 158-132.2-227.8-141z",
      "M512 568.2l158 132.2 226-147.8-156.2-125.4z",
      "M896 301.8l-226-147.8-158 132.2 227.8 141z",
      "M512.4 596.6l-159.6 132-68.8-44.4v49.8l228 136 228-136v-49.8l-68.4 44.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-dropbox"
    ]
  },
  {
    "paths": [
      "M620.286 128c62.674 0 118.192 5.214 176.274 16.728l-10.12 68.296c-58.81-8.638-111.318-12.858-159.706-12.858-70.050 0-117.070 12.306-148.258 38.73-38.192 32.358-42.476 77.96-42.476 109.444v37.66h272.102l-4.766 32h-267.336v160h243.504l-4.768 32h-238.736v55.66c0 39.092 4.676 88.122 42.168 120.548 30.084 26.020 75.842 37.624 148.516 37.624 49.068 0 100.394-4.11 159.542-12.84l10.028 68.276c-58.062 11.518-113.482 16.732-175.954 16.732-105.182 0-182.86-18.16-231.13-53.974-43.94-32.604-65.17-81.304-65.17-148.886v-83.14h-100v-32h100v-160h-100v-32h100v-55.14c0-67.582 21.226-116.284 65.164-148.884 48.266-35.816 125.94-53.976 231.122-53.976zM620.418 96c-229.46 0-328.418 82.45-328.418 234.86v23.14h-100v96h100v96h-100v96h100v51.14c0 152.408 98.962 234.86 328.422 234.86 70.5 0 135.554-6.246 211.578-23.732l-18.822-129.92c-74.646 12.488-133.884 17.484-186.412 17.484-128.55 0-158.766-37.478-158.766-126.172v-23.66h234.324l14.296-96h-248.62v-96h262.922l14.298-96h-277.22v-5.66c0-71.84 30.318-116.172 158.868-116.172 52.528 0 111.918 4.996 186.562 17.484l18.57-129.652c-76.024-17.486-141.084-24-211.582-24v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-euro-outline"
    ]
  },
  {
    "paths": [
      "M468 544v-96h262.188l14.298-96h-276.486v-3.66c0-71.84 29.95-116.172 158.5-116.172 52.528 0 111.734 4.996 186.378 17.484l19.122-129.92c-76.024-17.486-141.388-23.732-211.886-23.732-229.462 0-328.114 82.45-328.114 234.86v21.14h-100v96h100v96h-100v96h100v53.14c0 152.408 98.594 234.86 328.054 234.86 70.5 0 135.696-6.246 211.718-23.732l-19.238-129.92c-74.644 12.488-133.562 17.484-186.090 17.484-128.552 0-158.446-37.478-158.446-126.172v-25.66h233.59l14.296-96h-247.884z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-euro"
    ]
  },
  {
    "paths": [
      "M576 384v-76.2c0-34.4 7.6-51.8 61-51.8h67v-128h-111.8c-137 0-182.2 62.8-182.2 170.6v85.4h-90v128h90v384h166v-384h112.8l15.2-128h-128zM660.4 480h-116.4v384h-102v-384h-90v-64h90v-117.4c0-49 10.8-82.4 31-103.6 22.4-24 62.2-35 119.2-35h79.8v64h-35c-24 0-55 2.2-74.2 23.4-16.2 18-18.8 40.2-18.8 60.2v108.4h124l-7.6 64z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-facebook-outline"
    ]
  },
  {
    "paths": [
      "M576 384v-76.2c0-34.4 7.6-51.8 61-51.8h67v-128h-111.8c-137 0-182.2 62.8-182.2 170.6v85.4h-90v128h90v384h166v-384h112.8l15.2-128h-128z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-facebook"
    ]
  },
  {
    "paths": [
      "M796.968 328.904l-54.798 274.37c3.526-14.302 30.92-153.688 54.798-274.37z",
      "M753.528 64c0 0-410.706 0-476.446 0-65.75 0-85.082 49.596-85.082 80.828 0 31.254 0 759.28 0 759.28 0 35.182 18.85 48.234 29.436 52.534 10.598 4.31 39.832 7.942 57.346-12.336 0 0 224.938-262.18 228.8-266.054 5.842-5.862 5.842-6.25 11.688-6.25 11.686 0 98.384 0 145.532 0 61.15 0 70.98-43.352 77.368-69.118l54.798-274.174c12.148-61.404 23.386-117.876 30.106-150.65 15.212-74.172-3.586-114.060-73.546-114.060zM752.852 192c0 0-63.15 312.418-72.068 353.668-10.784 49.874-15.284 62.332-66.784 62.332-35.21 0-124.75 0-124.75 0-5.494 0-7.736-0.294-12.098 4.082-2.886 2.894-156.336 179.124-156.336 179.124-38.068 46.792-53.818 63.59-58.066 63.59s-6.75 0-6.75-76.816v-594.564c0-49.348 0.6-55.416 58.396-55.416 49.1 0 389.604 0 389.604 0 60 0 61.668 1.666 48.852 64z",
      "M796.968 328.904l30.106-150.748c-6.718 32.776-17.956 89.344-30.106 150.748z",
      "M657.146 192c-11.142 0-315.99 0-315.99 0-12.974 0-21.156 11.188-21.156 21.172v462.51c0 1.34 0.804 1.95 1.87 0.72 0 0 96.404-111.45 108.112-126.042 11.696-14.578 16.982-16.364 34.466-16.364 0 0 113.39 0 124.424 0 13.098 0 20.48-11.5 21.826-17.964 1.342-6.456 21.072-96.426 23.464-108.238 2.382-11.794-8.428-23.796-19.444-23.796-11 0-129.61 0-129.61 0-15.606 0-15.108-11.306-15.108-26.952v-11.024c0-15.63-0.564-26.024 15.032-26.024 0 0 140.806 0 150.626 0 9.822 0 20.416-8.884 22.204-17.324l16.936-88.084c2.68-12.944-7.142-22.59-17.652-22.59z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-foursquare-outline"
    ]
  },
  {
    "paths": [
      "M753.528 64c0 0-410.706 0-476.446 0-65.75 0-85.082 49.596-85.082 80.828 0 31.254 0 759.28 0 759.28 0 35.182 18.85 48.234 29.436 52.534 10.598 4.31 39.832 7.942 57.346-12.336 0 0 224.938-261.79 228.8-265.668 5.842-5.86 5.842-5.86 11.688-5.86 11.688 0 98.384 0 145.534 0 61.148 0 70.98-43.738 77.368-69.504 5.318-21.578 64.978-327.924 84.904-425.118 15.21-74.17-3.586-114.156-73.548-114.156zM742.172 603.274c5.318-21.578 64.978-327.924 84.904-425.118zM725.384 193.34l-19.998 103.468c-2.39 11.3-16.574 23.19-29.726 23.19-13.15 0-191.834 0-191.834 0-20.88 0.002-35.826 12.278-35.826 33.206v26.896c0 20.946 15.038 35.788 35.93 35.788 0 0 148.964 0 163.696 0 14.748 0 29.22 16.218 26.032 32.010-3.204 15.816-18.172 93.138-19.968 101.78-1.804 8.656-11.69 23.45-29.222 23.45-14.776 0-128.538 0-128.538 0-23.41 0-30.488 3.066-46.148 22.586-15.674 19.54-156.512 189.184-156.512 189.184-1.426 1.644-2.82 1.168-2.82-0.624v-592.482c0-13.368 11.586-29.046 28.958-29.046 0 0 367.426 0 382.346 0 14.070-0.002 27.222 13.262 23.63 30.594z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-foursquare"
    ]
  },
  {
    "paths": [
      "M1005.2 230c-45-87.4-116-102-116-102s31 64 32 102c0.8 32.2-11 56-54.4 67s-61.6-4-95.6-35-83.2-53-145.2-56c-80-4-154 18-154 18-40-50 40-160 40-160-149 59-187.4 166.6-192 227.4-3.8 48.2 17 81.6 17 81.6s-1 55.6-10 84c-6.2 19.6-33.8 50-52 69-24.4 25.4-25 77 0 114s88 55 134 79 63 42 63 42 2 16.6 1 30.6-6.4 28-18 36.4c-11 7.8-31 1-41-4s-10-12.4-21-16-14.6-8-13-22 4-18-7-37-37-19-59-16-34.6 13.6-34.6 13.6l-32.6-20c0 0 17-31.2 10.4-71.2-14.6-87.6-100-125.6-100-125.6l20.8 88.8c0 0 2.2-5.2 12.8-12.8s16.2-7.2 16.2-7.2 13.2 15.2 18.2 50.6c5 36-13.4 54.4-13.4 54.4l-56.6-36 2-29-77.6-20.6 32.4 73.4 30-8 48 45.4c0 0-31.4 23.4-66 23.4-22 0-44-12-44-12s-2.8-2-1.6-11c1.4-10 13.6-25 13.6-25h-92c0 0 54.6 77.4 130 77.4 62 0 88.4-25 88.4-25l37.6 37.4c0 0 6 11 0 14s-14 7-18 30 36 58 36 58c43.6 35.6 14 64 14 64h544c-18-26-45-36-64-64 0 0-89.6-116.8-3.6-180.8 114.8-85.4 85.6-138.8 82.4-202.8 0 0 63.6-13.2 118.6-67.2s77.8-141.6 39.8-215.2zM390 406c-33.8 9-45 71-45 71 3-126 115-186 130-178s-13 78-42 128c0 0-16-28.2-43-21zM464 436c0 0 36-112 75-119s83 42 83 124-52 130.8-85.6 138.4c-33 7.6-46 4-46 4s55-43.2 47-113.6c-5.6-49.4-62.8-48.4-73.4-33.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-freebsd-devil"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 205.8-448 459.4 0 203 128.4 375 306.4 435.8 2.8 0.6 5.2 0.8 7.6 0.8 16.6 0 23-12.2 23-22.8 0-11-0.4-39.8-0.6-78.2-16.8 3.8-31.8 5.4-45.2 5.4-86.2 0-105.8-67-105.8-67-20.4-53-49.8-67.2-49.8-67.2-39-27.4-0.2-28.2 2.8-28.2 0.2 0 0.2 0 0.2 0 45 4 68.6 47.6 68.6 47.6 22.4 39.2 52.4 50.2 79.2 50.2 21 0 40-6.8 51.2-12 4-29.6 15.6-49.8 28.4-61.4-99.4-11.6-204-51-204-227 0-50.2 17.4-91.2 46-123.2-4.6-11.6-20-58.4 4.4-121.6 0 0 3.2-1 10-1 16.2 0 52.8 6.2 113.2 48.2 35.8-10.2 74-15.2 112.2-15.4 38 0.2 76.4 5.2 112.2 15.4 60.4-42 97-48.2 113.2-48.2 6.8 0 10 1 10 1 24.4 63.2 9 110 4.4 121.6 28.6 32.2 46 73.2 46 123.2 0 176.4-104.8 215.2-204.6 226.6 16 14.2 30.4 42.2 30.4 85 0 61.4-0.6 111-0.6 126 0 10.8 6.2 23 22.8 23 2.4 0 5.2-0.2 8-0.8 178.2-60.8 306.4-233 306.4-435.8 0-253.6-200.6-459.4-448-459.4zM355.2 896.2c4.4 0 8.8-0.2 13.4-0.4 0 5.6 0 11 0.2 15.8 0 4.8 0 9.2 0.2 13-31.2-11.6-60.6-27-88.2-46 19.6 10.6 44.2 17.6 74.4 17.6zM378 750.4c-1.6 4.4-3 9-4.2 13.8-6.8 2-15 3.6-23.4 3.6-21.8 0-38-10.8-51.2-33.8-4.8-9.2-13.6-21.4-25.8-32.6 33.6 28.2 72.6 41.8 104.6 49zM758 868.2c-31.6 23.8-66 42.6-102 56.4 0-3.8 0-8.2 0-13 0-23.8 0-59.6 0-100.8 0-24.8-4.2-45-10-61 74.4-16.6 184-67.4 184-250.8 0-49.2-14.2-93-42.4-130.2 6.2-25.8 11-71.2-10.2-126l-5.4-14.2-14.4-4.8c-3-1-9.6-2.6-20-2.6-23 0-61.8 8.2-119 45.6-34-8.4-69.6-12.8-106.2-12.8h-0.6c-36.6 0-72.4 4.4-106.2 12.8-57.2-37.4-96-45.6-119-45.6-10.4 0-17 1.8-20 2.8l-14.4 4.8-5.4 14.2c-21.2 55-16.4 100.4-10.2 126-28.2 37.4-42.4 81.2-42.4 130.2 0 99.2 32 159.8 73.2 197-16.2-13.2-37.2-24.2-62.4-26h-2.6c-26.2 0-44.6 10.8-50.4 29.4-9.4 29.6 19.6 50 29.2 56.8l1 1.2 3 1.2c3.2 2 20.2 14 33.8 49 4 12.4 12.6 29 27.2 44.4-26.2-22.4-49.6-48-69.8-76.2-52.6-73.6-80.4-161-80.4-252.6 0-57.8 11-113.8 32.8-166.6 21-51 51-96.6 89.4-135.8 38.2-39.2 82.8-70 132.2-91.4 51.2-22.2 105.6-33.6 161.6-33.6s110.4 11.2 161.6 33.4c49.6 21.4 94 52.2 132.2 91.4s68.4 85 89.4 135.8c21.8 52.8 32.8 108.8 32.8 166.6 0 91.6-27.6 179-80.2 252.6-25.2 35.4-55.4 66.4-89.8 92.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-github-outline"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 205.8-448 459.4 0 203 128.4 375 306.4 435.8 2.8 0.6 5.2 0.8 7.6 0.8 16.6 0 23-12.2 23-22.8 0-11-0.4-39.8-0.6-78.2-16.8 3.8-31.8 5.4-45.2 5.4-86.2 0-105.8-67-105.8-67-20.4-53-49.8-67.2-49.8-67.2-39-27.4-0.2-28.2 2.8-28.2 0.2 0 0.2 0 0.2 0 45 4 68.6 47.6 68.6 47.6 22.4 39.2 52.4 50.2 79.2 50.2 21 0 40-6.8 51.2-12 4-29.6 15.6-49.8 28.4-61.4-99.4-11.6-204-51-204-227 0-50.2 17.4-91.2 46-123.2-4.6-11.6-20-58.4 4.4-121.6 0 0 3.2-1 10-1 16.2 0 52.8 6.2 113.2 48.2 35.8-10.2 74-15.2 112.2-15.4 38 0.2 76.4 5.2 112.2 15.4 60.4-42 97-48.2 113.2-48.2 6.8 0 10 1 10 1 24.4 63.2 9 110 4.4 121.6 28.6 32.2 46 73.2 46 123.2 0 176.4-104.8 215.2-204.6 226.6 16 14.2 30.4 42.2 30.4 85 0 61.4-0.6 111-0.6 126 0 10.8 6.2 23 22.8 23 2.4 0 5.2-0.2 8-0.8 178.2-60.8 306.4-233 306.4-435.8 0-253.6-200.6-459.4-448-459.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-github"
    ]
  },
  {
    "paths": [
      "M638.816 164.282c23.558 19.152 72.86 59.436 72.86 136.086 0 74.59-43.094 109.868-86.188 143.090-13.39 13.122-28.77 27.216-28.77 49.402 0 22.184 15.378 34.306 26.672 43.342l36.946 28.216c45.196 37.282 86.25 71.59 86.25 141.118 0 94.746-93.442 190.464-270.006 190.464-148.856 0-220.686-69.532-220.686-144.122 0-36.278 18.49-87.654 79.050-122.96 63.596-38.284 149.904-43.314 196.046-46.344-14.356-18.156-30.764-37.34-30.764-68.53 0-17.154 5.114-27.218 10.24-39.31-11.296 1-22.566 2-32.84 2-108.816 0-170.428-79.622-170.428-158.214 0-46.372 21.604-97.804 65.712-135.086 58.538-47.372 128.364-55.434 183.746-55.434h211.45l-65.692 36.282h-63.598zM565.91 611.792c-8.274-1.002-13.368-1.002-23.586-1.002-9.258 0-64.696 2.004-107.79 16.098-22.6 8.092-88.292 32.25-88.292 103.836 0 71.56 70.786 122.934 180.678 122.934 98.566 0 150.864-46.312 150.864-108.808 0.002-51.436-33.842-78.624-111.874-133.058zM595.668 420.296c23.648-23.184 25.688-55.46 25.688-73.586 0-72.562-44.172-185.46-129.342-185.46-26.678 0-55.448 13.094-71.896 33.278-17.444 21.186-22.568 48.376-22.568 74.562 0 67.528 40.010 179.454 128.326 179.454 25.652-0.002 53.312-12.12 69.792-28.248z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-google-outline"
    ]
  },
  {
    "paths": [
      "M651.724 551.116l-36.5-27.408c-11.654-9.158-19.904-16.626-19.904-29.37 0-13.958 10.098-23.648 21.792-34.872l0.932-0.898c40.050-30.342 89.452-68.572 89.452-149.112 0-53.868-23.832-89.458-46.56-115.458h25.938l120.644-66h-266.902c-50.648 0-125.36 6.45-189.122 57.152l-0.256 0.5c-43.618 36.222-69.656 89.168-69.656 141.382 0 42.394 17.412 84.318 47.77 114.894 42.856 43.158 96.604 52.254 134.148 52.254 2.924 0 5.912-0.056 8.94-0.186-1.518 5.938-2.5 12.642-2.5 20.642 0 21.852 7.256 38.602 16.166 52.39-47.926 3.864-116.296 12.954-169.794 44.556-78.67 45.124-84.792 111.75-84.792 131.102 0 76.414 71.414 153.524 230.958 153.524 183.222 0 279.086-99.584 279.086-197.958-0.002-74.318-45.674-111.336-89.84-147.134zM400.97 279.788c0-26.718 6.040-46.914 18.51-61.8 13.028-15.704 36.36-26.258 58.056-26.258 39.762 0 65.876 30.016 80.776 55.196 18.398 31.078 29.826 72.19 29.826 107.286 0 9.884 0 39.966-20.376 59.592-13.902 13.372-37.414 22.706-57.18 22.706-41.006 0-66.906-29.41-81.414-54.082-20.79-35.368-28.198-76.21-28.198-102.64zM643.2 735.948c0 54.888-50.424 88.986-131.598 88.986-96.116 0-160.694-41.206-160.694-102.53 0-52.28 43.080-73.578 75.6-85.042 37.888-12.128 88.594-14.61 100.124-14.61 7.814 0 12.174 0 17.366 0.458 73.402 50.422 99.202 72.256 99.202 112.738z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-google"
    ]
  },
  {
    "paths": [
      "M447 164.2c23.6 19.2 72.8 59.4 72.8 136 0 74.6-43 109.8-86.2 143-13.4 13.2-28.8 27.2-28.8 49.4s15.4 34.4 26.6 43.4l37 28.2c45.2 37.2 86.2 71.6 86.2 141.2 0 94.8-93.4 190.4-270 190.4-148.8 0.2-220.6-69.4-220.6-144 0-36.2 18.4-87.6 79-123 63.6-38.2 150-43.4 196-46.4-14.4-18.2-30.8-37.4-30.8-68.6 0-17.2 5.2-27.2 10.2-39.4-11.2 1-22.6 2-32.8 2-108.8 0-170.4-79.6-170.4-158.2 0-46.4 21.6-97.8 65.8-135 58.6-47.2 128.4-55.2 183.8-55.2h211.4l-65.6 36.2h-63.6zM374 611.8c-8.2-1-13.4-1-23.6-1-9.2 0-64.6 2-107.8 16-22.6 8-88.2 32.2-88.2 103.8s70.8 123 180.6 123c98.6 0 150.8-46.4 150.8-108.8 0-51.4-33.8-78.6-111.8-133zM403.8 420.2c23.6-23.2 25.6-55.4 25.6-73.6 0-72.6-44.2-185.4-129.4-185.4-26.6 0-55.4 13-71.8 33.2-17.4 21.2-22.6 48.4-22.6 74.6 0 67.6 40 179.4 128.4 179.4 25.6 0.2 53.2-12 69.8-28.2z",
      "M960 284.6h-156.6v-156.4h-35.4v156.4h-159.4v35.6h159.4v161.8h35.4v-161.8h156.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-googleplus-outline"
    ]
  },
  {
    "paths": [
      "M484.2 551.2l-36.4-27.4-0.2-0.2c-11.6-9.2-20-16.6-20-29.4 0-14 10-23.6 21.8-34.8l1-0.8c40-30.4 89.4-68.6 89.4-149.2 0-53.8-23.8-89.4-46.6-115.4h26l120.8-66h-267c-50.6 0-125.4 6.4-189.2 57.2l-0.2 0.6c-43.6 36-69.6 89-69.6 141.2 0 42.4 17.4 84.4 47.8 114.8 42.8 43.2 96.6 52.2 134.2 52.2 3 0 6 0 9-0.2-1.6 6-2.4 12.6-2.4 20.6 0 21.8 7.2 38.6 16.2 52.4-48 3.8-116.2 13-169.8 44.6-78.8 45.4-85 112-85 131.2 0 76.4 71.4 153.6 231 153.6 183.2 0 279-99.6 279-198 0-74.2-45.6-111.2-89.8-147zM233.4 279.8c0-26.8 6-47 18.6-61.8 13-15.8 36.4-26.2 58-26.2 39.8 0 65.8 30 80.8 55.2 18.4 31 29.8 72.2 29.8 107.2 0 9.8 0 40-20.4 59.6-14 13.4-37.4 22.8-57.2 22.8-41 0-67-29.4-81.4-54-20.8-35.6-28.2-76.4-28.2-102.8zM475.6 736c0 54.8-50.4 89-131.6 89-96.2 0-160.6-41.2-160.6-102.6 0-52.2 43-73.6 75.6-85 37.8-12.2 88.6-14.6 100.2-14.6 7.8 0 12.2 0 17.4 0.4 73.2 50.4 99 72.2 99 112.8z",
      "M804 284v-156h-68v156h-160v68h160v162h68v-162h156v-68z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-googleplus"
    ]
  },
  {
    "paths": [
      "M832 192v640h-640v-640h640zM896 128h-768v768h768v-768z",
      "M593.4 318h90.6l-127.8 240v144h-79.8v-144l-132.4-240h94.2l79.4 167.2 75.8-167.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-hackernews-outline"
    ]
  },
  {
    "paths": [
      "M128 128v768h768v-768h-768zM556 558v144h-80v-144l-132-240h94.2l79.4 167.2 76-167.2h90.4l-128 240z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-hackernews"
    ]
  },
  {
    "paths": [
      "M128 64l69.872 806.602 313.666 89.398 314.49-89.41 69.972-806.59h-768zM766.082 821.020l-254.524 72.374-253.734-72.338-60.032-693.056h628.408l-60.118 693.020z",
      "M295.982 528h333.986l-11.146 127.972-106.84 29.496-107.532-29.34-6.848-78.128h-96.502l13.526 154.672 197.356 55.62 196.99-55.966 27.010-302.326h-352l-7.982-102h367.982l8.416-99.368-481.556-0.256z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-html5-outline"
    ]
  },
  {
    "paths": [
      "M128 64l69.872 806.426 313.666 89.574 314.49-89.708 69.972-806.292h-768zM743.994 328h-368l7.982 102h352.016l-27.010 302.772-197 56.188-197.364-55.952-13.528-155.008h96.508l6.846 78.574 107.538 29.562 106.844-29.83 11.148-128.306h-334.002l-25.142-299.178 481.578 0.032-8.414 99.146z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-html5"
    ]
  },
  {
    "paths": [
      "M897 224c0-52.466-42.534-95-95-95h-578c-52.466 0-95 42.534-95 95v578c0 52.466 42.534 95 95 95h578c52.466 0 95-42.534 95-95v-578zM514 351.666c88.364 0 160 71.632 160 160s-71.636 160-160 160-160-71.632-160-160 71.636-160 160-160zM833 321c0 17.672-14.326 32-32 32h-96c-17.674 0-32-14.328-32-32v-96c0-17.672 14.326-32 32-32h96c17.674 0 32 14.328 32 32v96zM803 833h-576c-17.644 0-34-16.356-34-34v-350h106.144c-6.016 20-9.144 41.294-9.144 63.166 0 59.834 23.3 115.834 65.61 158.142s98.558 65.482 158.39 65.482 116.082-23.362 158.39-65.67 65.61-98.088 65.61-157.922c0-21.872-3.126-43.198-9.144-63.198h104.144v350c0 17.644-12.356 34-30 34z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-instagram-outline"
    ]
  },
  {
    "paths": [
      "M672 511.666c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.366 71.634-160 160-160s160 71.634 160 160z",
      "M355.61 353.774c42.308-42.308 98.558-65.858 158.39-65.858s116.082 23.674 158.39 65.982c26.844 26.844 46.022 59.102 56.464 95.102h168.146v-226c0-53.020-40.98-94-94-94h-576c-53.020 0-98 40.98-98 94v226h170.144c10.444-36 29.622-68.382 56.466-95.226zM833 295.4c0 14.138-11.46 25.6-25.6 25.6h-76.8c-14.138 0-25.6-11.46-25.6-25.6v-76.8c0-14.138 11.46-25.6 25.6-25.6h76.8c14.138 0 25.6 11.46 25.6 25.6v76.8z",
      "M672.39 670.558c-42.308 42.308-98.558 65.358-158.39 65.358s-116.082-22.924-158.39-65.232c-42.23-42.23-65.518-99.684-65.606-157.684h-161.004v286c0 53.020 44.98 98 98 98h576c53.020 0 94-44.98 94-98v-286h-159.004c-0.086 58-23.374 115.328-65.606 157.558z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-instagram"
    ]
  },
  {
    "paths": [
      "M384 208.002v394.034c0 83.134-19.288 143.976-57.324 180.834-34.12 33.060-84.122 49.13-152.862 49.13-24.004 0-51.56-2.992-74.37-7.772l8.18-61.010c14.292 2.538 30.93 4.298 49.548 4.298 43.84 0 75.784-12.918 97.654-39.49 22.634-27.49 33.174-67.856 33.174-127.028v-392.996h96zM416 176.002h-160v424.996c0 105.16-36.064 134.522-98.824 134.522-29.41 0-55.896-5.042-76.5-12.126l-16.676 124.414c29.4 10.124 74.518 16.192 109.814 16.192 144.096 0 242.186-67.742 242.186-261.96v-426.038z",
      "M764.926 192c48.916 0 91.796 6.292 130.2 19.17l-19.162 64.124c-27.224-11.010-65.072-21.874-112.972-21.874-37.214 0-68.924 9.168-91.698 26.512-23.464 17.872-36.388 43.166-36.388 71.226 0 69.948 66.124 96.298 142.694 126.81l0.214 0.086 0.216 0.082c53.954 20.598 91.876 44.522 115.938 73.144 23.218 27.622 34.032 59.806 34.032 101.288 0 50.354-18.666 93.42-53.98 124.548-40.7 35.878-102.834 54.844-179.686 54.844-56.104 0-109.396-12.854-145.23-27.958l15.186-63.206c35.158 14.496 83.764 28.764 138.876 28.764 40.56 0 73.258-8.956 97.182-26.612 25.614-18.9 39.714-47.394 39.714-80.238 0-30.696-12.082-55.844-36.938-76.888-20.314-17.206-49.602-32.096-94.934-48.272-53.72-19.808-94.718-43.894-121.868-71.59-28.478-29.050-42.322-62.302-42.322-101.652 0-48.298 19.662-90.202 56.86-121.182 40.16-33.448 96.892-51.126 164.066-51.126zM764.926 160c-154.886 0-252.926 87.996-252.926 204.308 0 100.166 75.502 162.88 185.282 203.33 79.4 28.316 110.784 53.616 110.784 95.078 0 45.512-36.278 74.85-104.896 74.85-63.726 0-121.578-21.28-160.788-42.51v-0.042l-30.382 126.44c37.278 21.276 106.882 42.51 182.334 42.51 181.374-0.004 265.666-97.104 265.666-211.396 0-97.1-53.916-159.8-170.556-204.326-86.278-34.382-122.54-53.59-122.54-97.084 0-34.4 31.376-65.738 96.086-65.738 63.692 0 107.488 21.414 133.010 34.582l38.25-128c-40-17.562-93.874-32.002-169.324-32.002v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-javascript-outline"
    ]
  },
  {
    "paths": [
      "M416 176.002h-160v424.996c0 105.16-36.064 134.522-98.824 134.522-29.41 0-55.896-5.042-76.5-12.126l-16.676 124.414c29.4 10.124 74.518 16.192 109.814 16.192 144.096 0 242.186-67.742 242.186-261.96v-426.038z",
      "M764.926 160c-154.886 0-252.926 87.996-252.926 204.308 0 100.166 75.502 162.88 185.282 203.33 79.4 28.316 110.784 53.616 110.784 95.078 0 45.512-36.278 74.85-104.896 74.85-63.726 0-121.578-21.28-160.788-42.51v-0.042l-30.382 126.44c37.278 21.276 106.882 42.51 182.334 42.51 181.374-0.004 265.666-97.104 265.666-211.396 0-97.1-53.916-159.8-170.556-204.326-86.278-34.382-122.54-53.59-122.54-97.084 0-34.4 31.376-65.738 96.086-65.738 63.692 0 107.488 21.414 133.010 34.582l38.25-128c-40-17.562-93.874-32.002-169.324-32.002v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-javascript"
    ]
  },
  {
    "paths": [
      "M365.6 768v-342.2h-109.8v342.2h109.8zM314.8 374c36.6 0 59.4-26.2 59.4-59-0.6-33.4-22.8-59-58.8-59s-59.4 25.6-59.4 59c0 32.8 22.8 59 58 59h0.8z",
      "M641.2 418c-58.2 0-83.2 32.8-99.2 55.6v-47.6h-110v342h110v-194.8c0-10 0.8-20 3.8-27 8-20 26-40.6 56.4-40.6 39.8 0 55.8 30.6 55.8 75.4v187h110v-199.8c0-102.6-54.4-150.2-126.8-150.2z",
      "M834.4 128h-640.8c-35 0-65.6 25.2-65.6 59.8v642.2c0 34.8 30.6 65.8 65.6 65.8h640.6c35.2 0 61.6-31.2 61.6-65.8v-642.2c0.2-34.6-26.4-59.8-61.4-59.8zM828 832c-2.2 0-626.2 0-629.8 0s-6.2-2.8-6.2-6.2-0-627.6-0-629.8 2-4 4-4 630 0 632 0 4 2 4 4c0 46.6 0 629.8 0 632 0 1.8-1.8 4-4 4z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-linkedin-outline"
    ]
  },
  {
    "paths": [
      "M834.4 128h-640.8c-35 0-65.6 25.2-65.6 59.8v642.2c0 34.8 30.6 65.8 65.6 65.8h640.6c35.2 0 61.6-31.2 61.6-65.8v-642.2c0.2-34.6-26.4-59.8-61.4-59.8zM366 768h-110v-342h110v342zM314.8 374h-0.8c-35.2 0-58-26.2-58-59 0-33.4 23.4-59 59.4-59s58 25.4 58.8 59c0 32.8-22.8 59-59.4 59zM768 768h-110v-187c0-44.8-16-75.4-55.8-75.4-30.4 0-48.4 20.6-56.4 40.6-3 7.2-3.8 17-3.8 27v194.8h-110v-342h110v47.6c16-22.8 41-55.6 99.2-55.6 72.2 0 126.8 47.6 126.8 150.2v199.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-linkedin"
    ]
  },
  {
    "paths": [
      "M895.318 192h-766.636c-35.674 0-64.682 28.968-64.682 64.616v510.698c0 35.672 29.008 64.686 64.682 64.686h766.636c35.674 0 64.682-29.014 64.682-64.688v-510.696c0-35.648-29.008-64.616-64.682-64.616zM568.046 704h-112.096v-192l-84.080 107.756-84.044-107.756v192h-112.088v-384h112.088l84.044 135.96 84.080-135.96h112.096v384zM735.36 704l-139.27-192h84v-192h112.086v192h84.054l-140.87 192z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-markdown"
    ]
  },
  {
    "paths": [
      "M511.834 960c-11.54 0-23.072-3.124-33.266-9.198l-105.97-64.88c-15.828-9.124-8.046-12.406-2.886-14.282 21.13-7.562 27.426-11.314 49.894-24.57 2.412-1.334 5.494-0.848 7.91 0.644l79.42 47.008c2.952 1.7 7.114 1.7 9.862 0l310.376-184.492c2.95-1.754 4.83-5.292 4.83-8.882v-373.61c0-3.7-1.88-7.184-4.898-9.056l-310.24-189.344c-2.956-1.788-6.842-1.788-9.796 0l-310.038 189.41c-3.088 1.806-5.032 5.396-5.032 8.99v373.61c0 3.626 1.944 7.026 4.962 8.778l79.858 47.944c47.22 24.408 75.18-0.34 75.18-29.222v-367.398c0-5.304 4.094-9.454 9.192-9.454h45.618c5.030 0 9.194 4.144 9.194 9.454v367.396c0 65.126-38.706 102.496-98.398 102.496-18.312 0-32.794 0-73.104-20.558l-83.168-49.562c-20.592-12.304-33.334-35.292-33.334-59.91v-378.93c0-24.632 12.742-47.568 33.33-59.834l317.37-189.728c20.054-11.76 46.748-11.76 66.664 0l317.3 189.728c20.596 12.298 33.336 35.25 33.336 59.834v378.93c0 24.618-12.74 47.5-33.336 59.906l-317.3 189.548c-10.194 6.072-21.664 9.198-33.396 9.198l-0.134 0.036z",
      "M609.886 703.996c-129.22 0-168.012-63.22-168.012-118.542 0-5.258 4.096-9.458 9.124-9.458h41.042c4.564 0 8.454 3.4 9.124 8.032 6.168 43.204 33.496 62.3 108.648 62.3 66.798 0 94.182-20.692 94.182-57.368 0-21.184-6.926-36.848-110.814-47.394-86.854-8.882-140.576-28.746-140.576-100.59 0-66.27 53.992-104.98 144.468-104.98 92.256 0 152.924 28 158.346 101.658 0.204 2.674-0.736 5.258-2.482 7.288-1.742 1.93-4.156 3.054-6.706 3.054h-41.182c-4.292 0-8.048-3.124-8.918-7.426-8.802-33.906-33.94-46.804-99.126-46.804-72.972 0-81.492 25.506-81.492 45.214 0 23.926 10.062 30.882 108.588 44.344 97.522 13.326 143.866 32.234 143.866 103.104 0 71.562-57.616 117.566-158.15 117.566l0.070 0.002z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-nodejs"
    ]
  },
  {
    "paths": [
      "M356.708 574.956c-18.246 0-33.856 8.414-46.402 25.666-12.582 16.956-18.796 37.946-18.796 62.862 0 24.948 6.332 46.016 18.796 63.018 12.546 17.080 28.078 25.542 46.402 25.542 16.988 0 31.778-8.54 44.242-25.542 12.542-17.002 18.796-38.070 18.796-63.018 0-24.838-6.332-45.86-18.796-62.862-12.466-17.174-27.134-25.666-44.242-25.666z",
      "M669.336 574.956c-18.090 0-33.782 8.414-46.364 25.666-12.542 16.956-18.718 37.946-18.718 62.862 0 24.948 6.372 46.016 18.718 63.018 12.582 17.080 28.196 25.542 46.364 25.542 17.066 0 31.812-8.54 44.356-25.542 12.586-17.002 18.836-38.070 18.836-63.018 0-24.838-6.328-45.86-18.836-62.862-12.544-17.174-27.094-25.666-44.356-25.666z",
      "M891.554 344h-0.118c0 0 5.586-28.528 0.628-78.36-4.364-49.832-14.942-95.676-32.246-137.64 0 0-8.844 1.52-25.52 5.792s-44.16 12.598-81.876 29.536c-37.082 17.080-75.972 39.576-116.594 67.010-27.606-7.868-68.816-11.878-123.988-11.878-52.578 0-93.828 4.024-123.954 11.89-89.184-61.718-163.664-95.89-224.184-102.35-17.188 41.964-27.766 87.982-32.090 137.94-4.796 49.878 0.864 78.658 0.864 78.658-48.518 52.504-68.476 128.484-68.476 190.988 0 48.488 1.316 92.156 12.25 130.96 11.128 38.62 25.324 70.26 42.196 94.442 17.222 24.242 38.024 45.576 63.152 63.876 24.934 18.628 47.976 31.924 68.778 40.432 20.922 8.744 44.75 15.204 71.964 19.722 26.66 4.772 46.876 7.29 60.954 7.992 0 0 56 2.988 128.708 2.988s128.59-2.988 128.59-2.988c14.040-0.704 34.29-3.268 61.070-7.992 27.094-4.598 51.042-11.214 71.882-19.722 20.804-8.586 43.886-21.802 68.938-40.432 25.046-18.064 45.812-39.478 63.036-63.876 16.872-24.182 30.988-55.822 42.196-94.442 10.972-38.804 12.29-82.77 12.29-131.258-0.004-60.51-20.040-137.288-68.45-191.288zM760.766 811.29c-55.724 26.182-137.794 36.71-246.644 36.71l-4.286-0.078c-108.886 0-190.722-10.496-245.696-36.82-55.016-26.184-82.542-80.114-82.542-161.476 0-48.66 17.144-87.98 50.964-118.214 14.708-13.030 32.876-22.038 55.29-27.434 22.258-5.116 42.708-5.524 61.938-4.93 18.796 0.83 45.102 4.392 78.688 6.928 33.58 2.594 58.592 6.024 83.522 6.024 23.396 0 54.426-3.914 104.208-7.918 49.98-3.942 86.988-5.942 110.934-2 24.578 4.004 45.972 12.404 64.258 29.484 35.468 31.502 53.204 71.010 53.204 118.168-0.002 81.332-28.276 135.34-83.838 161.556z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-octocat"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448 448-200.6 448-448-200.6-448-448-448zM783.6 783.6c-72.6 72.4-169 112.4-271.6 112.4-32.4 0-64.2-4-94.8-11.8 5.6-12.6 10.4-25.6 14-38.6 5.6-20 31.6-123.2 31.6-123.2 15.6 29.6 61 55.8 109.4 55.8 144 0 241.8-131.2 241.8-307 0-132.8-112.6-256.6-283.6-256.6-212.8 0-320.2 152.6-320.2 279.8 0 77 29.2 145.6 91.8 171.2 10.2 4.2 19.4 0.2 22.4-11.2 2-7.8 7-27.8 9.2-36 3-11.2 1.8-15.2-6.4-25-18-21.4-29.6-48.8-29.6-87.8 0-113.2 84.6-214.6 220.6-214.6 120.2 0 186.4 73.4 186.4 171.6 0 129.2-57.2 238.2-142 238.2-46.8 0-82-38.8-70.8-86.2 13.4-56.8 39.6-118 39.6-159 0-36.6-19.6-67.2-60.4-67.2-48 0-86.4 49.6-86.4 116 0 42.2 14.4 70.8 14.4 70.8s-49 207.8-57.6 244.2c-2.6 11-4.4 22.2-5.8 33.6-34.6-18-66.6-41.2-94.8-69.6-72.8-72.4-112.8-168.8-112.8-271.4s40-199 112.4-271.6c72.6-72.4 169-112.4 271.6-112.4s199 40 271.6 112.4c72.4 72.6 112.4 169 112.4 271.6s-40 199-112.4 271.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-pinterest-outline"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448 0 183.4 110.4 341 268.2 410.4-1.2-31.2-0.2-68.8 7.8-102.8 8.6-36.4 57.6-244.2 57.6-244.2s-14.4-28.6-14.4-70.8c0-66.4 38.4-116 86.4-116 40.8 0 60.4 30.6 60.4 67.2 0 41-26.2 102.2-39.6 159-11.2 47.6 23.8 86.2 70.8 86.2 84.8 0 142-109 142-238.2 0-98.2-66.2-171.6-186.4-171.6-135.8 0-220.6 101.4-220.6 214.6 0 39 11.6 66.6 29.6 87.8 8.2 9.8 9.4 13.8 6.4 25-2.2 8.2-7 28-9.2 36-3 11.4-12.2 15.4-22.4 11.2-62.6-25.6-91.8-94-91.8-171.2 0-127.2 107.4-279.8 320.2-279.8 171 0 283.6 123.8 283.6 256.6 0 175.8-97.8 307-241.8 307-48.4 0-93.8-26.2-109.4-55.8 0 0-26 103.2-31.6 123.2-9.4 34.6-28 69-45 96 40.2 11.8 82.8 18.4 127 18.4 247.4 0 448-200.6 448-448 0.2-247.6-200.4-448.2-447.8-448.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-pinterest"
    ]
  },
  {
    "paths": [
      "M386.92 498.112c7.446-1.34 15.178-2.082 23.172-2.082l-6.244-0.030h207.646c9.006 0 17.612-1.234 25.816-3.508 38.74-10.726 66.69-45.074 66.69-87.326v-174.448c0-49.664-42.3-86.968-92.578-95.212-31.862-5.248-78.516-7.654-110.178-7.498-31.658 0.172-61.962 2.808-88.554 7.498-78.404 13.646-92.69 42.35-92.69 95.212v57.282h192v32h-254.36c-71.256 0-129.076 85.142-129.626 190.484-0.004 0.506-0.014 1.010-0.014 1.516 0 19.046 1.88 37.44 5.37 54.808 15.926 79.332 65.532 137.192 124.27 137.192h30.36v-91.87c0-53.654 40.292-103.466 98.92-114.018zM407.312 254.004c-19.184 0-34.768-15.57-34.768-34.806 0-19.328 15.548-35.040 34.768-35.040 19.148 0 34.798 15.71 34.798 35.040 0.002 19.236-15.618 34.806-34.798 34.806z",
      "M887.902 445.086c-18.342-73.044-65.836-125.086-121.542-125.086h-30.36v81.344c0 67.83-44.572 116.948-98.978 125.362-5.474 0.848-10.966 1.292-16.602 1.292h-207.718c-9.036 0-17.808 1.168-26.098 3.344-38.244 10.036-66.604 41.858-66.604 83.13v174.454c0 49.664 49.954 78.852 98.962 93.102 58.654 17.062 122.534 20.136 192.732 0 46.606-13.32 92.306-40.242 92.306-93.102v-52.926h-192v-32h254.36c50.48 0 94.214-42.73 115.628-105.098 8.96-26.094 14.012-55.62 14.012-86.902 0-23.536-2.866-46.076-8.098-66.914zM615.734 765.64c19.18 0 34.762 15.57 34.762 34.8 0 19.3-15.582 35.042-34.762 35.042-19.154 0-34.798-15.742-34.798-35.042-0-19.26 15.612-34.8 34.798-34.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-python"
    ]
  },
  {
    "paths": [
      "M708.2 576.8c0 35.125-28.475 63.6-63.6 63.6s-63.6-28.475-63.6-63.6c0-35.125 28.475-63.6 63.6-63.6s63.6 28.475 63.6 63.6z",
      "M444.2 576.8c0 35.125-28.475 63.6-63.6 63.6s-63.6-28.475-63.6-63.6c0-35.125 28.475-63.6 63.6-63.6s63.6 28.475 63.6 63.6z",
      "M961 502c0-55.4-44.4-100.4-99-100.4-26 0-49.4 10-67.2 26.6-66.4-46.8-156.8-77-257.4-81.4l46.6-155.4 139.2 27.8c0.4 49.4 40.2 89.4 89 89.4 49.2 0 89-40.4 89-90.2s-39.8-90.4-89-90.4c-37.2 0-69 23.2-82.4 56l-170.4-34-58.8 196.4-14.2 0.4c-100.6 4.4-191 34.8-257.4 81.4-17.6-16.6-41.2-26.6-67.2-26.6-54.6 0-99 45-99 100.4 0 39.2 22 73 54.2 89.6-1.6 9.8-2.4 19.6-2.4 29.6 0.4 151.6 178.2 274.8 397.4 274.8s397-123.2 397-275c0-10-0.8-19.8-2.2-29.6 32.2-16.6 54.2-50.4 54.2-89.4zM812.2 163.8c29.6 0 53.6 24.4 53.6 54.4s-24 54.4-53.6 54.4c-29.6 0-53.6-24.4-53.6-54.4s24-54.4 53.6-54.4zM98.4 502c0-35.6 28.6-64.4 63.6-64.4 14.4 0 27.8 5 38.4 13.2-34.6 30.4-60.2 66-74 104.8-16.8-11.8-28-31.4-28-53.6zM772.8 785.8c-69.2 47.8-161.8 74.2-260.8 74.2s-191.6-26.4-260.8-74.2c-65-45-100.8-103.6-100.8-164.8 0-6.4 0.4-13 1.2-19.4 1.4-12 4.4-23.8 8.6-35.4 11.2-31.2 32-60.6 61.4-86.8 8.8-7.8 18.4-15.4 28.8-22.6 0.2-0.2 0.6-0.4 0.8-0.6 69.2-47.8 161.8-74.2 260.8-74.2s191.6 26.4 260.8 74.2c0.2 0.2 0.6 0.4 0.8 0.6 10.4 7.2 20 14.8 28.8 22.6 29.4 26.2 50.2 55.6 61.4 86.8 4.2 11.6 7 23.4 8.6 35.4 0.8 6.4 1.2 12.8 1.2 19.4 0 61.2-35.8 119.8-100.8 164.8zM897.6 555.4c-13.8-38.8-39.4-74.4-74-104.8 10.6-8.2 24-13.2 38.4-13.2 35 0 63.6 29 63.6 64.4 0 22.4-11.2 42-28 53.6z",
      "M641 715.8c-0.4 0.4-48.4 48.4-129 48.8-81.8-0.4-128.8-48.4-129.2-48.8l-25.2 24.8c2.4 2.4 59.2 59 154.4 59.4 95.2-0.4 151.8-57 154.2-59.4l-25.2-24.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-reddit-outline"
    ]
  },
  {
    "paths": [
      "M961 502c0-55.4-44.4-100.4-99-100.4-26 0-49.4 10-67.2 26.6-64.8-45.6-152.2-75.6-249.8-81.2l43.8-146.4 134.2 27c4.6 45.4 42.4 80.8 88.6 80.8 0.2 0 0.2 0 0.4 0s0.2 0 0.4 0c49.2 0 89-40.4 89-90.2s-40-90.2-89.2-90.2c-0.2 0-0.2 0-0.4 0 0 0-0.2 0-0.2 0-34.4 0-64 19.6-79 48.6l-179.4-36-61.6 206-5 0.2c-100.6 4.4-191 34.8-257.4 81.4-17.6-16.6-41.2-26.6-67.2-26.6-54.6 0-99 45-99 100.4 0 39.2 22 73 54.2 89.6-1.6 9.8-2.4 19.6-2.4 29.6 0.2 151.6 178 274.8 397.2 274.8s397-123.2 397-275c0-10-0.8-19.8-2.2-29.6 32.2-16.6 54.2-50.4 54.2-89.4zM131.6 542.2c-13.2-9-21.8-24.2-21.8-41.6 0-27.6 22.2-50.2 49.4-50.2 11.2 0 21.6 3.8 30 10.2-27 23.8-47 51.4-57.6 81.6zM778.6 218.2c0-18.4 14.8-33.6 33-33.6s33 15 33 33.6c0 18.4-14.8 33.6-33 33.6s-33-15-33-33.6zM317 576.8c0-35.2 28.4-63.6 63.6-63.6s63.6 28.4 63.6 63.6c0 35.2-28.4 63.6-63.6 63.6s-63.6-28.4-63.6-63.6zM512 800c-95.2-0.4-152-57-154.4-59.4l25.2-24.8c0.4 0.4 47.4 48.4 129.2 48.8 80.6-0.4 128.4-48.4 129-48.8l25.2 24.8c-2.4 2.4-59 59-154.2 59.4zM644.6 640.4c-35.2 0-63.6-28.4-63.6-63.6s28.4-63.6 63.6-63.6 63.6 28.4 63.6 63.6c0 35.2-28.6 63.6-63.6 63.6zM892.8 543c-10.8-30.6-31.2-58.8-58.6-82.8 8.4-6.6 19-10.4 30.4-10.4 27.8 0 50.2 22.8 50.2 51 0.2 17.6-8.6 33-22 42.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-reddit"
    ]
  },
  {
    "paths": [
      "M239.8 672.2c-61.6 0-111.8 50.2-111.8 111.6 0 61.6 50.2 111.2 111.8 111.2 61.8 0 111.8-49.8 111.8-111.2s-50-111.6-111.8-111.6zM239.8 863c-44 0-79.8-35.6-79.8-79.2 0-43.8 35.8-79.6 79.8-79.6s79.8 35.8 79.8 79.6c0 43.6-35.8 79.2-79.8 79.2z",
      "M128 384v159.8c96 0 188.2 28.4 256 96.2s96 159.8 96 256h160c0-279.8-232-512-512-512zM607 864h-96c-6.2-99.4-42-184.2-104.4-246.6-62.4-62.6-146.6-98.4-246.6-104.6v-95.6c52 3.6 104.2 16 153.4 37 57 24.4 108.4 59.2 152.8 103.6s79.2 95.8 103.6 152.8c21.2 49.2 33.6 100.6 37.2 153.4z",
      "M128 128v159.8c342 0 607.8 266 607.8 608.2h160.2c0-423.4-344-768-768-768zM582.8 441c-112-112.2-260.8-177-422.8-184.6v-95.8c380 16.4 687 323 703.4 703.4h-96.4c-7.6-161.8-72.4-311-184.2-423z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-rss-outline"
    ]
  },
  {
    "paths": [
      "M239.8 672.2c-61.6 0-111.8 50.2-111.8 111.6 0 61.6 50.2 111.2 111.8 111.2 61.8 0 111.8-49.8 111.8-111.2s-50-111.6-111.8-111.6z",
      "M128 384v159.8c96 0 188.2 28.4 256 96.2s96 159.8 96 256h160c0-279.8-232-512-512-512z",
      "M128 128v159.8c342 0 607.8 266 607.8 608.2h160.2c0-423.4-344-768-768-768z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-rss"
    ]
  },
  {
    "paths": [
      "M1023.568 658.216c-3.34-27.198-18.472-48.292-41.59-64.832 5.714 4.080 10.55 7.532-0.11-0.082-14.378-10.262-6.76-4.822-0.094-0.064-57-40.602-131.352-31.578-193.466-9.022-24.894-40.59-25.974-71.566-11.632-115.874 1.858-5.6 0.59-8.708-5.248-11.208-14.172-6.060-34.582-2.854-48.844 0.926-4.924 1.292-8.508 3.8-9.6 8.762-10.308 48.486-42.018 92.896-69.656 133.772-19.462-37.304-17.92-66.174-4.828-105.032 1.596-4.732 0.862-7.248-3.874-9.758-14.52-7.514-36.802-3.824-51.6 0.552-17.018 4.964-42.58 89.188-50.744 105.892-17.062 34.884-32.182 89.33-61.17 117.004-24.6-31.614 45.052-103.034 21.764-131.702-7.876-9.696-22.126-9.446-31.172-1.232 2.17-15.216 3.296-25.218-0.64-38.126-4.162-13.58-14.722-21.374-30.18-20.98-35.99 1.054-67.686 27.63-89.282 52.794-20.554 24.21-74.762 39.254-103.906 53.854-50.064-43.614-158.442-89.894-161.264-164.162-3.056-83.692 96.638-140.49 163.194-174.456 86.56-44.208 219.922-99.216 318.276-50.872 26.098 12.828 36.598 40.342 29.414 66.696-18.736 68.732-94.396 114.586-160.206 135.614-32.378 10.35-67.938 18.054-102.2 16.052-45.91-2.686-81.66-30.448-86.562-32.172-4.098-0.778-3.776 4.522-2.694 7.328 47.632 124.866 288.834 33.362 351.912-30.742 30.378-30.842 48.826-60.73 56.702-107.788 9.232-55.166-31.268-89.684-62.008-103.914-155.836-72.144-371.272 22.336-489.106 118.654-51.136 41.802-115.104 108.22-85.748 177.892 31.86 75.61 129.472 114.38 193.006 160.624-51.408 25.546-115.724 51.966-149.036 99.866-19.048 27.458-25.806 56.718-11.622 87.932 25.144 55.136 116.57 31.244 155.146 6.942 35.34-22.26 59.126-52.14 69.4-90.456 8.91-33.218 7.082-67.732-7.712-99.024l57.17-28.916c-15.394 46.152-22.194 104.006 9.762 145.71 12.804 16.676 46.034 17.35 59.634 0.622 17.632-21.886 29.328-49.31 41.006-74.412-1.364 18.746-3.712 39.992 2.754 56.33 7.42 18.746 24.252 22.582 41.584 10.686 53.040-36.406 86.796-137.304 112.926-196.124 7.104 25.658 14.946 49.096 27.914 72.752 3.204 5.806 2.814 9.548-1.592 14.39-19.37 21.35-65.652 56.958-70.138 85.798-1.048 6.742 3.426 13.198 11.372 14.74 31.146 6.216 65.676-5.062 90.964-22.156 26.376-17.844 34.892-42.174 28.49-71.030-9.152-41.542 21.986-87.96 51.602-122.060 5.438 25.816 13.632 50.662 28.286 73.212-26.15 22.966-65.16 55.528-59.558 93.878 1.976 13.73 14.27 22.602 29.028 19.472 31.566-6.648 58.832-20.226 78.74-44.292 18.046-21.71 11.584-45.402 3.712-69.27 47.744-13.63 96.044-16.354 143.662-0.054 22.99 7.82 41.51 21 52.496 41.636 13.452 25.288 5.878 48.584-20.1 65.208-6.574 4.208-11.124 7.666-8.9 9.486 2.224 1.822 9.8 4.226 26.568-6.304 16.768-10.534 27.020-24.766 29.646-43.45 0.526-5.166 0.51-10.334-0.048-15.51zM225.892 708.734c-2.716 33.346-19.272 60.386-46.35 82.228-15.234 12.316-34.204 22.352-53.040 24.184-18.836 1.834-33.502-2.922-34.756-22.46-3.528-54.986 81.846-108.848 129.25-125.066 4.040 13.72 6.022 27.332 4.864 41.174l0.032-0.060zM432.096 563.828c-7.806 44.618-29.66 124.694-64.628 156.672-4.712 4.286-9.22 4.036-11.618-1.542-20.69-48.118 7.342-147.338 66.164-162.656 6.914-1.778 11.204 1.164 10.082 7.526zM572.718 727.364c16.844-17.924 33.668-35.832 50.538-53.854 2.086 20.042-35.142 59.928-50.538 53.854zM734.146 691.972c-4.696 2.546-15.242 5.030-15.654 1.67-2.964-24.17 23.632-49.748 40.134-61.734 8.906 22.686-1.636 47.668-24.48 60.064z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-sass"
    ]
  },
  {
    "paths": [
      "M340.4 192c28 0 55.4 7.8 79.2 22.6l20.6 12.8 24-4c17-3 34.4-4.4 51.8-4.4 81 0 157 31 214 87.4 56.8 56 88.2 130.6 88.2 209.8 0 21.4-2.4 42.8-7 63.6l-5 22.2 10.2 20.4c10.2 20.2 15.4 41.8 15.4 64.4 0 80.2-66.6 145.4-148.4 145.4-25 0-48.6-5.8-70.4-17.4l-19.6-10.4-21.8 4c-18.2 3.4-37 5-55.6 5-81 0-157-31-214-87.4-56.8-56-88.2-130.6-88.2-209.8 0-20 2-40.2 6-59.8l5-24.4-12.8-21.4c-13-22.2-20-47.4-20-73.2 0-80.2 66.6-145.4 148.4-145.4zM340.4 128c-117.2 0-212.4 93.8-212.4 209.4 0 38.8 10.6 75 29.2 106-4.8 23.4-7.4 47.8-7.4 72.6 0 199.6 164 361.2 366.2 361.2 23 0 45.4-2 67-6 30 15.8 64.2 24.8 100.4 24.8 117.4 0 212.4-93.8 212.4-209.4 0-33.4-8-65-22.2-93 5.6-25 8.4-50.8 8.4-77.4 0-199.4-164-361.2-366.4-361.2-21.4 0-42.2 1.8-62.6 5.2-32.4-20.4-71-32.2-112.6-32.2v0z",
      "M703.8 688.2c-17 23.6-42 42.4-74.4 55.6-32.2 13.2-70.6 19.8-114.6 19.8-52.6 0-96.6-9.2-131.2-27.2-24.6-13.2-44.8-30.8-60.4-52.8s-23.4-44-23.4-65.2c0-13.2 5.2-24.6 15.2-34.2 10-9.2 23-14 38.2-14 12.6 0 23.4 3.6 32.2 11 8.4 7 15.6 17.4 21.4 31 6.6 14.6 13.6 27 21.2 36.8 7.2 9.4 17.4 17.2 30.6 23.4 13.4 6.2 31.2 9.4 53.2 9.4 30.2 0 55-6.4 73.6-19 18.4-12.2 27.2-27 27.2-45 0-14.2-4.6-25.4-14.2-34.2-10-9.2-23-16.4-39.2-21.2-16.6-5.2-39.2-10.6-67.2-16.4-38-8-70.2-17.6-96-28.4-26.2-11-47.4-26.4-63-45.4-15-19.2-23-43.6-23-72.2 0-27.4 8.4-51.8 24.8-73 16.4-21 40.2-37.4 71.2-48.6 30.4-11.2 66.6-16.8 107.4-16.8 32.8 0 61.4 3.8 85.4 11 24.2 7.4 44.4 17.4 60.6 29.8 16 12.4 28 25.6 35.6 39.4 7.6 14 11.4 27.8 11.4 41.2 0 12.8-5 24.6-15 34.8s-22.6 15.6-37.6 15.6c-13.6 0-24.2-3.2-31.6-9.6-6.8-6-14-15.2-21.8-28.6-9.2-17-20.2-30.6-32.8-40.2-12.4-9.2-32.8-14-61.2-14-26.2 0-47.6 5.2-63.4 15.4-15.2 9.8-22.6 21.2-22.6 34.6 0 8.2 2.4 15 7.4 21 5.2 6.2 12.4 11.8 21.8 16.4 9.6 4.8 19.6 8.6 29.4 11.2 10.2 2.8 27.2 7 50.6 12.2 29.8 6.2 57 13.4 81 20.8 24.4 7.8 45.4 17.2 62.6 28.2 17.6 11.2 31.4 25.8 41.4 43 9.8 17.2 14.8 38.8 14.8 63.6 0 30-8.6 57.2-25.6 80.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-skype-outline"
    ]
  },
  {
    "paths": [
      "M873.8 593.6c5.6-25 8.4-50.8 8.4-77.4 0-199.4-164-361.2-366.4-361.2-21.4 0-42.2 1.8-62.6 5.2-32.6-20.4-71.2-32.2-112.8-32.2-117.2 0-212.4 93.8-212.4 209.4 0 38.8 10.6 75 29.2 106-4.8 23.4-7.4 47.8-7.4 72.6 0 199.6 164 361.2 366.2 361.2 23 0 45.4-2 67-6 30 15.8 64.2 24.8 100.4 24.8 117.4 0 212.4-93.8 212.4-209.4 0.2-33.4-7.8-65-22-93zM703.8 688.6c-17 23.6-42 42.4-74.4 55.6-32.2 13.2-70.6 19.8-114.6 19.8-52.6 0-96.6-9.2-131.2-27.2-24.6-13.2-44.8-30.8-60.4-52.8s-23.4-44-23.4-65.2c0-13.2 5.2-24.6 15.2-34.2 10-9.2 23-14 38.2-14 12.6 0 23.4 3.6 32.2 11 8.4 7 15.6 17.4 21.4 31 6.6 14.6 13.6 27 21.2 36.8 7.2 9.4 17.4 17.2 30.6 23.4 13.4 6.2 31.2 9.4 53.2 9.4 30.2 0 55-6.4 73.6-19 18.4-12.2 27.2-27 27.2-45 0-14.2-4.6-25.4-14.2-34.2-10-9.2-23-16.4-39.2-21.2-16.6-5.2-39.2-10.6-67.2-16.4-38-8-70.2-17.6-96-28.4-26.2-11-47.4-26.4-63-45.4-15.8-19.4-23.6-43.8-23.6-72.4 0-27.4 8.4-51.8 24.8-73 16.4-21 40.2-37.4 71.2-48.6 30.4-11.2 66.6-16.8 107.4-16.8 32.8 0 61.4 3.8 85.4 11 24.2 7.4 44.4 17.4 60.6 29.8 16 12.4 28 25.6 35.6 39.4 7.6 14 11.4 27.8 11.4 41.2 0 12.8-5 24.6-15 34.8s-22.6 15.6-37.6 15.6c-13.6 0-24.2-3.2-31.6-9.6-6.8-6-14-15.2-21.8-28.6-9.2-17-20.2-30.6-32.8-40.2-12.4-9.2-32.8-14-61.2-14-26.2 0-47.6 5.2-63.4 15.4-15.2 9.8-22.6 21.2-22.6 34.6 0 8.2 2.4 15 7.4 21 5.2 6.2 12.4 11.8 21.8 16.4 9.6 4.8 19.6 8.6 29.4 11.2 10.2 2.8 27.2 7 50.6 12.2 29.8 6.2 57 13.4 81 20.8 24.4 7.8 45.4 17.2 62.6 28.2 17.6 11.2 31.4 25.8 41.4 43 9.8 17.2 14.8 38.8 14.8 63.6 0.8 30.2-7.8 57.4-25 81z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-skype"
    ]
  },
  {
    "paths": [
      "M512.566 95.106c141.386 0 256 109.364 236 257.862-4.144 30.776-6.844 62.966-8.52 89.518 0 0 4.804 8.506 25.328 8.506 12.142 0 29.79-3.086 55.192-12.708 4.472-1.694 8.754-2.482 12.754-2.482 15.836 0 27.23 11.862 28.246 24.542 0.852 10.62-9.128 22.398-16.742 26.018-27.532 13.084-93.982 20.126-93.982 65.276 0 45.152 44.724 93.312 81.724 127.426s127.434 42.14 127.434 42.14 0.566 43.14-63.434 58.194c-64 15.048-64.2 11.424-66.5 27.592-4.266 29.958-3.070 42.756-22.496 42.756-3.344 0-7.302-0.38-12.004-1.116-16.46-2.582-38.478-7.288-62.242-7.288-22.432 0-46.42 4.194-68.758 18.322-46 29.098-82.566 68.228-152.566 68.228s-106-39.13-152-68.228c-22.34-14.13-46.324-18.322-68.758-18.322-23.76 0-45.784 4.706-62.242 7.288-4.704 0.734-8.66 1.116-12.004 1.116-19.42 0-18.23-12.798-22.496-42.756-2.302-16.168-2.5-12.54-66.5-27.59s-64-58.194-64-58.194 91-8.024 128-42.136c37-34.116 81.724-82.268 81.724-127.42 0-45.15-66.452-52.18-93.982-65.264-7.614-3.62-17.592-15.374-16.742-25.994 1.014-12.672 12.392-24.502 28.214-24.5 4.008 0 8.304 0.76 12.786 2.458 25.498 9.658 43.176 12.684 55.324 12.684 20.408 0 25.196-8.546 25.196-8.546-1.674-26.55-4.374-58.742-8.518-89.518-20-148.498 94.614-257.862 236-257.862v0zM512.566 64h-0.566c-82.186 0-158.43 32.416-209.182 90.682-47.964 55.068-68.75 126.69-58.53 202.584 2.832 21.020 4.92 42.462 6.42 61.236-7.94-1.118-19.372-3.996-35.406-10.068-7.93-3.004-16.034-4.59-24.086-4.59-31.282-0.002-57.688 23.704-60.114 54.006-2.054 25.636 16.47 48.786 34.94 57.566 8.502 4.040 18.362 7.156 28.8 10.464 13.414 4.25 28.618 9.064 38.586 15.406 8.294 5.278 8.294 8.336 8.294 10.364 0 17.32-12.382 49.382-71.376 103.776-20.998 19.362-78.11 31.002-109.176 33.794l-29.144 2.622-0.026 29.364c0 3.358 0.624 21.092 12.97 40.638 10.492 16.612 32.146 38.566 75.726 48.814 12.358 2.906 22.372 5.126 30.416 6.908 4.612 1.024 9.11 2.020 12.908 2.906 0.054 0.418 0.108 0.834 0.162 1.246 1.8 14.008 3.222 25.070 8.784 35.5 4.906 9.2 17.148 24.632 44.030 24.632 4.956 0 10.498-0.492 16.944-1.502 3.344-0.526 6.772-1.108 10.4-1.726 14.232-2.424 30.364-5.174 46.902-5.174 20.554 0 37.464 4.376 51.692 13.376 9.062 5.734 17.784 11.944 27.018 18.52 35.982 25.618 76.764 54.656 142.048 54.656 65.452 0 106.586-29.164 142.878-54.892 9.152-6.488 17.796-12.618 26.754-18.284 14.226-9 31.136-13.376 51.692-13.376 16.54 0 32.668 2.75 46.898 5.172 3.628 0.622 7.058 1.204 10.404 1.728 6.446 1.010 11.986 1.502 16.944 1.502 26.88 0 39.124-15.43 44.030-24.626 5.562-10.428 6.984-21.492 8.784-35.498 0.054-0.416 0.11-0.836 0.164-1.258 3.796-0.882 8.296-1.882 12.91-2.904 8.046-1.784 18.058-4.002 30.412-6.908 43.702-10.278 65.222-32.34 75.58-49.036 12.196-19.656 12.592-37.472 12.546-40.844l-0.378-29.002-28.796-2.556c-30.826-2.792-87.6-14.438-108.602-33.8-32.562-30.022-71.376-72.398-71.376-103.786 0-2.028 0-5.092 8.3-10.372 9.97-6.348 25.178-11.168 38.594-15.42 10.434-3.308 20.288-6.434 28.788-10.472 18.472-8.78 36.996-31.956 34.942-57.614-2.43-30.332-28.848-54.092-60.144-54.092-8.042 0-16.136 1.52-24.054 4.518-16.054 6.082-27.486 8.82-35.41 9.924 1.494-18.638 3.582-40.24 6.422-61.34 10.222-75.896-10.562-147.018-58.528-202.084-50.758-58.264-127.002-90.68-209.188-90.68v0z",
      "M512 458c-41.676 0-81.208-16.58-111.314-46.686-6.25-6.248-6.248-16.378 0-22.626 6.25-6.248 16.38-6.248 22.626 0 24.064 24.060 55.56 37.312 88.688 37.312 32.774 0 64.3-13.28 88.77-37.396 6.296-6.204 16.426-6.126 22.624 0.164 6.204 6.294 6.128 16.424-0.164 22.626-30.494 30.056-69.996 46.606-111.23 46.606z",
      "M448 304c0 26.51-14.327 48-32 48s-32-21.49-32-48c0-26.51 14.327-48 32-48s32 21.49 32 48z",
      "M640 304c0 26.51-14.327 48-32 48s-32-21.49-32-48c0-26.51 14.327-48 32-48s32 21.49 32 48z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-snapchat-outline"
    ]
  },
  {
    "paths": [
      "M991.996 720.778l-0.378-29.002-28.796-2.556c-30.826-2.792-87.6-14.438-108.602-33.8-32.562-30.022-71.376-72.398-71.376-103.786 0-2.028 0-5.092 8.3-10.372 9.97-6.348 25.178-11.168 38.594-15.42 10.434-3.308 20.288-6.434 28.788-10.472 18.472-8.78 36.996-31.956 34.942-57.614-2.43-30.332-28.848-54.092-60.144-54.092-8.042 0-16.136 1.52-24.054 4.518-16.054 6.082-27.486 8.82-35.41 9.924 1.494-18.638 3.582-40.24 6.422-61.34 10.222-75.896-10.562-147.018-58.528-202.084-50.758-58.266-127.002-90.682-209.188-90.682h-0.566c-82.186 0-158.43 32.416-209.182 90.682-47.964 55.068-68.75 126.69-58.53 202.584 2.832 21.020 4.92 42.462 6.42 61.236-7.94-1.118-19.372-3.996-35.406-10.068-7.93-3.004-16.034-4.59-24.086-4.59-31.282-0.002-57.688 23.704-60.114 54.006-2.054 25.636 16.47 48.786 34.94 57.566 8.502 4.040 18.362 7.156 28.8 10.464 13.414 4.25 28.618 9.064 38.586 15.406 8.294 5.278 8.294 8.336 8.294 10.364 0 17.32-12.382 49.382-71.376 103.776-20.998 19.362-78.11 31.002-109.176 33.794l-29.144 2.622-0.026 29.364c0 3.358 0.624 21.092 12.97 40.638 10.492 16.612 32.146 38.566 75.726 48.814 12.358 2.906 22.372 5.126 30.416 6.908 4.612 1.024 9.11 2.020 12.908 2.906 0.054 0.418 0.108 0.834 0.162 1.246 1.8 14.008 3.222 25.070 8.784 35.5 4.906 9.2 17.148 24.632 44.030 24.632 4.956 0 10.498-0.492 16.944-1.502 3.344-0.526 6.772-1.108 10.4-1.726 14.232-2.424 30.364-5.174 46.902-5.174 20.554 0 37.464 4.376 51.692 13.376 9.062 5.734 17.784 11.944 27.018 18.52 35.982 25.618 76.764 54.656 142.048 54.656 65.452 0 106.586-29.164 142.878-54.892 9.152-6.488 17.796-12.618 26.754-18.284 14.226-9 31.136-13.376 51.692-13.376 16.54 0 32.668 2.75 46.898 5.172 3.628 0.622 7.058 1.204 10.404 1.728 6.446 1.010 11.986 1.502 16.944 1.502 26.88 0 39.124-15.43 44.030-24.626 5.562-10.428 6.984-21.492 8.784-35.498 0.054-0.416 0.11-0.836 0.164-1.258 3.796-0.882 8.296-1.882 12.91-2.904 8.046-1.784 18.058-4.002 30.412-6.908 43.702-10.278 65.222-32.34 75.58-49.036 12.194-19.656 12.592-37.472 12.546-40.842zM416 256c17.672 0 32 21.49 32 48s-14.328 48-32 48-32-21.49-32-48 14.328-48 32-48zM623.23 411.396c-30.494 30.054-69.996 46.604-111.23 46.604-41.676 0-81.208-16.58-111.314-46.686-6.25-6.248-6.248-16.378 0-22.626 6.25-6.248 16.38-6.248 22.626 0 24.064 24.060 55.56 37.312 88.688 37.312 32.774 0 64.3-13.28 88.77-37.396 6.296-6.204 16.426-6.126 22.624 0.164 6.204 6.294 6.13 16.426-0.164 22.628zM608 352c-17.672 0-32-21.492-32-48s14.328-48 32-48 32 21.492 32 48-14.328 48-32 48z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-snapchat"
    ]
  },
  {
    "paths": [
      "M642.4 792.6c-23.6 0-44.8-5.6-63-16.6-13.8-8.2-23-19.2-28-32.8-5.2-13.8-7.2-44.6-7.2-92.8v-202.4h192v-128h-192v-224h-123.8c-5.4 43-15 89.4-29 117.2s-28 51.6-51.2 71.4c-23.2 19.8-51.2 35.8-83.8 46.6v116.8h96v280.8c0 38 4 67 11.8 87 8 20 22.2 39 42.8 56.8s45.6 31.4 74.6 41c29.2 9.6 62.8 14.4 100.8 14.4 33.4 0 60.6-3.4 89.4-10.2s61-18.6 96.4-35.2v-131.2c-41.8 27.4-83.6 41.2-125.8 41.2zM736 862c-26.2 11.4-50.2 19.8-71.8 24.8-26.2 6.2-51.2 9.2-82.2 9.2-34.4 0-65-4.4-90.8-12.8-25-8.2-46.4-20-63.8-35-16.6-14.4-28-29.2-34-44.4-4.4-11-9.6-33.2-9.6-75.2v-312.6h-95.8v-62.6c26.8-11.2 51-26 72.6-44.4 26.4-22.4 43.2-49.8 59.2-81.4 14.2-28 23.2-68 28.2-99.6h64v224h192v64h-192v234.2c0 69.2 4.8 92 9.2 104 7.6 20.6 21.6 37.2 42 49.2 23.4 14 50 21 79.4 21 31.4 0 62.6-6.6 93.4-19.6v57.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-tumblr-outline"
    ]
  },
  {
    "paths": [
      "M642.4 792.6c-23.6 0-44.8-5.6-63-16.6-13.8-8.2-23-19.2-28-32.8-5.2-13.8-7.2-44.6-7.2-92.8v-202.4h192v-128h-192v-224h-123.8c-5.4 43-15 89.4-29 117.2s-28 51.6-51.2 71.4c-23.2 19.8-51.2 35.8-83.8 46.6v116.8h96v280.8c0 38 4 67 11.8 87 8 20 22.2 39 42.8 56.8s45.6 31.4 74.6 41c29.2 9.6 62.8 14.4 100.8 14.4 33.4 0 60.6-3.4 89.4-10.2s61-18.6 96.4-35.2v-131.2c-41.8 27.4-83.6 41.2-125.8 41.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-tumblr"
    ]
  },
  {
    "paths": [
      "M509.4 202.6c-1.2 2-2.4 4-3.4 6.2 3.6-7 8.6-13 14.8-17.4-4.2 2.6-8.2 6.2-11.4 11.2-1.2 2 3.2-5 0 0z",
      "M852.6 792c-13.4-8-26.4-22-24-37.6 4.6-30.6 5-43-0.4-51.6-3.798-6.4-11-10-17.2-11.602 4-5 6.2-10.798 7.6-21.798 3.684-28.336-6.478-61.34-13.22-88.486-8.89-35.8-20.638-68.028-40.864-99.044-32.978-50.576-74.506-93.608-103.714-146.87-19.4-58-8.602-94.2-9.602-132.4-1.8-74.6-53.8-138.6-129.2-138.6h-28c-75 0-116 53.8-116 120 1.394 33.332 2.704 66.666 4 100 1.538 39.512 3.96 75.334-16 110.6-14.066 24.976-39.142 44.86-57.184 66.956-19.050 23.33-26.12 47.338-35.718 75.238-11.974 34.802-42.55 61.812-49.772 97.858-3.316 16.542 5.452 35.714-1.66 49.386-7.396 14.218-1.626 28.938-5.666 43.364-7.010 23.458-41.462 21.458-60.43 23.016-35.204 2.886-22.102 35.976-15.686 59.402 11.196 40.87-39.080 84.156 22.064 100.942 27.978 7.68 57.172 10.26 85.454 16.64 27.962 6.308 53.834 17.224 80.792 26.524 20.938 7.222 40.524 8.292 60.646-2.464 21.964-11.74 37.894-30.166 63.382-34 49.414-7.432 109.658-8.338 158.746 1.26 15.014 2.936 20.15 13.050 29.81 23.532 16.29 17.676 43.028 20.25 65.588 16.44 23.78-4.020 41.692-18.932 59.372-34.224 25.052-21.67 52.274-35.992 81.582-51.094 14.878-7.666 44.356-18.776 48.318-37.806 4.664-22.424-28.354-34.804-43.038-43.57zM404 902.6c-2.6 26-27.8 40.6-50.8 38.6-39.004-3.298-75.72-24.474-114.328-31.5-18.786-3.418-94.702-6.346-93.886-34.158 0.43-14.722 11.502-23.332 15.134-36.83 5.622-20.898-11.506-39.864-12.64-60.32-0.894-16.162 21.46-15.214 32.576-16.106 17.522-1.404 38.314-4.024 47.144-22.086 3.2-6.6-1-30 3.8-43.6 7.054-20.31 30.978-17.898 46.6-9.798 35.524 18.134 57.886 71.092 77.066 103.642 19.45 33.012 53.424 71.242 49.334 112.156zM636.6 771.4c4.578 23.574 8.448 48.774 3.4 72.6-4.032 19.032-17.124 31.228-25.4 48-4.4-13.6 22.6-33.4 19.6-67.4-0.084-0.95-1.894-21.764-2.072-21.668-3.958 2.164-7.65 10.15-10.608 13.46-9.618 10.766-21.542 19.316-33.458 27.354-27.594 18.612-58.442 30.116-91.66 33.254-42 4-76-21-76-21 5.034 16.61 17.984 42 2.2 56.6 3.486-31.296-9.752-56.12-23.2-83.4 92.748-49.278-82.726-128.794-106-159.6-20.952-27.792-11.106-63.66-5.4-87-6.886 27.55-7.918 83.912 28 93.6 15.844 4.338 11.21-74.142 11.968-82.926 3.16-36.624 15.442-71.994 36.686-102.030 6.798-9.612 3.726-19.066 5.346-30.644 3.386-21.336 14.59-41.094 26.976-58.45 10.338-14.486 3.47-25.236 6.028-42.11 1.454-9.59 10.236 6.386 11.596 8.558 8 13 33.4 45.4 49.4 44 26.554-2.322 49.384-31.876 72.030-44.092 7.182-3.874 28.82-10.484 31.732-19.264 3.536-10.66-25.332-0.322-28.228 1.166-21.564 11.070-62.036 42.896-87.734 30.59-17.524-8.39-21.382-29.988-34.4-41 30.8 27.2 43 21 55.2 18.2 19.33-4.364 37.594-12.972 55.6-21 8.434-3.76 40.214-8.082 44.602-17.4 5.49-11.668-10.1-13.452-16.136-7.16-12.502 13.030-31.706 17.962-48.194 23.574-37.77 12.854-75.288 18.262-103.67-17.214-16.708-20.424 31.116-45.008 44.4-57.6 0 0 2-14.4-1.2-25.4-3.8-13-15.6-18.6-23.8-16.2-8.2 2.2-16 11-13.6 29.6 2 16.6 14 22 14 22s-5.4 7-10.4 9.4c0 0-1.6-0.6-7-12.6s-13.2-39-0.6-62.2c12.6-23.2 39.2-10.4 47.6 7.6 7.8 16.6 4.8 45.4 4.8 45.4 6.716-1.686 13.67-2.6 20.6-2.6 8.484 0 13.628 9.126 21.2 9.6-1.27 0-1.128-36.248-0.466-40.156 2.198-12.98 8.224-27.238 19.866-34.444 32.174-22.982 69.2 7.832 69.2 42.4 0.048 8.972-0.274 18.43-2.398 27.2-1.318 5.274-3.164 16.938-10.228 18.354-2.29 0.46-21.366-0.862-15.97-6.554 25.614-25.624-3.644-76.414-34.8-49-11.202 8.398-10.966 27.666-9.602 40 2.196 18.282 41.020 23.082 53.704 27.56 16.448 5.806 15.886 19.252 13.358 34.232-3.8 22.52-5.63 37.584 8.762 56.428 14.688 19.232 25.858 40.172 31.83 63.756 2.966 11.718 3.33 21.686 11.242 31.14 11.966 14.302 21.238 29.61 26.582 47.634 10.45 35.242 13.026 70.844 12.324 107.25-1 16.398-4.2 30 16.6 19.398 8-4 13-5.798 22-7.398 6.202-12.602 8.8-36.602 9-48.602 0.4-27-0.6-83-55.398-143 0 0 57 43.4 66 124 5 44.602-4 68.8-4 68.8 10.6 2.6 21.6 10.6 27.2 19.6-0.266-0.44 2.076 3.496 2.358 3.728-19.622-16.342-63.416-25.718-79.358 0.472-4 6.6-6.2 15.2-6.4 23.398-14.2-2.398-24.798 0-33.6 9.8-11.61 14.206-6.010 48.606-2.010 69.406 4 20.6-4-20.8 0 0zM441.2 249.8c-0.4-9.8-4.2-18-9.4-21.6 0.6-0.6 1.6-1.4 3.4-0.8 2.8 0.8 7 5.4 8.6 12.6 1.4 5.8 0.8 15.4-2.8 15.4-0.004-1.868 0.062-3.734 0.2-5.6-0.4-9.8 0 1.8 0 0zM550.6 225.8c0.8-0.6 2.202-1.2 4.6-0.6 3.602 0.8 8.8 5.6 10.602 12.4 1.398 5.6 0.2 14.8-4.4 14.6-0.010-1.806 0.124-3.606 0.4-5.4-0.202-9.2-4.602-17.2-11.202-21 0.8-0.6 6.6 3.8 0 0zM824.8 865.8c-35.008 15.106-62.608 39.936-94.234 60.38-27.648 17.874-76.312 16.626-80.044-25.758-3.13-35.552 8.368-70.576 3.68-106.714-3.174-24.478-17.068-57.812-4.602-81.708 5.4-10.2 16.202-11 25-8 6.386 26.534 27.864 47.2 56 47.2 34.062 0 47.084-28.016 68-49 6.8 0.4 14.8 2.202 17.6 9.602 4.602 11.6-3.798 35-3.6 44.6 0.6 31.4 18 38.4 52.8 58 30.6 17.598 8.4 30.198-40.6 51.398-48.2 20.8 49-21.2 0 0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-tux"
    ]
  },
  {
    "paths": [
      "M160 64l-64 160v608h192v128h128l128-128h160l224-224v-544h-768zM832 576l-128 128h-192.002l-127.998 128v-128h-160v-544h608v416z",
      "M640 286h96v258h-96v-258z",
      "M416 286h96v258h-96v-258z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-twitch-outline"
    ]
  },
  {
    "paths": [
      "M160 64l-64 160v608h192v128h128l128-128h160l224-224v-544h-768zM512 544h-96v-258h96v258zM736 544h-96v-258h96v258z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-twitch"
    ]
  },
  {
    "paths": [
      "M984 219c-34.8 15.4-72 25.8-111.2 30.6 40-24 70.8-62 85.2-107.2-37.4 22.2-78.8 38.4-123 47-35.4-37.8-86-61.4-141.4-61.4-107 0-193.6 86.8-193.6 193.8 0 15.2 1.6 30 5 44.2-161-8-304-85.2-399.4-202.6-16.6 28.6-26.2 62-26.2 97.4 0 67.2 34.2 126.6 86.2 161.4-31.6-0.8-61.6-9.6-87.6-24.2 0 0.8 0 1.6 0 2.4 0 94 66.8 172.2 155.4 190-16.2 4.4-33.4 6.8-51 6.8-12.4 0-24.6-1.2-36.4-3.6 24.6 77 96.2 133 181 134.6-66.2 52-149.8 83-240.6 83-15.6 0-31-1-46.2-2.8 85.4 55.6 187.2 87.6 296.4 87.6 356.4 0 551.4-295.4 551.4-551.6 0-8.4-0.2-16.8-0.6-25 37.6-27.4 70.6-61.4 96.6-100.4zM868.4 293.4l-14 10.2 0.8 17.2c0.4 7.6 0.6 15.6 0.6 23.6 0 60.4-11.8 123.6-34 183-23.4 62.4-57 118.8-100 167.6-46 52.2-100.4 93-162.2 121.6-67.6 31.4-142.6 47.2-223 47.2-57.8 0-114.8-9.6-169-28.4 19.8-3.8 39.2-9.2 58.2-15.8 43.4-15.2 83.8-37.4 120.2-66l70.6-55.4-89.8-1.6c-52.2-1-99.4-26.8-128.6-67.8 14.6-1 29-3.6 43-7.4l121.4-40.4-123.4-21.8c-59.2-11.8-105.6-55.8-122.6-111.6 15.6 4 30.8 5.6 47.8 6.6 0 0 63.6 2.8 111.6-0.2-26-12.4-92.8-58.4-92.8-58.4-45-30.2-72-80.4-72-134.8 0-12.8 1.6-25.6 4.4-38 43.8 44.8 94 82.2 150.2 111 74 38.2 153.8 59.6 237.2 63.8l42.4 2.2-9.6-41.4c-2.8-11.8-4.2-24.2-4.2-37 0-88.8 72.6-161.4 161.8-161.4 44.6 0 87.6 18.6 118 51.2l12.2 13 17.4-3.4c9-1.8 17.8-3.8 26.6-6.2-2 2.8-11.4 12.2-22 21.6-9 8-35.6 33-35.6 33s26 8.2 42.2 10c16.2 1.8 34.8-1.2 37.8-1.6-5.6 4.6-15.6 11.6-21.6 15.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-twitter-outline"
    ]
  },
  {
    "paths": [
      "M984 219c-34.8 15.4-72 25.8-111.2 30.6 40-24 70.8-62 85.2-107.2-37.4 22.2-78.8 38.4-123 47-35.4-37.8-85.8-61.4-141.4-61.4-107 0-193.6 86.8-193.6 193.8 0 15.2 1.6 30 5 44.2-161-8-303.8-85.2-399.2-202.6-16.6 28.6-26.2 62-26.2 97.4 0 67.2 34.4 126.6 86.4 161.4-32-0.8-62-9.6-88-24.2 0 0.8 0 1.6 0 2.4 0 94 66.8 172.2 155.4 190-16.2 4.4-33.4 6.8-51 6.8-12.4 0-24.6-1.2-36.4-3.6 24.6 77 96.2 133 181 134.6-66.2 52-149.8 83-240.6 83-15.6 0-31-1-46.2-2.8 85.4 55.6 187.2 87.6 296.4 87.6 356.6 0 551.4-295.4 551.4-551.6 0-8.4-0.2-16.8-0.6-25 37.8-27.4 70.6-61.4 96.6-100.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-twitter"
    ]
  },
  {
    "paths": [
      "M441.492 205.25c-15.576 3.366-34.88 9.626-49.282 17.058-18.036 9.298-32.822 21.93-45.208 38.59-13.412 18.004-20.21 39.978-20.21 65.314 0 35.832 12.394 64.576 36.81 85.404 18.668 15.966 43.008 28.862 73.374 38.33l43.024 11.388v-260.846c0 0-16.468 0-38.508 4.762zM448 419.398c-24-7.486-47.824-18.176-64.102-32.096-17.242-14.71-25.346-35.068-25.346-61.090 0-18.482 4.828-33.88 14.008-46.204 9.16-12.322 19.824-22.076 33.76-29.262 12.36-6.378 27.68-11.13 41.68-14.276v182.928z",
      "M696.434 593.45c-16.864-16.578-36.004-28.592-56.828-35.68-17.898-6.15-34.882-11.696-54.93-16.954l-40.676-10.526v290.376c0 0 24.102-1.284 36.742-2.952s21.406-3.942 33.34-7.596c25.454-7.78 46.618-18.040 62.64-30.5 17.356-13.494 30.29-29.57 38.328-47.814 7.55-17.19 11.412-35.162 11.412-53.422 0-36.738-10.086-65.31-30.028-84.932zM685.804 718.942c-5.878 13.346-15.398 25.152-28.606 35.422-13.204 10.266-31.488 18.656-52.754 25.154-9 2.756-16.446 4.888-28.446 6.472v-214.22c20 5.248 36.36 10.664 52.652 16.262 16.124 5.488 31.496 14.886 45.074 28.232 13.57 13.352 20.618 34.060 20.618 62.12 0.002 13.7-2.674 27.21-8.538 40.558z",
      "M822.774 606.512c-6.238-19.154-15.782-37.122-28.602-53.904-12.844-16.764-28.792-31.652-47.86-44.662-19.078-12.996-41.442-23.26-67.106-30.8-10.286-2.726-28.378-7.012-52.208-12.836-17.032-4.148-33-8.4-51-12.734v-211.446c18 4.792 30.504 12.404 43.852 20.86 28.558 18.080 46.464 49.010 51.71 91.010h138.348c-1.308-36-9.3-65.52-23.992-92.040-16.14-29.086-37.954-54.048-65.46-73.912-27.5-19.844-60.45-34.98-96.754-44.91-15.768-4.306-29.702-7.928-47.702-10.366v-66.772h-128v66.334c-14 2.088-30.296 4.89-44.852 8.5-34.484 8.566-64.776 21.736-91.902 39.528-27.142 17.81-48.704 40.224-65.208 67.254-16.502 27.046-24.624 59.040-24.624 96 0 19.17 2.814 37.986 8.314 56.47 5.504 18.482 14.884 35.934 28.084 52.362 13.206 16.428 30.99 31.316 53.374 44.664 22.366 13.344 49.41 24.128 83.152 32.342 18.574 4.69 37.66 9.068 53.66 13.152v239.172c-22-5.838-43.778-14.798-61.356-26.958-18.34-12.654-32.132-27.906-42.396-47.768-9.558-18.458-14.146-41.052-14.814-65.052h-137.432c1.39 42 10.5 78.988 27.344 110.742 17.598 33.208 41.066 59.92 70.408 81.124 29.324 21.226 62.786 36.712 102.396 46.982 17.77 4.608 37.852 7.92 55.852 10.46v70.692h128v-69.080c20-2.138 37.914-5.38 57.054-9.758 37.402-8.546 71.29-22.072 100.632-40.552 29.324-18.48 53.242-42.256 71.222-71.362 17.96-29.082 27.090-64.17 27.090-105.238 0.002-19.156-3.002-38.328-9.224-57.498zM777.808 752.436c-15.246 24.68-35.746 45.238-60.914 61.1-26.070 16.42-56.496 28.678-90.438 36.434-18.118 4.142-34.57 7.128-53.308 9.132l-29.148 3.058v65.84h-64v-66.488l-27.016-3.886c-18.512-2.614-37.342-5.936-52.542-9.876-35.73-9.266-65.752-23.020-92.062-42.064-25.69-18.566-45.54-41.102-60.816-69.934-10.008-18.874-16.836-41.752-20.536-63.752h73.428c3.058 16 8.324 33.674 15.608 47.738 12.648 24.478 29.958 43.828 52.882 59.646 20.29 14.034 47.62 25.28 71.352 31.448s39.702 6.502 39.702 6.502v-301.586l-23.572-6.148c-9.904-2.526-22.148-5.166-33.116-7.92-6.79-1.708-13.628-3.458-20.74-5.252l-0.066-0.034-0.102-0.034c-29.904-7.28-55.066-16.944-74.822-28.73-18.974-11.314-34.042-23.84-44.798-37.222-10.542-13.12-18.058-27.066-22.34-41.444-4.614-15.51-6.952-31.442-6.952-47.35 0-31.32 6.548-57.272 20.004-79.33 14.194-23.244 32.374-41.946 55.572-57.17 24.402-16.006 51.332-27.528 82.31-35.222 12.668-3.142 25.73-5.802 39.852-7.908l28.77-4.068v-61.916h64v62.726l26.254 3.754c14.742 1.998 28.472 4.808 45.274 9.398 32.778 8.964 61.82 22.378 86.046 39.858 23.382 16.886 42.364 38.666 56.266 63.724 7.61 13.73 13.008 28.54 16.274 44.54h-76.238c-10.156-38-30.704-67.274-60.344-86.042-18.508-11.722-35.122-18.43-54.746-24.502-19.254-5.956-38.786-6.956-38.786-6.956v274.284l25.058 5.902c15.262 3.674 28.368 7.288 42.906 10.83l9.464 2.256c22.746 5.56 39.302 9.598 49.116 12.192 22.168 6.55 41.6 15.442 57.702 26.408 16.156 11.026 29.79 23.706 40.472 37.656 10.582 13.85 18.528 28.786 23.602 44.358 5.124 15.796 7.726 31.82 7.726 47.624 0 34.78-7.48 64.532-22.238 88.426z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-usd-outline"
    ]
  },
  {
    "paths": [
      "M822.774 606.512c-6.238-19.154-15.782-37.122-28.602-53.904-12.844-16.764-28.792-31.652-47.86-44.662-19.078-12.996-41.442-23.26-67.106-30.8-10.286-2.726-28.378-7.012-52.208-12.836-17.032-4.148-33-8.4-51-12.734v-211.446c18 4.792 30.504 12.404 43.852 20.86 28.558 18.080 46.464 49.010 51.71 91.010h138.348c-1.308-36-9.3-65.52-23.992-92.040-16.14-29.086-37.954-54.048-65.46-73.912-27.5-19.844-60.45-34.98-96.754-44.91-15.768-4.306-29.702-7.928-47.702-10.366v-66.772h-128v66.334c-14 2.088-30.296 4.89-44.852 8.5-34.484 8.566-64.776 21.736-91.902 39.528-27.142 17.81-48.704 40.224-65.208 67.254-16.502 27.046-24.624 59.040-24.624 96 0 19.17 2.814 37.986 8.314 56.47 5.504 18.482 14.884 35.934 28.084 52.362 13.206 16.428 30.99 31.316 53.374 44.664 22.366 13.344 49.41 24.128 83.152 32.342 18.574 4.69 37.66 9.068 53.66 13.152v239.172c-22-5.838-43.778-14.798-61.356-26.958-18.34-12.654-32.132-27.906-42.396-47.768-9.558-18.458-14.146-41.052-14.814-65.052h-137.432c1.39 42 10.5 78.988 27.344 110.742 17.598 33.208 41.066 59.92 70.408 81.124 29.324 21.226 62.786 36.712 102.396 46.982 17.77 4.608 37.852 7.92 55.852 10.46v70.692h128v-69.080c20-2.138 37.914-5.38 57.054-9.758 37.402-8.546 71.29-22.072 100.632-40.552 29.324-18.48 53.242-42.256 71.222-71.362 17.96-29.082 27.090-64.17 27.090-105.238 0.002-19.156-3.002-38.328-9.224-57.498zM448 419.398c-24-7.486-47.824-18.176-64.102-32.096-17.242-14.71-25.346-35.068-25.346-61.090 0-18.482 4.828-33.88 14.008-46.204 9.16-12.322 19.824-22.076 33.76-29.262 12.36-6.378 27.68-11.13 41.68-14.276v182.928zM685.804 718.942c-5.878 13.346-15.398 25.152-28.606 35.422-13.204 10.266-31.488 18.656-52.754 25.154-9 2.756-16.446 4.888-28.446 6.472v-214.22c20 5.248 36.36 10.664 52.652 16.262 16.124 5.488 31.496 14.886 45.074 28.232 13.57 13.352 20.618 34.060 20.618 62.12 0.002 13.7-2.674 27.21-8.538 40.558z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-usd"
    ]
  },
  {
    "paths": [
      "M953.8 228c-10-46.8-35-77.6-81.2-92.6-14.8-4.8-33.4-7.4-53.8-7.4-43.4 0-94.8 12-134.4 41-59.8 43.6-95.2 119.4-107.6 167.6 24.4-10.6 41.6-14.2 63.8-14.2 4.4 0 9.2 0.2 14.2 0.4 30 1.6 49 24 49.8 50.6 0.6 19.6-0.4 37.4-7.2 55.4-21.6 57.4-55.4 113-95.2 161.6-5.8 7.2-12.8 13.8-20 19.8-8.2 6.8-16 10-23.2 10-10.4 0-19.8-7-27.6-20.4-10.8-18.6-18-37.8-24.4-58.2-24.8-79.4-33.6-161.8-47.6-243.2-6.6-39-14-79.6-36-113.8-20-30.8-48-45.2-83-45.2-5.6 0-11.2 0.4-17.2 1-29.4 3.6-73.8 35-95.6 52.8 0 0-112 93.8-163.6 142.8l42.4 54c0 0 35.8-25 55-36.6 5.8-3.6 12.2-5.6 18.4-5.6 5.8 0 11.4 1.8 16 6 9 7.8 19.2 18 24.6 28.2 11.4 21.4 22.4 43.8 29.4 66.8 26.4 88.6 51 177.4 75.6 266.6 12.6 45.6 27.8 88.4 56 127.2 26.4 36.4 53.8 53.6 88.6 53.6 16 0 33.6-3.6 53.2-10.8 50.8-18.2 93.2-52.4 132-87.8 66.2-60.4 118.2-130.8 171-202.4 40.8-55.4 74.6-111.4 102.8-174 28-61.6 39-126.6 24.8-193.2zM900 407.8c-26.6 58.8-58.2 112.4-99.4 168.2l-0.6 0.8c-52.8 71.4-102.6 139-166.2 197-35.6 32.6-75 64.8-121.2 81.4-16.6 6-30.4 8.8-42.4 8.8-16.4 0-36.8-4.8-62.8-40.4-26.8-36.8-40.4-78-51-116.8-24.8-90.2-49.2-178.4-75.8-267.2-7.8-26.4-20.4-51.6-31.8-72.8-6.4-11.8-16.8-24-31.8-37.2-10.4-9-23.2-13.8-37.2-13.8-11.8 0-24 3.6-35 10.2-9 5.4-21 13.4-31.8 20.6l-5.6-7.2c53.8-48.8 136.6-118.2 140.6-121.6 29.6-24.2 63.6-43.8 79-45.8 4.6-0.6 9-0.8 13.2-0.8 24.8 0 42.6 9.8 56.2 30.6 19 29.4 25.6 67.8 31.4 101.8 3.2 19.4 6.4 39.2 9.4 58.2 9.6 62.2 19.6 126.6 39.2 189.2 6 19.4 14 42.4 27.2 65 17.6 30 39.8 36.2 55.2 36.2 14.8 0 29.4-5.8 43.4-17.2 9.2-7.4 17.4-15.6 24.6-24.4 43.8-53.6 78.6-112.6 100.4-170.6 9-24 9.8-46.6 9.2-67.6-1.2-44.8-34.8-79.2-80-81.8-5.8-0.4-11-0.4-16-0.4-4.4 0-8.6 0.2-12.6 0.4 17.6-36.2 43.4-72.6 75.4-95.8 30-21.8 73.2-35 115.6-35 16.6 0 32.2 2 43.8 5.8 34 11 52 31.6 59.8 68.8 12 55.8 4.4 114-22.4 173.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-vimeo-outline"
    ]
  },
  {
    "paths": [
      "M953.8 228c-10-46.8-35-77.6-81.2-92.6s-129.8-9-188.2 33.6c-59.8 43.6-95.2 119.4-107.6 167.6 29.4-12.6 48-15.4 78-13.8s49 24 49.8 50.6c0.6 19.6-0.4 37.4-7.2 55.4-21.6 57.4-55.4 113-95.2 161.6-5.8 7.2-12.8 13.8-20 19.8-20.4 16.6-37.6 12.2-50.8-10.4-10.8-18.6-18-37.8-24.4-58.2-24.8-79.4-33.6-161.8-47.6-243.2-6.6-39-14-79.6-36-113.8-23.2-35.6-57.2-49.2-100-44-29.4 3.6-73.8 35-95.6 52.8 0 0-112 93.8-163.6 142.8l42.4 54c0 0 35.8-25 55-36.6 11.4-6.8 24.8-8.2 34.4 0.4 9 7.8 19.2 18 24.6 28.2 11.4 21.4 22.4 43.8 29.4 66.8 26.4 88.6 51 177.4 75.6 266.6 12.6 45.6 27.8 88.4 56 127.2 38.6 53.2 79.2 65.4 141.8 43 50.8-18.2 93.2-52.4 132-87.8 66.2-60.4 118.2-130.8 171-202.4 40.8-55.4 74.6-111.4 102.8-174 27.8-62 38.8-127 24.6-193.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-vimeo"
    ]
  },
  {
    "paths": [
      "M419.754 308.228c-8.516-22.646-18.352-21.030-24.9-21.278-6.554-0.242-12.292-0.122-21.146 0.022-7.492 0.122-19.764 2.052-30.464 12.826-10.714 10.756-40.732 36.624-42.808 91.45-2.062 54.816 36.16 109.286 41.498 116.91 5.334 7.652 72.988 126.472 185.438 175.34 112.462 48.854 113.050 33.962 133.68 32.87 20.65-1.080 67.452-24.492 77.798-50.146 10.344-25.654 11.176-47.958 8.542-52.716-2.632-4.742-10-7.822-21.020-13.8-11.032-5.99-65.19-34.996-75.346-39.1-10.162-4.088-17.574-6.216-25.484 4.658-7.914 10.844-30.382 35.138-37.192 42.336-6.84 7.2-13.422 7.868-24.452 1.86-11-5.976-46.746-19.096-88.196-58.634-32.252-30.76-53.422-68.086-59.558-79.472-6.138-11.394-0.040-17.208 5.8-22.538 5.236-4.814 11.714-12.602 17.584-18.898 5.838-6.296 7.898-10.86 11.922-18.166 4.014-7.29 2.4-13.864-0.204-19.542-2.606-5.676-22.98-61.336-31.492-83.982z",
      "M520.124 128c100.498 0 194.956 38.804 265.964 109.264 70.876 70.328 109.912 163.802 109.912 263.2 0 99.388-39.036 192.86-109.912 263.192-71.014 70.464-165.47 109.274-265.964 109.274-63.612 0-126.48-16.046-181.812-46.402l-24.034-13.186-149.030 47.342 48.346-142.6-15.542-25.526c-35.186-57.796-53.784-124.222-53.784-192.094 0-99.398 39.036-192.872 109.914-263.202 71.010-70.458 165.456-109.262 265.942-109.262zM520.124 64c-242.914 0-439.856 195.402-439.856 436.464 0 82.458 23.064 159.582 63.118 225.374l-79.386 234.162 243.528-77.364c63.016 34.57 135.49 54.292 212.596 54.292 242.946 0 439.876-195.43 439.876-436.464 0-241.062-196.93-436.464-439.876-436.464v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-whatsapp-outline"
    ]
  },
  {
    "paths": [
      "M520.124 64c-242.914 0-439.856 195.402-439.856 436.464 0 82.46 23.064 159.58 63.118 225.374l-79.386 234.162 243.528-77.364c63.016 34.57 135.49 54.292 212.596 54.292 242.946 0 439.876-195.43 439.876-436.464 0-241.062-196.93-436.464-439.876-436.464zM738.848 666.22c-10.348 25.654-57.148 49.066-77.798 50.144-20.628 1.094-21.216 15.988-133.68-32.868-112.45-48.868-180.104-167.688-185.438-175.34-5.338-7.624-43.56-62.094-41.498-116.91 2.076-54.826 32.094-80.692 42.808-91.45 10.702-10.774 22.972-12.704 30.464-12.826 8.856-0.144 14.592-0.264 21.146-0.022 6.548 0.248 16.384-1.37 24.9 21.278 8.512 22.646 28.886 78.306 31.492 83.978 2.604 5.678 4.216 12.252 0.204 19.542-4.024 7.306-6.084 11.87-11.922 18.166-5.87 6.296-12.348 14.084-17.584 18.898-5.84 5.33-11.94 11.144-5.8 22.538 6.136 11.386 27.306 48.712 59.558 79.472 41.45 39.542 77.196 52.658 88.196 58.634 11.030 6.008 17.612 5.34 24.452-1.858 6.808-7.198 29.278-31.492 37.192-42.338 7.91-10.876 15.322-8.746 25.484-4.658 10.156 4.104 64.314 33.112 75.346 39.102 11.020 5.978 18.386 9.058 21.020 13.8 2.634 4.76 1.802 27.062-8.542 52.718z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-whatsapp"
    ]
  },
  {
    "paths": [
      "M928 562v361l-432-62.6v-298.4h432zM960 530h-496v358l496 72v-430z",
      "M400 562v284.4l-304-44v-240.4h304zM432 530h-368v300l368 53.4v-353.4z",
      "M928 100v366h-432v-303.4l432-61.8zM960 64l-496 70.8v363.2h496v-434z",
      "M400 176v290h-304v-246.2l304-43.4zM432 139.4l-368 52.6v306h368v-358.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-windows-outline"
    ]
  },
  {
    "paths": [
      "M960 530h-496v358l496 72v-430z",
      "M432 530h-368v300l368 53.4v-353.4z",
      "M960 64l-496 70.8v363.2h496v-434z",
      "M432 139.4l-368 52.6v306h368v-358.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-windows"
    ]
  },
  {
    "paths": [
      "M511.8 128c-211.4 0-383.8 172.4-383.8 384.2 0 211.6 172.4 383.8 383.8 383.8 17 0 33.6-1 49.8-3.6 171.4-22 307.6-157.4 330.6-328.2 2.6-17 3.8-34.4 3.8-52 0-211.8-172.4-384.2-384.2-384.2zM166.8 512.2c0-50 10.8-97.6 30-140.4l164.6 451c-115.2-56-194.6-174.2-194.6-310.6zM556.6 854.6c-14.6 1.8-29.6 2.8-44.8 2.8-33.8 0-66.4-5-97.2-14.2l37.6-110h0.2l65.4-191 106.2 290.8c0.8 1.6 1.8 3.2 2.6 4.6-22.4 8-45.8 13.6-70 17zM559.6 350.2c20.8-1 39.4-3.2 39.4-3.2 18.8-2 16.4-29.6-2.2-28.4 0 0-56 4.4-92 4.4-33.8 0-91-4.4-91-4.4-18.4-1.2-20.8 27.4-2 28.4 0 0 17.4 2.2 36.2 3.2l53.8 147.4-75.6 226.6-125.8-374c21-1 39.6-3.2 39.6-3.2 18.4-2 16.4-29.6-2.2-28.4 0 0-55.8 4.4-92 4.4-6.6 0-14.2-0.2-22.2-0.4 61.6-93.6 167.8-155.4 288.2-155.4 90 0 171.8 34.4 233.2 90.4-1.6 0-3-0.2-4.6-0.2-34 0-58 29.6-58 61.4 0 28.4 16.4 52.4 33.8 80.8 13.2 23 28.6 52.6 28.6 95.2 0 29.6-8.8 66.8-26.2 111.4l-34.6 115.2-124.4-371.2zM685.4 810.6l27.4-79.4 78-225.6c19.8-49.2 26.2-88.6 26.2-123.6 0-12.6-0.8-24.6-2.2-35.6 27 49.2 42.4 105.6 42.4 165.8 0 16-1 31.6-3 47-14.8 107.4-79 199.2-168.8 251.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-wordpress-outline"
    ]
  },
  {
    "paths": [
      "M518 542.6l-65.6 191.4h-0.2l-50.8 146.2c3.6 1 7 1.8 10.6 2.8 0.2 0 0.4 0 0.6 0 31.6 8.4 64.8 13 99 13 17 0 33.6-1 49.8-3.6 22.4-2.8 44-7.6 65-14.2 0 0 0 0 0 0 5.2-1.6 10.4-3.4 15.6-5.2-5.6-12-17.6-38.6-18.2-39.8l-105.8-290.6z",
      "M161.6 361c-20 45.2-33.6 100.8-33.6 151 0 12.6 0.6 25.2 1.8 37.6 13.8 142.4 105.8 262 232.2 315.8 5.2 2.2 10.6 4.4 16 6.4l-186-510.6c-16-0.6-19 0.4-30.4-0.2z",
      "M860.4 350.8c-8.6-18.6-18.8-36.4-30.2-53.2-3.2-4.8-6.8-9.6-10.2-14.4-43-57.6-101.6-102.8-169.8-129.2-42.8-16.8-89.6-26-138.4-26-120.6 0-228.4 56-298.8 143.4-13 16-24.6 33.2-35 51.2 28.4 0.2 63.6 0.2 67.6 0.2 36.2 0 92-4.4 92-4.4 18.8-1.2 20.8 26.2 2.2 28.4 0 0-18.8 2.2-39.6 3.2l125.8 374 75.6-226.6-53.6-147.2c-18.8-1-36.2-3.2-36.2-3.2-18.8-1-16.4-29.6 2-28.4 0 0 57 4.4 91 4.4 36.2 0 92-4.4 92-4.4 18.6-1.2 21 26.2 2.2 28.4 0 0-18.6 2.2-39.4 3.2l124.6 371.2 34.6-115.2c17.4-44.8 26.2-81.8 26.2-111.4 0-42.6-15.4-72.2-28.6-95.2-17.4-28.6-33.8-52.6-33.8-80.8 0-31.8 24-61.4 58-61.4 1.4 0 3 0 4.4 0 52.4-1.4 69.6 50.6 71.8 86 0 0 0 0.8 0 1.2 0.8 14.4 0.2 25 0.2 37.6 0 34.8-6.6 74.2-26.2 123.6l-78 225.6-44.6 131.4c3.6-1.6 7-3.2 10.6-5 113.4-54.8 196-164 213.4-293.4 2.6-17 3.8-34.4 3.8-52 0-57.8-12.8-112.6-35.6-161.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-wordpress"
    ]
  },
  {
    "paths": [
      "M769.2 136.8c-22.6 0-45-1.6-65.2-8.8l-192 320-192-320c-20.2 7.2-41.4 8.8-64 8.8-22.2 0-44.2-1.8-64-8.8l256 425.4v342.6c20-7 41.6-8.8 64-8.8s44 1.8 64 8.8v-342l256-426c-19.8 6.8-40.6 8.8-62.8 8.8zM548.4 537l-4.4 8v311.4c-10-1.2-22.4-1.4-32-1.4s-20 0.2-32 1.4v-311.8l-4.8-7.6-221.2-368.2c0.6 0 1.4 0 2 0 15.2 0 32-0.6 49.4-3.8l179.6 299.6 26.8 45.6 28-45.8 179.6-299.8c18 3.2 35.2 3.4 49.6 3.4 0.4 0 0.6 0 1 0l-221.6 369z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-yahoo-outline"
    ]
  },
  {
    "paths": [
      "M769.2 136.8c-22.6 0-45-1.6-65.2-8.8l-192 320-192-320c-20.2 7.2-41.4 8.8-64 8.8-22.2 0-44.2-1.8-64-8.8l256 425.4v342.6c20-7 41.6-8.8 64-8.8s44 1.8 64 8.8v-342l256-426c-19.8 6.8-40.6 8.8-62.8 8.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-yahoo"
    ]
  },
  {
    "paths": [
      "M896 64h-160l-224 442.256-224-442.256h-160l224.736 416h-96.736v96h147.128l28.872 62v34h-176v96h176v192h160v-192h176v-96h-176v-34l29.782-62h146.218v-96h-96.578l224.578-416zM736 512v32h-134l-42 86v74h176v32h-176v192h-96v-192h-176v-32h176v-71.5l-40-88.5h-136v-32h118.394l-224.736-416h86.342l244 480 244-480h86.36l-224.578 416h118.218z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-yen-outline"
    ]
  },
  {
    "paths": [
      "M896 64h-160l-224 442.256-224-442.256h-160l224.736 416h-96.736v96h147.128l28.872 62v34h-176v96h176v192h160v-192h176v-96h-176v-34l29.782-62h146.218v-96h-96.578l224.578-416z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-yen"
    ]
  },
  {
    "paths": [
      "M530 192c130.6 0 237.4 2.2 336.2 6.6h2.8c46.2 0 84 44 84 98.2v2.2l0.2 2.2c4.6 68 6.8 138.6 6.8 209.8v0 0c0.2 71.2-2.2 141.8-6.8 209.8l-0.2 2.2v2.2c0 27.6-9.4 53.2-26.8 72.2-15.6 17.2-36 26.8-57.2 26.8h-3.2c-105.8 5-217.6 7.6-332.8 7.6-7 0-14.2 0-21.2 0v0c-7.2 0-14.4 0-21.6 0-115.6 0-227.4-2.6-332.4-7.4h-3.2c-21.2 0-41.4-9.6-57-26.8-17.2-19-26.8-44.6-26.8-72.2v-2.2l-0.2-2.2c-4.8-68.2-7-138.8-6.6-209.4v-0.4c-0.2-70.6 2-141 6.6-209.2l0.2-2.2v-2.2c0-54.4 37.6-98.6 83.8-98.6h2.8c99-4.6 205.8-6.6 336.4-6.6h36.2zM530 128c-6 0-12 0-18 0s-12 0-18 0c-115.2 0-228.4 1.6-339.2 6.6-81.6 0-147.8 72.6-147.8 162.6-5 71.6-7.2 142.8-7 214.2-0.2 71.4 1.8 142.6 6.8 214 0 90 66.2 163.2 147.8 163.2 109.6 5.2 221.4 7.6 335.6 7.6 7.2 0 14.6 0 21.8 0s14.4 0 21.4 0c114.2 0 226-2.4 335.8-7.6 81.8 0 148-73.2 148-163.2 4.8-71.4 7-142.8 6.8-214.2 0.2-71.4-2-142.6-6.8-214.2 0-90-66.2-162.2-148-162.2-110.8-5.2-223.8-6.8-339.2-6.8v0z",
      "M414 707.6v-392.8l290 196.4-290 196.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-youtube-outline"
    ]
  },
  {
    "paths": [
      "M1017.2 297.6c0-90-66.2-162.4-148-162.4-110.8-5.2-223.8-7.2-339.2-7.2-6 0-12 0-18 0s-12 0-18 0c-115.2 0-228.4 2-339.2 7.2-81.6 0-147.8 72.8-147.8 162.8-5 71.2-7.2 142.4-7 213.6-0.2 71.2 2 142.4 6.8 213.8 0 90 66.2 163 147.8 163 116.4 5.4 235.8 7.8 357.2 7.6 121.6 0.4 240.6-2 357.2-7.6 81.8 0 148-73 148-163 4.8-71.4 7-142.6 6.8-214 0.4-71.2-1.8-142.4-6.6-213.8zM414 707.8v-393l290 196.4-290 196.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-social-youtube"
    ]
  },
  {
    "paths": [
      "M511.64 288c176.538 0 319.648-57.308 319.648-128s-143.11-128-319.648-128c-176.536 0-319.646 57.308-319.646 128s143.11 128 319.646 128zM511.64 66.082c139.458 0 252.52 38.468 252.52 85.918s-113.062 85.918-252.52 85.918c-139.458 0-252.516-38.468-252.516-85.918s113.058-85.918 252.516-85.918z",
      "M513.14 320c-176.538 0-321.134-57.308-321.134-128 0 0-0.006 67.998 15.994 80v480c0 70.692 127.464 128 304 128 176.538 0 304-57.308 304-128v-480c16-14.876 15.416-69.706 15.634-80-2.304 69.892-143.402 128-318.494 128zM752 751.176c0 4.464-15.922 21.364-58.846 37.376-47.448 17.7-111.53 27.448-180.608 27.448s-133.66-9.748-181.108-27.45c-42.924-16.010-57.438-32.91-59.438-37.374v-159.128c36 19.442 85.484 34.23 144.312 41.958l3.176 0.474c11.486 40.136 48.384 69.52 92.164 69.52s80.676-29.378 92.168-69.508l3.51-0.488c58.83-7.726 108.67-22.516 144.67-41.958v159.13zM752 528.046c-36 19.662-86.952 34.568-146.65 42.22l-5.22 0.39c-14.548-34.462-48.684-58.656-88.412-58.656-39.734 0-73.838 24.204-88.38 58.68l-5.028-0.412c-59.7-7.652-110.31-22.558-146.31-42.22v-182.53c68 24.982 151.846 38.482 240.998 38.482 88.332 0 173.002-13.426 239.002-37.91v181.956z",
      "M548.004 927.16z",
      "M512.544 928c0.586 0 1.166-0.012 1.752-0.014-0.702 0.002-1.398 0.010-2.102 0.010 0.118 0 0.234 0.004 0.35 0.004z",
      "M816 831.998v-31.998c0 72.002-126.864 128-304 128-177.138 0-304-57.308-304-128v31.998l-15.478 32.002c0 13.988 5.876 27.45 16.234 40.050 41.984 51.074 162.186 87.95 303.79 87.95 141.602 0 261.74-36.876 303.726-87.95 10.36-12.602 15.846-26.062 15.846-40.050l-16.118-32.002z"
    ],
    "grid": 0,
    "tags": [
      "ion-soup-can-outline"
    ]
  },
  {
    "paths": [
      "M832 160c0 70.692-143.269 128-320 128s-320-57.308-320-128c0-70.692 143.269-128 320-128s320 57.308 320 128z",
      "M512 880c176.73 0 304-57.308 304-128v-256c0 57.162-83.224 105.566-208.52 122.004-5.004 48.316-45.84 85.996-95.48 85.996s-90.476-37.68-95.48-85.996c-125.296-16.438-208.52-64.842-208.52-122.004v256c0 70.692 127.268 128 304 128z",
      "M512 320c-176.732 0-320-57.308-320-128 0 0 0 65.668 16 80v192c0 57.464 84.098 106.084 210.5 122.268 9.852-42.546 47.958-74.268 93.5-74.268s83.648 31.722 93.5 74.268c126.402-16.184 210.5-64.804 210.5-122.268v-192c16-16.5 16-80 16-80 0 70.692-143.27 128-320 128z",
      "M816 784c0 70.692-127.27 128-304 128-176.732 0-304-57.308-304-128v47.998l-16 32.002c0 13.988 5.63 27.45 16 40.050 42.032 51.074 162.242 87.95 304 87.95s261.968-36.876 304-87.95c10.372-12.602 16-26.062 16-40.050l-16-32.002v-47.998z"
    ],
    "grid": 0,
    "tags": [
      "ion-soup-can"
    ]
  },
  {
    "paths": [
      "M141.8 363c0-82 50-153 121.2-183h-15.4c-82.2 0-150.2 65.6-162.2 150.4-12 2-21.4 15.8-21.4 32.2 0 17.2 10.2 30.8 23.2 31.8 14.4 72.8 70.2 131.6 139.4 137.6 0 0 0.2 0 0.2 0 2.8 0 5.6 1.2 8.4 1.8 2.2 0.4 4.4 0.8 6.6 1.4-59.8-34.2-100-98.4-100-172.2z",
      "M930.2 182c-2.2-5.8-4.6-11.2-7-16.6-13-28.8-28.8-52-46.8-69.2-22.4-21-48.2-32.2-74.8-32.2-16.6 0-32.8 4.4-48.2 12.8 0 0 0 0-0.2 0-2.4 1.4-4.8 2.6-7.2 4-98 58-208.2 92.4-325.2 98.8-13 0.8-26 0.4-39 0.4h-84.6c-68 30-118 101-118 183 0 73.6 38.4 138.2 95.6 172.2 26 21.8 83.4 23.4 80 47.8-3.8 26.4-11 43.8-15.6 61.4-2.6 9.6-47.2 145.8-50.6 289.4 0 4 0 7.4 0.4 13.2s4.4 12.8 17 12.8h153.6c13.2 0 19.4-6.6 18.6-18.6-0.4-3.8-1.2-8.6-1.6-13-4.8-46.2-9.2-99.6-6.6-163.2 2.6-68 10.4-103.8 14-122.6 4.2-20.8 15.2-44.8 24.2-60.6 61.6 1.8 185.8 38.6 230.2 57.8 0 0 14.4 6.8 20.2 10.4 14 6.8 28.4 10.2 43.2 10.2 1.8 0 3.6 0 5.4-0.2 24.6-1.4 48.4-19.4 69.4-39 18.2-17 33.8-40.4 46.8-69.2 2.4-5.6 4.8-11.2 7-17.2 19.2-50 29.6-111.8 29.6-176.2s-10.4-126.4-29.8-176.4zM884 535c-15.6 37-36.4 66.6-59 66.6s-43.2-29.4-58.8-66.6c-18.2-43.2-29.8-106.2-29.8-176.2 0-70.4 11.6-133.6 30-176.8 15.6-36.8 36.2-59 58.6-59 22.6 0 43 22.4 58.8 59 18.4 43.2 30 106.4 30 176.8-0 70-11.6 133-29.8 176.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-speakerphone"
    ]
  },
  {
    "paths": [
      "M688 512l-168.8 128.4c-2.4-0.2-4.8-0.4-7.2-0.4-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64 0-2.4-0.2-4.8-0.4-7.2l128.4-168.8-16-16z",
      "M512 192c-247.4 0-448 200.6-448 448 0 68.8 15.6 133.8 43.2 192h72.2c-30.8-53.2-48.4-113.2-51-176h63.6v-32h-63.6c2.4-57.6 17.4-113 43.6-162.8l55 31.8 16-27.8-55-31.6c14.8-23.2 32.4-45.2 52.4-65.2 20.4-20.2 42.6-38 66.2-53l31.6 54.6 27.8-16-31.6-54.6c49.6-26 104.4-40.6 161.6-43v63.6h32v-63.6c57.2 2.4 112 17.2 161.6 43l-31.4 54.6 27.8 16 31.6-54.6c23.6 15 45.8 32.8 66.2 53 20 20 37.4 41.8 52.4 65.2l-54.8 31.6 16 27.8 55-31.8c26.2 49.8 41.2 105.2 43.6 162.8h-64v32h63.6c-2.6 62.8-20.2 122.8-51 176h72.2c27.6-58.2 43.2-123.2 43.2-192-0-247.4-200.6-448-448-448z"
    ],
    "grid": 0,
    "tags": [
      "ion-speedometer"
    ]
  },
  {
    "paths": [
      "M640 320c0-128-53-256-128-256s-128 128-128 256v0c1.8 50 31.4 108.6 73.2 128.6 1 0.4 1.8 0.8 2.8 1.2 0 0 0 0 0.2 0 6.8 3.8 19.6 11 19.6 19.4 0 0-32 397.4-32 420.2s10 41 21 52c11 11 26.2 18.4 42.6 18.4 0.2 0 0.2 0 0.4 0s0.2 0 0.4 0c16.4 0 31.6-7.4 42.8-18.4 11-11 20.6-25.8 20.6-52s-32-420.2-32-420.2c0-8.4 12.8-15.8 19.6-19.6l3.4-1.8c43.2-19.8 73.4-75.8 73.4-127.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-spoon"
    ]
  },
  {
    "paths": [
      "M960 400h-342.962l-104.98-336-105.020 336h-343.038l277.892 208.418-109.892 351.582 280-224 280 224-109.854-351.61z"
    ],
    "grid": 0,
    "tags": [
      "ion-star"
    ]
  },
  {
    "paths": [
      "M352 192h128v640h-128v-640z",
      "M160 640h128v192h-128v-192z",
      "M544 512h128v320h-128v-320z",
      "M736 384h128v448h-128v-448z"
    ],
    "grid": 0,
    "tags": [
      "ion-stats-bars"
    ]
  },
  {
    "paths": [
      "M960 416.4c0 41-33.2 74.4-74.4 74.4-41 0-74.4-33.2-74.4-74.4 0-41 33.2-74.4 74.4-74.4 41 0 74.4 33.4 74.4 74.4zM885.2 278c-76.2 0-138 61.4-138.8 137.4l-86.4 124c-3.6-0.4-7.2-0.6-10.8-0.6-19.4 0-37.4 5.4-52.8 14.6l-391.6-157.4c-10.2-46.4-51.8-81.4-101.2-81.4-57-0.2-103.6 46.6-103.6 103.6s46.6 103.6 103.6 103.6c19.4 0 37.4-5.4 52.8-14.6l391.6 157.2c10.2 46.6 51.6 81.6 101.2 81.6 53.6 0 98-41.2 103-93.4l133-97.2c76.6 0 138.8-62 138.8-138.6s-62.2-138.8-138.8-138.8zM885.2 323.8c51.4 0 93 41.8 93 93 0 51.4-41.8 92.8-93 92.8-51.4 0-93-41.6-93-92.8 0-51.4 41.6-93 93-93zM103.6 341.8c29.2 0 54.6 16.4 67.4 40.4l-37.8-15.2v0.2c-30.6-11-64.4 4-76.6 34.2-12.2 30.4 1.8 64.6 31.4 77.8v0.2l32.2 12.8c-5.2 1.2-10.8 1.8-16.4 1.8-42.2 0-76.2-34-76.2-76.2-0.2-41.8 33.8-76 76-76zM649.2 566.2c42.2 0 76.2 34 76.2 76.2s-34 76.2-76.2 76.2c-29.4 0-54.8-16.4-67.4-40.6 12.6 5 25 10 37.6 15.2 31 12.4 66.4-2.6 78.8-33.6s-2.6-66.2-33.8-78.8l-31.8-12.8c5.6-1 11-1.8 16.6-1.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-steam"
    ]
  },
  {
    "paths": [
      "M874.8 128h-725.6c-11.8 0-21.2 9.4-21.2 21.2v725.6c0 11.8 9.4 21.2 21.2 21.2h725.6c11.6 0 21.2-9.4 21.2-21.2v-725.6c0-11.8-9.6-21.2-21.2-21.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-stop"
    ]
  },
  {
    "paths": [
      "M606 671.2v-514.4c0-51.4-42-93-94-93s-94 41.6-94 93v513.6c-40 29-65.8 76.4-65.8 129.8 0 88.4 72 160 160.4 160s159.6-71.6 159.6-160c-0.2-53-26.2-100-66.2-129zM482 156.8c0-16 13.4-29 30-29s30 13 30 29v99.2h-60v-99.2zM544 576h-32v-32h32v32zM544 512h-32v-128h32v128z"
    ],
    "grid": 0,
    "tags": [
      "ion-thermometer"
    ]
  },
  {
    "paths": [
      "M175.6 505.4c-27.6 9-47.6 35-47.6 65.6 0 38 30.8 69 69 69h205.2c-4 50-20 107.2-2.2 174.6 15 56.8 78.8 99.4 104.8 73.6 10-9.8 7-30.4 7-67.6 0-85.6 35.6-172.2 79.6-217.4 18.8-19.4 50.4-26 80.4-27.2v32h224v-480h-223.8v64c-41.2 1-105.2-10.4-151.6-13.2-104-6.2-204 4.8-252.6 16.2s-70 26-70 61.2c0 12.8 3.8 24.6 10.2 34.6-23.6 9.4-40.2 32.4-40.2 59.4 0 14.4 4.8 27.6 12.8 38.4-23.8 9.2-40.8 32.4-40.8 59.6 0.2 25 14.8 46.8 35.8 57.2zM800 192.6c17.6 0 32 14.2 32 32 0 17.6-14.4 32-32 32s-32-14.2-32-32c0-17.6 14.4-32 32-32z"
    ],
    "grid": 0,
    "tags": [
      "ion-thumbsdown"
    ]
  },
  {
    "paths": [
      "M848.4 518.6c27.6-9 47.6-35 47.6-65.6 0-38-30.8-69-69-69h-205.2c4-50 20-107.2 2.2-174.6-15-56.8-78.8-99.4-104.8-73.6-10 9.8-7 30.4-7 67.6 0 85.6-35.6 172.2-79.6 217.4-18.8 19.4-50.4 26-80.4 27.2v-32h-224.2v480h224v-64c41.2-1 105.2 10.4 151.6 13.2 104 6.2 204-4.8 252.6-16.2s70-26 70-61.2c0-12.8-3.8-24.6-10.2-34.6 23.6-9.4 40.2-32.4 40.2-59.4 0-14.4-4.8-27.6-12.8-38.4 23.8-9.2 40.8-32.4 40.8-59.6-0.2-25-14.8-46.8-35.8-57.2zM224 831.4c-17.6 0-32-14.2-32-32 0-17.6 14.4-32 32-32s32 14.2 32 32c0 17.6-14.4 32-32 32z"
    ],
    "grid": 0,
    "tags": [
      "ion-thumbsup"
    ]
  },
  {
    "paths": [
      "M704 416c-52.934 0-96 43.066-96 96s43.066 96 96 96 96-43.066 96-96c0-52.934-43.066-96-96-96z",
      "M704 256h-384c-141.384 0-256 114.616-256 256s114.616 256 256 256h384c141.384 0 256-114.616 256-256s-114.616-256-256-256zM704 672c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160-71.634 160-160 160z"
    ],
    "grid": 0,
    "tags": [
      "ion-toggle-filled"
    ]
  },
  {
    "paths": [
      "M704 320c105.868 0 192 86.13 192 192s-86.132 192-192 192h-384c-105.87 0-192-86.13-192-192s86.13-192 192-192h384zM704 256h-384c-141.384 0-256 114.616-256 256s114.616 256 256 256h384c141.384 0 256-114.616 256-256s-114.616-256-256-256v0z",
      "M320 416c52.934 0 96 43.066 96 96s-43.066 96-96 96-96-43.066-96-96c0-52.934 43.066-96 96-96zM320 352c-88.366 0-160 71.634-160 160s71.634 160 160 160 160-71.634 160-160-71.634-160-160-160v0z"
    ],
    "grid": 0,
    "tags": [
      "ion-toggle"
    ]
  },
  {
    "paths": [
      "M736 0v80h139.746l-186.092 183.94c-17.058-16.498-30.264-25.172-30.264-25.172-41.708-29.38-92.546-46.768-147.39-46.768-69.050 0-131.72 27.338-177.806 71.788l-34.666-34.262 71.666-71.666-65.054-65.054-72.044 72.042-85.842-84.848h139.746v-80h-288v288h80v-152.388l92.17 91.164-71.366 71.364 65.052 65.052 71.724-71.722 44.37 43.884c-16.79 34.13-26.236 72.534-26.236 113.156 0 125.258 90.286 229.468 208.286 251.99v103.5h-144v92h144v128h96v-128h144v-92h-144v-103.5c116-22.522 208.444-126.794 208.444-252.050 0-40.404-9.588-79.476-26.188-113.298l201.744-199.54v152.388h80v-288h-288zM511.858 608.804c-88.312 0-160.158-71.936-160.158-160.356 0-88.422 71.846-160.36 160.158-160.36 88.31 0 160.156 71.938 160.156 160.36s-71.846 160.356-160.156 160.356z"
    ],
    "grid": 0,
    "tags": [
      "ion-transgender"
    ]
  },
  {
    "paths": [
      "M682 256v-58c0-38.2-29-70-69-70h-202.2c-39.8 0-68.8 31.8-68.8 70v58h-182v64h18.4c0 0 10.8 1.2 16.4 6.8s7.8 18 7.8 18l38 483.4c3 58.8 3 67.8 72 67.8h398.8c69 0 69-8.8 72-67.6l38-483.2c0 0 2.2-12.6 7.8-18.2s16.4-6.8 16.4-6.8h18.4v-64h-182v-0.2zM384 198c0-19.2 15.6-30 35.4-30h183.4c19.8 0 37.2 11 37.2 30v58h-256v-58zM367 768l-20.6-384h40.6l21 384h-41zM534.2 768h-44v-384h44v384zM657.4 768h-40.8l21-384h40.6l-20.8 384z"
    ],
    "grid": 0,
    "tags": [
      "ion-trash-a"
    ]
  },
  {
    "paths": [
      "M827.4 266.8c-4.8-18-8-28-8-28-5.2-18.6-18.4-18.6-38-21.8l-106.2-13.4c-13.2-2.2-13.2-2.2-18.4-13.6-17.4-39.2-22.8-62-41.8-62h-206c-19 0-24.2 22.8-41.6 62.2-5.2 11.2-5.2 11.2-18.4 13.6l-106.4 13.4c-19.4 3.2-33.4 5-38.6 23.6 0 0-2.4 8.2-7.4 26-6.4 23.8-9 21.2 13 21.2h604.8c22 0.2 19.6 2.6 13-21.2z",
      "M758.8 352h-493.6c-33.2 0-34.8 4.4-32.8 29.4l37.4 485.2c3.2 24.6 5.6 29.6 35 29.6h414.4c29.4 0 31.8-5 35-29.6l37.4-485.2c2-25.2 0.4-29.4-32.8-29.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-trash-b"
    ]
  },
  {
    "paths": [
      "M959.726 206.684c-0.102-5.666-0.192-10.558-0.192-14.684h-161.67c3.12-69.234 1.024-128 1.024-128s-191.182 0-285.136 0c-0.674 0-1.338 0.044-2 0.112-0.66-0.068-1.324-0.112-2-0.112-93.954 0-285.862 0-285.862 0s-2.096 58.766 1.024 128h-160.914v41.096c0 0.228 0 0.456 0 0.684v22.22h0.322c1.622 52.192 9.96 121.998 44.666 193.458 29.436 60.614 71.824 111.328 125.992 150.734 44.844 32.624 96.082 56.128 152.41 70.168 32.53 34.718 64.61 53.858 92.61 61.554v71.25c-4 21.166-28.28 92.836-197.532 92.836h-26.468v64h512v-64h-26.356c-198.568 0-197.644-98.668-197.644-98.668v-65.428c28-7.686 59.46-26.748 91.82-61.288 56.738-14.008 108.144-37.602 153.266-70.426 54.164-39.406 96.524-90.12 125.96-150.734 47.36-97.522 45.606-192.010 44.68-242.772zM166.524 421.49c-28.92-59.558-36.488-119.498-38.15-165.49h100.974c1.736 17.828 3.932 35.402 6.712 51.96 17.026 101.418 40.426 190.986 84.708 270.018-67.676-34.282-120.828-87.68-154.244-156.488zM857.474 421.49c-33.614 69.22-87.206 122.842-155.458 157.1 44.43-79.182 67.632-168.95 84.704-270.628 2.78-16.56 4.976-34.134 6.712-51.96h102.192c-1.662 45.99-9.228 105.93-38.15 165.488z"
    ],
    "grid": 0,
    "tags": [
      "ion-trophy"
    ]
  },
  {
    "paths": [
      "M356.498 171.068c37.522 45.952 87.818 68.018 154.89 69.144l0.538-0.212h0.538c45.276 0 82.338-9.722 113.306-30.182 15.602-10.308 29.442-22.94 42.058-38.764l208.922 62.734-23.57 65.032-153.31-18.548 4.228 76.266 28.254 509.462h-440.704l32.466-585.42-153.272 17.962-23.534-64.716 209.19-62.758zM640 96c-27.976 54.454-61.542 80.446-127.538 80.446-65.016-1.094-101.018-26.446-128.462-80.446l-320 96 64 176 128-15-32 577h576l-32-577 128 15.5 64-176.5-320-96z"
    ],
    "grid": 0,
    "tags": [
      "ion-tshirt-outline"
    ]
  },
  {
    "paths": [
      "M960 192l-320-96c-27.976 54.454-61.542 80.446-127.538 80.446-65.016-1.094-101.018-26.446-128.462-80.446l-320 96 64 176 128-16-32 576h576l-32-576 128 16 64-176z"
    ],
    "grid": 0,
    "tags": [
      "ion-tshirt"
    ]
  },
  {
    "paths": [
      "M752.4 576c0 0.2 0 0.4 0 0.8 0-0.4 0-0.6 0-0.8v0z",
      "M272.4 576c0 0.2 0 0.4 0 0.8 0-0.4 0-0.6 0-0.8v0z",
      "M544 97.6c0-0.6 0-1 0-1.6 0-17.6-14.4-32-32-32s-32 14.4-32 32c0 0.4 0 1 0 1.4-232.6 16-416 206.2-416 442.8 0 7.2 0.4 28.4 0.8 35.6 5.4-52.6 49.4-103.4 103.4-103.4 57.4 0 103.8 46.2 104.2 103.4v0c0.4-57.2 46.8-103.4 104.2-103.4 53 0 101.8 42.2 103.4 91v268.6c0 35.8-28.2 64-64 64-34.2 0-62-28.8-62-64 0-17.6-14.4-32-32-32s-32 14.4-32 32c0 70.6 56.6 128 126 128 34.6 0 67-13.4 91-37.6 23.8-24 37-56.2 37-90.4v-270.6c6.6-65.4 46.8-88.8 104.2-88.8s103.8 46.2 104.2 103.4v0c0.4-57.2 46.8-103.4 104.2-103.4 52.2 0 95.2 53.4 102.8 103.4 0.2-5.6 0.4-18.2 0.4-23.6 0.2-236.8-183.4-437.8-415.8-454.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-umbrella"
    ]
  },
  {
    "paths": [
      "M512 128l-448 224.59 64 42.144v405.266l64 32v-396.302l319.704 204.302 264.288-170.902 184.008-119.644z",
      "M780.26 512l-268.26 175.536-270.938-175.536-17.062 163.058c32 24.91 224 156.942 288.004 220.942 63.996-64 255.996-195.938 287.996-220.878l-19.74-163.122z"
    ],
    "grid": 0,
    "tags": [
      "ion-university"
    ]
  },
  {
    "paths": [
      "M172.8 960h678.4c24.6 0 44.8-19.8 44.8-44.2v-423.8c0-24.4-20-44-44.8-44h-529.2v-61.8c0-54.6 19.8-122.2 56.2-160.6v0-0.6c35.2-37.2 83.8-59 133.6-59h0.4c49.8 0 98.4 21.8 133.6 59v0.6c22.6 23.8 38.8 58.6 48 94.6h106.8c-11.8-62.6-39.4-123.6-78.4-164.8-52.4-55.6-127.4-91.4-210-91.4-0.2 0-0.2 0-0.2 0s-0.2 0-0.2 0c-82.6 0-158 35.8-210.6 91.2-52.8 55.6-85.2 147.8-85.2 230.8v62h-43.2c-24.8 0-44.8 19.8-44.8 44v423.8c0 24.4 20 44.2 44.8 44.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-unlocked"
    ]
  },
  {
    "paths": [
      "M796.2 466.4c0-2.4 0.4-4.8 0.4-7.2 0-130-103.6-235.2-231.4-235.2-92.2 0-171.4 54.8-208.6 134-16.2-8.2-34.4-13-53.6-13-59 0-108.2 43.8-117.6 101-70.8 24.4-121.4 92.2-121.4 172 0 100.4 80.2 182 179 182h205v-160h-96.4l160.4-167.4 160.4 167.2h-96.4v160h220.6c90.4 0 163.4-75 163.4-166.8s-73.4-166.4-163.8-166.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-upload"
    ]
  },
  {
    "paths": [
      "M288 440c0 0 0.2 0.2 0 0v0z",
      "M768 256.6c0-35.6-28.8-64.4-64.2-64.4s-64.2 28.8-64.2 64.2c0 24.2 13.4 45.4 33.2 56.4 2.6 3 4.4 9 4.4 12 0 0.2 0 0.4 0 0.8-1.6 35.2-7.6 63.8-14.2 83.4-8.6 25.2-76.4 79.2-103 84.4-11.6 2.4-15.8-1.2-15.8-20.4 0 0 0-277.8 0-280.8s0.4-7 3.8-10c0 0 0 0 0 0 17.2-11.6 28.6-31.2 28.6-53.6 0-35.6-28.8-64.4-64.2-64.4s-64.2 28.8-64.2 64.4c0 22.6 11.6 42.6 29.2 54 0 0 0.2 0.2 0.2 0.2 0.2 0.2 0.4 0.2 0.8 0.4s0.8 0.4 1.2 0.8c4.6 3 6.6 6 6.6 8.4 0 2.6 0 378.6 0 392.6s-2.2 24.6-16.8 23.6-83.4-47-102.8-88.2c-9-19-13.6-37.6-13.6-56v0c0 0 0-0.8 0-1 0-6.2 0-22.6 6.4-27.2 15.6-11.8 25.6-30.4 25.6-51.4 0-35.6-28.8-64.4-64.2-64.4s-64.8 28.4-64.8 64c0 23.8 13 44.6 32 55.6 4.8 3 6 5.8 7.6 21.2s6 49.2 18.2 79.8c14.6 37.2 41.8 65.2 79.4 90.4 27.2 18.6 50.6 33.2 64.2 52.8s20.4 27 20.4 54c0 0 0-1.8 0 0 0 25.6-8 28-18.6 35.6-28.2 17.4-47 48.4-47 84 0 0.2 0 0.6 0 0.8 0 0.4 0 1 0 1.4 0 55 44.6 99.6 99.6 99.6s99.6-44.6 99.6-99.6c0-26.6-10.4-50.8-27.4-68.6-5.8-6.4-12-12-19.2-16.6-15-10.4-20.6-23-20.6-36.2v-48.2c0-50.2 8.2-82.2 22.2-106.6 14.6-25.4 36.6-45.2 70.8-68.4 37.6-25.2 64.4-53.2 79.2-90.4 11.4-28.8 15.2-62 17.2-101.8 0.2-3.6 2.8-11.6 6.6-13.6v0c16.6-11.6 27.8-31 27.8-53zM320.2 416.6c-17.8 0-32.2-14.6-32.2-32.4s14.4-32.4 32.2-32.4 32.2 14.6 32.2 32.4-14.4 32.4-32.2 32.4zM512 160.6c-17.8 0-32.2-14.6-32.2-32.4s14.4-32.2 32.2-32.2 32.2 14.6 32.2 32.4-14.4 32.2-32.2 32.2zM703.8 288.6c-17.8 0-32.2-14.6-32.2-32.4s14.4-32.2 32.2-32.2 32.2 14.6 32.2 32.4-14.4 32.2-32.2 32.2z"
    ],
    "grid": 0,
    "tags": [
      "ion-usb"
    ]
  },
  {
    "paths": [
      "M734 370.6c0-10.2-8-18.6-18.4-18.6h-103.6v-64.4c0-70.4-58.6-127.6-129.8-127.6h-356.2v96h352.2c9 0 19.8 11.2 19.8 20.2v75.8h-415.2c-10.4 0-18.8 8.4-18.8 18.6v474.8c0 10.2 8.4 18.6 18.8 18.6h632.8c10.4 0 18.4-8.4 18.4-18.6v-129l226 69.4v-352.8l-226 69.4v-131.8zM516.4 682h-236.2c-39.6 0-71.8-32-71.8-71.6s32.2-71.6 71.8-71.6c39.6 0 71.8 32.4 71.8 72 0 20-8.4 37.2-21.6 51.2h135.8c-13.2-14-21.6-31.2-21.6-51.2 0-39.6 32.2-71.8 71.8-71.8s71.8 31.8 71.8 71.4-32.2 71.6-71.8 71.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-videocamera"
    ]
  },
  {
    "paths": [
      "M462 815.6v-607l-189.8 175.4h-208.2v256h208.2z",
      "M574.2 711.4c41-55.8 65.6-124.6 65.6-199.4s-24.6-143.6-65.6-199.4l-40.8 30.6c34.8 47.2 55.6 105.4 55.6 168.8 0 63.2-20.8 121.6-55.6 168.6l40.8 30.8z",
      "M707.4 803.4c60-81.4 96-182.2 96-291.4s-36-209.8-96-291.4l-40.8 30.6c53.8 72.8 86 163 86 260.8s-32.2 187.8-86 260.6l40.8 30.8z",
      "M793.4 158.8c72.8 98.6 115.8 221 115.8 353.2s-43 254.4-115.8 353.2l41 30.8c78.8-107.2 125.6-240 125.6-384s-46.8-276.8-125.6-384l-41 30.8z"
    ],
    "grid": 0,
    "tags": [
      "ion-volume-high"
    ]
  },
  {
    "paths": [
      "M622 815.4v-606.6l-189.6 175.2h-208.4v256h208.4z",
      "M734.4 711.2c41-55.6 65.6-124.6 65.6-199.2 0-74.8-24.6-143.6-65.6-199.2l-40.8 30.6c34.8 47.2 55.6 105.4 55.6 168.6s-20.8 121.4-55.6 168.6l40.8 30.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-volume-low"
    ]
  },
  {
    "paths": [
      "M540 815.4v-606.6l-189.4 175.2h-208.6v256h208.6z",
      "M652.6 711.2c41-55.6 65.6-124.6 65.6-199.2 0-74.8-24.6-143.6-65.6-199.2l-40.8 30.6c34.8 47.2 55.6 105.4 55.6 168.6s-20.8 121.4-55.6 168.6l40.8 30.6z",
      "M785.6 803.2c60-81.4 96-182 96-291.2s-36-209.8-96-291.2l-40.8 30.6c53.8 72.8 86 162.8 86 260.6s-32.2 187.6-86 260.6l40.8 30.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-volume-medium"
    ]
  },
  {
    "paths": [
      "M511.8 434h-129.8v156h129.8l94.2 102.6v-361.2z",
      "M729 120.2c-0.8-0.4-1.4-0.8-2.2-1.2-63.8-35-137-55-214.8-55-247.4 0-448 200.6-448 448 0 168.6 93.2 315.2 230.8 391.8 0.8 0.4 1.4 1 2.2 1.4 64 34.8 137.2 54.8 215 54.8 247.4 0 448-200.6 448-448 0-168.6-93.2-315.4-231-391.8zM787.8 710.8l-115.8-116.6v153.4l39.2 39.8c-56 40.6-124.6 65.4-199 65.4-43.2 0-84.6-8.4-122.6-23-13-5-25.8-10.6-38-17.2-107.2-57.4-180.2-170.4-180.2-300.6 0-74.4 24.8-142.8 65.4-198.8l70.6 70.8h153.4l-147.2-147.6c56-40.4 124.2-65.2 198.8-65.2 43.2 0 84.4 8.4 122.6 23 12.2 4.8 24.4 10 35.8 16 108.4 57 182.6 170.6 182.6 301.6-0.4 74.8-25 143-65.6 199z"
    ],
    "grid": 0,
    "tags": [
      "ion-volume-mute"
    ]
  },
  {
    "paths": [
      "M544 383.994l95.999 95.999-95.999 95.999-95.999-95.999 95.999-95.999z",
      "M416.015 512l96.002 96.002-351.996 351.996-96.002-96.002 351.996-351.996z",
      "M512 64h64v128h-64v-128z",
      "M770.263 298.994l-45.254-45.254 90.507-90.507 45.254 45.254-90.507 90.507z",
      "M227.212 208.468l45.254-45.254 90.509 90.509-45.254 45.254-90.509-90.509z",
      "M725.010 706.252l45.254-45.254 90.509 90.509-45.254 45.254-90.509-90.509z",
      "M832 448h128v64h-128v-64z"
    ],
    "grid": 0,
    "tags": [
      "ion-wand"
    ]
  },
  {
    "paths": [
      "M542 77.2c-0.6-0.8-1.4-1.4-1.8-2 0 0-0.2-0.2-0.2-0.2-7.2-6.8-17-11-27.8-11-11 0-20.8 4.2-27.8 11 0 0-0.2 0.2-0.2 0.2-0.6 0.6-1.2 1.2-1.8 2-12.2 12.6-27.6 28.8-44.8 48.2-34.8 39.4-77.2 92-117 153.6-66.8 103.6-125.8 232.2-128.2 366.2 0 2.6-0.2 5.4-0.2 8 0 39.4 7.8 77 21.8 111.6 8.2 20 18.4 38.8 30.4 56.4 57 83.6 155.6 138.8 267.6 138.8 176.8 0 320-137.4 320-306.8 0-255.8-210.4-494.8-290-576zM512 848c-31.6 0-61.4-7.4-87.8-20.2 131.8-28.8 236.8-129.4 271.6-259 10.4 24.2 16.4 51 16.4 79.2-0.2 110.4-89.8 200-200.2 200z"
    ],
    "grid": 0,
    "tags": [
      "ion-waterdrop"
    ]
  },
  {
    "paths": [
      "M512.2 192v0c-159.8 0-311.4 59.8-427.8 168.2l-20.4 19 103 102 19.2-17.6c89-81.8 204.6-127 325.6-127s236.8 45.2 325.6 127l19.2 17.6 18.6-18.4 84.4-83.6-20.4-19c-116-108.4-267.8-168.2-427-168.2z",
      "M794.8 512.8c-77.6-70.2-177.8-108.8-282.2-108.8h-17.8l-0.2 0.4c-98.4 4-192 42.2-265.2 108.4l-21 19 103.8 102.8 19.2-16.8c50.6-44.4 114.8-69 180.6-69 66.2 0 130.4 24.6 181 69l19.2 16.8 18.2-18 85.6-84.8-21.2-19z",
      "M512.4 832l146-144.4-23.2-19c-30.8-22.8-64.8-40-123-40-58 0-89.8 18.8-123 40l-23 19 21.2 21 105.6 104.4 19.4 19z"
    ],
    "grid": 0,
    "tags": [
      "ion-wifi"
    ]
  },
  {
    "paths": [
      "M589.8 590.8c22-8.2 36-13.8 52.4-23.4 24-13.8 45.6-31.6 63.8-52.2 40.8-45.8 62-102.2 62-172.2 0-99.8-7.4-202.2-16.2-229.4-8.8-27.6-27-49.6-61.4-49.6h-357c-34.2 0-52.4 22.2-61.2 49.2s-16.2 129.8-16.2 229.6c0 70.2 21.2 126.4 61.8 172.2 18.2 20.6 39.8 38.2 63.6 52 16.4 9.6 30.2 15.6 52 23.4s44.6 15 44.6 63.6v188.4c0 21.4-5.8 38-22.2 49.6-5.6 4.2-12.6 8.6-28.6 13-63 17.2-93.8 31.2-98.4 34.4-4 2.8-9 7.2-9 14.2 0 0 27.6 6.2 192.4 6.2s192-6.2 192-6.2c0-7-5-11.4-9.2-14.2-4.6-3.2-35.6-17.2-98.8-34.4-16-4.4-24.4-8.8-30.2-13-16-11.4-24-28-24-49.4v-188.4c0-48 25.8-55.4 47.8-63.4zM511.8 540.6c-50.8 0-97-20-131-52.6-5.4-4.8-10.4-10-15.2-15.4-31.2-35-44.8-73.4-46.2-129.6-1.4-56.4-0.2-145 14.6-215h354c12.6 48 18.2 153.6 15.4 214.4-2.8 61-14.4 94.6-45.6 129.8-4 4.4-7.8 8.6-12.2 12.8-34.2 34.4-81.6 55.6-133.8 55.6z",
      "M672.4 341.2c0-15-0.2-63.8-2.6-105.2-1-16.8-2.4-32-4.2-44h-306c-1.8 6-3.6 23.2-5 44-2.6 37.8-4.2 87.8-3 105.8 1.8 27.6 3 41.2 9 58.8 6.2 18.2 16 34.6 29.2 49.4 4 4.6 8.2 8.8 12.8 12.8 28.4 27.2 67 44 109.4 44 43.6 0 83-17.6 111.8-46.2 3.6-3.4 7-7 10.4-10.6 13.2-14.8 22.8-31 29-49.2 6.2-18 9.2-38.6 9.2-59.6zM640 358c0 10-7.8 16.2-16.6 16.2-3.2 0-6-1-8.6-2.6-4.4-2.8-7-7.8-7-13.4v-52c0-8.8 7.2-16 16-16s16 7.2 16 16v51.8zM637.8 263.6c-2.4 3.6-6 6-10.2 7-4.2 0.8-8.6 0-12-2.2-3.6-2.4-6-6-7-10.2-0.8-4.2 0-8.6 2.2-12 2.4-3.6 6-6 10.2-7 4.2-0.8 8.6 0 12 2.2 3.6 2.4 6 6 7 10.2 1 4 0.2 8.4-2.2 12z"
    ],
    "grid": 0,
    "tags": [
      "ion-wineglass"
    ]
  },
  {
    "paths": [
      "M380.8 297.2l-58.8 208.6c-12.6 45.6 41.4 63.4 54.6 20.6l52.6-192.4h14.8l-90.4 338h84.4v254c0 46 64 46 64 0v-254h20v254c0 46 62 46 62 0v-254h86.8l-92.4-338h16.8l52.6 192.4c13 43.8 66.6 25 54.6-20.4l-58.8-208.8c-8-23.6-36.4-65.2-84-67.2h-94.6c-49.2 2-77.4 43.2-84.2 67.2z",
      "M585.2 138.4c0-41.2-32.8-74.6-73.2-74.6s-73.2 33.4-73.2 74.6c0 41.2 32.8 74.6 73.2 74.6s73.2-33.4 73.2-74.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-woman"
    ]
  },
  {
    "paths": [
      "M923.8 229.8l-113 113.4-110.2-20-19.8-110.2 113-113.4c-25.4-25.4-61.6-37-88.4-35.6-27 1.4-84.6 16.6-129.2 64-43.2 45.6-88.6 130.6-48.4 225 4.8 11.4 10.2 26.4-5.8 42.4-16.2 16-430 405.6-430 405.6-38.8 33.4-36 95.2-0.2 131.2 36.4 35.8 97.8 38 131.2-0.6 0 0 386.4-411.6 405.4-430.2 17-16.6 32.2-11 42.4-5.8 71.2 36.8 172.6 4.8 225.2-47.8s62.2-103.4 63.8-129.4c1.6-25.8-7.4-60-36-88.6zM182.6 886.4c-12.6 12.4-33 12.4-45.4 0-12.4-12.6-12.4-33 0-45.4 12.6-12.4 33-12.4 45.4 0 12.4 12.6 12.4 33 0 45.4z"
    ],
    "grid": 0,
    "tags": [
      "ion-wrench"
    ]
  },
  {
    "paths": [
      "M253.6 496.6c79.4-117.2 155.8-185.6 155.8-185.6s-84.2-97.8-185.6-134.8l-6.6-1.6c-93.8 82.2-153.2 202.8-153.2 337.4 0 101.4 33.8 195 90.4 270 0-8.8 1.2-140.6 99.2-285.4z",
      "M960 512c0-134.6-59.4-255.2-153.2-337.4l-6.4 1.8c-101.4 37-185.8 134.8-185.8 134.8s76.4 68.4 155.8 185.6c98 144.8 99.2 276.6 99 285.4 57-75.2 90.6-168.8 90.6-270.2z",
      "M402.4 161.8c58.6 26.2 109.2 69.2 109.2 69.2s51-42.8 109.6-69.2c73.6-33 129.8-22.6 144.6-19-72.2-49.6-159.6-78.8-253.8-78.8s-181.6 29.2-253.8 78.8c14.4-3.6 70.4-14.2 144.2 19z",
      "M717.4 585.8c-92.6-113.8-205.8-187.8-205.8-187.8s-112.6 74-205.4 187.8c-79.6 97.8-109.2 169.6-125.2 215.6l-2.6 9.6c82 91.4 201 149 333.6 149s251.6-57.6 333.6-149l-2.8-9.6c-16-46-45.8-117.8-125.4-215.6z"
    ],
    "grid": 0,
    "tags": [
      "ion-xbox"
    ]
  }
]
